var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React from "react";
import React__default, { useState, useCallback, Fragment, useEffect, useContext, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { isCollapsed, findNodePath, getPointAfter, insertNodes, ELEMENT_DEFAULT, focusEditor, getPointBefore, setNodes, isElement, ELEMENT_H1, ELEMENT_H2, ELEMENT_H3, ELEMENT_H4, ELEMENT_H5, ELEMENT_H6, ELEMENT_PARAGRAPH, ELEMENT_BLOCKQUOTE, ELEMENT_CODE_BLOCK, ELEMENT_UL, ELEMENT_OL, ELEMENT_LI, ELEMENT_LIC, ELEMENT_LINK, MARK_CODE, MARK_ITALIC, MARK_BOLD, ELEMENT_HR, createPluginFactory, normalizeEditor, getBlockAbove, queryNode, unwrapList, getParentNode, isType, ELEMENT_CODE_LINE, toggleList, someNode, isSelectionAtBlockStart, setElements, insertNode, getPluginType, ELEMENT_TODO_LI, isBlock, createTrailingBlockPlugin, createAutoformatPlugin, createExitBreakPlugin, KEYS_HEADING, createResetNodePlugin, isBlockAboveEmpty, createHeadingPlugin, createParagraphPlugin, createBlockquotePlugin, createBoldPlugin, createItalicPlugin, createUnderlinePlugin, createCodePlugin, createListPlugin, createHorizontalRulePlugin, createNodeIdPlugin, isMarkActive as isMarkActive$1, getListItemEntry, findNode, unwrapNodes, getAboveNode, getNodeEntries, wrapNodes, useEditorState, isEditorFocused, getEditorString, getPreventDefaultHandler, toggleNodeType, toggleMark, createPlugins, createLinkPlugin, Plate } from "@udecode/plate-headless";
import MonacoEditor, { loader, useMonaco } from "@monaco-editor/react";
import { useSelected, ReactEditor } from "slate-react";
import { Combobox, Transition, Popover as Popover$1, Disclosure, Menu } from "@headlessui/react";
import { Transforms, Element, Range, Path, Node, Editor } from "slate";
import arrayMutators from "final-form-arrays";
import setFieldData from "final-form-set-field-data";
import { FORM_ERROR, createForm as createForm$1, getIn } from "final-form";
import { Field, Form as Form$1 } from "react-final-form";
import PropTypes from "prop-types";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import isHotkey from "is-hotkey";
import { SketchPicker, BlockPicker } from "react-color";
import { to, get } from "color-string";
import { useDropzone } from "react-dropzone";
import { computePosition, flip, shift } from "@floating-ui/dom";
import moment from "moment";
import onClickOutside from "react-onclickoutside";
import { useWindowWidth } from "@react-hook/window-size";
import { EditContext, useEditState } from "@tinacms/sharedctx";
const ModalProvider = ({ children }) => {
  const [modalRootContainerRef, setModalRootContainerRef] = useState(null);
  const setModalRef = useCallback((node) => {
    if (node !== null) {
      setModalRootContainerRef(node);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    id: "modal-root",
    className: "tina-tailwind",
    ref: setModalRef
  }), /* @__PURE__ */ React.createElement(ModalContainerContext.Provider, {
    value: { portalNode: modalRootContainerRef }
  }, children));
};
const ModalContainerContext = React.createContext(null);
function useModalContainer() {
  const modalContainer = React.useContext(ModalContainerContext);
  if (!modalContainer) {
    throw new Error("No Modal Container context provided");
  }
  return modalContainer;
}
const ModalOverlay = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "fixed inset-0 z-modal w-screen h-screen overflow-y-auto"
  }, children, /* @__PURE__ */ React.createElement("div", {
    className: "fixed -z-1 inset-0 opacity-80 bg-gradient-to-br from-gray-800 via-gray-900 to-black"
  }));
};
const Modal = (props) => {
  const { portalNode } = useModalContainer();
  if (!portalNode)
    return null;
  return createPortal(/* @__PURE__ */ React.createElement(ModalOverlay, null, /* @__PURE__ */ React.createElement("div", {
    ...props
  })), portalNode);
};
const ModalActions = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "w-full flex justify-between gap-4 items-center px-5 pb-5 rounded-b-md"
  }, children);
};
const ModalBody = ({ className = "", padded = false, ...props }) => /* @__PURE__ */ React__default.createElement("div", {
  className: `${padded ? "p-5" : "p-0"} m-0 overflow-hidden flex flex-col min-h-[160px] [&:last-child]:rounded-[0_0_5px_5px] ${className}`,
  ...props
});
const AddIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M14.9524 4.89689L14.9524 26.8016H16.7461L16.7461 4.89689H14.9524Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4.8969 16.7461H26.8016L26.8016 14.9523H4.89689L4.8969 16.7461Z"
}));
const AlignCenter = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M9.125 24H22.875V26H9.125V24ZM5 18H27V20H5V18ZM5 6H27V8H5V6ZM9.125 12H22.875V14H9.125V12Z",
  fill: "inherit"
}));
const AlignLeft = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5 24H20.125V26H5V24ZM5 18H27V20H5V18ZM5 6H27V8H5V6ZM5 12H20.125V14H5V12Z",
  fill: "inherit"
}));
const AlignRight = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M11.875 24H27V26H11.875V24ZM5 18H27V20H5V18ZM5 6H27V8H5V6ZM11.875 12H27V14H11.875V12Z",
  fill: "inherit"
}));
const CloseIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5 6.2684L24.7316 26L26 24.7316L6.2684 5L5 6.2684Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.2684 26L26 6.2684L24.7316 5L5 24.7316L6.2684 26Z"
}));
const EllipsisVerticalIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 4 14",
  fill: "#828282",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2 5.5C1.5625 5.5 1.21875 5.65625 0.9375 5.9375C0.625 6.25 0.5 6.59375 0.5 7C0.5 7.4375 0.625 7.78125 0.9375 8.0625C1.21875 8.375 1.5625 8.5 2 8.5C2.40625 8.5 2.75 8.375 3.0625 8.0625C3.34375 7.78125 3.5 7.4375 3.5 7C3.5 6.59375 3.34375 6.25 3.0625 5.9375C2.75 5.65625 2.40625 5.5 2 5.5ZM0.5 2.25C0.5 1.84375 0.625 1.5 0.9375 1.1875C1.21875 0.90625 1.5625 0.75 2 0.75C2.40625 0.75 2.75 0.90625 3.0625 1.1875C3.34375 1.5 3.5 1.84375 3.5 2.25C3.5 2.6875 3.34375 3.03125 3.0625 3.3125C2.75 3.625 2.40625 3.75 2 3.75C1.5625 3.75 1.21875 3.625 0.9375 3.3125C0.625 3.03125 0.5 2.6875 0.5 2.25ZM0.5 11.75C0.5 11.3438 0.625 11 0.9375 10.6875C1.21875 10.4062 1.5625 10.25 2 10.25C2.40625 10.25 2.75 10.4062 3.0625 10.6875C3.34375 11 3.5 11.3438 3.5 11.75C3.5 12.1875 3.34375 12.5312 3.0625 12.8125C2.75 13.125 2.40625 13.25 2 13.25C1.5625 13.25 1.21875 13.125 0.9375 12.8125C0.625 12.5312 0.5 12.1875 0.5 11.75Z"
}));
const HamburgerIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4 10H28V8H4V10Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4 17H28V15H4V17Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4 24H28V22H4V24Z"
}));
const EditIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M24.3324 8.96875C24.754 9.42578 25 9.95312 25 10.5859C25 11.2188 24.754 11.7461 24.3324 12.168L11.9634 24.543L7.85212 25C7.57101 25 7.36018 24.9297 7.21962 24.7188C7.04392 24.543 6.97365 24.332 7.00878 24.0508L7.46559 20.043L19.8346 7.66797C20.2562 7.24609 20.7833 7 21.4158 7C22.0483 7 22.5754 7.24609 23.0322 7.66797L24.3324 8.96875ZM11.1903 22.9258L20.3968 13.7148L18.2884 11.6055L9.08199 20.8164L8.80088 23.207L11.1903 22.9258ZM23.1376 10.9727C23.243 10.8672 23.3133 10.7266 23.3133 10.5859C23.3133 10.4453 23.243 10.3047 23.1376 10.1641L21.8375 8.86328C21.6969 8.75781 21.5564 8.6875 21.4158 8.6875C21.2753 8.6875 21.1347 8.75781 21.0293 8.86328L19.4832 10.4102L21.5915 12.5195L23.1376 10.9727Z"
}));
const ChevronDownIcon$2 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M6.708 10.5L5.5 11.7654L14.2939 20.9773C14.9597 21.6747 16.0412 21.6737 16.7061 20.9773L25.5 11.7654L24.292 10.5L15.5 19.7098L6.708 10.5Z"
}));
const ChevronUpIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M25.292 21.5L26.5 20.2346L17.7061 11.0227C17.0403 10.3253 15.9588 10.3263 15.2939 11.0227L6.5 20.2346L7.708 21.5L16.5 12.2901L25.292 21.5Z"
}));
const ChevronLeftIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M21 7.208L19.7346 6L10.5227 14.7939C9.82527 15.4597 9.82626 16.5412 10.5227 17.2061L19.7346 26L21 24.792L11.7901 16L21 7.208Z"
}));
const ChevronRightIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M11 24.792L12.2654 26L21.4773 17.2061C22.1747 16.5403 22.1737 15.4588 21.4773 14.7939L12.2654 6L11 7.208L20.2099 16L11 24.792Z"
}));
const DuplicateIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M24.95,25.85H13.01c-0.5,0-0.9-0.4-0.9-0.9V13.01c0-0.5,0.4-0.9,0.9-0.9h11.94c0.5,0,0.9,0.4,0.9,0.9v11.94\n      C25.85,25.45,25.45,25.85,24.95,25.85z M13.91,24.05h10.14V13.91H13.91V24.05z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.93,19.89H7.05c-0.5,0-0.9-0.4-0.9-0.9V7.05c0-0.5,0.4-0.9,0.9-0.9h11.94c0.5,0,0.9,0.4,0.9,0.9v2.89h-1.8V7.95H7.95\n      v10.14h1.99V19.89z"
}));
const DragIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15 22C15 23.1 14.1 24 13 24C11.9 24 11 23.1 11 22C11 20.9 11.9 20 13 20C14.1 20 15 20.9 15 22ZM13 14C11.9 14 11 14.9 11 16C11 17.1 11.9 18 13 18C14.1 18 15 17.1 15 16C15 14.9 14.1 14 13 14ZM13 8C11.9 8 11 8.9 11 10C11 11.1 11.9 12 13 12C14.1 12 15 11.1 15 10C15 8.9 14.1 8 13 8ZM19 12C20.1 12 21 11.1 21 10C21 8.9 20.1 8 19 8C17.9 8 17 8.9 17 10C17 11.1 17.9 12 19 12ZM19 14C17.9 14 17 14.9 17 16C17 17.1 17.9 18 19 18C20.1 18 21 17.1 21 16C21 14.9 20.1 14 19 14ZM19 20C17.9 20 17 20.9 17 22C17 23.1 17.9 24 19 24C20.1 24 21 23.1 21 22C21 20.9 20.1 20 19 20Z"
}));
const LeftArrowIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M21 7.208L19.7346 6L10.5227 14.7939C9.82527 15.4597 9.82626 16.5412 10.5227 17.2061L19.7346 26L21 24.792L11.7901 16L21 7.208Z"
}));
const RightArrowIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M11 24.792L12.2654 26L21.4773 17.2061C22.1747 16.5403 22.1737 15.4588 21.4773 14.7939L12.2654 6L11 7.20799L20.2099 16L11 24.792Z"
}));
const BoldIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M20.8 14.3867C22.0933 13.4933 23 12.0267 23 10.6667C23 7.65334 20.6667 5.33334 17.6667 5.33334H9.33333V24H18.72C21.5067 24 23.6667 21.7333 23.6667 18.9467C23.6667 16.92 22.52 15.1867 20.8 14.3867V14.3867ZM13.3333 8.66667H17.3333C18.44 8.66667 19.3333 9.56 19.3333 10.6667C19.3333 11.7733 18.44 12.6667 17.3333 12.6667H13.3333V8.66667ZM18 20.6667H13.3333V16.6667H18C19.1067 16.6667 20 17.56 20 18.6667C20 19.7733 19.1067 20.6667 18 20.6667Z"
}));
const CodeIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12.5333 22.1333L6.40001 16L12.5333 9.86667L10.6667 8L2.66667 16L10.6667 24L12.5333 22.1333ZM19.4667 22.1333L25.6 16L19.4667 9.86667L21.3333 8L29.3333 16L21.3333 24L19.4667 22.1333V22.1333Z"
}));
const ExitIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15.5 23.0129L8.88889 23.0129L8.88889 9.10324L15.5 9.10324L15.5 7.11615L8.88889 7.11615C7.85 7.11615 7 8.01034 7 9.10324L7 23.0129C7 24.1058 7.85 25 8.88889 25L15.5 25L15.5 23.0129Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M18.6961 12.4912L21.1328 15.0645L12 15.0645L12 17.0516L21.1328 17.0516L18.6961 19.6249L20.0278 21.0258L24.75 16.0581L20.0278 11.0903L18.6961 12.4912Z"
}));
const HeadingIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12 5.33334V9.33334H18.6667V25.3333H22.6667V9.33334H29.3333V5.33334H12ZM4 16H8V25.3333H12V16H16V12H4V16Z"
}));
const ItalicIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M13.3333 5.33334V9.33334H16.28L11.72 20H8V24H18.6667V20H15.72L20.28 9.33334H24V5.33334H13.3333Z"
}));
const MediaIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M26 20V8C26 6.9 25.1 6 24 6H12C10.9 6 10 6.9 10 8V20C10 21.1 10.9 22 12 22H24C25.1 22 26 21.1 26 20ZM15 16L17.03 18.71L20 15L24 20H12L15 16ZM6 10V24C6 25.1 6.9 26 8 26H22V24H8V10H6Z"
}));
const OrderedListIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2.66667 22.6667H5.33333V23.3333H4V24.6667H5.33333V25.3333H2.66667V26.6667H6.66667V21.3333H2.66667V22.6667ZM4 10.6667H5.33333V5.33334H2.66667V6.66667H4V10.6667ZM2.66667 14.6667H5.06667L2.66667 17.4667V18.6667H6.66667V17.3333H4.26667L6.66667 14.5333V13.3333H2.66667V14.6667ZM9.33333 6.66667V9.33334H28V6.66667H9.33333ZM9.33333 25.3333H28V22.6667H9.33333V25.3333ZM9.33333 17.3333H28V14.6667H9.33333V17.3333Z"
}));
const SettingsIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M24.7021 13.8628L24.0959 12.4533C24.0959 12.4533 25.5063 9.34049 25.3804 9.22033L23.5152 7.43748C23.3853 7.3142 20.2046 8.73502 20.2046 8.73502L18.7364 8.1553C18.7364 8.1553 17.4403 5 17.2622 5H14.629C14.4469 5 13.2457 8.16271 13.2457 8.16271L11.7807 8.74321C11.7807 8.74321 8.53338 7.393 8.40784 7.51277L6.54507 9.29875C6.41594 9.42125 7.89851 12.4724 7.89851 12.4724L7.29273 13.8788C7.29273 13.8788 4 15.1209 4 15.2883V17.8143C4 17.9903 7.3003 19.1415 7.3003 19.1415L7.90608 20.5467C7.90608 20.5467 6.49724 23.6572 6.62079 23.7765L8.48595 25.5641C8.61189 25.6854 11.795 24.265 11.795 24.265L13.264 24.847C13.264 24.847 14.5601 28 14.739 28H17.373C17.5551 28 18.7555 24.8373 18.7555 24.8373L20.2257 24.2552C20.2257 24.2552 23.467 25.607 23.5922 25.4888L25.4581 23.7028C25.5872 23.5788 24.1015 20.5292 24.1015 20.5292L24.7057 19.1228C24.7057 19.1228 28 17.8791 28 17.7094V15.1841C28.0008 15.0105 24.7021 13.8628 24.7021 13.8628ZM19.8479 16.4984C19.8479 18.5306 18.1222 20.1855 16.0012 20.1855C13.8818 20.1855 12.1537 18.5306 12.1537 16.4984C12.1537 14.4679 13.8818 12.8161 16.0012 12.8161C18.123 12.8169 19.8479 14.4679 19.8479 16.4984Z"
}));
const TableIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4 21h15.893c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2v-5h4v5H4zM14 7v5h-4V7h4zM8 7v5H4V7h4zm2 12v-5h4v5h-4zm6 0v-5h3.894v5H16zm3.893-7H16V7h3.893v5z"
}));
const TinaIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M18.6466 14.5553C19.9018 13.5141 20.458 7.36086 21.0014 5.14903C21.5447 2.9372 23.7919 3.04938 23.7919 3.04938C23.7919 3.04938 23.2085 4.06764 23.4464 4.82751C23.6844 5.58738 25.3145 6.26662 25.3145 6.26662L24.9629 7.19622C24.9629 7.19622 24.2288 7.10204 23.7919 7.9785C23.355 8.85496 24.3392 17.4442 24.3392 17.4442C24.3392 17.4442 21.4469 22.7275 21.4469 24.9206C21.4469 27.1136 22.4819 28.9515 22.4819 28.9515H21.0296C21.0296 28.9515 18.899 26.4086 18.462 25.1378C18.0251 23.8669 18.1998 22.596 18.1998 22.596C18.1998 22.596 15.8839 22.4646 13.8303 22.596C11.7767 22.7275 10.4072 24.498 10.16 25.4884C9.91287 26.4787 9.81048 28.9515 9.81048 28.9515H8.66211C7.96315 26.7882 7.40803 26.0129 7.70918 24.9206C8.54334 21.8949 8.37949 20.1788 8.18635 19.4145C7.99321 18.6501 6.68552 17.983 6.68552 17.983C7.32609 16.6741 7.97996 16.0452 10.7926 15.9796C13.6052 15.914 17.3915 15.5965 18.6466 14.5553Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M11.1268 24.7939C11.1268 24.7939 11.4236 27.5481 13.0001 28.9516H14.3511C13.0001 27.4166 12.8527 23.4155 12.8527 23.4155C12.1656 23.6399 11.3045 24.3846 11.1268 24.7939Z"
}));
const TrashIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9 4.2V6.9H25V8.7H7V6.9H15.1V4.2H16.9ZM7.77201 10.5H24.2279L22.4102 24.1332C22.2853 25.0698 21.4406 25.8 20.4977 25.8H11.5022C10.5561 25.8 9.71404 25.0653 9.58977 24.1332L7.77201 10.5ZM22.172 12.3H9.82791L11.3739 23.8953C11.3788 23.9318 11.4569 24 11.5022 24H20.4977C20.5432 24 20.6209 23.9328 20.6259 23.8953L22.172 12.3Z"
}));
const UnorderedListIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5.33333 14C4.22667 14 3.33333 14.8933 3.33333 16C3.33333 17.1067 4.22667 18 5.33333 18C6.44 18 7.33333 17.1067 7.33333 16C7.33333 14.8933 6.44 14 5.33333 14ZM5.33333 6C4.22667 6 3.33333 6.89333 3.33333 8C3.33333 9.10667 4.22667 10 5.33333 10C6.44 10 7.33333 9.10667 7.33333 8C7.33333 6.89333 6.44 6 5.33333 6ZM5.33333 22C4.22667 22 3.33333 22.9067 3.33333 24C3.33333 25.0933 4.24 26 5.33333 26C6.42667 26 7.33333 25.0933 7.33333 24C7.33333 22.9067 6.44 22 5.33333 22ZM9.33333 25.3333H28V22.6667H9.33333V25.3333ZM9.33333 17.3333H28V14.6667H9.33333V17.3333ZM9.33333 6.66667V9.33333H28V6.66667H9.33333Z"
}));
const UndoIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M16.6667 10.6667C13.1333 10.6667 9.93333 11.9867 7.46667 14.1333L2.66667 9.33334V21.3333H14.6667L9.84 16.5067C11.6933 14.96 14.0533 14 16.6667 14C21.3867 14 25.4 17.08 26.8 21.3333L29.96 20.2933C28.1067 14.7067 22.8667 10.6667 16.6667 10.6667Z"
}));
const RedoIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M24.5333 14.1333C22.0667 11.9867 18.8667 10.6667 15.3333 10.6667C9.13333 10.6667 3.89333 14.7067 2.05333 20.2933L5.2 21.3333C6.6 17.08 10.6 14 15.3333 14C17.9333 14 20.3067 14.96 22.16 16.5067L17.3333 21.3333H29.3333V9.33334L24.5333 14.1333Z"
}));
const ReorderIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3012 6.23952L11.0607 10.4801L10 9.41943L14.2406 5.17886C14.9213 4.49816 16.0233 4.48258 16.7196 5.17886L20.9602 9.41943L19.8995 10.4801L15.6589 6.23952C15.5561 6.13671 15.4039 6.13689 15.3012 6.23952Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6988 25.8732L19.9393 21.6326L21 22.6933L16.7594 26.9339C16.0787 27.6146 14.9767 27.6301 14.2804 26.9339L10.0398 22.6933L11.1005 21.6326L15.3411 25.8732C15.4439 25.976 15.5961 25.9758 15.6988 25.8732Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6569 27.1127V17.799L16.1569 17.799V27.1127L14.6569 27.1127Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6569 14.3137V5L16.1569 5V14.3137L14.6569 14.3137Z"
}));
const ReorderRowIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.7605 15.3012L21.5199 11.0607L22.5806 10L26.8211 14.2406C27.5018 14.9213 27.5174 16.0233 26.8211 16.7196L22.5806 20.9602L21.5199 19.8995L25.7605 15.6589C25.8633 15.5561 25.8631 15.4039 25.7605 15.3012Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.12679 15.6988L10.3674 19.9393L9.3067 21L5.06613 16.7594C4.38543 16.0787 4.36985 14.9767 5.06613 14.2804L9.3067 10.0398L10.3674 11.1005L6.12679 15.3411C6.02398 15.4439 6.02416 15.5961 6.12679 15.6988Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.88727 14.6569L14.201 14.6569L14.201 16.1569L4.88727 16.1569L4.88727 14.6569Z"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6863 14.6569L27 14.6569L27 16.1569L17.6863 16.1569L17.6863 14.6569Z"
}));
const UploadIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17.3 25.1V19.9H21.2L16 13.4L10.8 19.9H14.7V25.1H17.3Z"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.5 25.1H12.1V22.5H9.5C7.3498 22.5 5.6 20.7502 5.6 18.6C5.6 16.7748 7.1587 15.0172 9.0749 14.6805L9.8302 14.5479L10.0798 13.8225C10.9937 11.1562 13.2635 9.49996 16 9.49996C19.5841 9.49996 22.5 12.4159 22.5 16V17.3H23.8C25.2339 17.3 26.4 18.4661 26.4 19.9C26.4 21.3339 25.2339 22.5 23.8 22.5H19.9V25.1H23.8C26.6678 25.1 29 22.7678 29 19.9C28.998 18.7347 28.6056 17.6036 27.8855 16.6874C27.1654 15.7713 26.1591 15.1228 25.0272 14.8456C24.4591 10.371 20.628 6.89996 16 6.89996C12.4172 6.89996 9.305 8.99426 7.8841 12.295C5.0917 13.1296 3 15.766 3 18.6C3 22.1841 5.9159 25.1 9.5 25.1Z"
}));
const ResetIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12.625 13.3846H19.375C21.2358 13.3846 22.75 14.8342 22.75 16.6154C22.75 18.3966 21.2358 19.8462 19.375 19.8462H16V22H19.375C22.4766 22 25 19.5845 25 16.6154C25 13.6463 22.4766 11.2308 19.375 11.2308H12.625V8L7 12.3077L12.625 16.6154V13.3846Z",
  fill: "inherit"
}));
const LinkIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5.2 16C5.2 13.72 7.05333 11.8667 9.33333 11.8667H14.6667V9.33334H9.33333C5.65333 9.33334 2.66666 12.32 2.66666 16C2.66666 19.68 5.65333 22.6667 9.33333 22.6667H14.6667V20.1333H9.33333C7.05333 20.1333 5.2 18.28 5.2 16ZM10.6667 17.3333H21.3333V14.6667H10.6667V17.3333ZM22.6667 9.33334H17.3333V11.8667H22.6667C24.9467 11.8667 26.8 13.72 26.8 16C26.8 18.28 24.9467 20.1333 22.6667 20.1333H17.3333V22.6667H22.6667C26.3467 22.6667 29.3333 19.68 29.3333 16C29.3333 12.32 26.3467 9.33334 22.6667 9.33334Z"
}));
const LockIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M25 16.5C25 15.3419 23.9909 14.4 22.75 14.4H21.625V10.25C21.625 7.35515 19.1016 5 16 5C12.8984 5 10.375 7.35515 10.375 10.25V14.4H9.25C8.00912 14.4 7 15.3419 7 16.5V23.9C7 25.0581 8.00912 26 9.25 26H22.75C23.9909 26 25 25.0581 25 23.9V16.5ZM12.625 10.25C12.625 8.5133 14.1392 7.1 16 7.1C17.8608 7.1 19.375 8.5133 19.375 10.25V14.4H12.625V10.25Z",
  fill: "inherit"
}));
const QuoteIcon$1 = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8.00001 22.6667H12L14.6667 17.3333V9.33334H6.66667V17.3333H10.6667L8.00001 22.6667ZM18.6667 22.6667H22.6667L25.3333 17.3333V9.33334H17.3333V17.3333H21.3333L18.6667 22.6667Z"
}));
const UnderlineIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M16 22.6667C20.4133 22.6667 24 19.08 24 14.6667V4H20.6667V14.6667C20.6667 17.24 18.5733 19.3333 16 19.3333C13.4267 19.3333 11.3333 17.24 11.3333 14.6667V4H8.00001V14.6667C8.00001 19.08 11.5867 22.6667 16 22.6667ZM6.66667 25.3333V28H25.3333V25.3333H6.66667Z"
}));
const StrikethroughIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.578 26a14.1 14.1 0 01-4.535-.75A12.299 12.299 0 018 22.889l2.628-3.028a13.437 13.437 0 002.83 1.722c.982.426 2.051.64 3.206.64.924 0 1.637-.158 2.137-.473.52-.333.78-.787.78-1.361v-.056c0-.117-.01-.228-.03-.333H24c-.003.952-.186 1.804-.549 2.556a5.478 5.478 0 01-1.53 1.888c-.655.5-1.435.89-2.34 1.167-.905.26-1.906.389-3.003.389zm-3.993-9H29v-3H17.265a71.646 71.646 0 01-1.843-.5c-.558-.167-1-.343-1.328-.528-.327-.185-.558-.389-.693-.61a1.905 1.905 0 01-.174-.834v-.056c0-.481.212-.88.636-1.194.443-.334 1.097-.5 1.964-.5.866 0 1.733.176 2.599.528a14.16 14.16 0 012.657 1.388l2.31-3.222a11.94 11.94 0 00-3.436-1.833C18.724 6.213 17.367 6 15.884 6c-1.04 0-1.992.139-2.859.417-.866.277-1.617.676-2.252 1.194a5.537 5.537 0 00-1.444 1.861c-.347.704-.52 1.5-.52 2.39v.055c0 .804.107 1.498.322 2.083H4v3h8.585z"
}));
const MarkdownIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.0035 7H4.01374C2.91056 7 2 7.988 2 9.185V23.796C2 25.012 2.91056 26 4.01374 26H27.986C29.1067 26 29.9998 25.012 29.9998 23.815V9.185C30.0173 7.988 29.1067 7 28.0035 7ZM17.7597 22.2H14.2576V16.5L11.6309 20.148L9.00432 16.5V22.2H5.50216V10.8H9.00432L11.6309 14.6L14.2576 10.8H17.7597V22.2ZM22.9954 23.15L18.6352 16.5H21.2619V10.8H24.764V16.5H27.3906L22.9954 23.15Z"
}));
const AlertIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M16 29.3333C17.4666 29.3333 18.6666 28.1333 18.6666 26.6666H13.3333C13.3333 27.3739 13.6143 28.0522 14.1144 28.5523C14.6145 29.0524 15.2927 29.3333 16 29.3333ZM24 21.3333V14.6666C24 10.5733 21.8133 7.14665 18 6.23998V5.33331C18 4.22665 17.1066 3.33331 16 3.33331C14.8933 3.33331 14 4.22665 14 5.33331V6.23998C10.1733 7.14665 7.99998 10.56 7.99998 14.6666V21.3333L5.33331 24V25.3333H26.6666V24L24 21.3333Z",
  fill: "inherit"
}));
const InfoIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M16 2.66669C8.64802 2.66669 2.66669 8.64802 2.66669 16C2.66669 23.352 8.64802 29.3334 16 29.3334C23.352 29.3334 29.3334 23.352 29.3334 16C29.3334 8.64802 23.352 2.66669 16 2.66669ZM17.3334 22.6667H14.6667V14.6667H17.3334V22.6667ZM17.3334 12H14.6667V9.33335H17.3334V12Z",
  fill: "inherit"
}));
const WarningIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M31.2176 28.768L16.9664 2.1568C16.8686 1.98698 16.7278 1.84593 16.5581 1.74786C16.3884 1.64978 16.1959 1.59814 16 1.59814C15.804 1.59814 15.6115 1.64978 15.4419 1.74786C15.2722 1.84593 15.1314 1.98698 15.0336 2.1568L0.783977 28.768C0.688907 28.9338 0.639554 29.1219 0.640959 29.3131C0.642365 29.5042 0.694478 29.6916 0.791977 29.856C0.991977 30.1936 1.35518 30.4 1.74878 30.4H30.2512C30.4442 30.4003 30.6339 30.3503 30.8017 30.2549C30.9695 30.1595 31.1095 30.022 31.208 29.856C31.3054 29.6916 31.3576 29.5044 31.3593 29.3133C31.361 29.1222 31.3121 28.9341 31.2176 28.768V28.768ZM17.6 27.2H14.4V24H17.6V27.2ZM17.6 21.6H14.4V11.2H17.6V21.6Z",
  fill: "inherit"
}));
const ErrorIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M22.276 3.05736C22.1524 2.9333 22.0055 2.83491 21.8437 2.76787C21.6819 2.70082 21.5085 2.66643 21.3334 2.66669H10.6667C10.4916 2.66643 10.3181 2.70082 10.1563 2.76787C9.99455 2.83491 9.84763 2.9333 9.72402 3.05736L3.05736 9.72402C2.9333 9.84763 2.83491 9.99455 2.76787 10.1563C2.70082 10.3181 2.66643 10.4916 2.66669 10.6667V21.3334C2.66669 21.688 2.80669 22.0267 3.05736 22.276L9.72402 28.9427C9.84763 29.0667 9.99455 29.1651 10.1563 29.2322C10.3181 29.2992 10.4916 29.3336 10.6667 29.3334H21.3334C21.688 29.3334 22.0267 29.1934 22.276 28.9427L28.9427 22.276C29.0667 22.1524 29.1651 22.0055 29.2322 21.8437C29.2992 21.6819 29.3336 21.5085 29.3334 21.3334V10.6667C29.3336 10.4916 29.2992 10.3181 29.2322 10.1563C29.1651 9.99455 29.0667 9.84763 28.9427 9.72402L22.276 3.05736ZM17.3334 22.6667H14.6667V20H17.3334V22.6667ZM17.3334 17.3334H14.6667V9.33336H17.3334V17.3334Z",
  fill: "inherit"
}));
const PullRequestIcon = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 32 32",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M22.6328 19.163V11.997C22.6281 10.391 21.613 8 18.8359 8V6L15.0484 9L18.8359 12V10C20.5677 10 20.7306 11.539 20.7391 12V19.163C19.3756 19.597 18.3719 20.92 18.3719 22.5C18.3719 24.43 19.8585 26 21.686 26C23.5134 26 25 24.43 25 22.5C25 20.92 23.9963 19.597 22.6328 19.163ZM21.686 24C20.9029 24 20.2656 23.327 20.2656 22.5C20.2656 21.673 20.9029 21 21.686 21C22.469 21 23.1063 21.673 23.1063 22.5C23.1063 23.327 22.469 24 21.686 24ZM13.6281 9.5C13.6281 7.57 12.1415 6 10.314 6C8.48659 6 7 7.57 7 9.5C7 11.08 8.00368 12.403 9.36718 12.837V19.163C8.00368 19.597 7 20.92 7 22.5C7 24.43 8.48659 26 10.314 26C12.1415 26 13.6281 24.43 13.6281 22.5C13.6281 20.92 12.6244 19.597 11.2609 19.163V12.837C12.6244 12.403 13.6281 11.08 13.6281 9.5ZM8.89374 9.5C8.89374 8.673 9.53098 8 10.314 8C11.0971 8 11.7344 8.673 11.7344 9.5C11.7344 10.327 11.0971 11 10.314 11C9.53098 11 8.89374 10.327 8.89374 9.5ZM11.7344 22.5C11.7344 23.327 11.0971 24 10.314 24C9.53098 24 8.89374 23.327 8.89374 22.5C8.89374 21.673 9.53098 21 10.314 21C11.0971 21 11.7344 21.673 11.7344 22.5Z"
}));
const Folder = ({ ...props }) => {
  return /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 20 20",
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M20,5h-8.586L9.707,3.293C9.52,3.105,9.265,3,9,3H4C2.897,3,2,3.897,2,5v14c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V7 C22,5.897,21.103,5,20,5z M4,19V7h7h1h8l0.002,12H4z"
  }));
};
const File = ({ ...props }) => {
  return /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 20 20",
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M19.903,8.586c-0.049-0.106-0.11-0.207-0.196-0.293l-6-6c-0.086-0.086-0.187-0.147-0.293-0.196 c-0.03-0.014-0.062-0.022-0.094-0.033c-0.084-0.028-0.17-0.046-0.259-0.051C13.04,2.011,13.021,2,13,2H6C4.897,2,4,2.897,4,4v16 c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2V9c0-0.021-0.011-0.04-0.013-0.062c-0.005-0.089-0.022-0.175-0.051-0.259 C19.926,8.647,19.917,8.616,19.903,8.586z M16.586,8H14V5.414L16.586,8z M6,20V4h6v5c0,0.553,0.447,1,1,1h5l0.002,10H6z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M8 12H16V14H8zM8 16H16V18H8zM8 8H10V10H8z"
  }));
};
const Circle = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  className: "bi bi-circle",
  viewBox: "0 0 16 16",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
}));
const CircleCheck = ({ ...props }) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  className: "bi bi-check-circle-fill",
  viewBox: "0 0 16 16",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
}));
const ModalHeader = ({ children, close }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "h-14 flex items-center justify-between px-5 border-b border-gray-200 m-0"
  }, /* @__PURE__ */ React.createElement(ModalTitle, null, children), close && /* @__PURE__ */ React.createElement("div", {
    onClick: close,
    className: "flex items-center fill-gray-400 cursor-pointer transition-colors duration-100 ease-out hover:fill-gray-700"
  }, /* @__PURE__ */ React.createElement(CloseIcon, {
    className: "w-6 h-auto"
  })));
};
const ModalTitle = ({ children }) => {
  return /* @__PURE__ */ React.createElement("h2", {
    className: "text-gray-600 font-sans font-medium text-base leading-none m-0 block truncate"
  }, children);
};
const FullscreenModal = ({ className = "", style = {}, ...props }) => /* @__PURE__ */ React__default.createElement("div", {
  className: `flex flex-col z-0 overflow-visible bg-white rounded-none absolute top-0 left-0 w-full max-w-[1500px] h-full ${className} md:w-[calc(100%-170px)]`,
  style: {
    animation: "popup-right 150ms ease-out 1",
    ...style
  },
  ...props
});
const ModalFullscreen = FullscreenModal;
const PopupModal = ({ className = "", style = {}, ...props }) => /* @__PURE__ */ React__default.createElement("div", {
  className: `block z-0 overflow-visible bg-gray-50 rounded-[5px] my-10 mx-auto w-[460px] max-w-[90%] ${className}`,
  style: {
    animation: "popup-down 150ms ease-out 1",
    ...style
  },
  ...props
});
const ModalPopup = PopupModal;
const ERROR_MISSING_CMS = `useCMS could not find an instance of CMS`;
const CMSContext = React.createContext(null);
function useCMS$1() {
  const cms = React.useContext(CMSContext);
  if (!cms) {
    throw new Error(ERROR_MISSING_CMS);
  }
  const [, setEnabled] = React.useState(cms.enabled);
  React.useEffect(() => {
    return cms.events.subscribe("cms", () => {
      setEnabled(cms.enabled);
    });
  }, [cms]);
  return cms;
}
function useCMSEvent(event, callback, deps) {
  const cms = useCMS$1();
  React.useEffect(function() {
    return cms.events.subscribe(event, callback);
  }, deps);
}
const useEventSubscription = useCMSEvent;
function useEvent(eventType) {
  const cms = useCMS$1();
  return {
    dispatch: (event) => cms.events.dispatch({
      ...event,
      type: eventType
    }),
    subscribe: (callback) => cms.events.subscribe(eventType, callback)
  };
}
function wrapFieldsWithMeta(Field2) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(FieldMeta, {
      name: props.input.name,
      label: props.field.label,
      description: props.field.description,
      error: props.meta.error,
      index: props.index,
      tinaForm: props.tinaForm
    }, /* @__PURE__ */ React.createElement(Field2, {
      ...props
    }));
  };
}
const FieldMeta = ({
  name,
  label,
  description,
  error,
  margin = true,
  children,
  index,
  tinaForm,
  ...props
}) => {
  const { dispatch: setHoveredField } = useEvent("field:hover");
  const { dispatch: setFocusedField } = useEvent("field:focus");
  return /* @__PURE__ */ React.createElement(FieldWrapper, {
    margin,
    onMouseOver: () => setHoveredField({ id: tinaForm.id, fieldName: name }),
    onMouseOut: () => setHoveredField({ id: null, fieldName: null }),
    onClick: () => setFocusedField({ id: tinaForm.id, fieldName: name }),
    style: { zIndex: index ? 1e3 - index : void 0 },
    ...props
  }, /* @__PURE__ */ React.createElement(FieldLabel, {
    name
  }, label || name, description && /* @__PURE__ */ React.createElement(FieldDescription, null, description)), children, error && typeof error === "string" && /* @__PURE__ */ React.createElement(FieldError, null, error));
};
const FieldWrapper = ({
  margin,
  children,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative ${margin ? `mb-5 last:mb-0` : ``}`,
    ...props
  }, children);
};
const FieldLabel = ({
  children,
  className,
  name,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("label", {
    htmlFor: name,
    className: `block font-sans text-xs font-semibold text-gray-700 whitespace-normal mb-2 ${className}`,
    ...props
  }, children);
};
const FieldDescription = ({
  children,
  className,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: `block font-sans text-xs italic font-light text-gray-400 pt-0.5 whitespace-normal m-0 ${className}`,
    ...props
  }, children);
};
const FieldError = ({
  children,
  className,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: `block font-sans text-xs font-normal text-red-500 pt-2 whitespace-normal m-0 ${className}`,
    ...props
  }, children);
};
function classNames$1(...classes) {
  return classes.filter(Boolean).join(" ");
}
const uuid = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
function ChevronDownIcon(props, svgRef) {
  return /* @__PURE__ */ React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = React.forwardRef(ChevronDownIcon);
var ChevronDownIcon$1 = ForwardRef;
const Autocomplete = ({
  value,
  onChange,
  defaultQuery,
  items
}) => {
  const [query, setQuery] = React__default.useState(defaultQuery != null ? defaultQuery : "");
  const filteredItems = React__default.useMemo(() => {
    try {
      const reFilter = new RegExp(query, "i");
      const _items = items.filter((item) => reFilter.test(item.label));
      if (_items.length === 0)
        return items;
      return _items;
    } catch (err) {
      return items;
    }
  }, [items, query]);
  return /* @__PURE__ */ React__default.createElement(Combobox, {
    value,
    onChange,
    as: "div",
    className: "relative inline-block text-left z-20"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "mt-1"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md sm:text-sm"
  }, /* @__PURE__ */ React__default.createElement(Combobox.Input, {
    className: "w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300",
    displayValue: (item) => {
      var _a;
      return (_a = item == null ? void 0 : item.label) != null ? _a : "Plain Text";
    },
    onChange: (event) => setQuery(event.target.value),
    onClick: (ev) => ev.stopPropagation()
  }), /* @__PURE__ */ React__default.createElement(Combobox.Button, {
    className: "absolute inset-y-0 right-0 flex items-center pr-2"
  }, /* @__PURE__ */ React__default.createElement(ChevronDownIcon$1, {
    className: "h-5 w-5 text-gray-400",
    "aria-hidden": "true"
  })))), /* @__PURE__ */ React__default.createElement(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /* @__PURE__ */ React__default.createElement(Combobox.Options, {
    className: "origin-top-right absolute right-0 mt-1 w-full max-h-[300px] overflow-y-auto rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
  }, filteredItems.map((item) => /* @__PURE__ */ React__default.createElement(Combobox.Option, {
    key: item.key,
    value: item
  }, ({ active }) => /* @__PURE__ */ React__default.createElement("button", {
    className: classNames$1(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "block px-4 py-2 text-xs w-full text-right")
  }, item.render(item)))))));
};
loader.config({
  paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.31.1/min/vs" }
});
let retryCount = 0;
const retryFocus = (ref) => {
  if (ref.current) {
    ref.current.focus();
  } else {
    if (retryCount < 30) {
      setTimeout(() => {
        retryCount = retryCount + 1;
        retryFocus(ref);
      }, 100);
    }
  }
};
const CodeBlock = ({
  attributes,
  editor,
  element,
  language: restrictLanguage,
  ...props
}) => {
  const [navigateAway, setNavigateAway] = React__default.useState(null);
  const monaco = useMonaco();
  const monacoEditorRef = React__default.useRef(null);
  const selected = useSelected();
  const [height, setHeight] = React__default.useState(28);
  React__default.useEffect(() => {
    if (selected && isCollapsed(editor.selection)) {
      retryFocus(monacoEditorRef);
    }
  }, [selected, monacoEditorRef.current]);
  const value = element.value || "";
  if (typeof value !== "string") {
    throw new Error(`Element must be of type string for code block`);
  }
  const language = restrictLanguage || element.lang;
  const id = React__default.useMemo(() => uuid(), []);
  const languages = React__default.useMemo(() => {
    const defaultLangSet = { "": "plain text" };
    if (!monaco)
      return defaultLangSet;
    return monaco.languages.getLanguages().reduce((ac, cv) => {
      if (cv.id === "plaintext")
        return ac;
      return { ...ac, [cv.id]: cv.id };
    }, defaultLangSet);
  }, [monaco]);
  React__default.useEffect(() => {
    if (monaco) {
      monaco.languages.typescript.typescriptDefaults.setEagerModelSync(true);
      monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: true,
        noSyntaxValidation: true
      });
    }
  }, [monaco]);
  const items = Object.entries(languages).map(([key, label]) => ({
    key,
    label,
    render: (item) => item.label
  }));
  const currentItem = React__default.useMemo(() => {
    var _a;
    return (_a = items.find((item) => item.key === language)) != null ? _a : {
      key: "",
      label: "Plain Text"
    };
  }, [items, language]);
  React__default.useEffect(() => {
    if (navigateAway) {
      setNavigateAway(null);
      switch (navigateAway) {
        case "remove":
          {
            focusEditor(editor);
            setNodes(editor, {
              type: "p",
              children: [{ text: "" }],
              lang: void 0,
              value: void 0
            }, {
              match: (n) => {
                if (isElement(n) && n.type === element.type) {
                  return true;
                }
              }
            });
          }
          break;
        case "insertNext":
          {
            insertNodes(editor, [
              {
                type: ELEMENT_DEFAULT,
                children: [{ text: "" }],
                lang: void 0,
                value: void 0
              }
            ], { select: true });
            focusEditor(editor);
          }
          break;
        case "up":
          {
            const path = findNodePath(editor, element);
            if (!path) {
              return;
            }
            const previousNodePath = getPointBefore(editor, path);
            if (!previousNodePath) {
              focusEditor(editor);
              insertNodes(editor, [
                {
                  type: ELEMENT_DEFAULT,
                  children: [{ text: "" }],
                  lang: void 0,
                  value: void 0
                }
              ], { at: path, select: true });
              return;
            }
            focusEditor(editor, previousNodePath);
          }
          break;
        case "down": {
          const path = findNodePath(editor, element);
          if (!path) {
            return;
          }
          const nextNodePath = getPointAfter(editor, path);
          if (!nextNodePath) {
            insertNodes(editor, [
              {
                type: ELEMENT_DEFAULT,
                children: [{ text: "" }],
                lang: void 0,
                value: void 0
              }
            ], { select: true });
            focusEditor(editor);
          } else {
            focusEditor(editor, nextNodePath);
          }
          break;
        }
      }
    }
  }, [navigateAway]);
  function handleEditorDidMount(monacoEditor, monaco2) {
    monacoEditorRef.current = monacoEditor;
    monacoEditor.onDidContentSizeChange(() => {
      setHeight(monacoEditor.getContentHeight());
      monacoEditor.layout();
    });
    monacoEditor.addCommand(monaco2.KeyMod.Shift | monaco2.KeyCode.Enter, () => {
      if (monacoEditor.hasTextFocus()) {
        setNavigateAway("insertNext");
      }
    });
    monacoEditor.onKeyDown((l) => {
      if (l.code === "ArrowUp") {
        const selection = monacoEditor.getSelection();
        if (selection.endLineNumber === 1 && selection.startLineNumber === 1) {
          setNavigateAway("up");
        }
      }
      if (l.code === "ArrowDown") {
        const selection = monacoEditor.getSelection();
        const totalLines = monacoEditor.getModel().getLineCount();
        if (selection.endLineNumber === totalLines && selection.startLineNumber === totalLines) {
          setNavigateAway("down");
        }
      }
      if (l.code === "Backspace") {
        const selection = monacoEditor.getSelection();
        if (selection.endColumn === 1 && selection.endLineNumber === 1 && selection.positionColumn === 1 && selection.positionLineNumber === 1 && selection.selectionStartColumn === 1 && selection.selectionStartLineNumber === 1 && selection.startColumn === 1 && selection.startLineNumber === 1) {
          setNavigateAway("remove");
        }
      }
    });
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    ...attributes,
    className: "relative mb-2 mt-0.5 rounded-lg shadow-md p-2 border-gray-200 border"
  }, /* @__PURE__ */ React__default.createElement("style", null, `.tina-tailwind .monaco-editor .editor-widget {
          display: none !important;
          visibility: hidden !important;
        }`), props.children, /* @__PURE__ */ React__default.createElement("div", {
    contentEditable: false
  }, !restrictLanguage && /* @__PURE__ */ React__default.createElement("div", {
    className: "flex justify-between pb-2"
  }, /* @__PURE__ */ React__default.createElement("div", null), /* @__PURE__ */ React__default.createElement(Autocomplete, {
    items,
    value: currentItem,
    defaultQuery: "plaintext",
    onChange: (item) => setNodes(editor, { lang: item.key })
  })), /* @__PURE__ */ React__default.createElement("div", {
    style: { height: `${height}px` }
  }, /* @__PURE__ */ React__default.createElement(MonacoEditor, {
    path: id,
    onMount: handleEditorDidMount,
    options: {
      scrollBeyondLastLine: false,
      tabSize: 2,
      disableLayerHinting: true,
      accessibilitySupport: "off",
      codeLens: false,
      wordWrap: "on",
      minimap: {
        enabled: false
      },
      fontSize: 14,
      lineHeight: 2,
      formatOnPaste: true,
      lineNumbers: "off",
      formatOnType: true,
      fixedOverflowWidgets: true,
      folding: false,
      renderLineHighlight: "none",
      scrollbar: {
        verticalScrollbarSize: 1,
        horizontalScrollbarSize: 1,
        alwaysConsumeMouseWheel: false
      }
    },
    language: String(language),
    value: String(element.value),
    onChange: (value2) => {
      setNodes(editor, { value: value2, lang: language });
    }
  }))));
};
const blockClasses = "mt-0.5";
const headerClasses = "font-normal";
const components = () => {
  return {
    [ELEMENT_H1]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h1", {
      className: classNames$1(headerClasses, blockClasses, className, "text-4xl font-medium mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_H2]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h2", {
      className: classNames$1(headerClasses, blockClasses, className, "text-3xl font-medium mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_H3]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h3", {
      className: classNames$1(headerClasses, blockClasses, className, "text-2xl font-semibold mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_H4]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h4", {
      className: classNames$1(headerClasses, blockClasses, className, "text-xl font-bold mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_H5]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h5", {
      className: classNames$1(headerClasses, blockClasses, className, "text-lg font-bold mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_H6]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("h6", {
      className: classNames$1(headerClasses, blockClasses, className, "text-base font-bold mb-4 last:mb-0 mt-6 first:mt-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_PARAGRAPH]: ({
      attributes,
      className,
      editor,
      element,
      ...props
    }) => /* @__PURE__ */ React__default.createElement("p", {
      className: classNames$1(blockClasses, className, `text-base font-normal mb-4 last:mb-0`),
      ...attributes,
      ...props
    }),
    [ELEMENT_BLOCKQUOTE]: ({
      className,
      attributes,
      editor,
      element,
      ...props
    }) => /* @__PURE__ */ React__default.createElement("blockquote", {
      className: classNames$1("not-italic mb-4 last:mb-0 border-l-3 border-gray-200 pl-3", blockClasses, className),
      ...attributes,
      ...props
    }),
    [ELEMENT_CODE_BLOCK]: (props) => /* @__PURE__ */ React__default.createElement(CodeBlock, {
      ...props
    }),
    html: ({ attributes, editor, element, children, className }) => {
      return /* @__PURE__ */ React__default.createElement("div", {
        ...attributes,
        className: classNames$1("font-mono text-sm bg-green-100 cursor-not-allowed mb-4", className)
      }, children, element.value);
    },
    html_inline: ({ attributes, editor, element, children, className }) => {
      return /* @__PURE__ */ React__default.createElement("span", {
        ...attributes,
        className: classNames$1("font-mono bg-green-100 cursor-not-allowed", className)
      }, children, element.value);
    },
    [ELEMENT_UL]: ({ attributes, editor, className, element, ...props }) => /* @__PURE__ */ React__default.createElement("ul", {
      className: classNames$1(blockClasses, className, "mb-4 pl-4 list-disc list-inside last:mb-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_OL]: ({ attributes, editor, className, element, ...props }) => /* @__PURE__ */ React__default.createElement("ol", {
      className: classNames$1(blockClasses, className, "mb-4 pl-4 list-decimal list-inside last:mb-0"),
      ...attributes,
      ...props
    }),
    [ELEMENT_LI]: ({ attributes, className, editor, element, ...props }) => /* @__PURE__ */ React__default.createElement("li", {
      className: classNames$1("p-0 mt-0 mb-0 list-outside", className),
      ...attributes,
      ...props
    }),
    [ELEMENT_LIC]: ({ attributes, editor, element, className, ...props }) => /* @__PURE__ */ React__default.createElement("span", {
      className: classNames$1(className, "w-full inline-block align-top mb-2"),
      ...attributes,
      ...props
    }),
    [ELEMENT_LINK]: ({
      attributes,
      editor,
      element,
      nodeProps,
      className,
      ...props
    }) => /* @__PURE__ */ React__default.createElement("a", {
      className: classNames$1(className, "text-blue-500 hover:text-blue-600 transition-color ease-out duration-150 underline"),
      ...attributes,
      ...props
    }),
    [MARK_CODE]: ({ editor, leaf, text, attributes, className, ...props }) => /* @__PURE__ */ React__default.createElement("code", {
      className: classNames$1("bg-gray-100 p-1 rounded-sm", className),
      ...attributes,
      ...props
    }),
    [MARK_ITALIC]: ({ editor, leaf, text, ...props }) => /* @__PURE__ */ React__default.createElement("em", {
      ...props.attributes,
      ...props
    }),
    [MARK_BOLD]: ({ editor, leaf, text, ...props }) => /* @__PURE__ */ React__default.createElement("strong", {
      ...props.attributes,
      ...props
    }),
    [ELEMENT_HR]: ({
      attributes,
      className,
      editor,
      element,
      children,
      ...props
    }) => {
      const selected = useSelected();
      return /* @__PURE__ */ React__default.createElement("div", {
        className: classNames$1(className, "cursor-pointer relative border bg-gray-200 my-4 first:mt-0 last:mb-0"),
        ...attributes,
        ...props
      }, children, selected && /* @__PURE__ */ React__default.createElement("span", {
        className: "absolute h-4 -top-2 inset-0 ring-2 ring-blue-100 ring-inset rounded-md z-10 pointer-events-none"
      }));
    }
  };
};
const RawMarkdown = () => {
  return /* @__PURE__ */ React__default.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    role: "img",
    className: "h-5 w-5",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null), /* @__PURE__ */ React__default.createElement("path", {
    d: "M22.27 19.385H1.73A1.73 1.73 0 010 17.655V6.345a1.73 1.73 0 011.73-1.73h20.54A1.73 1.73 0 0124 6.345v11.308a1.73 1.73 0 01-1.73 1.731zM5.769 15.923v-4.5l2.308 2.885 2.307-2.885v4.5h2.308V8.078h-2.308l-2.307 2.885-2.308-2.885H3.46v7.847zM21.232 12h-2.309V8.077h-2.307V12h-2.308l3.461 4.039z"
  }));
};
const iconEl = {
  heading: /* @__PURE__ */ React__default.createElement(HeadingIcon, null),
  link: /* @__PURE__ */ React__default.createElement(LinkIcon, null),
  quote: /* @__PURE__ */ React__default.createElement(QuoteIcon, null),
  image: /* @__PURE__ */ React__default.createElement(ImageIcon, null),
  ul: /* @__PURE__ */ React__default.createElement(UnorderedListIcon, null),
  ol: /* @__PURE__ */ React__default.createElement(OrderedListIcon, null),
  code: /* @__PURE__ */ React__default.createElement(CodeIcon, null),
  codeBlock: /* @__PURE__ */ React__default.createElement(CodeBlockIcon, null),
  bold: /* @__PURE__ */ React__default.createElement(BoldIcon, null),
  italic: /* @__PURE__ */ React__default.createElement(ItalicIcon, null),
  raw: /* @__PURE__ */ React__default.createElement(RawMarkdown, null)
};
const ToolbarIcon = ({ name }) => {
  return iconEl[name];
};
const EllipsisIcon = ({ title }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, title && /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only"
  }, title), /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-5 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /* @__PURE__ */ React__default.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
  })));
};
function UnorderedListIcon(props) {
  const title = props.title || "format list bulleted";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M7 5h14v2H7V5z",
    fill: "currentColor"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M4 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "currentColor"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M7 11h14v2H7v-2zm0 6h14v2H7v-2zm-3 2.5c.82 0 1.5-.68 1.5-1.5s-.67-1.5-1.5-1.5-1.5.68-1.5 1.5.68 1.5 1.5 1.5z",
    fill: "currentColor"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M4 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "currentColor"
  })));
}
function HeadingIcon(props) {
  const title = props.title || "format size";
  return /* @__PURE__ */ React__default.createElement("svg", {
    height: "24",
    width: "24",
    className: "h-5 w-5",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z",
    fill: "currentColor"
  })));
}
function OrderedListIcon(props) {
  const title = props.title || "format list numbered";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z",
    fill: "currentColor"
  })));
}
function QuoteIcon(props) {
  const title = props.title || "format quote";
  return /* @__PURE__ */ React__default.createElement("svg", {
    height: "24",
    className: "h-5 w-5",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M6 17h3l2-4V7H5v6h3l-2 4zm8 0h3l2-4V7h-6v6h3l-2 4z",
    fill: "currentColor"
  })));
}
function LinkIcon(props) {
  const title = props.title || "insert link";
  return /* @__PURE__ */ React__default.createElement("svg", {
    height: "24",
    className: "h-5 w-5",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z",
    fill: "currentColor"
  })));
}
function CodeIcon(props) {
  const title = props.title || "code";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z",
    fill: "currentColor"
  })));
}
function CodeBlockIcon(props) {
  const title = props.title || "code-block";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("path", {
    d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"
  }));
}
function ImageIcon(props) {
  const title = props.title || "image";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M19 5v14H5V5h14zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z",
    fill: "currentColor"
  })));
}
function BoldIcon(props) {
  const title = props.title || "format bold";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z",
    fill: "currentColor"
  })));
}
function ItalicIcon(props) {
  const title = props.title || "format italic";
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "h-5 w-5",
    height: "24",
    width: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("g", {
    fill: "none"
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z",
    fill: "currentColor"
  })));
}
function PlusIcon({ className = "" }) {
  return /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: `h-4 w-4 ${className}`,
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /* @__PURE__ */ React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
    clipRule: "evenodd"
  }));
}
class Form {
  constructor({
    id,
    label,
    fields,
    actions,
    buttons,
    global,
    reset,
    loadInitialValues,
    onChange,
    ...options
  }) {
    this.global = null;
    this.loading = false;
    this.subscribe = (cb, options2) => {
      return this.finalForm.subscribe(cb, options2);
    };
    this.handleSubmit = async (values, form, cb) => {
      try {
        const response = await this.onSubmit(values, form, cb);
        form.initialize(values);
        return response;
      } catch (error) {
        return { [FORM_ERROR]: error };
      }
    };
    this.submit = () => {
      return this.finalForm.submit();
    };
    const initialValues = options.initialValues || {};
    this.__type = options.__type || "form";
    this.id = id;
    this.label = label;
    this.global = global;
    this.fields = fields || [];
    this.onSubmit = options.onSubmit;
    this.finalForm = createForm$1({
      ...options,
      initialValues,
      onSubmit: this.handleSubmit,
      mutators: {
        ...arrayMutators,
        setFieldData,
        ...options.mutators
      }
    });
    this._reset = reset;
    this.actions = actions || [];
    this.buttons = buttons || {
      save: "Save",
      reset: "Reset"
    };
    this.updateFields(this.fields);
    if (loadInitialValues) {
      this.loading = true;
      loadInitialValues().then((initialValues2) => {
        this.updateInitialValues(initialValues2);
      }).finally(() => {
        this.loading = false;
      });
    }
    if (onChange) {
      let firstUpdate = true;
      this.subscribe((formState) => {
        if (firstUpdate) {
          firstUpdate = false;
        } else {
          onChange(formState);
        }
      }, { values: true, ...(options == null ? void 0 : options.extraSubscribeValues) || {} });
    }
  }
  get name() {
    return this.id;
  }
  get values() {
    if (this.loading) {
      return void 0;
    }
    return this.finalForm.getState().values || this.initialValues;
  }
  get initialValues() {
    return this.finalForm.getState().initialValues;
  }
  get pristine() {
    return this.finalForm.getState().pristine;
  }
  get dirty() {
    return this.finalForm.getState().dirty;
  }
  get submitting() {
    return this.finalForm.getState().submitting;
  }
  get valid() {
    return this.finalForm.getState().valid;
  }
  async reset() {
    if (this._reset) {
      await this._reset();
    }
    this.finalForm.reset();
  }
  updateFields(fields) {
    this.fields = fields;
  }
  change(name, value) {
    return this.finalForm.change(name, value);
  }
  get mutators() {
    return this.finalForm.mutators;
  }
  updateValues(values) {
    this.finalForm.batch(() => {
      const activePath = this.finalForm.getState().active;
      if (!activePath) {
        updateEverything(this.finalForm, values);
      } else {
        updateSelectively(this.finalForm, values);
      }
    });
  }
  updateInitialValues(initialValues) {
    this.finalForm.batch(() => {
      const values = this.values || {};
      this.finalForm.initialize(initialValues);
      const activePath = this.finalForm.getState().active;
      if (!activePath) {
        updateEverything(this.finalForm, values);
      } else {
        updateSelectively(this.finalForm, values);
      }
    });
  }
}
function updateEverything(form, values) {
  Object.entries(values).forEach(([path, value]) => {
    form.change(path, value);
  });
}
function updateSelectively(form, values, prefix) {
  const activePath = form.getState().active;
  Object.entries(values).forEach(([name, value]) => {
    const path = prefix ? `${prefix}.${name}` : name;
    if (typeof value === "object") {
      if (typeof activePath === "string" && activePath.startsWith(path)) {
        updateSelectively(form, value, path);
      } else {
        form.change(path, value);
      }
    } else if (path !== activePath) {
      form.change(path, value);
    }
  });
}
const usePlugin = usePlugins;
function usePlugins(plugins2) {
  const cms = useCMS$1();
  let pluginArray;
  if (Array.isArray(plugins2)) {
    pluginArray = plugins2;
  } else {
    pluginArray = [plugins2];
  }
  React.useEffect(() => {
    pluginArray.forEach((plugin) => {
      if (plugin) {
        cms.plugins.add(plugin);
      }
    });
    return () => {
      pluginArray.forEach((plugin) => {
        if (plugin) {
          cms.plugins.remove(plugin);
        }
      });
    };
  }, [cms.plugins, ...pluginArray]);
}
function useLocalForm(options, watch = {}) {
  const [values, form] = useForm(options, watch);
  usePlugins(form);
  return [values, form];
}
function useForm({ loadInitialValues, ...options }, watch = {}) {
  options.initialValues = options.initialValues || watch.values;
  const [, setValues] = React.useState(options.initialValues);
  const [form, setForm] = React.useState(() => {
    return createForm(options, (form2) => {
      setValues(form2.values);
    });
  });
  React.useEffect(function() {
    if (form.id === options.id)
      return;
    setForm(createForm(options, (form2) => {
      setValues(form2.values);
    }));
  }, [options.id]);
  const [formIsLoading, setFormIsLoading] = React.useState(() => loadInitialValues ? true : false);
  const loadFormData = React.useCallback(async () => {
    if (loadInitialValues) {
      setFormIsLoading(true);
      await loadInitialValues().then((values) => {
        form.updateInitialValues(values);
      }).finally(() => {
        setFormIsLoading(false);
      });
    }
  }, [form, setFormIsLoading]);
  React.useEffect(() => {
    loadFormData();
  }, [form, loadFormData]);
  useCMSEvent("unstable:reload-form-data", async () => {
    await loadFormData();
    await form.reset();
  }, [loadFormData, form]);
  useUpdateFormFields(form, watch.fields);
  useUpdateFormLabel(form, watch.label);
  useUpdateFormValues(form, watch.values);
  return [form ? form.values : options.initialValues, form, formIsLoading];
}
function createForm(options, handleChange) {
  const form = new Form(options);
  form.subscribe(handleChange, { values: true });
  return form;
}
function useUpdateFormFields(form, fields) {
  React.useEffect(() => {
    if (typeof fields === "undefined")
      return;
    form.updateFields(fields);
  }, [form, fields]);
}
function useUpdateFormLabel(form, label) {
  React.useEffect(() => {
    if (typeof label === "undefined")
      return;
    form.label = label;
  }, [form, label]);
}
function useUpdateFormValues(form, values) {
  React.useEffect(() => {
    if (typeof values === "undefined")
      return;
    form.updateValues(values);
  }, [form, values]);
}
function useSubscribable(subscribable, cb) {
  const [, s] = React.useState(0);
  React.useEffect(() => {
    return subscribable.subscribe(() => {
      s((x) => x + 1);
      if (cb)
        cb();
    });
  });
}
function useWatchFormValues(form, cb) {
  useEffect(() => {
    if (!form)
      return;
    let firstUpdate = true;
    return form.subscribe((formState) => {
      if (firstUpdate) {
        firstUpdate = false;
      } else {
        cb(formState);
      }
    }, { values: true });
  }, [cb, form]);
}
function withPlugins(Component, plugins2) {
  return (props) => {
    usePlugin(plugins2);
    return /* @__PURE__ */ React.createElement(Component, {
      ...props
    });
  };
}
const withPlugin = withPlugins;
function FieldsBuilder({
  form,
  fields,
  padding = false
}) {
  const cms = useCMS$1();
  const [fieldPlugins, setFieldPlugins] = React.useState([]);
  const updateFieldPlugins = React.useCallback(() => {
    const fieldPlugins2 = cms.plugins.getType("field").all();
    setFieldPlugins(fieldPlugins2);
  }, [setFieldPlugins]);
  React.useEffect(() => updateFieldPlugins(), []);
  useEventSubscription("plugin:add:field", () => updateFieldPlugins(), []);
  return /* @__PURE__ */ React.createElement(FieldsGroup, {
    padding
  }, fields.map((field, index) => /* @__PURE__ */ React.createElement(InnerField, {
    key: field.name,
    field,
    form,
    fieldPlugins,
    index
  })));
}
const InnerField = ({ field, form, fieldPlugins, index }) => {
  React.useEffect(() => {
    form.mutators.setFieldData(field.name, {
      tinaField: field
    });
  }, [form, field]);
  if (field.component === null)
    return null;
  const plugin = fieldPlugins.find((plugin2) => plugin2.name === field.component);
  let type;
  if (plugin && plugin.type) {
    type = plugin.type;
  }
  const parse2 = getProp("parse", field, plugin);
  const validate = getProp("validate", field, plugin);
  let format2 = field.format;
  if (!format2 && plugin && plugin.format) {
    format2 = plugin.format;
  }
  return /* @__PURE__ */ React.createElement(Field, {
    name: field.name,
    key: field.name,
    type,
    parse: parse2 ? (value, name) => parse2(value, name, field) : void 0,
    format: format2 ? (value, name) => format2(value, name, field) : void 0,
    validate: (value, values, meta) => {
      if (validate) {
        return validate(value, values, meta, field);
      }
    }
  }, (fieldProps) => {
    if (typeof field.component !== "string" && field.component !== null) {
      return /* @__PURE__ */ React.createElement(field.component, {
        ...fieldProps,
        form: form.finalForm,
        tinaForm: form,
        field
      });
    }
    if (plugin) {
      return /* @__PURE__ */ React.createElement(plugin.Component, {
        ...fieldProps,
        form: form.finalForm,
        tinaForm: form,
        field,
        index
      });
    }
    return /* @__PURE__ */ React.createElement("p", null, "Unrecognized field type");
  });
};
const FieldsGroup = ({
  padding,
  children
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative block w-full h-full whitespace-nowrap overflow-x-visible ${padding ? `pb-5` : ``}`
  }, children);
};
function getProp(name, field, plugin) {
  let prop = field[name];
  if (!prop && plugin && plugin[name]) {
    prop = plugin[name];
  }
  return prop;
}
const FF = Form$1;
const FormLegacy = ({ form, children }) => {
  const [i, setI] = React.useState(0);
  React.useEffect(() => {
    setI((i2) => i2 + 1);
  }, [form]);
  return /* @__PURE__ */ React.createElement(FF, {
    form: form.finalForm,
    key: `${i}: ${form.id}`
  }, children);
};
const EditingContext = React.createContext(false);
function TinaForm({ form, children }) {
  const [isEditing, setIsEditing] = useState(false);
  if (!form) {
    return /* @__PURE__ */ React.createElement(EditingContext.Provider, {
      value: isEditing
    }, children({ isEditing, setIsEditing }));
  }
  return /* @__PURE__ */ React.createElement(EditingContext.Provider, {
    value: isEditing
  }, /* @__PURE__ */ React.createElement(FormLegacy, {
    form
  }, () => {
    return children({ isEditing, setIsEditing });
  }));
}
function TinaField({
  Component,
  children,
  ...fieldProps
}) {
  const isEditing = useContext(EditingContext);
  if (!isEditing)
    return children || null;
  return /* @__PURE__ */ React.createElement(Field, {
    ...fieldProps
  }, ({ input, meta }) => {
    return /* @__PURE__ */ React.createElement(Component, {
      input,
      meta,
      ...fieldProps
    });
  });
}
TinaField.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  Component: PropTypes.any.isRequired,
  children: PropTypes.any
};
const Button = ({
  variant = "secondary",
  as: Tag2 = "button",
  size = "medium",
  busy,
  disabled,
  rounded = "full",
  children,
  className,
  ...props
}) => {
  const baseClasses = "icon-parent border-0 inline-flex items-center font-medium focus:outline-none focus:ring-2 focus:shadow-outline text-center inline-flex justify-center transition-all duration-150 ease-out ";
  const variantClasses = {
    primary: `shadow text-white bg-blue-500 hover:bg-blue-600 focus:ring-blue-500`,
    secondary: `shadow text-gray-500 hover:text-blue-500 bg-gray-50 hover:bg-white border border-gray-200`,
    white: `shadow text-gray-500 hover:text-blue-500 bg-white hover:bg-gray-50 border border-gray-200`,
    ghost: `text-gray-500 hover:text-blue-500 hover:shadow border border-transparent hover:border-gray-200 bg-transparent`,
    danger: `shadow text-white bg-red-500 hover:bg-red-600 focus:ring-red-500`
  };
  const state = busy ? `busy` : disabled ? `disabled` : `default`;
  const stateClasses = {
    disabled: `pointer-events-none	opacity-30 cursor-not-allowed`,
    busy: `pointer-events-none opacity-70 cursor-wait`,
    default: ``
  };
  const roundedClasses = {
    full: `rounded-full`,
    left: `rounded-l-full`,
    right: `rounded-r-full`
  };
  const sizeClasses = {
    small: `text-xs h-8 px-3`,
    medium: `text-sm h-10 px-4`,
    custom: ``
  };
  return /* @__PURE__ */ React.createElement(Tag2, {
    className: `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${stateClasses[state]} ${roundedClasses[rounded]} ${className}`,
    ...props
  }, children);
};
const IconButton = ({
  variant = "secondary",
  size = "medium",
  busy,
  disabled,
  children,
  className,
  ...props
}) => {
  const baseClasses = "icon-parent inline-flex items-center border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:shadow-outline text-center inline-flex justify-center transition-all duration-150 ease-out rounded-full ";
  const variantClasses = {
    primary: `shadow text-white bg-blue-500 hover:bg-blue-600 focus:ring-blue-500`,
    secondary: `shadow text-gray-500 hover:text-blue-500 bg-gray-50 hover:bg-white border border-gray-200`,
    white: `shadow text-gray-500 hover:text-blue-500 bg-white hover:bg-gray-50 border border-gray-200`,
    ghost: `text-gray-500 hover:text-blue-500 hover:shadow border border-transparent hover:border-gray-200 bg-transparent`
  };
  const state = busy ? `busy` : disabled ? `disabled` : `default`;
  const stateClasses = {
    disabled: `pointer-events-none	opacity-30 cursor-not-allowed`,
    busy: `pointer-events-none opacity-70 cursor-wait`,
    default: ``
  };
  const sizeClasses = {
    small: `h-7 w-7`,
    medium: `h-9 w-9`,
    custom: ``
  };
  return /* @__PURE__ */ React.createElement("button", {
    className: `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${stateClasses[state]} ${className}`,
    ...props
  }, children);
};
function FontLoader() {
  const [fontLoaded, setFontLoaded] = React.useState(false);
  const WebFontConfig = {
    google: {
      families: ["Inter:400,600"]
    },
    loading: () => {
      setFontLoaded(true);
    }
  };
  React.useEffect(() => {
    if (!fontLoaded) {
      import("webfontloader").then((WebFont) => {
        return WebFont.load(WebFontConfig);
      });
    }
  }, []);
  return null;
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const OverflowMenu$1 = ({ toolbarItems }) => {
  return /* @__PURE__ */ React__default.createElement(Popover$1, {
    as: "div",
    className: "relative block w-full"
  }, ({ open }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Popover$1.Button, {
    "data-test": "popoverRichTextButton",
    className: `cursor-pointer relative w-full justify-center inline-flex border items-center p-3 text-sm font-medium focus:outline-none pointer-events-auto ${open ? `text-blue-400` : `text-gray-300 hover:text-blue-500`}`,
    onMouseDown: (e) => {
      e.preventDefault();
    }
  }, /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-5 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /* @__PURE__ */ React__default.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
  }))), /* @__PURE__ */ React__default.createElement(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /* @__PURE__ */ React__default.createElement(Popover$1.Panel, {
    className: "absolute z-20 origin-top-right right-0"
  }, ({ close }) => /* @__PURE__ */ React__default.createElement("div", {
    className: "mt-0 -mr-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none py-1"
  }, toolbarItems.map((toolbarItem) => {
    return /* @__PURE__ */ React__default.createElement("span", {
      "data-test": `${toolbarItem.name}OverflowButton`,
      key: toolbarItem.name,
      onMouseDown: (event) => {
        event.preventDefault();
        close();
        toolbarItem.onMouseDown(event);
      },
      className: classNames(toolbarItem.active ? "bg-gray-50 text-blue-500" : "bg-white text-gray-600", "hover:bg-gray-50 hover:text-blue-500 cursor-pointer pointer-events-auto px-4 py-2 text-sm w-full flex items-center whitespace-nowrap")
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "mr-2 opacity-80"
    }, toolbarItem.Icon), " ", toolbarItem.label);
  }))))));
};
var keyframes$1 = "@keyframes loading-dots-scale-up-and-down {\n  0% {\n    transform: scale(0.1);\n  }\n\n  50% {\n    transform: scale(1);\n  }\n\n  90% {\n    transform: scale(0.1);\n  }\n\n  100% {\n    transform: scale(0.1);\n  }\n}\n";
const LoadingDots = ({
  dotSize = 8,
  color = "white"
}) => {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("style", null, keyframes$1), /* @__PURE__ */ React.createElement(SingleDot, {
    dotSize,
    color
  }), /* @__PURE__ */ React.createElement(SingleDot, {
    dotSize,
    color,
    delay: 0.3
  }), /* @__PURE__ */ React.createElement(SingleDot, {
    dotSize,
    color,
    delay: 0.5
  }));
};
const SingleDot = ({ delay = 0, color, dotSize }) => /* @__PURE__ */ React.createElement("span", {
  className: "inline-block mr-1",
  style: {
    animation: "loading-dots-scale-up-and-down 2s linear infinite",
    animationDelay: `${delay}s`,
    background: color,
    width: dotSize,
    height: dotSize,
    borderRadius: dotSize
  }
});
const FormPortalContext = React.createContext(() => {
  return null;
});
function useFormPortal() {
  return useContext(FormPortalContext);
}
const FormPortalProvider = ({ children }) => {
  const wrapperRef = React.useRef(null);
  const zIndexRef = React.useRef(0);
  const FormPortal = React.useCallback((props) => {
    if (!wrapperRef.current)
      return null;
    return createPortal(props.children({ zIndexShift: zIndexRef.current += 1 }), wrapperRef.current);
  }, [wrapperRef, zIndexRef]);
  return /* @__PURE__ */ React.createElement(FormPortalContext.Provider, {
    value: FormPortal
  }, /* @__PURE__ */ React.createElement("div", {
    ref: wrapperRef,
    style: {
      position: "relative",
      width: "100%",
      flex: "1 1 0%",
      overflow: "hidden"
    }
  }, children));
};
const ResetForm = ({
  pristine,
  reset,
  children,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => {
      setOpen((p) => !p);
    },
    disabled: pristine,
    ...props
  }, children), open && /* @__PURE__ */ React.createElement(ResetModal, {
    reset,
    close: () => setOpen(false)
  }));
};
const ResetModal = ({ close, reset }) => {
  return /* @__PURE__ */ React.createElement(Modal, null, /* @__PURE__ */ React.createElement(ModalPopup, null, /* @__PURE__ */ React.createElement(ModalHeader, {
    close
  }, "Reset"), /* @__PURE__ */ React.createElement(ModalBody, {
    padded: true
  }, /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to reset all changes?")), /* @__PURE__ */ React.createElement(ModalActions, null, /* @__PURE__ */ React.createElement(Button, {
    style: { flexGrow: 2 },
    onClick: close
  }, "Cancel"), /* @__PURE__ */ React.createElement(Button, {
    style: { flexGrow: 3 },
    variant: "primary",
    onClick: async () => {
      await reset();
      close();
    }
  }, "Reset"))));
};
const Dismissible = ({
  onDismiss,
  escape,
  click,
  disabled,
  allowClickPropagation,
  document: document2,
  ...props
}) => {
  const area = useDismissible({
    onDismiss,
    escape,
    click,
    disabled,
    allowClickPropagation,
    document: document2
  });
  return /* @__PURE__ */ React.createElement("div", {
    ref: area,
    ...props
  });
};
function useDismissible({
  onDismiss,
  escape = false,
  click = false,
  disabled = false,
  allowClickPropagation = false,
  document: customDocument
}) {
  const area = useRef();
  useEffect(() => {
    const documents = customDocument ? [document, customDocument] : [document];
    const stopAndPrevent = (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
    };
    const handleDocumentClick = (event) => {
      if (disabled)
        return;
      if (!area.current.contains(event.target)) {
        console.log("did not click main content", event.target, area.current);
        if (!allowClickPropagation) {
          stopAndPrevent(event);
        }
        onDismiss(event);
      }
    };
    const handleEscape = (event) => {
      if (disabled)
        return;
      if (event.keyCode === 27) {
        event.stopPropagation();
        onDismiss(event);
      }
    };
    if (click) {
      documents.forEach((document2) => document2.body.addEventListener("click", handleDocumentClick));
    }
    if (escape) {
      documents.forEach((document2) => document2.addEventListener("keydown", handleEscape));
    }
    return () => {
      documents.forEach((document2) => {
        document2.body.removeEventListener("click", handleDocumentClick);
        document2.removeEventListener("keydown", handleEscape);
      });
    };
  }, [click, customDocument, escape, disabled, onDismiss]);
  return area;
}
const FormActionMenu = ({ actions, form }) => {
  const [actionMenuVisibility, setActionMenuVisibility] = useState(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsButton, {
    onClick: () => setActionMenuVisibility((p) => !p)
  }), /* @__PURE__ */ React.createElement(ActionsOverlay, {
    open: actionMenuVisibility
  }, /* @__PURE__ */ React.createElement(Dismissible, {
    click: true,
    escape: true,
    disabled: !actionMenuVisibility,
    onDismiss: () => {
      setActionMenuVisibility((p) => !p);
    }
  }, actions.map((Action, i) => /* @__PURE__ */ React.createElement(Action, {
    form,
    key: i
  })))));
};
const MoreActionsButton = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("button", {
  className: `h-16 w-10 self-stretch bg-transparent bg-center bg-[length:auto_18px] -mr-4 ml-2 outline-none cursor-pointer transition-opacity duration-100 ease-out flex justify-center items-center hover:bg-gray-50 hover:fill-gray-700 ${className}`,
  ...props
}, /* @__PURE__ */ React.createElement(EllipsisVerticalIcon, null));
const ActionsOverlay = ({ open, className = "", style = {}, ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: `min-w-[192px] rounded-3xl border border-solid border-[#efefef] block absolute bottom-5 right-5 ${open ? "opacity-100" : "opacity-0"} transition-all duration-100 ease-out origin-bottom-right shadow-[0_2px_3px_rgba(0,0,0,0.05)] bg-white overflow-hidden z-10 ${className}`,
  style: {
    transform: open ? "translate3d(0, -28px, 0) scale3d(1, 1, 1)" : "translate3d(0, 0, 0) scale3d(0.5, 0.5, 1)",
    pointerEvents: open ? "all" : "none",
    ...style
  },
  ...props
});
const ActionButton = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("button", {
  className: `relative text-center text-[13px] px-3 h-10 font-normal w-full bg-none cursor-pointer outline-none border-0 transition-all duration-[150ms] ease-out hover:text-blue-500 hover:bg-gray50 [&:not(:last-child)]: border-b-[1px] border-solid border-b-[#edecf3] ${className}`,
  ...props
});
const NoFieldsPlaceholder = () => /* @__PURE__ */ React.createElement("div", {
  className: "relative flex flex-col items-center justify-center text-center p-5 pb-16 w-full h-full overflow-y-auto",
  style: {
    animationName: "fade-in",
    animationDelay: "300ms",
    animationTimingFunction: "ease-out",
    animationIterationCount: 1,
    animationFillMode: "both",
    animationDuration: "150ms"
  }
}, /* @__PURE__ */ React.createElement(Emoji$1, {
  className: "block pb-5"
}, "\u{1F914}"), /* @__PURE__ */ React.createElement("h3", {
  className: "font-sans font-normal text-lg block pb-5"
}, "Hey, you don't have any fields added to this form."), /* @__PURE__ */ React.createElement("p", {
  className: "block pb-5"
}, /* @__PURE__ */ React.createElement("a", {
  className: "text-center rounded-3xl border border-solid border-gray-100 shadow-[0_2px_3px_rgba(0,0,0,0.12)] font-normal cursor-pointer text-[12px] transition-all duration-100 ease-out bg-white text-gray-700 py-3 pr-5 pl-14 relative no-underline inline-block hover:text-blue-500",
  href: "https://tinacms.org/docs/fields",
  target: "_blank"
}, /* @__PURE__ */ React.createElement(Emoji$1, {
  className: "absolute left-5 top-1/2 origin-center -translate-y-1/2 transition-all duration-100 ease-out",
  style: { fontSize: 24 }
}, "\u{1F4D6}"), " ", "Field Setup Guide")));
const FormBuilder = ({
  form: tinaForm,
  onPristineChange,
  ...rest
}) => {
  const hideFooter = !!rest.hideFooter;
  const [i, setI] = React.useState(0);
  React.useEffect(() => {
    setI((i2) => i2 + 1);
  }, [tinaForm]);
  const finalForm = tinaForm.finalForm;
  const moveArrayItem = React.useCallback((result) => {
    if (!result.destination || !finalForm)
      return;
    const name = result.type;
    finalForm.mutators.move(name, result.source.index, result.destination.index);
  }, [tinaForm]);
  React.useEffect(() => {
    const unsubscribe = finalForm.subscribe(({ pristine }) => {
      if (onPristineChange) {
        onPristineChange(pristine);
      }
    }, { pristine: true });
    return () => {
      unsubscribe();
    };
  }, [finalForm]);
  useOnChangeEventDispatch({ finalForm, tinaForm });
  return /* @__PURE__ */ React.createElement(Form$1, {
    form: finalForm,
    key: `${i}: ${tinaForm.id}`,
    onSubmit: tinaForm.onSubmit
  }, ({
    handleSubmit,
    pristine,
    invalid,
    submitting,
    dirtySinceLastSubmit,
    hasValidationErrors
  }) => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DragDropContext, {
      onDragEnd: moveArrayItem
    }, /* @__PURE__ */ React.createElement(FormPortalProvider, null, /* @__PURE__ */ React.createElement(FormWrapper$1, {
      id: tinaForm.id
    }, tinaForm && tinaForm.fields.length ? /* @__PURE__ */ React.createElement(FieldsBuilder, {
      form: tinaForm,
      fields: tinaForm.fields
    }) : /* @__PURE__ */ React.createElement(NoFieldsPlaceholder, null))), !hideFooter && /* @__PURE__ */ React.createElement("div", {
      className: "relative flex-none w-full h-16 px-6 bg-white border-t border-gray-100	flex items-center justify-center"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "flex-1 w-full flex justify-between gap-4 items-center max-w-form"
    }, tinaForm.reset && /* @__PURE__ */ React.createElement(ResetForm, {
      pristine,
      reset: async () => {
        finalForm.reset();
        await tinaForm.reset();
      },
      style: { flexGrow: 1 }
    }, tinaForm.buttons.reset), /* @__PURE__ */ React.createElement(Button, {
      onClick: () => handleSubmit(),
      disabled: pristine || submitting || hasValidationErrors || invalid && !dirtySinceLastSubmit,
      busy: submitting,
      variant: "primary",
      style: { flexGrow: 3 }
    }, submitting && /* @__PURE__ */ React.createElement(LoadingDots, null), !submitting && tinaForm.buttons.save), tinaForm.actions.length > 0 && /* @__PURE__ */ React.createElement(FormActionMenu, {
      form: tinaForm,
      actions: tinaForm.actions
    })))));
  });
};
const FullscreenFormBuilder = ({
  form: tinaForm,
  label
}) => {
  const [i, setI] = React.useState(0);
  React.useEffect(() => {
    setI((i2) => i2 + 1);
  }, [tinaForm]);
  const finalForm = tinaForm.finalForm;
  const moveArrayItem = React.useCallback((result) => {
    if (!result.destination || !finalForm)
      return;
    const name = result.type;
    finalForm.mutators.move(name, result.source.index, result.destination.index);
  }, [tinaForm]);
  return /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(Form$1, {
    form: finalForm,
    key: `${i}: ${tinaForm.id}`,
    onSubmit: tinaForm.onSubmit
  }, ({ handleSubmit, pristine, invalid, submitting }) => {
    return /* @__PURE__ */ React.createElement(DragDropContext, {
      onDragEnd: moveArrayItem
    }, /* @__PURE__ */ React.createElement("div", {
      className: "w-full h-screen flex flex-col items-center"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "px-6 py-4 w-full bg-white border-b border-gray-150 shadow-sm sticky flex flex-wrap gap-x-6 gap-y-3 justify-between items-center"
    }, label && /* @__PURE__ */ React.createElement("h4", {
      className: "font-bold font-sans text-lg opacity-80"
    }, label), /* @__PURE__ */ React.createElement("div", {
      className: "flex flex-1 gap-4 items-center justify-end"
    }, /* @__PURE__ */ React.createElement(FormStatus, {
      pristine
    }), tinaForm.reset && /* @__PURE__ */ React.createElement(ResetForm, {
      pristine,
      reset: async () => {
        finalForm.reset();
        await tinaForm.reset();
      },
      style: { flexBasis: "7rem" }
    }, tinaForm.buttons.reset), /* @__PURE__ */ React.createElement(Button, {
      onClick: () => handleSubmit(),
      disabled: pristine || submitting || invalid,
      busy: submitting,
      variant: "primary",
      style: { flexBasis: "10rem" }
    }, submitting && /* @__PURE__ */ React.createElement(LoadingDots, null), !submitting && tinaForm.buttons.save), tinaForm.actions.length > 0 && /* @__PURE__ */ React.createElement(FormActionMenu, {
      form: tinaForm,
      actions: tinaForm.actions
    }))), /* @__PURE__ */ React.createElement(FormPortalProvider, null, /* @__PURE__ */ React.createElement(FormWrapper$1, {
      id: tinaForm.id
    }, tinaForm && tinaForm.fields.length ? /* @__PURE__ */ React.createElement(FieldsBuilder, {
      form: tinaForm,
      fields: tinaForm.fields
    }) : /* @__PURE__ */ React.createElement(NoFieldsPlaceholder, null)))));
  }));
};
const FormStatus = ({ pristine }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-0 items-center"
  }, !pristine && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "w-3 h-3 flex-0 rounded-full bg-yellow-400 border border-yellow-500 mr-2"
  }), " ", /* @__PURE__ */ React.createElement("p", {
    className: "text-gray-700 text-sm leading-tight whitespace-nowrap"
  }, "Unsaved Changes")), pristine && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: "w-3 h-3 flex-0 rounded-full bg-green-300 border border-green-400 mr-2"
  }), " ", /* @__PURE__ */ React.createElement("p", {
    className: "text-gray-500 text-sm leading-tight whitespace-nowrap"
  }, "No Changes")));
};
const FormWrapper$1 = ({ children, id }) => {
  return /* @__PURE__ */ React.createElement("div", {
    "data-test": `form:${id == null ? void 0 : id.replace(/\\/g, "/")}`,
    className: "h-full overflow-y-auto max-h-full bg-gray-50 pt-6 px-6 pb-2"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-full flex justify-center"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-full max-w-form"
  }, children)));
};
const useOnChangeEventDispatch = ({
  finalForm,
  tinaForm
}) => {
  const [formValues, setFormValues] = React.useState({});
  const [newUpdate, setNewUpdate] = React.useState(null);
  const { subscribe } = finalForm;
  React.useEffect(() => {
    subscribe(({ values }) => {
      setFormValues(values);
    }, { values: true });
  }, [subscribe, setFormValues]);
  const cms = useCMS$1();
  React.useEffect(() => {
    var _a;
    if ((newUpdate == null ? void 0 : newUpdate.name) === "reset") {
      cms.events.dispatch({
        type: `forms:reset`,
        value: null,
        mutationType: newUpdate.mutationType,
        formId: tinaForm.id
      });
      setNewUpdate(null);
    } else if (newUpdate == null ? void 0 : newUpdate.name) {
      const previousValue = (_a = newUpdate == null ? void 0 : newUpdate.field) == null ? void 0 : _a.value;
      const newValue = getIn(formValues, newUpdate == null ? void 0 : newUpdate.name);
      cms.events.dispatch({
        type: `forms:fields:onChange`,
        value: newValue,
        previousValue,
        mutationType: newUpdate.mutationType,
        formId: tinaForm.id,
        field: newUpdate.field
      });
      setNewUpdate(null);
    }
  }, [JSON.stringify(formValues), cms]);
  const { change, reset } = finalForm;
  const { insert, move, remove, ...moreMutators } = finalForm.mutators;
  const prepareNewUpdate = (name, mutationType) => {
    setNewUpdate({
      name,
      field: finalForm.getFieldState(name),
      mutationType
    });
  };
  React.useMemo(() => {
    finalForm.reset = (initialValues) => {
      prepareNewUpdate("reset", { type: "reset" });
      return reset(initialValues);
    };
    finalForm.change = (name, value) => {
      prepareNewUpdate(name.toString(), { type: "change" });
      return change(name, value);
    };
    finalForm.mutators = {
      insert: (...args) => {
        prepareNewUpdate(args[0], { type: "insert", at: args[1] });
        insert(...args);
      },
      move: (...args) => {
        prepareNewUpdate(args[0], {
          type: "move",
          from: args[1],
          to: args[2]
        });
        move(...args);
      },
      remove: (...args) => {
        prepareNewUpdate(args[0], { type: "remove", at: args[1] });
        remove(...args);
      },
      ...moreMutators
    };
  }, [JSON.stringify(formValues)]);
};
const Emoji$1 = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("span", {
  className: `text-[40px] leading-none inline-block ${className}`,
  ...props
});
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return React__default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React__default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React__default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
function BiChevronLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" } }] })(props);
}
function BiCloudUpload(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M13 19v-4h3l-4-5-4 5h3v4z" } }, { "tag": "path", "attr": { "d": "M7 19h2v-2H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-3v2h3c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5z" } }] })(props);
}
function BiEdit(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "m7 17.013 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583v4.43zM18.045 4.458l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58zM9 13.417l6.03-5.973 1.586 1.586-6.029 5.971L9 15.006v-1.589z" } }, { "tag": "path", "attr": { "d": "M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2z" } }] })(props);
}
function BiExit(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z" } }, { "tag": "path", "attr": { "d": "m11 16 5-4-5-4v3.001H3v2h8z" } }] })(props);
}
function BiGitRepoForked(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M5.559 8.855c.166 1.183.789 3.207 3.087 4.079C11 13.829 11 14.534 11 15v.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V15c0-.466 0-1.171 2.354-2.065 2.298-.872 2.921-2.896 3.087-4.079C19.912 8.441 21 7.102 21 5.5 21 3.57 19.43 2 17.5 2S14 3.57 14 5.5c0 1.552 1.022 2.855 2.424 3.313-.146.735-.565 1.791-1.778 2.252-1.192.452-2.053.953-2.646 1.536-.593-.583-1.453-1.084-2.646-1.536-1.213-.461-1.633-1.517-1.778-2.252C8.978 8.355 10 7.052 10 5.5 10 3.57 8.43 2 6.5 2S3 3.57 3 5.5c0 1.602 1.088 2.941 2.559 3.355zM17.5 4c.827 0 1.5.673 1.5 1.5S18.327 7 17.5 7 16 6.327 16 5.5 16.673 4 17.5 4zm-4 14.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5zM6.5 4C7.327 4 8 4.673 8 5.5S7.327 7 6.5 7 5 6.327 5 5.5 5.673 4 6.5 4z" } }] })(props);
}
function BiLeftArrowAlt(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z" } }] })(props);
}
function BiMenu(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" } }] })(props);
}
function BiPencil(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z" } }] })(props);
}
function BiPlus(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z" } }] })(props);
}
function BiRefresh(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M10 11H7.101l.001-.009a4.956 4.956 0 0 1 .752-1.787 5.054 5.054 0 0 1 2.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 0 1 2.018 0 4.978 4.978 0 0 1 2.525 1.361l1.416-1.412a7.036 7.036 0 0 0-2.224-1.501 6.921 6.921 0 0 0-1.315-.408 7.079 7.079 0 0 0-2.819 0 6.94 6.94 0 0 0-1.316.409 7.04 7.04 0 0 0-3.08 2.534 6.978 6.978 0 0 0-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 0 1-2.103 3.138 4.943 4.943 0 0 1-1.787.752 5.073 5.073 0 0 1-2.017 0 4.956 4.956 0 0 1-1.787-.752 5.072 5.072 0 0 1-.74-.61L7.05 16.95a7.032 7.032 0 0 0 2.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 0 0 2.818 0 7.031 7.031 0 0 0 4.395-2.945 6.974 6.974 0 0 0 1.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z" } }] })(props);
}
function BiRightArrowAlt(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" } }] })(props);
}
function BiSearch(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z" } }] })(props);
}
function IoMdClose(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" } }] })(props);
}
function IoMdSync(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M256 93.09V32l-80 81.454 80 81.456v-61.093c65.996 0 120 54.982 120 122.183 0 20.363-5 39.714-14.004 57.016L391 342.547c15.996-25.457 25-54.988 25-86.547 0-89.599-72.002-162.91-160-162.91zm0 285.094c-66.001 0-120-54.988-120-122.184 0-20.363 5-39.709 13.999-57.02L121 169.454C104.999 193.89 96 224.436 96 256c0 89.599 72.002 162.91 160 162.91V480l80-81.453-80-81.457v61.094z" } }] })(props);
}
const Group$1 = wrapFieldsWithMeta(({ tinaForm, field }) => {
  const cms = useCMS$1();
  const [isExpanded, setExpanded] = React.useState(false);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Header, {
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded((p) => !p);
    }
  }, field.label || field.name), /* @__PURE__ */ React.createElement(Panel$2, {
    isExpanded,
    setExpanded,
    field,
    tinaForm
  }));
});
const Panel$2 = function Panel2({
  setExpanded,
  isExpanded,
  tinaForm,
  field
}) {
  const cms = useCMS$1();
  const FormPortal = useFormPortal();
  const fields = React.useMemo(() => {
    return field.fields.map((subField) => ({
      ...subField,
      name: `${field.name}.${subField.name}`
    }));
  }, [field.fields, field.name]);
  return /* @__PURE__ */ React.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React.createElement(GroupPanel, {
    isExpanded,
    style: { zIndex: zIndexShift + 1e3 }
  }, /* @__PURE__ */ React.createElement(PanelHeader, {
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded(false);
    }
  }, field.label || field.name), /* @__PURE__ */ React.createElement(PanelBody, {
    id: tinaForm.id
  }, isExpanded ? /* @__PURE__ */ React.createElement(FieldsBuilder, {
    form: tinaForm,
    fields
  }) : null)));
};
const Header = ({ onClick, children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "pt-1 mb-5"
  }, /* @__PURE__ */ React.createElement("button", {
    onClick,
    className: "group px-4 py-3 bg-white hover:bg-gray-50 shadow focus:shadow-outline focus:border-blue-500 w-full border border-gray-100 hover:border-gray-200 text-gray-500 hover:text-blue-400 focus:text-blue-500 rounded-md flex justify-between items-center gap-2"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "text-left text-base font-medium overflow-hidden text-ellipsis whitespace-nowrap flex-1"
  }, children), " ", /* @__PURE__ */ React.createElement(BiPencil, {
    className: "h-6 w-auto transition-opacity duration-150 ease-out opacity-80 group-hover:opacity-90"
  })));
};
const PanelHeader = ({ onClick, children }) => {
  return /* @__PURE__ */ React.createElement("button", {
    className: `relative z-40 group text-left w-full bg-white hover:bg-gray-50 py-2 border-t border-b shadow-sm
       border-gray-100 px-6 -mt-px`,
    onClick,
    tabIndex: -1
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-between gap-3 text-xs tracking-wide font-medium text-gray-700 group-hover:text-blue-400 uppercase max-w-form mx-auto"
  }, children, /* @__PURE__ */ React.createElement(IoMdClose, {
    className: "h-auto w-5 inline-block opacity-70 -mt-0.5 -mx-0.5"
  })));
};
const PanelBody = ({ id, children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    style: {
      flex: "1 1 0%",
      width: "100%",
      overflowY: "auto",
      background: "var(--tina-color-grey-1)"
    }
  }, /* @__PURE__ */ React.createElement(FormWrapper$1, {
    id
  }, children));
};
const GroupPanel = ({
  isExpanded,
  className = "",
  style = {},
  ...props
}) => /* @__PURE__ */ React.createElement("div", {
  className: `absolute w-full top-0 bottom-0 left-0 flex flex-col justify-between overflow-hidden z-10 ${className}`,
  style: {
    pointerEvents: isExpanded ? "all" : "none",
    ...isExpanded ? {
      animationName: "fly-in-left",
      animationDuration: "150ms",
      animationDelay: "0",
      animationIterationCount: 1,
      animationTimingFunction: "ease-out",
      animationFillMode: "backwards"
    } : {
      transition: "transform 150ms ease-out",
      transform: "translate3d(100%, 0, 0)"
    },
    ...style
  },
  ...props
});
function GroupField(props) {
  return /* @__PURE__ */ React.createElement("div", null, "Subfield: ", props.field.label || props.field.name);
}
const GroupFieldPlugin = {
  name: "group",
  Component: Group$1
};
const NestedForm = (props) => {
  const FormPortal = useFormPortal();
  const id = React__default.useMemo(() => uuid(), [props.id]);
  const form = React__default.useMemo(() => {
    return new Form({
      ...props,
      id,
      onChange: ({ values }) => {
        props.onChange(values);
      },
      onSubmit: () => {
      }
    });
  }, [id]);
  return /* @__PURE__ */ React__default.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React__default.createElement(GroupPanel, {
    isExpanded: true,
    style: { zIndex: zIndexShift + 1e3 }
  }, /* @__PURE__ */ React__default.createElement(PanelHeader, {
    onClick: props.onClose
  }, props.label), /* @__PURE__ */ React__default.createElement(FormBuilder, {
    form,
    hideFooter: true
  })));
};
const handleCloseBase = (editor, element) => {
  const path = ReactEditor.findPath(editor, element);
  const editorEl = ReactEditor.toDOMNode(editor, editor);
  if (editorEl) {
    editorEl.focus();
    setTimeout(() => {
      Transforms.select(editor, path);
    }, 1);
  }
};
const handleRemoveBase = (editor, element) => {
  const path = ReactEditor.findPath(editor, element);
  Transforms.removeNodes(editor, {
    at: path
  });
};
const useHotkey = (key, callback) => {
  const selected = useSelected();
  React__default.useEffect(() => {
    const handleEnter = (e) => {
      if (selected) {
        if (isHotkey(key, e)) {
          e.preventDefault();
          callback();
        }
      }
    };
    document.addEventListener("keydown", handleEnter);
    return () => document.removeEventListener("keydown", handleEnter);
  }, [selected]);
};
const useEmbedHandles = (editor, element) => {
  const [isExpanded, setIsExpanded] = React__default.useState(false);
  const handleClose = () => {
    setIsExpanded(false);
    handleCloseBase(editor, element);
  };
  const handleSelect = (e) => {
    e.preventDefault();
    setIsExpanded(true);
  };
  const handleRemove = () => {
    handleRemoveBase(editor, element);
  };
  return { isExpanded, handleClose, handleRemove, handleSelect };
};
const EditorContext = React__default.createContext({
  rawMode: false,
  setRawMode: () => {
  },
  templates: []
});
const useEditorContext = () => {
  return React__default.useContext(EditorContext);
};
const useTemplates = () => {
  const { templates } = React__default.useContext(EditorContext);
  return templates;
};
const Wrapper$1 = ({ inline, children }) => {
  const Component = inline ? "span" : "div";
  return /* @__PURE__ */ React__default.createElement(Component, {
    contentEditable: false,
    style: { userSelect: "none" },
    className: "relative"
  }, children);
};
const InlineEmbed = ({
  attributes,
  children,
  element,
  onChange,
  editor
}) => {
  const selected = useSelected();
  const { handleClose, handleRemove, handleSelect, isExpanded } = useEmbedHandles(editor, element);
  useHotkey("enter", () => {
    insertNodes(editor, [{ type: ELEMENT_PARAGRAPH, children: [{ text: "" }] }]);
  });
  useHotkey("space", () => {
    insertNodes(editor, [{ text: " " }], {
      match: (n) => {
        if (Element.isElement(n) && n.type === ELEMENT_MDX_INLINE) {
          return true;
        }
      },
      select: true
    });
  });
  const templates = useTemplates();
  const activeTemplate = templates.find((template) => template.name === element.name);
  const formProps = {
    activeTemplate,
    element,
    editor,
    onChange,
    onClose: handleClose
  };
  if (!activeTemplate) {
    return null;
  }
  const label = getLabel(activeTemplate, formProps);
  return /* @__PURE__ */ React__default.createElement("span", {
    ...attributes
  }, children, /* @__PURE__ */ React__default.createElement(Wrapper$1, {
    inline: true
  }, /* @__PURE__ */ React__default.createElement("span", {
    style: { margin: "0 0.5px" },
    className: "relative inline-flex shadow-sm rounded-md leading-none"
  }, selected && /* @__PURE__ */ React__default.createElement("span", {
    className: "absolute inset-0 ring-2 ring-blue-100 ring-inset rounded-md z-10 pointer-events-none"
  }), /* @__PURE__ */ React__default.createElement("span", {
    style: { fontWeight: "inherit", maxWidth: "275px" },
    className: "truncate cursor-pointer relative inline-flex items-center justify-start px-2 py-0.5 rounded-l-md border border-gray-200 bg-white  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500",
    onMouseDown: handleSelect
  }, label), /* @__PURE__ */ React__default.createElement(DotMenu, {
    onOpen: handleSelect,
    onRemove: handleRemove
  })), isExpanded && /* @__PURE__ */ React__default.createElement(EmbedNestedForm, {
    ...formProps
  })));
};
const BlockEmbed = ({
  attributes,
  children,
  element,
  editor,
  onChange
}) => {
  const selected = useSelected();
  const { handleClose, handleRemove, handleSelect, isExpanded } = useEmbedHandles(editor, element);
  useHotkey("enter", () => {
    insertNodes(editor, [{ type: ELEMENT_PARAGRAPH, children: [{ text: "" }] }]);
  });
  const templates = useTemplates();
  const activeTemplate = templates.find((template) => template.name === element.name);
  const formProps = {
    activeTemplate,
    element,
    editor,
    onChange,
    onClose: handleClose
  };
  if (!activeTemplate) {
    return null;
  }
  const label = getLabel(activeTemplate, formProps);
  return /* @__PURE__ */ React__default.createElement("div", {
    ...attributes,
    className: "w-full my-2"
  }, children, /* @__PURE__ */ React__default.createElement(Wrapper$1, {
    inline: false
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "relative w-full inline-flex shadow-sm rounded-md"
  }, selected && /* @__PURE__ */ React__default.createElement("span", {
    className: "absolute inset-0 ring-2 ring-blue-100 ring-inset rounded-md z-10 pointer-events-none"
  }), /* @__PURE__ */ React__default.createElement("span", {
    onMouseDown: handleSelect,
    className: "truncate cursor-pointer w-full relative inline-flex items-center justify-start px-4 py-2 rounded-l-md border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
  }, label), /* @__PURE__ */ React__default.createElement(DotMenu, {
    onOpen: handleSelect,
    onRemove: handleRemove
  })), isExpanded && /* @__PURE__ */ React__default.createElement(EmbedNestedForm, {
    ...formProps
  })));
};
const getLabel = (activeTemplate, formProps) => {
  const titleField = activeTemplate.fields.find((field) => field.isTitle);
  let label = activeTemplate.label || activeTemplate.name;
  if (titleField) {
    const titleValue = formProps.element.props[titleField.name];
    if (titleValue) {
      label = `${label}: ${titleValue}`;
    }
  }
  return label;
};
const EmbedNestedForm = ({
  editor,
  element,
  activeTemplate,
  onClose,
  onChange
}) => {
  const path = ReactEditor.findPath(editor, element);
  const id = [...path, activeTemplate.name].join(".");
  return /* @__PURE__ */ React__default.createElement(NestedForm, {
    id,
    label: activeTemplate.label,
    fields: activeTemplate.fields,
    initialValues: element.props,
    onChange,
    onClose
  });
};
const DotMenu = ({ onOpen, onRemove }) => {
  return /* @__PURE__ */ React__default.createElement(Popover$1, {
    as: "span",
    className: "-ml-px relative block"
  }, /* @__PURE__ */ React__default.createElement(Popover$1.Button, {
    as: "span",
    className: "cursor-pointer h-full relative inline-flex items-center px-1 py-0.5 rounded-r-md border border-gray-200 bg-white text-gray-500 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
  }, /* @__PURE__ */ React__default.createElement(EllipsisIcon, {
    title: "Open options"
  })), /* @__PURE__ */ React__default.createElement(Transition, {
    as: React__default.Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /* @__PURE__ */ React__default.createElement(Popover$1.Panel, {
    className: "z-30 absolute origin-top-right right-0"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "mt-2 -mr-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "py-1"
  }, /* @__PURE__ */ React__default.createElement("span", {
    onClick: onOpen,
    className: classNames$1("cursor-pointer text-left w-full block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900")
  }, "Edit"), /* @__PURE__ */ React__default.createElement("button", {
    onMouseDown: (e) => {
      e.preventDefault();
      onRemove();
    },
    className: classNames$1("cursor-pointer text-left w-full block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900")
  }, "Remove"))))));
};
const createCodeBlockPlugin = createPluginFactory({
  key: "code_block",
  isElement: true,
  isVoid: true,
  isInline: false
});
const createHTMLBlockPlugin = createPluginFactory({
  key: "html",
  isElement: true,
  isVoid: true,
  isInline: false
});
const createHTMLInlinePlugin = createPluginFactory({
  key: "html_inline",
  isElement: true,
  isVoid: true,
  isInline: true
});
const textFieldClasses = "shadow-inner focus:shadow-outline focus:border-blue-500 focus:outline-none block text-base px-3 py-2 text-gray-600 w-full bg-white border border-gray-200 transition-all ease-out duration-150 focus:text-gray-900 rounded-md";
const disabledClasses = "opacity-50 pointer-events-none cursor-not-allowed";
const BaseTextField = ({ ...props }) => {
  return /* @__PURE__ */ React.createElement("input", {
    type: "text",
    className: `${textFieldClasses} ${(props == null ? void 0 : props.disabled) ? disabledClasses : ""}`,
    ...props
  });
};
const TextArea = ({ ...props }) => {
  return /* @__PURE__ */ React.createElement("textarea", {
    className: "shadow-inner text-base px-3 py-2 text-gray-600 resize-y focus:shadow-outline focus:border-blue-500 block w-full border-gray-200 focus:text-gray-900 rounded-md",
    ...props,
    style: { minHeight: "160px" }
  });
};
var ColorFormat = /* @__PURE__ */ ((ColorFormat2) => {
  ColorFormat2["Hex"] = "hex";
  ColorFormat2["RGB"] = "rgb";
  return ColorFormat2;
})(ColorFormat || {});
const rgbToHex = function(color) {
  return "#" + ((1 << 24) + (color.r << 16) + (color.g << 8) + color.b).toString(16).slice(1);
};
function ParseColorStr(color) {
  if (!color) {
    return null;
  }
  const colorDescriptor = get(color);
  if (!colorDescriptor)
    return null;
  const colorVals = colorDescriptor.value;
  return { r: colorVals[0], g: colorVals[1], b: colorVals[2], a: colorVals[3] };
}
const ColorFormatter = {
  ["rgb"]: {
    getLabel(color) {
      return `R${color.r} G${color.g} B${color.b}`;
    },
    getValue(color) {
      const colorVals = [color.r, color.g, color.b, color.a];
      return to.rgb(colorVals);
    },
    parse: ParseColorStr
  },
  ["hex"]: {
    getLabel(color) {
      return rgbToHex(color);
    },
    getValue(color) {
      const colorVals = [color.r, color.g, color.b, color.a];
      return to.hex(colorVals);
    },
    parse: ParseColorStr
  }
};
var keyframes = "@keyframes color-popup-keyframes {\n  0% {\n    transform: translate3d(-50%, 0, 0) scale3d(0.5, 0.5, 1);\n  }\n  100% {\n    transform: translate3d(-50%, 8px, 0) scale3d(1, 1, 1);\n  }\n}\n\n@keyframes color-popup-open-top-keyframes {\n  0% {\n    transform: translate3d(-50%, -100%, 0) scale3d(0.5, 0.5, 1);\n  }\n  100% {\n    transform: translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1);\n  }\n}\n\n.color-picker-clip-path::before,\n.color-picker-clip-path::after {\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n}\n\n.color-picker-on-top-clip-path::before,\n.color-picker-on-top-clip-path::after {\n  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);\n}\n";
const GetTextColorForBackground = function(backgroundColor) {
  return !backgroundColor || backgroundColor.r * 0.299 + backgroundColor.g * 0.587 + backgroundColor.b * 0.114 > 186 ? "#000000" : "#ffffff";
};
const Swatch = ({
  colorRGBA,
  colorFormat,
  unselectable,
  ...props
}) => /* @__PURE__ */ React.createElement("div", {
  className: "bg-gray-100 rounded-3xl shadow-[0_2px_3px_rgba(0,0,0,0.12)] cursor-pointer w-full m-0",
  ...props
}, /* @__PURE__ */ React.createElement("div", {
  className: "swatch-inner flex items-center justify-center text-[13px] font-bold w-full h-10 rounded-3xl hover:opacity-[.6]",
  style: {
    background: colorRGBA ? `rgba(${colorRGBA.r}, ${colorRGBA.g}, ${colorRGBA.b}, ${colorRGBA.a})` : `#fff`,
    color: GetTextColorForBackground(colorRGBA),
    transition: "all var(--tina-timing-short) ease-out"
  }
}, !colorRGBA ? "Click to add color" : ColorFormatter[colorFormat].getLabel(colorRGBA)));
const Popover = ({
  triggerBoundingBox,
  openTop,
  className = "",
  style = {},
  ...props
}) => /* @__PURE__ */ React.createElement("div", {
  className: `fixed z-50 before:content-[""] before:absolute before:left-1/2 before:-translate-x-1/2 before:w-[18px] before:h-[14px] before:bg-gray-200 before:z-10 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:w-4 after:h-[13px] after:bg-white after:z-20 ${openTop ? "before:bottom-0 before:mt-[1px] before:translate-y-full color-picker-on-top-clip-path after:bottom-0 after:mb-0.5 after:translate-y-full" : "before:top-0 before:mb-[1px] before:-translate-y-full color-picker-clip-path after:top-0 after:mt-0.5 after:-translate-y-full"} ${className}`,
  style: {
    top: triggerBoundingBox ? openTop ? triggerBoundingBox.top : triggerBoundingBox.bottom : 0,
    left: triggerBoundingBox ? triggerBoundingBox.left + triggerBoundingBox.width / 2 : 0,
    transform: openTop ? "translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1)" : "translate3d(-50%, 8px, 0) scale3d(1, 1, 1)",
    animation: `${openTop ? "color-popup-open-top-keyframes" : "color-popup-keyframes"} 85ms ease-out both 1`,
    transformOrigin: `50% ${openTop ? "100%" : "0"}`,
    ...style
  },
  ...props
});
const nullColor = "transparent";
const presetColors = [
  "#D0021B",
  "#F5A623",
  "#F8E71C",
  "#8B572A",
  "#7ED321",
  "#417505",
  "#BD10E0",
  "#9013FE",
  "#4A90E2",
  "#50E3C2",
  "#B8E986",
  "#000000",
  "#4A4A4A",
  "#9B9B9B",
  "#FFFFFF"
];
const SketchWidget = (props) => /* @__PURE__ */ React.createElement(SketchPicker, {
  presetColors: props.presetColors,
  color: props.color,
  onChange: props.onChange,
  disableAlpha: props.disableAlpha,
  width: props.width
});
const BlockWidget = (props) => /* @__PURE__ */ React.createElement(BlockPicker, {
  colors: props.presetColors,
  color: props.color,
  onChange: props.onChange,
  width: props.width
});
const WIDGETS = { sketch: SketchWidget, block: BlockWidget };
const ColorPicker = ({
  colorFormat,
  userColors = presetColors,
  widget = "sketch",
  input
}) => {
  const FormPortal = useFormPortal();
  const triggerRef = React.useRef(null);
  const [triggerBoundingBox, setTriggerBoundingBox] = useState(null);
  const [openTop, setOpenTop] = useState(false);
  const updateTriggerBoundingBox = () => {
    if (triggerRef.current) {
      setTriggerBoundingBox(triggerRef.current.getBoundingClientRect());
    }
  };
  React.useEffect(() => {
    if (triggerBoundingBox) {
      const triggerOffsetTop = triggerBoundingBox.top + triggerBoundingBox.height / 2;
      const windowHeight = window.innerHeight;
      if (triggerOffsetTop > windowHeight / 2) {
        setOpenTop(true);
      } else {
        setOpenTop(false);
      }
    }
  }, [triggerBoundingBox]);
  React.useEffect(() => {
    const delay = 100;
    let timeout = false;
    setTimeout(() => {
      updateTriggerBoundingBox();
    }, delay);
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(updateTriggerBoundingBox, delay);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [triggerRef.current]);
  const Widget = WIDGETS[widget];
  if (!Widget)
    throw new Error("You must specify a widget type.");
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const getColorFormat = (colorFormat || ColorFormat.Hex).toLowerCase();
  const getColorRGBA = input.value ? ColorFormatter[getColorFormat].parse(input.value) : null;
  const handleChange = (pickerColor) => {
    const color = pickerColor.hex === nullColor ? null : { ...pickerColor.rgb, a: 1 };
    input.onChange(color ? ColorFormatter[getColorFormat].getValue(color) : null);
  };
  const toggleColorPicker = (event) => {
    event.stopPropagation();
    const display = !displayColorPicker;
    setDisplayColorPicker(display);
    if (display) {
      updateTriggerBoundingBox();
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "relative",
    ref: triggerRef
  }, /* @__PURE__ */ React.createElement("style", null, keyframes), /* @__PURE__ */ React.createElement(Swatch, {
    onClick: toggleColorPicker,
    colorRGBA: getColorRGBA,
    colorFormat: getColorFormat
  }), displayColorPicker && /* @__PURE__ */ React.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React.createElement(Popover, {
    openTop,
    triggerBoundingBox,
    style: { zIndex: 5e3 + zIndexShift }
  }, /* @__PURE__ */ React.createElement(Dismissible, {
    click: true,
    escape: true,
    disabled: !displayColorPicker,
    onDismiss: toggleColorPicker
  }, /* @__PURE__ */ React.createElement(Widget, {
    presetColors: [...userColors, nullColor],
    color: getColorRGBA || { r: 0, g: 0, b: 0, a: 0 },
    onChange: handleChange,
    disableAlpha: true,
    width: "240px"
  })))));
};
const Toggle = ({
  input,
  field,
  name,
  disabled = false
}) => {
  const checked = !!(input.value || input.checked);
  let labels = null;
  if (field.toggleLabels) {
    const fieldLabels = typeof field.toggleLabels === "object" && "true" in field.toggleLabels && "false" in field.toggleLabels && field.toggleLabels;
    labels = {
      true: fieldLabels ? fieldLabels["true"] : "Yes",
      false: fieldLabels ? fieldLabels["false"] : "No"
    };
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center"
  }, labels && /* @__PURE__ */ React.createElement("span", {
    className: "text-gray-700"
  }, labels.false), /* @__PURE__ */ React.createElement("div", {
    className: "relative w-12 h-7",
    style: { margin: labels !== null ? "0 10px" : "0" }
  }, /* @__PURE__ */ React.createElement(ToggleInput, {
    id: name,
    type: "checkbox",
    ...input
  }), /* @__PURE__ */ React.createElement("label", {
    className: "bg-none p-0 outline-none w-12 h-7",
    style: {
      opacity: disabled ? 0.4 : 1,
      pointerEvents: disabled ? "none" : "inherit"
    },
    htmlFor: name,
    role: "switch"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "relative w-12 h-7 rounded-3xl bg-white pointer-events-none -ml-0.5"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "absolute rounded-3xl left-0.5 top-1/2 w-[22px] h-[22px]",
    style: {
      background: checked ? "var(--tina-color-primary)" : "var(--tina-color-grey-4)",
      border: `1px solid ${checked ? "var(--tina-color-primary-dark)" : "var(--tina-color-grey-5)"}`,
      transform: `translate3d(${checked ? "20px" : "0"}, -50%, 0)`,
      transition: "all 150ms ease-out",
      boxShadow: "var(--tina-shadow-big)"
    }
  })))), labels && /* @__PURE__ */ React.createElement("span", {
    className: "text-gray-700"
  }, labels.true));
};
const ToggleInput = ({ disabled, ...props }) => {
  return /* @__PURE__ */ React.createElement("input", {
    className: `absolute left-0 top-0 w-12 h-8 opacity-0 m-0 ${disabled ? `cursor-not-allowed pointer-events-none` : `cursor-pointer z-20`}`,
    ...props
  });
};
function MdKeyboardArrowDown(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" } }] })(props);
}
function MdArrowForward(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" } }] })(props);
}
function MdSyncProblem(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z" } }] })(props);
}
function MdOutlineSettings(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" } }] })(props);
}
function MdOutlineClear(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" } }] })(props);
}
function MdOutlineCloud(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6m0-2C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4z" } }] })(props);
}
function MdOutlinePhotoLibrary(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z" } }] })(props);
}
function MdOutlineArrowBackIos(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z", "opacity": ".87" } }, { "tag": "path", "attr": { "d": "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" } }] })(props);
}
const selectFieldClasses = "shadow appearance-none bg-white text-gray-600 block pl-3 pr-7 py-2 truncate w-full text-base cursor-pointer border border-gray-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md";
const Select = ({ input, field, options }) => {
  const selectOptions = options || field.options;
  return /* @__PURE__ */ React.createElement("div", {
    className: "relative group"
  }, /* @__PURE__ */ React.createElement("select", {
    id: input.name,
    value: input.value,
    onChange: input.onChange,
    className: selectFieldClasses,
    ...input
  }, selectOptions ? selectOptions.map(toProps).map(toComponent) : /* @__PURE__ */ React.createElement("option", null, input.value)), /* @__PURE__ */ React.createElement(MdKeyboardArrowDown, {
    className: "absolute top-1/2 right-3 w-6 h-auto -translate-y-1/2 text-gray-300 group-hover:text-blue-500 transition duration-150 ease-out pointer-events-none"
  }));
};
function toProps(option) {
  if (typeof option === "object")
    return option;
  return { value: option, label: option };
}
function toComponent(option) {
  return /* @__PURE__ */ React.createElement("option", {
    key: option.value,
    value: option.value
  }, option.label);
}
const RadioGroup = ({
  input,
  field,
  options
}) => {
  const [activeRadioRef, setActiveRadioRef] = React.useState(null);
  const radioOptions = options || field.options;
  const radioRefs = {};
  React.useEffect(() => {
    setActiveRadioRef(radioRefs[`radio_${input.value}`]);
  }, [input.value]);
  const toProps2 = (option) => {
    if (typeof option === "object")
      return option;
    return { value: option, label: option };
  };
  const toComponent2 = (option) => {
    const optionId = `field-${field.name}-option-${option.value}`;
    const checked = option.value === input.value;
    return /* @__PURE__ */ React.createElement("div", {
      className: field.variant === "button" ? "flex-1" : "",
      key: option.value,
      ref: (ref) => {
        radioRefs[`radio_${option.value}`] = ref;
      }
    }, /* @__PURE__ */ React.createElement("input", {
      className: "absolute w-0 h-0 opacity-0 cursor-pointer",
      type: "radio",
      id: optionId,
      name: input.name,
      value: option.value,
      onChange: (event) => {
        console.log(optionId, event);
        console.log(event.target);
        console.log(event.target.value);
        input.onChange(event.target.value);
      },
      checked
    }), /* @__PURE__ */ React.createElement(RadioOption, {
      htmlFor: optionId,
      checked,
      variant: field.variant
    }, /* @__PURE__ */ React.createElement(Label$1, {
      variant: field.variant
    }, option.label)));
  };
  return /* @__PURE__ */ React.createElement(RadioOptions, {
    id: input.name,
    direction: field.direction,
    variant: field.variant
  }, field.variant === "button" && /* @__PURE__ */ React.createElement(ActiveRadioIndicator, {
    width: activeRadioRef == null ? void 0 : activeRadioRef.offsetWidth,
    height: activeRadioRef == null ? void 0 : activeRadioRef.offsetHeight,
    left: activeRadioRef == null ? void 0 : activeRadioRef.offsetLeft,
    top: activeRadioRef == null ? void 0 : activeRadioRef.offsetTop,
    hasValue: !!input.value
  }), radioOptions ? radioOptions.map(toProps2).map(toComponent2) : input.value);
};
const Label$1 = ({ variant, ...props }) => /* @__PURE__ */ React.createElement("span", {
  className: variant === "button" ? "relative" : "",
  ...props
});
const ActiveRadioIndicator = ({
  hasValue,
  left,
  top,
  width,
  height,
  style = {},
  className = "",
  ...props
}) => /* @__PURE__ */ React.createElement("div", {
  className: `absolute transition-all duration-100 ease-out bg-blue-500 shadow-[0_2px_3px_rgba(0,0,0,0.12)] rounded-3xl h-[34px] pointer-events-none ${className}`,
  style: {
    backfaceVisibility: "hidden",
    width,
    height: height ? width : "",
    left,
    top,
    transform: `scale(${hasValue ? `1` : `0`})`,
    ...style
  },
  ...props
});
const RadioOptions = ({ direction, variant, className = "", ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: `flex pt-1 ${variant === "button" ? "min-h-[42px] bg-white rounded-3xl text-blue-500 padding-[3px] shadow-[0_0_0_0_#e1ddec] transition-all duration-100 ease-out gap-[3px] [&:not(:active)]:[&:not(:focus-within)]:hover:shadow-[0_0_0_2px_#e1ddec] focus-within:shadow-[0_0_0_2px_#0084ff] active:shadow-[0_0_0_2px_#0084ff]" : "gap-3 flex-wrap"} ${direction === "vertical" ? "flex-col" : ""} ${className}`,
  ...props
});
const RadioOption = ({ checked, variant, className = "", ...props }) => /* @__PURE__ */ React.createElement("label", {
  className: `flex items-center text-[13px] ${variant === "button" ? `flex-1 text-center rounded-3xl font-normal cursor-pointer h-[34px] px-3 transition-all duration-100 ease-out m-0 border-none justify-center ${checked ? "text-white" : "text-blue-500"} [&:not(:active)]:hover:bg-gray-50 active:bg-gray-100` : `before:content-[""] before:block before:w-4 before:h-4 before:mr-1 before:rounded-3xl before:bg-blue-500 ${checked ? "before:border before:border-solid before:border-blue-500" : "before:border-gray-100"} before:shadow-[0_0_0_0_#e1ddec,_inset_0_0_0_8px_white] before:transition-all before:duration-100 before:ease-out ${checked ? "before:shadow-[0_0_0_0_#0084ff,_inset_0_0_0_4px_white] [input:focus+&:before]:border [input:focus+&:before]:border-solid [input:focus+&:before]:border-gray-100 [input:focus+&:before]:shadow-[0_0_0_2px_#0084ff,_inset_0_0_0_4px_white]" : "[input:focus+&:before]:border [input:focus+&:before]:border-solid [input:focus+&:before]:border-gray-100 [input:focus+&:before]:shadow-[0_0_0_2px_#0084ff,_inset_0_0_0_8px_white] hover:before:shadow-[0_0_0_2px_#e1ddec,_inset_0_0_0_8px_white]"} ${className}`}`,
  ...props
});
const CheckboxGroup = ({
  input,
  field,
  options,
  disabled = false
}) => {
  const checkboxOptions = options || field.options;
  const toProps2 = (option) => {
    if (typeof option === "object")
      return option;
    return { value: option, label: option };
  };
  const toComponent2 = (option) => {
    const optionId = `field-${field.name}-option-${option.value}`;
    const checked = input.value ? input.value.includes(option.value) : false;
    return /* @__PURE__ */ React.createElement("div", {
      className: "flex-1",
      key: option.value
    }, /* @__PURE__ */ React.createElement("input", {
      className: "absolute w-0 h-0 opacity-0 cursor-pointer",
      type: "checkbox",
      name: input.name,
      id: optionId,
      value: option.value,
      checked,
      disabled,
      onChange: (event) => {
        if (event.target.checked === true) {
          input.onChange([...input.value, event.target.value]);
        } else {
          input.onChange([
            ...input.value.filter((v) => v !== event.target.value)
          ]);
        }
      }
    }), /* @__PURE__ */ React.createElement("label", {
      className: "flex items-center text-[13px] flex-grow rounded-3xl text-blue-500 font-normal cursor-pointer h-[34px] px-3 transition-all duration-100 ease-out m-0 border-0",
      htmlFor: optionId
    }, checked === true ? /* @__PURE__ */ React.createElement(CircleCheck, {
      className: "w-5 h-auto text-black mr-[5px]"
    }) : /* @__PURE__ */ React.createElement(Circle, {
      className: "w-5 h-auto text-black mr-[5px]"
    }), /* @__PURE__ */ React.createElement("span", {
      className: "relative"
    }, option.label)));
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col min-h-[42px] bg-white rounded-3xl shadow-none  text-blue-500 p-[3px] transition-all duration-100 ease-out gap-[3px] [&:not(:active)]:[&:not(:focus-within)]:hover:shadow-[0_0_0_2px_#e1ddec] focus-within:shadow-[0_0_0_2px_#0084ff] active:shadow-[0_0_0_2px_#0084ff]",
    id: input.name
  }, checkboxOptions == null ? void 0 : checkboxOptions.map(toProps2).map(toComponent2));
};
const Input = ({ ...props }) => {
  return /* @__PURE__ */ React.createElement("input", {
    className: textFieldClasses,
    ...props
  });
};
const NumberInput = ({
  onChange,
  value,
  step
}) => /* @__PURE__ */ React.createElement(Input, {
  type: "number",
  step,
  value,
  onChange
});
function useCMS() {
  return useCMS$1();
}
const StyledImage = ({ src }) => /* @__PURE__ */ React.createElement("img", {
  src,
  className: "max-w-full min-h-[100px] max-h-[400px] rounded-[5px] transition-opacity duration-100 ease-out m-0 block bg-gray-200 bg-auto bg-center bg-no-repeat",
  style: {
    backgroundImage: src && (src.includes("png") || src.includes("svg")) ? "none" : `url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E")`
  }
});
const ImageContainer = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: "w-fit relative overflow-hidden hover:opacity-60 " + className,
  ...props
});
const ImageUpload = ({
  onDrop,
  onClear,
  onClick,
  value,
  previewSrc,
  loading
}) => {
  const cms = useCMS();
  const { getRootProps, getInputProps } = useDropzone({
    accept: cms.media.accept || "image/*",
    onDrop,
    noClick: !!onClick
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: "rounded-[5px] flex-1 flex flex-col outline-none cursor-pointer",
    ...getRootProps(),
    onClick
  }, /* @__PURE__ */ React.createElement("input", {
    ...getInputProps()
  }), value ? /* @__PURE__ */ React.createElement(ImageContainer, null, loading ? /* @__PURE__ */ React.createElement(ImageLoadingIndicator, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledImage, {
    src: previewSrc
  }), onClear && /* @__PURE__ */ React.createElement(DeleteImageButton, {
    onClick: (e) => {
      e.stopPropagation();
      onClear();
    }
  }))) : /* @__PURE__ */ React.createElement(ImageContainer, {
    className: "w-full"
  }, loading ? /* @__PURE__ */ React.createElement(ImageLoadingIndicator, null) : /* @__PURE__ */ React.createElement("div", {
    className: "text-center rounded-[5px] bg-gray-100 text-gray-300 leading-[1.35] py-3 text-[15px] font-normal transition-all ease-out duration-100 hover:opacity-60"
  }, "Drag 'n' drop a file here,", /* @__PURE__ */ React.createElement("br", null), "or click to select a file")));
};
const DeleteImageButton = ({
  onClick
}) => {
  return /* @__PURE__ */ React.createElement(IconButton, {
    className: "absolute top-2 right-2 [&:not(:hover)]:fill-white",
    onClick
  }, /* @__PURE__ */ React.createElement(TrashIcon, {
    className: "w-5/6 h-auto"
  }));
};
const ImageLoadingIndicator = () => /* @__PURE__ */ React.createElement("div", {
  className: "p-4 w-full min-h-[96px] flex flex-col justify-center items-center"
}, /* @__PURE__ */ React.createElement(LoadingDots, null));
const useGetOptionSets = (cms, collections) => {
  const [optionSets, setOptionSets] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const fetchOptionSets = async () => {
      const optionSets2 = await Promise.all(collections.map(async (collection) => {
        try {
          const response = await cms.api.tina.request(`#graphql
            query ($collection: String!){
              collection(collection: $collection) {
                documents(first: -1) {
                  edges {
                    node {
                      ...on Node {
                        id,
                      }
                      ...on Document {
                        _internalSys: _sys {
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
            `, { variables: { collection } });
          return {
            collection,
            edges: response.collection.documents.edges
          };
        } catch (e) {
          return {
            collection,
            edges: []
          };
        }
      }));
      setOptionSets(optionSets2);
      setLoading(false);
    };
    if (cms && collections.length > 0) {
      fetchOptionSets();
    } else {
      setOptionSets([]);
    }
  }, [cms, collections]);
  return { optionSets, loading };
};
const ReferenceSelect = ({
  cms,
  input,
  field
}) => {
  const { optionSets, loading } = useGetOptionSets(cms, field.collections);
  if (loading === true) {
    return /* @__PURE__ */ React.createElement(LoadingDots, {
      color: "var(--tina-color-primary)"
    });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("select", {
    id: input.name,
    value: input.value,
    onChange: input.onChange,
    className: selectFieldClasses,
    ...input
  }, /* @__PURE__ */ React.createElement("option", {
    value: ""
  }, "Choose an option"), optionSets.length > 0 && optionSets.map(({ collection, edges }) => /* @__PURE__ */ React.createElement("optgroup", {
    key: `${collection}-group`,
    label: collection
  }, edges.map(({
    node: {
      id,
      _internalSys: { title }
    }
  }) => /* @__PURE__ */ React.createElement("option", {
    key: `${id}-option`,
    value: id
  }, title || id))))), /* @__PURE__ */ React.createElement(MdKeyboardArrowDown, {
    className: "absolute top-1/2 right-3 w-6 h-auto -translate-y-1/2 text-gray-300 group-hover:text-blue-500 transition duration-150 ease-out"
  }));
};
const useGetNode = (cms, id) => {
  const [document2, setDocument] = React.useState(void 0);
  React.useEffect(() => {
    const fetchNode = async () => {
      const response = await cms.api.tina.request(`#graphql
        query($id: String!) {
          node(id:$id) {
            ... on Document {
              _sys {
                collection {
                  name
                }
                breadcrumbs
              }
            }
          }
        }`, { variables: { id } });
      setDocument(response.node);
    };
    if (cms && id) {
      fetchNode();
    } else {
      setDocument(void 0);
    }
  }, [cms, id]);
  return document2;
};
const GetReference = ({ cms, id, children }) => {
  const document2 = useGetNode(cms, id);
  if (!document2) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children(document2));
};
const ReferenceLink = ({ cms, input }) => {
  const hasTinaAdmin = cms.flags.get("tina-admin") === false ? false : true;
  const tinaPreview = cms.flags.get("tina-preview") || false;
  if (!hasTinaAdmin) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(GetReference, {
    cms,
    id: input.value
  }, (document2) => /* @__PURE__ */ React.createElement("a", {
    href: `${tinaPreview ? `/${tinaPreview}/index.html#` : "/admin#"}/collections/${document2._sys.collection.name}/${document2._sys.breadcrumbs.join("/")}`,
    className: "text-gray-700 hover:text-blue-500 flex items-center uppercase text-sm mt-2 mb-2 leading-none"
  }, /* @__PURE__ */ React.createElement(BiEdit, {
    className: "h-5 w-auto opacity-80 mr-2"
  }), "Edit in CMS"));
};
const Reference = ({ input, field }) => {
  const cms = useCMS();
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "relative group"
  }, /* @__PURE__ */ React.createElement(ReferenceSelect, {
    cms,
    input,
    field
  })), /* @__PURE__ */ React.createElement(ReferenceLink, {
    cms,
    input
  }));
};
const Wrapper = ({ inline, children }) => {
  const Component = inline ? "span" : "div";
  return /* @__PURE__ */ React__default.createElement(Component, {
    contentEditable: false,
    style: { userSelect: "none" },
    className: "relative"
  }, children);
};
const ImgEmbed = ({
  attributes,
  children,
  element,
  editor,
  onChange
}) => {
  const selected = useSelected();
  const { handleClose, handleRemove, handleSelect, isExpanded } = useEmbedHandles(editor, element);
  useHotkey("enter", () => {
    insertNodes(editor, [{ type: ELEMENT_PARAGRAPH, children: [{ text: "" }] }]);
  });
  return /* @__PURE__ */ React__default.createElement("div", {
    ...attributes,
    className: "w-full mb-2"
  }, children, /* @__PURE__ */ React__default.createElement(Wrapper, {
    inline: false
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "relative w-full inline-flex shadow-sm rounded-md"
  }, selected && /* @__PURE__ */ React__default.createElement("span", {
    className: "z-10 absolute inset-0 ring-2 ring-blue-100 ring-inset rounded-md pointer-events-none"
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "z-10"
  }, /* @__PURE__ */ React__default.createElement(DeleteImageButton, {
    onClick: (e) => {
      e.stopPropagation();
      handleRemove();
    }
  })), /* @__PURE__ */ React__default.createElement("span", {
    onMouseDown: handleSelect,
    style: { minHeight: "50px" },
    className: "cursor-pointer flex items-center justify-center rounded-md w-full relative bg-gray-100 overflow-hidden"
  }, element.url ? /* @__PURE__ */ React__default.createElement("img", {
    className: "my-0",
    src: element.url,
    title: element.caption,
    alt: element.alt
  }) : /* @__PURE__ */ React__default.createElement("span", {
    className: "absolute inset-0 flex items-center justify-center text-gray-300"
  }, /* @__PURE__ */ React__default.createElement("span", null, "Click to add an image")))), isExpanded && /* @__PURE__ */ React__default.createElement(ImageForm, {
    onChange,
    initialValues: element,
    onClose: handleClose,
    element
  })));
};
const ImageForm = (props) => {
  return /* @__PURE__ */ React__default.createElement(NestedForm, {
    id: "image-form",
    label: "Image",
    fields: [
      {
        label: "URL",
        name: "url",
        component: "image",
        clearable: true
      },
      { label: "Caption", name: "caption", component: "text" },
      { label: "Alt", name: "alt", component: "text" }
    ],
    initialValues: props.initialValues,
    onChange: props.onChange,
    onClose: props.onClose
  });
};
const ELEMENT_IMG = "img";
const createImgPlugin = createPluginFactory({
  key: ELEMENT_IMG,
  isVoid: true,
  isInline: false,
  isElement: true,
  component: (props) => {
    const handleChange = (values) => {
      const path = ReactEditor.findPath(props.editor, props.element);
      setNodes(props.editor, values, { at: path });
    };
    return /* @__PURE__ */ React__default.createElement(ImgEmbed, {
      ...props,
      onChange: handleChange
    });
  }
});
const insertImg = (editor) => {
  insertBlockElement(editor, {
    type: ELEMENT_IMG,
    children: [{ text: "" }],
    url: "",
    caption: "",
    alt: ""
  });
  normalizeEditor(editor, { force: true });
};
const onKeyDownSoftBreak = (editor, { options: { rules = [] } }) => (event) => {
  const entry = getBlockAbove(editor);
  if (!entry)
    return;
  rules.forEach(({ hotkey, query }) => {
    if (isHotkey(hotkey, event) && queryNode(entry, query)) {
      event.preventDefault();
      event.stopPropagation();
      insertNodes(editor, [
        { type: KEY_SOFT_BREAK, children: [{ text: "" }] },
        { type: "text", text: "" }
      ], { select: true });
    }
  });
};
const KEY_SOFT_BREAK = "break";
const createSoftBreakPlugin = createPluginFactory({
  key: KEY_SOFT_BREAK,
  isElement: true,
  isInline: true,
  isVoid: true,
  component: (props) => {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("br", {
      className: props.className,
      ...props.attributes
    }), props.children);
  },
  handlers: {
    onKeyDown: onKeyDownSoftBreak
  },
  options: {
    rules: [{ hotkey: "shift+enter" }]
  }
});
const preFormat = (editor) => unwrapList(editor);
const format$1 = (editor, customFormatting) => {
  if (editor.selection) {
    const parentEntry = getParentNode(editor, editor.selection);
    if (!parentEntry)
      return;
    const [node] = parentEntry;
    if (isElement(node) && !isType(editor, node, ELEMENT_CODE_BLOCK) && !isType(editor, node, ELEMENT_CODE_LINE)) {
      customFormatting();
    }
  }
};
const formatList = (editor, elementType) => {
  format$1(editor, () => toggleList(editor, {
    type: elementType
  }));
};
const insertEmptyCodeBlock = (editor) => {
  const matchCodeElements = (node2) => node2.type === getPluginType(editor, ELEMENT_CODE_BLOCK);
  if (someNode(editor, {
    match: matchCodeElements
  })) {
    return;
  }
  const node = {
    type: ELEMENT_CODE_BLOCK,
    value: "",
    lang: "javascript",
    children: [{ type: "text", text: "" }]
  };
  if (isSelectionAtBlockStart(editor)) {
    setElements(editor, node);
  } else {
    insertNode(editor, node);
  }
};
const autoformatBlocks = [
  {
    mode: "block",
    type: ELEMENT_H1,
    match: "# ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_H2,
    match: "## ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_H3,
    match: "### ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_H4,
    match: "#### ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_H5,
    match: "##### ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_H6,
    match: "###### ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_BLOCKQUOTE,
    match: "> ",
    preFormat
  },
  {
    mode: "block",
    type: ELEMENT_CODE_BLOCK,
    match: "```",
    triggerAtBlockStart: false,
    preFormat,
    format: (editor) => {
      insertEmptyCodeBlock(editor);
    }
  },
  {
    mode: "block",
    type: ELEMENT_HR,
    match: ["---", "\u2014-", "___ "],
    format: (editor) => {
      setNodes(editor, { type: ELEMENT_HR });
      insertNodes(editor, {
        type: ELEMENT_DEFAULT,
        children: [{ text: "" }]
      });
    }
  }
];
const autoformatLists = [
  {
    mode: "block",
    type: ELEMENT_LI,
    match: ["* ", "- "],
    preFormat,
    format: (editor) => formatList(editor, ELEMENT_UL)
  },
  {
    mode: "block",
    type: ELEMENT_LI,
    match: ["1. ", "1) "],
    preFormat,
    format: (editor) => formatList(editor, ELEMENT_OL)
  },
  {
    mode: "block",
    type: ELEMENT_TODO_LI,
    match: "[] "
  },
  {
    mode: "block",
    type: ELEMENT_TODO_LI,
    match: "[x] ",
    format: (editor) => setNodes(editor, { type: ELEMENT_TODO_LI, checked: true }, {
      match: (n) => isBlock(editor, n)
    })
  }
];
const autoformatMarks = [
  {
    mode: "mark",
    type: [MARK_BOLD, MARK_ITALIC],
    match: "***"
  },
  {
    mode: "mark",
    type: MARK_BOLD,
    match: "**"
  },
  {
    mode: "mark",
    type: MARK_ITALIC,
    match: "*"
  },
  {
    mode: "mark",
    type: MARK_ITALIC,
    match: "_"
  },
  {
    mode: "mark",
    type: MARK_CODE,
    match: "`"
  }
];
const autoformatRules = [
  ...autoformatBlocks,
  ...autoformatLists,
  ...autoformatMarks
];
const withCorrectVoidBehavior = (editor) => {
  const { deleteBackward, insertBreak } = editor;
  editor.insertBreak = () => {
    if (!editor.selection || !Range.isCollapsed(editor.selection)) {
      return insertBreak();
    }
    const selectedNodePath = Path.parent(editor.selection.anchor.path);
    const selectedNode = Node.get(editor, selectedNodePath);
    if (Editor.isVoid(editor, selectedNode)) {
      Editor.insertNode(editor, {
        type: "p",
        children: [{ text: "" }]
      });
      return;
    }
    insertBreak();
  };
  editor.deleteBackward = (unit) => {
    if (!editor.selection || !Range.isCollapsed(editor.selection) || editor.selection.anchor.offset !== 0) {
      return deleteBackward(unit);
    }
    const parentPath = Path.parent(editor.selection.anchor.path);
    const parentNode = Node.get(editor, parentPath);
    const parentIsEmpty = Node.string(parentNode).length === 0;
    if (parentIsEmpty && Path.hasPrevious(parentPath)) {
      const prevNodePath = Path.previous(parentPath);
      const prevNode = Node.get(editor, prevNodePath);
      if (Editor.isVoid(editor, prevNode)) {
        Transforms.removeNodes(editor);
        Editor.normalize(editor, { force: true });
        return;
      }
    }
    deleteBackward(unit);
  };
  return editor;
};
const HANDLES_MDX = [
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH
];
const resetBlockTypesCommonRule = {
  types: [
    ELEMENT_BLOCKQUOTE,
    ELEMENT_H1,
    ELEMENT_H2,
    ELEMENT_H3,
    ELEMENT_H3,
    ELEMENT_H4,
    ELEMENT_H5,
    ELEMENT_H6
  ],
  defaultType: ELEMENT_PARAGRAPH
};
const createCorrectNodeBehaviorPlugin = createPluginFactory({
  key: "WITH_CORRECT_NODE_BEHAVIOR",
  withOverrides: withCorrectVoidBehavior
});
const plugins$1 = [
  createTrailingBlockPlugin(),
  createCorrectNodeBehaviorPlugin(),
  createAutoformatPlugin({
    options: {
      rules: autoformatRules
    }
  }),
  createExitBreakPlugin({
    options: {
      rules: [
        {
          hotkey: "mod+enter"
        },
        {
          hotkey: "mod+shift+enter",
          before: true
        },
        {
          hotkey: "enter",
          query: {
            start: true,
            end: true,
            allow: KEYS_HEADING
          }
        }
      ]
    }
  }),
  createResetNodePlugin({
    options: {
      rules: [
        {
          ...resetBlockTypesCommonRule,
          hotkey: "Enter",
          predicate: isBlockAboveEmpty
        },
        {
          ...resetBlockTypesCommonRule,
          hotkey: "Backspace",
          predicate: isSelectionAtBlockStart
        }
      ]
    }
  }),
  createSoftBreakPlugin({
    options: {
      rules: [
        { hotkey: "shift+enter" },
        {
          hotkey: "enter",
          query: {
            allow: [ELEMENT_CODE_BLOCK, ELEMENT_BLOCKQUOTE]
          }
        }
      ]
    }
  })
];
const plugins = [
  createHeadingPlugin(),
  createParagraphPlugin(),
  createCodeBlockPlugin(),
  createHTMLBlockPlugin(),
  createHTMLInlinePlugin(),
  createBlockquotePlugin(),
  createBoldPlugin(),
  createItalicPlugin(),
  createUnderlinePlugin(),
  createCodePlugin(),
  createListPlugin(),
  createHorizontalRulePlugin(),
  createNodeIdPlugin()
];
const isNodeActive = (editor, type) => {
  const pluginType = getPluginType(editor, type);
  return !!(editor == null ? void 0 : editor.selection) && someNode(editor, { match: { type: pluginType } });
};
const isMarkActive = (editor, type) => {
  return !!(editor == null ? void 0 : editor.selection) && isMarkActive$1(editor, type);
};
const isListActive = (editor, type) => {
  const res = !!(editor == null ? void 0 : editor.selection) && getListItemEntry(editor);
  return !!res && res.list[0].type === type;
};
const normalize = (node) => {
  if ([ELEMENT_MDX_BLOCK, ELEMENT_MDX_INLINE, ELEMENT_IMG].includes(node.type)) {
    return {
      ...node,
      children: [{ type: "text", text: "" }]
    };
  }
  if (node.children) {
    if (node.children.length) {
      return {
        ...node,
        children: node.children.map(normalize)
      };
    } else {
      return {
        ...node,
        children: [{ text: "" }]
      };
    }
  }
  return node;
};
const insertInlineElement = (editor, inlineElement) => {
  insertNodes(editor, [inlineElement]);
  setTimeout(() => {
    Transforms.move(editor);
  }, 1);
};
const insertBlockElement = (editor, blockElement) => {
  const editorEl = ReactEditor.toDOMNode(editor, editor);
  if (editorEl) {
    editorEl.focus();
    setTimeout(() => {
      if (isCurrentBlockEmpty(editor)) {
        setNodes(editor, blockElement);
      } else {
        insertNodes(editor, [blockElement]);
      }
    }, 1);
  }
};
const isCurrentBlockEmpty = (editor) => {
  var _a;
  if (!editor.selection) {
    return false;
  }
  const [node] = Editor.node(editor, editor.selection);
  const cursor = editor.selection.focus;
  const blockAbove = getBlockAbove(editor);
  const isEmpty = !Node.string(node) && !((_a = node.children) == null ? void 0 : _a.some((n) => Editor.isInline(editor, n))) && Editor.isStart(editor, cursor, blockAbove[1]);
  return isEmpty;
};
const currentNodeSupportsMDX = (editor) => findNode(editor, {
  match: { type: HANDLES_MDX }
});
const helpers = {
  isNodeActive,
  isMarkActive,
  isListActive,
  currentNodeSupportsMDX,
  normalize
};
const ELEMENT_MDX_INLINE = "mdxJsxTextElement";
const ELEMENT_MDX_BLOCK = "mdxJsxFlowElement";
const Embed = (props) => {
  const handleChange = (values) => {
    const path = ReactEditor.findPath(props.editor, props.element);
    setNodes(props.editor, { props: values }, { at: path });
  };
  if (props.inline) {
    return /* @__PURE__ */ React__default.createElement(InlineEmbed, {
      ...props,
      onChange: handleChange
    });
  }
  return /* @__PURE__ */ React__default.createElement(BlockEmbed, {
    ...props,
    onChange: handleChange
  });
};
const createMdxInlinePlugin = createPluginFactory({
  key: ELEMENT_MDX_INLINE,
  isInline: true,
  isVoid: true,
  isElement: true,
  component: (props) => /* @__PURE__ */ React__default.createElement(Embed, {
    ...props,
    inline: true
  })
});
const createMdxBlockPlugin = createPluginFactory({
  key: ELEMENT_MDX_BLOCK,
  isVoid: true,
  isElement: true,
  component: (props) => /* @__PURE__ */ React__default.createElement(Embed, {
    ...props,
    inline: false
  })
});
const insertMDX = (editor, value) => {
  const flow = value.inline ? false : true;
  if (!helpers.currentNodeSupportsMDX(editor)) {
    return;
  }
  if (flow) {
    insertBlockElement(editor, {
      type: ELEMENT_MDX_BLOCK,
      name: value.name,
      children: [{ text: "" }],
      props: value.defaultItem ? value.defaultItem : {}
    });
    normalizeEditor(editor, { force: true });
  } else {
    insertInlineElement(editor, {
      type: ELEMENT_MDX_INLINE,
      name: value.name,
      children: [{ text: "" }],
      props: value.defaultItem ? value.defaultItem : {}
    });
  }
};
const wrapOrRewrapLink = (editor) => {
  const baseLink = {
    type: "a",
    url: "",
    title: "",
    children: [{ text: "" }]
  };
  if (isCollapsed(editor.selection)) {
    const [, path] = getAboveNode(editor, {
      match: (n) => !Editor.isEditor(n) && Element.isElement(n) && getPluginType(editor, ELEMENT_LINK)
    });
    Transforms.select(editor, path);
  }
  if (isLinkActive(editor)) {
    const [link] = getLinks(editor);
    baseLink.url = link[0].url;
    baseLink.title = link[0].title;
    unwrapLink(editor);
  }
  wrapNodes(editor, baseLink, { split: true });
};
const LinkForm = (props) => {
  const editor = useEditorState();
  const selection = React__default.useMemo(() => editor.selection, []);
  const handleChange = (values) => {
    const linksInSelection = getNodeEntries(editor, {
      match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === ELEMENT_LINK,
      at: selection
    });
    if (linksInSelection) {
      for (const [, location] of linksInSelection) {
        setNodes(editor, values, {
          match: (n) => {
            return !Editor.isEditor(n) && Element.isElement(n) && n.type === ELEMENT_LINK;
          },
          at: location
        });
      }
    }
  };
  const [link] = getLinks(editor);
  return /* @__PURE__ */ React__default.createElement(NestedForm, {
    id: "link-form",
    label: "Link",
    fields: [
      { label: "URL", name: "url", component: "text" },
      { label: "Title", name: "title", component: "text" }
    ],
    initialValues: {
      url: link ? link[0].url : "",
      title: link ? link[0].title : ""
    },
    onChange: handleChange,
    onClose: props.onClose
  });
};
const isLinkActive = (editor) => {
  const [link] = getLinks(editor);
  return !!link;
};
const unwrapLink = (editor, selection) => {
  unwrapNodes(editor, {
    match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === ELEMENT_LINK,
    at: selection || void 0
  });
};
const getLinks = (editor) => {
  return getNodeEntries(editor, {
    match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === ELEMENT_LINK
  });
};
const ToolbarItem = ({
  hidden,
  label,
  active,
  onMouseDown,
  icon,
  options,
  name,
  isLastItem = false
}) => {
  const editor = useEditorState();
  const [selection, setSelection] = React__default.useState(null);
  React__default.useEffect(() => {
    if (editor.selection) {
      setSelection(editor.selection);
    }
  }, [JSON.stringify(editor.selection)]);
  const [isExpanded, setIsExpanded] = React__default.useState(false);
  if (options) {
    return /* @__PURE__ */ React__default.createElement(Popover$1, {
      as: "div",
      className: "relative z-10 w-full"
    }, /* @__PURE__ */ React__default.createElement(Popover$1.Button, {
      as: "span",
      className: `cursor-pointer w-full inline-flex justify-center items-center px-2 py-2 rounded-l-md border-l border-b border-t border-gray-200 bg-white text-sm font-medium text-gray-600 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${isLastItem ? "border-r rounded-r-md" : "border-r-0"}`,
      onMouseDown: (e) => {
        e.preventDefault();
      }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "sr-only"
    }, "Open options"), /* @__PURE__ */ React__default.createElement(HeadingIcon, null)), /* @__PURE__ */ React__default.createElement(Transition, {
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, /* @__PURE__ */ React__default.createElement(Popover$1.Panel, null, ({ close }) => /* @__PURE__ */ React__default.createElement("div", {
      className: "origin-top-left absolute left-0 mt-2 -mr-1 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "py-2 tina-prose"
    }, /* @__PURE__ */ React__default.createElement("span", {
      onMouseDown: () => close()
    }, options))))));
  }
  if (icon === "image") {
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "relative"
    }, /* @__PURE__ */ React__default.createElement("span", {
      "data-test": `${name}Button`,
      className: `cursor-pointer w-full inline-flex relative justify-center items-center px-2 py-2 border-l border-b border-t border-r-0 border-gray-200 text-sm font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${active ? "bg-gray-50 text-blue-500" : "bg-white text-gray-600"} ${isLastItem ? "border-r rounded-r-md" : "border-r-0"}`,
      style: {
        visibility: hidden ? "hidden" : "visible",
        pointerEvents: hidden ? "none" : "auto"
      },
      onMouseDown: (e) => {
        e.preventDefault();
        insertImg(editor);
      }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "sr-only"
    }, label), /* @__PURE__ */ React__default.createElement(ToolbarIcon, {
      name: icon
    })));
  }
  if (icon === "link") {
    const isDisabled = !editor.selection || isCollapsed(editor.selection) && !isLinkActive(editor);
    return /* @__PURE__ */ React__default.createElement("span", {
      className: "relative"
    }, /* @__PURE__ */ React__default.createElement("span", {
      "data-test": `${name}Button`,
      className: `cursor-pointer w-full inline-flex relative justify-center items-center px-2 py-2 border-l border-b border-t border-r-0 border-gray-200 text-sm font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${active ? "bg-gray-50 text-blue-500" : isDisabled ? "bg-gray-50 text-gray-300" : "bg-white text-gray-600"} ${isLastItem ? "border-r rounded-r-md" : "border-r-0"}`,
      style: {
        visibility: hidden ? "hidden" : "visible",
        pointerEvents: hidden ? "none" : "auto"
      },
      onMouseDown: (e) => {
        e.preventDefault();
        if (isDisabled) {
          return;
        }
        wrapOrRewrapLink(editor);
        setIsExpanded((isExpanded2) => !isExpanded2);
      }
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "sr-only"
    }, label), /* @__PURE__ */ React__default.createElement(ToolbarIcon, {
      name: icon
    })), isExpanded && /* @__PURE__ */ React__default.createElement(LinkForm, {
      selection,
      onClose: () => {
        setIsExpanded(false);
      },
      onChange: (v) => console.log(v)
    }));
  }
  return /* @__PURE__ */ React__default.createElement("span", {
    "data-test": `${name}Button`,
    className: `cursor-pointer w-full inline-flex relative justify-center items-center px-2 py-2 border-l border-b border-t border-r-0 border-gray-200 text-sm font-medium  hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${active ? "bg-gray-50 text-blue-500" : "bg-white text-gray-600"} ${isLastItem ? "border-r rounded-r-md" : "border-r-0"}`,
    style: {
      visibility: hidden ? "hidden" : "visible",
      pointerEvents: hidden ? "none" : "auto"
    },
    onMouseDown
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only"
  }, label), /* @__PURE__ */ React__default.createElement(ToolbarIcon, {
    name: icon
  }));
};
const EmbedButton = ({
  editor,
  templates
}) => {
  return /* @__PURE__ */ React__default.createElement(Popover$1, {
    as: "span",
    className: "relative z-10 block",
    style: { width: "85px" }
  }, ({ open }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Popover$1.Button, {
    as: "span",
    onMouseDown: (e) => {
      e.preventDefault();
    },
    className: `cursor-pointer relative inline-flex items-center px-2 py-2 rounded-r-md border text-sm font-medium transition-all ease-out duration-150 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${open ? `bg-gray-50 border-gray-200 text-blue-500` : `text-white border-blue-500 bg-blue-500`}`
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "text-sm font-semibold tracking-wide align-baseline mr-1"
  }, "Embed"), /* @__PURE__ */ React__default.createElement(PlusIcon, {
    className: `origin-center transition-all ease-out duration-150 ${open ? `rotate-45` : ``}`
  })), /* @__PURE__ */ React__default.createElement(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /* @__PURE__ */ React__default.createElement(Popover$1.Panel, null, ({ close }) => /* @__PURE__ */ React__default.createElement("div", {
    className: "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none py-1 max-h-[10rem] overflow-y-auto"
  }, templates.map((template) => /* @__PURE__ */ React__default.createElement("span", {
    key: template.name,
    onMouseDown: (e) => {
      e.preventDefault();
      close();
      insertMDX(editor, template);
    },
    className: `hover:bg-gray-50 hover:text-blue-500 cursor-pointer pointer-events-auto px-4 py-2 text-sm w-full flex items-center`
  }, template.label || template.name)))))));
};
const OverflowMenu = ({ toolbarItems, itemsShown, showEmbed }) => {
  return /* @__PURE__ */ React.createElement(Popover$1, {
    as: "span",
    className: "relative z-10 block w-full"
  }, /* @__PURE__ */ React.createElement(Popover$1.Button, {
    "data-test": "popoverRichTextButton",
    as: "span",
    className: `cursor-pointer relative w-full justify-center inline-flex border border-gray-200 focus:border-blue-500 items-center px-2 py-2 bg-white text-sm font-medium text-gray-600 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 pointer-events-auto ${showEmbed ? `rounded-none` : `rounded-r-md`}`,
    onMouseDown: (e) => {
      e.preventDefault();
    }
  }, /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-5 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /* @__PURE__ */ React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
  }))), /* @__PURE__ */ React.createElement(Transition, {
    as: Fragment,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /* @__PURE__ */ React.createElement(Popover$1.Panel, null, ({ close }) => /* @__PURE__ */ React.createElement("div", {
    className: "origin-top-right absolute right-0 mt-2 -mr-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none py-1"
  }, toolbarItems.map((toolbarItem, index) => {
    if (index < itemsShown - 1) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("span", {
      "data-test": `${toolbarItem.name}OverflowButton`,
      key: toolbarItem.name,
      onMouseDown: (event) => {
        event.preventDefault();
        close();
        toolbarItem.onMouseDown(event);
      },
      className: classNames$1(toolbarItem.active ? "bg-gray-50 text-blue-500" : "bg-white text-gray-600", "hover:bg-gray-50 hover:text-blue-500 cursor-pointer pointer-events-auto px-4 py-2 text-sm w-full flex items-center")
    }, /* @__PURE__ */ React.createElement("div", {
      className: "mr-2 opacity-80"
    }, /* @__PURE__ */ React.createElement(ToolbarIcon, {
      name: toolbarItem.name
    })), " ", toolbarItem.label);
  })))));
};
const useResize = (ref, callback) => {
  React__default.useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        callback(entry);
      }
    });
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    return () => resizeObserver.disconnect();
  }, [ref.current]);
};
const FloatingToolbarWrapper = ({
  children,
  position
}) => {
  const ref = React.useRef();
  const editor = useEditorState();
  const { selection } = editor;
  React.useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    if (!selection || !isEditorFocused(editor) || Range.isCollapsed(selection) || getEditorString(editor, selection) === "") {
      el.classList.add("hidden");
      el.classList.remove("block");
      return;
    }
    el.classList.add("block");
    el.classList.remove("hidden");
    const run = async () => {
      if (ref.current) {
        const domSelection = window.getSelection();
        const domRange = domSelection.getRangeAt(0);
        const { x, y } = await computePosition(domRange, ref.current, {
          placement: position || "top",
          middleware: [flip(), shift()]
        });
        Object.assign(ref.current.style, {
          left: `${x}px`,
          top: `${y}px`
        });
      }
    };
    run();
  }, [JSON.stringify(selection), ref.current]);
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    className: "absolute z-10"
  }, children);
};
const headers = [
  {
    name: ELEMENT_H1,
    render: /* @__PURE__ */ React.createElement("h1", {
      className: "my-0 text-4xl font-medium"
    }, "Heading 1")
  },
  {
    name: ELEMENT_H2,
    render: /* @__PURE__ */ React.createElement("h2", {
      className: "my-0 text-3xl font-medium"
    }, "Heading 2")
  },
  {
    name: ELEMENT_H3,
    render: /* @__PURE__ */ React.createElement("h3", {
      className: "my-0 text-2xl font-semibold"
    }, "Heading 3")
  },
  {
    name: ELEMENT_H4,
    render: /* @__PURE__ */ React.createElement("h4", {
      className: "my-0 text-xl font-bold"
    }, "Heading 4")
  },
  {
    name: ELEMENT_H5,
    render: /* @__PURE__ */ React.createElement("h5", {
      className: "my-0 text-lg font-bold"
    }, "Heading 5")
  },
  {
    name: ELEMENT_H6,
    render: /* @__PURE__ */ React.createElement("h6", {
      className: "my-0 text-base font-bold"
    }, "Heading 6")
  },
  { name: ELEMENT_PARAGRAPH, render: /* @__PURE__ */ React.createElement("p", {
    className: "my-0"
  }, "Paragraph") }
];
const ICON_WIDTH = 40;
const EMBED_ICON_WIDTH = 85;
function Toolbar({
  templates
}) {
  const { setRawMode } = useEditorContext();
  const showEmbed = templates.length > 0;
  const toolbarRef = React.useRef(null);
  const editor = useEditorState();
  const isBoldActive = helpers.isMarkActive(editor, MARK_BOLD);
  const isCodeActive = helpers.isMarkActive(editor, MARK_CODE);
  const isItalicActive = helpers.isMarkActive(editor, MARK_ITALIC);
  const isLinkActive2 = helpers.isNodeActive(editor, ELEMENT_LINK);
  const ulActive = helpers.isListActive(editor, ELEMENT_UL);
  const olActive = helpers.isListActive(editor, ELEMENT_OL);
  const codeBlockActive = helpers.isNodeActive(editor, ELEMENT_CODE_BLOCK);
  const blockQuoteActive = helpers.isNodeActive(editor, ELEMENT_BLOCKQUOTE);
  const isImgActive = helpers.isNodeActive(editor, ELEMENT_IMG);
  const toolbarItems = [
    {
      name: "heading",
      label: "Heading",
      active: false,
      options: headers.map((item) => /* @__PURE__ */ React.createElement("span", {
        key: item.name,
        onMouseDown: getPreventDefaultHandler(toggleNodeType, editor, {
          activeType: item.name
        }),
        className: classNames$1("hover:bg-gray-100 hover:text-gray-900 cursor-pointer block px-4 py-2 text-sm w-full text-left")
      }, item.render))
    },
    {
      name: "link",
      label: "Link",
      active: isLinkActive2
    },
    {
      name: "image",
      label: "Image",
      active: isImgActive
    },
    {
      name: "quote",
      label: "Quote",
      active: blockQuoteActive,
      onMouseDown: getPreventDefaultHandler(toggleNodeType, editor, {
        activeType: ELEMENT_BLOCKQUOTE
      })
    },
    {
      name: "ul",
      label: "Bullet List",
      active: ulActive,
      onMouseDown: getPreventDefaultHandler(toggleList, editor, {
        type: ELEMENT_UL
      })
    },
    {
      name: "ol",
      label: "List",
      active: olActive,
      onMouseDown: getPreventDefaultHandler(toggleList, editor, {
        type: ELEMENT_OL
      })
    },
    {
      name: "code",
      label: "Code",
      active: isCodeActive,
      onMouseDown: getPreventDefaultHandler(toggleMark, editor, {
        key: MARK_CODE
      })
    },
    {
      name: "codeBlock",
      label: "Code Block",
      active: codeBlockActive,
      onMouseDown: getPreventDefaultHandler(insertEmptyCodeBlock, editor)
    },
    {
      name: "bold",
      label: "Bold",
      active: isBoldActive,
      onMouseDown: getPreventDefaultHandler(toggleMark, editor, {
        key: MARK_BOLD
      })
    },
    {
      name: "italic",
      label: "Italic",
      active: isItalicActive,
      onMouseDown: getPreventDefaultHandler(toggleMark, editor, {
        key: MARK_ITALIC
      })
    },
    {
      name: "raw",
      label: "Raw",
      active: false,
      onMouseDown: () => setRawMode(true)
    }
  ];
  const [itemsShown, setItemsShown] = React.useState(toolbarItems.length);
  useResize(toolbarRef, (entry) => {
    const width = entry.target.getBoundingClientRect().width;
    const itemsShown2 = (width - (showEmbed ? EMBED_ICON_WIDTH : 0)) / ICON_WIDTH;
    setItemsShown(Math.floor(itemsShown2));
  });
  return /* @__PURE__ */ React.createElement("div", {
    className: "sticky -top-4 inline-flex shadow rounded-md mb-2 z-50 max-w-full",
    style: {
      width: `${toolbarItems.length * ICON_WIDTH + (showEmbed ? EMBED_ICON_WIDTH : 0)}px`
    }
  }, /* @__PURE__ */ React.createElement("div", {
    ref: toolbarRef,
    className: "grid w-full",
    style: {
      gridTemplateColumns: showEmbed ? `1fr ${EMBED_ICON_WIDTH}px` : `1fr`
    }
  }, /* @__PURE__ */ React.createElement("div", {
    className: "grid",
    style: {
      gridTemplateColumns: `repeat(auto-fit, minmax(${ICON_WIDTH}px, 1fr))`,
      gridTemplateRows: "auto",
      gridAutoRows: 0
    }
  }, toolbarItems.map((toolbarItem, index) => {
    const isLastItem = index + 1 === itemsShown;
    const hidden = index + 1 > itemsShown;
    if (itemsShown < toolbarItems.length) {
      if (isLastItem) {
        return /* @__PURE__ */ React.createElement(OverflowMenu, {
          key: toolbarItem.name,
          itemsShown,
          toolbarItems,
          showEmbed
        });
      } else {
        return /* @__PURE__ */ React.createElement(ToolbarItem, {
          key: toolbarItem.name,
          name: toolbarItem.name,
          hidden,
          active: toolbarItem.active,
          onMouseDown: toolbarItem.onMouseDown,
          label: toolbarItem.label,
          options: toolbarItem.options,
          icon: toolbarItem.name,
          isLastItem: isLastItem && !showEmbed
        });
      }
    } else {
      return /* @__PURE__ */ React.createElement(ToolbarItem, {
        key: toolbarItem.name,
        name: toolbarItem.name,
        hidden,
        active: toolbarItem.active,
        onMouseDown: toolbarItem.onMouseDown,
        label: toolbarItem.label,
        options: toolbarItem.options,
        icon: toolbarItem.name,
        isLastItem: isLastItem && !showEmbed
      });
    }
  })), showEmbed && /* @__PURE__ */ React.createElement(EmbedButton, {
    templates,
    editor
  })));
}
const FloatingLink = () => {
  const editor = useEditorState();
  const isLinkActive2 = helpers.isNodeActive(editor, ELEMENT_LINK);
  return /* @__PURE__ */ React.createElement(FloatingToolbarWrapper, {
    position: "bottom"
  }, isLinkActive2 && /* @__PURE__ */ React.createElement("button", {
    onMouseDown: (e) => {
      e.preventDefault();
      unwrapLink(editor);
    },
    className: "mt-2 cursor-pointer hover:bg-gray-100 border border-gray-200 rounded-md bg-gray-100 text-gray-600 py-1 px-2"
  }, "Clear"));
};
const buildError = (element) => {
  return {
    message: element.message,
    position: element.position && {
      endColumn: element.position.end.column,
      startColumn: element.position.start.column,
      startLineNumber: element.position.start.line,
      endLineNumber: element.position.end.line
    }
  };
};
const buildErrorMessage = (element) => {
  if (!element) {
    return "";
  }
  const errorMessage = buildError(element);
  const message = errorMessage ? `${errorMessage.message}${errorMessage.position ? ` at line: ${errorMessage.position.startLineNumber}, column: ${errorMessage.position.startColumn}` : ""}` : null;
  return message;
};
const ELEMENT_INVALID_MARKDOWN = "invalid_markdown";
const createInvalidMarkdownPlugin = createPluginFactory({
  key: ELEMENT_INVALID_MARKDOWN,
  isVoid: true,
  isInline: false,
  isElement: true,
  component: ({ attributes, element, children }) => {
    return /* @__PURE__ */ React__default.createElement("div", {
      ...attributes
    }, /* @__PURE__ */ React__default.createElement(ErrorMessage, {
      error: element
    }), children);
  }
});
function ErrorMessage({ error }) {
  const message = buildErrorMessage(error);
  useEditorContext();
  return /* @__PURE__ */ React__default.createElement("div", {
    contentEditable: false,
    className: "bg-red-50 sm:rounded-lg"
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "px-4 py-5 sm:p-6"
  }, /* @__PURE__ */ React__default.createElement("h3", {
    className: "text-lg leading-6 font-medium text-red-800"
  }, "Error parsing markdown"), /* @__PURE__ */ React__default.createElement("div", {
    className: "mt-2 max-w-xl text-sm text-red-800 space-y-4"
  }, /* @__PURE__ */ React__default.createElement("p", null, message), /* @__PURE__ */ React__default.createElement("p", null, "To fix these errors, edit your content locally and then restart the Tina server."))));
}
const RichEditor = (props) => {
  const initialValue = React__default.useMemo(() => {
    var _a, _b;
    return ((_b = (_a = props.input.value) == null ? void 0 : _a.children) == null ? void 0 : _b.length) ? props.input.value.children.map(helpers.normalize) : [{ type: "p", children: [{ type: "text", text: "" }] }];
  }, []);
  const plugins$2 = React__default.useMemo(() => createPlugins([
    ...plugins$1,
    ...plugins,
    createMdxBlockPlugin(),
    createMdxInlinePlugin(),
    createImgPlugin(),
    createInvalidMarkdownPlugin(),
    createLinkPlugin()
  ], {
    components: components()
  }), []);
  const tempId = [props.tinaForm.id, props.input.name].join(".");
  const id = React__default.useMemo(() => uuid() + tempId, [tempId]);
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "with-toolbar"
  }, /* @__PURE__ */ React__default.createElement(Plate, {
    id,
    initialValue,
    plugins: plugins$2,
    onChange: (value) => {
      props.input.onChange({ type: "root", children: value });
    },
    firstChildren: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Toolbar, {
      templates: props.field.templates,
      inlineOnly: false
    }), /* @__PURE__ */ React__default.createElement(FloatingLink, null))
  }));
};
const MdxFieldPlugin = {
  name: "rich-text",
  Component: wrapFieldsWithMeta((props) => {
    const [rawMode, setRawMode] = React__default.useState(false);
    const [key, setKey] = React__default.useState(0);
    React__default.useMemo(() => {
      const { reset } = props.form;
      props.form.reset = (initialValues) => {
        setKey((key2) => key2 + 1);
        return reset(initialValues);
      };
    }, []);
    return /* @__PURE__ */ React__default.createElement(EditorContext.Provider, {
      key,
      value: { templates: props.field.templates, rawMode, setRawMode }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "min-h-[100px] max-w-full tina-prose relative shadow-inner focus-within:shadow-outline focus-within:border-blue-500 block w-full bg-white border border-gray-200 text-gray-600 focus-within:text-gray-900 rounded-md px-3 py-2 mb-5"
    }, /* @__PURE__ */ React__default.createElement(RichEditor, {
      ...props
    })));
  })
};
const MdxFieldPluginExtendible = {
  name: "rich-text",
  Component: wrapFieldsWithMeta((props) => {
    const [key, setKey] = React__default.useState(0);
    React__default.useMemo(() => {
      const { reset } = props.form;
      props.form.reset = (initialValues) => {
        setKey((key2) => key2 + 1);
        return reset(initialValues);
      };
    }, []);
    return /* @__PURE__ */ React__default.createElement(EditorContext.Provider, {
      key,
      value: {
        templates: props.field.templates,
        rawMode: props.rawMode,
        setRawMode: props.setRawMode
      }
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "min-h-[100px] max-w-full tina-prose relative shadow-inner focus-within:shadow-outline focus-within:border-blue-500 block w-full bg-white border border-gray-200 text-gray-600 focus-within:text-gray-900 rounded-md px-3 py-2 mb-5"
    }, props.rawMode ? props.rawEditor : /* @__PURE__ */ React__default.createElement(RichEditor, {
      ...props
    })));
  })
};
class PluginTypeManager {
  constructor(events) {
    this.events = events;
    this.plugins = {};
  }
  getType(type) {
    return this.plugins[type] = this.plugins[type] || new PluginType(type, this.events);
  }
  findOrCreateMap(type) {
    return this.getType(type);
  }
  add(plugin) {
    this.findOrCreateMap(plugin.__type).add(plugin);
  }
  remove(plugin) {
    this.findOrCreateMap(plugin.__type).remove(plugin);
  }
  all(type) {
    return this.findOrCreateMap(type).all();
  }
}
class PluginType {
  constructor(__type, events) {
    this.__type = __type;
    this.events = events;
    this.__plugins = {};
  }
  add(plugin) {
    const p = plugin;
    if (!p.__type) {
      p.__type = this.__type;
    }
    this.__plugins[p.name] = p;
    this.events.dispatch({ type: `plugin:add:${this.__type}` });
  }
  all() {
    return Object.keys(this.__plugins).map((name) => this.__plugins[name]);
  }
  find(name) {
    return this.__plugins[name];
  }
  remove(pluginOrName) {
    const name = typeof pluginOrName === "string" ? pluginOrName : pluginOrName.name;
    const plugin = this.__plugins[name];
    delete this.__plugins[name];
    this.events.dispatch({ type: `plugin:remove:${this.__type}` });
    return plugin;
  }
  subscribe(cb) {
    return this.events.subscribe(`plugin:*:${this.__type}`, cb);
  }
}
class EventBus {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
  }
  subscribe(event, callback) {
    let events;
    if (typeof event === "string") {
      events = [event];
    } else {
      events = event;
    }
    const newListeners = events.map((event2) => new Listener(event2, callback));
    newListeners.forEach((newListener) => this.listeners.add(newListener));
    return () => {
      newListeners.forEach((listener) => this.listeners.delete(listener));
    };
  }
  dispatch(event) {
    if (!this.listeners)
      return;
    const listenerSnapshot = Array.from(this.listeners.values());
    listenerSnapshot.forEach((listener) => listener.handleEvent(event));
  }
}
class Listener {
  constructor(eventPattern, callback) {
    this.eventPattern = eventPattern;
    this.callback = callback;
  }
  handleEvent(event) {
    if (this.watchesEvent(event)) {
      this.callback(event);
      return true;
    }
    return false;
  }
  watchesEvent(currentEvent) {
    if (this.eventPattern === "*")
      return true;
    const eventParts = currentEvent.type.split(":");
    const patternParts = this.eventPattern.split(":");
    let index = 0;
    let ignoresEvent = false;
    while (!ignoresEvent && index < patternParts.length) {
      const wildcard = patternParts[index] === "*";
      const matchingParts = patternParts[index] === eventParts[index];
      ignoresEvent = !(wildcard || matchingParts);
      index++;
    }
    return !ignoresEvent;
  }
}
const s3ErrorRegex = /<Error>.*<Code>(.+)<\/Code>.*<Message>(.+)<\/Message>.*/;
class DummyMediaStore {
  constructor() {
    this.accept = "*";
  }
  async persist(files) {
    return files.map(({ directory, file }) => ({
      id: file.name,
      type: "file",
      directory,
      filename: file.name
    }));
  }
  async previewSrc(filename) {
    return filename;
  }
  async list() {
    const items = [];
    return {
      items,
      nextOffset: 0
    };
  }
  async delete() {
  }
}
class TinaMediaStore {
  constructor(cms) {
    this.fetchFunction = (input, init) => {
      return fetch(input, init);
    };
    this.accept = "image/*";
    this.parse = (img) => {
      return img.src;
    };
    this.cms = cms;
  }
  setup() {
    var _a, _b, _c, _d;
    if (!this.api) {
      this.api = (_b = (_a = this.cms) == null ? void 0 : _a.api) == null ? void 0 : _b.tina;
      this.isLocal = !!this.api.isLocalMode;
      const contentApiUrl = new URL(this.api.contentApiUrl);
      this.url = `${contentApiUrl.origin}/media`;
      if (!this.isLocal) {
        if ((_d = (_c = this.api.options) == null ? void 0 : _c.tinaioConfig) == null ? void 0 : _d.assetsApiUrlOverride) {
          const url = new URL(this.api.assetsApiUrl);
          this.url = `${url.origin}/v1/${this.api.clientId}`;
        } else {
          this.url = `${contentApiUrl.origin.replace("content", "assets")}/v1/${this.api.clientId}`;
        }
      }
    }
  }
  async isAuthenticated() {
    this.setup();
    return await this.api.isAuthenticated();
  }
  async persist_cloud(media) {
    const newFiles = [];
    if (await this.isAuthenticated()) {
      for (const item of media) {
        const path = `${item.directory && item.directory !== "/" ? `${item.directory}/${item.file.name}` : item.file.name}`;
        const res = await this.api.fetchWithToken(`${this.url}/upload_url/${path}`, { method: "GET" });
        const { signedUrl } = await res.json();
        if (!signedUrl) {
          throw new Error("Unexpected error generating upload url");
        }
        const uploadRes = await this.fetchFunction(signedUrl, {
          method: "PUT",
          body: item.file,
          headers: {
            "Content-Type": item.file.type || "application/octet-stream",
            "Content-Length": String(item.file.size)
          }
        });
        if (!uploadRes.ok) {
          const xmlRes = await uploadRes.text();
          const matches = s3ErrorRegex.exec(xmlRes);
          console.error(xmlRes);
          if (!matches) {
            throw new Error("Unexpected error uploading media asset");
          } else {
            throw new Error(`Upload error: '${matches[2]}'`);
          }
        }
      }
    }
    return newFiles;
  }
  async persist_local(media) {
    const newFiles = [];
    for (const item of media) {
      const { file, directory } = item;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("directory", directory);
      formData.append("filename", file.name);
      const path = `${directory ? `${directory}/${file.name}` : file.name}`;
      const res = await this.fetchFunction(`${this.url}/upload/${path}`, {
        method: "POST",
        body: formData
      });
      if (res.status != 200) {
        const responseData = await res.json();
        throw new Error(responseData.message);
      }
      const fileRes = await res.json();
      if (fileRes == null ? void 0 : fileRes.success) {
        const parsedRes = {
          type: "file",
          id: file.name,
          filename: file.name,
          directory,
          previewSrc: path,
          src: path
        };
        newFiles.push(parsedRes);
      } else {
        throw new Error("Unexpected error uploading media");
      }
    }
    return newFiles;
  }
  async persist(media) {
    this.setup();
    if (this.isLocal) {
      return this.persist_local(media);
    } else {
      return this.persist_cloud(media);
    }
  }
  async previewSrc(filename) {
    return filename;
  }
  async list(options) {
    this.setup();
    let res;
    if (!this.isLocal) {
      if (await this.isAuthenticated()) {
        res = await this.api.fetchWithToken(`${this.url}/list/${options.directory || ""}?limit=${options.limit | 20}${options.offset ? `&cursor=${options.offset}` : ""}`);
        if (res.status == 401) {
          throw E_UNAUTHORIZED;
        }
        if (res.status == 404) {
          throw E_BAD_ROUTE;
        }
      } else {
        throw new Error("Not authenticated");
      }
    } else {
      res = await this.fetchFunction(`${this.url}/list/${options.directory || ""}?limit=${options.limit | 20}${options.offset ? `&cursor=${options.offset}` : ""}`);
      if (res.status == 404) {
        throw E_BAD_ROUTE;
      }
      if (res.status >= 500) {
        const { e } = await res.json();
        const error = new Error("Unexpected error");
        console.error(e);
        throw error;
      }
    }
    const { cursor, files, directories } = await res.json();
    const items = [];
    for (const file of files) {
      items.push({
        directory: options.directory || "",
        type: "file",
        id: file.filename,
        filename: file.filename,
        src: file.src,
        previewSrc: !this.isLocal ? `${file.src}?fit=crop&max-w=56&max-h=56` : file.src
      });
    }
    for (const dir of directories) {
      items.push({
        type: "dir",
        id: dir,
        directory: options.directory || "",
        filename: dir
      });
    }
    return {
      items,
      nextOffset: cursor || 0
    };
  }
  async delete(media) {
    const path = `${media.directory ? `${media.directory}/${media.filename}` : media.filename}`;
    if (!this.isLocal) {
      if (await this.isAuthenticated()) {
        await this.api.fetchWithToken(`${this.url}/${path}`, {
          method: "DELETE"
        });
      } else {
        throw E_UNAUTHORIZED;
      }
    } else {
      await this.fetchFunction(`${this.url}/${path}`, {
        method: "DELETE"
      });
    }
  }
}
class MediaManager$1 {
  constructor(store, events) {
    this.store = store;
    this.events = events;
    this._pageSize = 20;
    this.previewSrc = async (src, fieldName = "", formValues = {}) => {
      try {
        this.events.dispatch({
          type: "media:preview:start",
          src,
          fieldName,
          formValues
        });
        const url = await this.store.previewSrc(src, fieldName, formValues);
        this.events.dispatch({
          type: "media:preview:success",
          src,
          url,
          fieldName,
          formValues
        });
        return url;
      } catch (error) {
        this.events.dispatch({
          type: "media:preview:failure",
          src,
          error,
          fieldName,
          formValues
        });
        throw error;
      }
    };
  }
  get isConfigured() {
    return !(this.store instanceof DummyMediaStore);
  }
  get pageSize() {
    return this._pageSize;
  }
  set pageSize(pageSize) {
    this._pageSize = pageSize;
    this.events.dispatch({
      type: "media:pageSize",
      pageSize
    });
  }
  open(options = {}) {
    this.events.dispatch({
      type: "media:open",
      ...options
    });
  }
  get accept() {
    return this.store.accept;
  }
  async persist(files) {
    try {
      this.events.dispatch({ type: "media:upload:start", uploaded: files });
      const media = await this.store.persist(files);
      this.events.dispatch({
        type: "media:upload:success",
        uploaded: files,
        media
      });
      return media;
    } catch (error) {
      console.error(error);
      this.events.dispatch({
        type: "media:upload:failure",
        uploaded: files,
        error
      });
      throw error;
    }
  }
  async delete(media) {
    try {
      this.events.dispatch({ type: "media:delete:start", media });
      await this.store.delete(media);
      this.events.dispatch({
        type: "media:delete:success",
        media
      });
    } catch (error) {
      this.events.dispatch({
        type: "media:delete:failure",
        media,
        error
      });
      throw error;
    }
  }
  async list(options) {
    try {
      this.events.dispatch({ type: "media:list:start", ...options });
      const media = await this.store.list(options);
      this.events.dispatch({ type: "media:list:success", ...options, media });
      return media;
    } catch (error) {
      this.events.dispatch({ type: "media:list:failure", ...options, error });
      throw error;
    }
  }
}
class MediaListError extends Error {
  constructor(config) {
    super(config.message);
    this.ERR_TYPE = "MediaListError";
    this.title = config.title;
    this.docsLink = config.docsLink;
  }
}
const E_UNAUTHORIZED = new MediaListError({
  title: "Unauthorized",
  message: "You don't have access to this resource.",
  docsLink: "https://tina.io/packages/next-tinacms-cloudinary"
});
const E_BAD_ROUTE = new MediaListError({
  title: "Bad Route",
  message: "The Cloudinary API route is missing or misconfigured.",
  docsLink: "https://tina.io/packages/next-tinacms-cloudinary/#set-up-api-routes"
});
new MediaListError({
  title: "An Error Occurred",
  message: "Something went wrong accessing your media from Tina Cloud.",
  docsLink: ""
});
class Flags {
  constructor(events) {
    this.events = events;
    this._flags = /* @__PURE__ */ new Map();
  }
  get(key) {
    return this._flags.get(key);
  }
  set(key, value) {
    this._flags.set(key, value);
    this.events.dispatch({ type: "flag:set", key, value });
  }
}
const _CMS = class {
  constructor(config = {}) {
    this._enabled = false;
    this.api = {};
    this.unsubscribeHooks = {};
    this.events = new EventBus();
    this.media = new MediaManager$1(new DummyMediaStore(), this.events);
    this.enable = () => {
      this._enabled = true;
      this.events.dispatch(_CMS.ENABLED);
    };
    this.disable = () => {
      this._enabled = false;
      this.events.dispatch(_CMS.DISABLED);
    };
    this.toggle = () => {
      if (this.enabled) {
        this.disable();
      } else {
        this.enable();
      }
    };
    this.plugins = new PluginTypeManager(this.events);
    this.flags = new Flags(this.events);
    if (config.media) {
      this.media.store = config.media;
    } else {
      this.media.store = new DummyMediaStore();
    }
    if (config.mediaOptions && config.mediaOptions.pageSize) {
      this.media.pageSize = config.mediaOptions.pageSize;
    }
    if (config.plugins) {
      config.plugins.forEach((plugin) => this.plugins.add(plugin));
    }
    if (config.apis) {
      Object.entries(config.apis).forEach(([name, api]) => this.registerApi(name, api));
    }
    if (config.enabled) {
      this.enable();
    }
  }
  registerApi(name, api) {
    if (this.unsubscribeHooks[name]) {
      this.unsubscribeHooks[name]();
    }
    if (api.events instanceof EventBus) {
      const unsubscribeHost = api.events.subscribe("*", this.events.dispatch);
      const unsubscribeGuest = this.events.subscribe("*", (e) => api.events.dispatch(e));
      this.unsubscribeHooks[name] = () => {
        unsubscribeHost();
        unsubscribeGuest();
      };
    }
    this.api[name] = api;
  }
  get enabled() {
    return this._enabled;
  }
  get disabled() {
    return !this._enabled;
  }
};
let CMS = _CMS;
CMS.ENABLED = { type: "cms:enable" };
CMS.DISABLED = { type: "cms:disable" };
class Alerts$1 {
  constructor(events, map = {}) {
    this.events = events;
    this.map = map;
    this.alerts = /* @__PURE__ */ new Map();
    this.mapEventToAlert = (event) => {
      const toAlert = this.map[event.type];
      if (toAlert) {
        let getArgs;
        if (typeof toAlert === "function") {
          getArgs = toAlert;
        } else {
          getArgs = () => toAlert;
        }
        const { level, message, timeout } = getArgs(event);
        this.add(level, message, timeout);
      }
    };
    this.events.subscribe("*", this.mapEventToAlert);
  }
  setMap(eventsToAlerts) {
    this.map = {
      ...this.map,
      ...eventsToAlerts
    };
  }
  add(level, message, timeout = 3e3) {
    const alert = {
      level,
      message,
      timeout,
      id: `${message}|${Date.now()}`
    };
    this.alerts.set(alert.id, alert);
    this.events.dispatch({ type: "alerts:add", alert });
    let timeoutId = null;
    const dismiss = () => {
      clearTimeout(timeoutId);
      this.dismiss(alert);
    };
    timeoutId = level !== "error" ? setTimeout(dismiss, alert.timeout) : null;
    return dismiss;
  }
  dismiss(alert) {
    this.alerts.delete(alert.id);
    this.events.dispatch({ type: "alerts:remove", alert });
  }
  subscribe(cb) {
    const unsub = this.events.subscribe("alerts", cb);
    return () => unsub();
  }
  get all() {
    return Array.from(this.alerts.values());
  }
  info(message, timeout) {
    return this.add("info", message, timeout);
  }
  success(message, timeout) {
    return this.add("success", message, timeout);
  }
  warn(message, timeout) {
    return this.add("warn", message, timeout);
  }
  error(message, timeout) {
    return this.add("error", message, timeout);
  }
}
function createScreen({
  Component,
  props,
  ...options
}) {
  return {
    __type: "screen",
    layout: "popup",
    ...options,
    Component(screenProps) {
      return /* @__PURE__ */ React__default.createElement(Component, {
        ...screenProps,
        ...props
      });
    }
  };
}
function useScreenPlugin(options, deps) {
  const memo = useMemo(() => {
    return createScreen(options);
  }, deps);
  usePlugins(memo);
}
const ScreenPluginModal = ({
  screen,
  close
}) => {
  return /* @__PURE__ */ React.createElement(ModalLayout, {
    name: screen.name,
    close,
    layout: screen.layout
  }, /* @__PURE__ */ React.createElement(screen.Component, {
    close
  }));
};
const ModalLayout = ({ children, name, close, layout }) => {
  let Wrapper2;
  switch (layout) {
    case "popup":
      Wrapper2 = ModalPopup;
      break;
    case "fullscreen":
      Wrapper2 = ModalFullscreen;
      break;
    default:
      Wrapper2 = ModalPopup;
      break;
  }
  return /* @__PURE__ */ React.createElement(Modal, null, /* @__PURE__ */ React.createElement(Wrapper2, null, /* @__PURE__ */ React.createElement(ModalHeader, {
    close
  }, name), /* @__PURE__ */ React.createElement(ModalBody, {
    className: layout === "fullscreen" ? "flex h-full flex-col" : ""
  }, children)));
};
const Group = ({ tinaForm, form, field, input }) => {
  const addItem = React.useCallback(() => {
    let obj = {};
    if (typeof field.defaultItem === "function") {
      obj = field.defaultItem();
    } else {
      obj = field.defaultItem || {};
    }
    form.mutators.insert(field.name, 0, obj);
  }, [form, field]);
  const items = input.value || [];
  const itemProps = React.useCallback((item) => {
    if (!field.itemProps)
      return {};
    return field.itemProps(item);
  }, [field.itemProps]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GroupListHeader, null, /* @__PURE__ */ React.createElement(GroupListMeta, null, /* @__PURE__ */ React.createElement(GroupLabel, null, field.label || field.name), field.description && /* @__PURE__ */ React.createElement(FieldDescription, {
    className: "whitespace-nowrap text-ellipsis overflow-hidden"
  }, field.description)), /* @__PURE__ */ React.createElement(IconButton, {
    onClick: addItem,
    variant: "primary",
    size: "small"
  }, /* @__PURE__ */ React.createElement(AddIcon, {
    className: "w-5/6 h-auto"
  }))), /* @__PURE__ */ React.createElement(ListPanel$1, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Droppable, {
    droppableId: field.name,
    type: field.name
  }, (provider) => /* @__PURE__ */ React.createElement("div", {
    ref: provider.innerRef
  }, items.length === 0 && /* @__PURE__ */ React.createElement(EmptyState$2, null), items.map((item, index) => /* @__PURE__ */ React.createElement(Item$1, {
    key: index,
    tinaForm,
    field,
    item,
    index,
    ...itemProps(item)
  })), provider.placeholder)))));
};
const EmptyState$2 = () => /* @__PURE__ */ React.createElement(EmptyList$1, null, "There are no items");
const Item$1 = ({ tinaForm, field, index, item, label, ...p }) => {
  const cms = useCMS$1();
  const FormPortal = useFormPortal();
  const [isExpanded, setExpanded] = React.useState(false);
  const removeItem = React.useCallback(() => {
    tinaForm.mutators.remove(field.name, index);
  }, [tinaForm, field, index]);
  const title = label || (field.label || field.name) + " Item";
  const { dispatch: setHoveredField } = useEvent("field:hover");
  const { dispatch: setFocusedField } = useEvent("field:focus");
  return /* @__PURE__ */ React.createElement(Draggable, {
    type: field.name,
    draggableId: `${field.name}.${index}`,
    index
  }, (provider, snapshot) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ItemHeader, {
    provider,
    isDragging: snapshot.isDragging,
    ...p
  }, /* @__PURE__ */ React.createElement(DragHandle, {
    isDragging: snapshot.isDragging
  }), /* @__PURE__ */ React.createElement(ItemClickTarget, {
    onMouseOver: () => setHoveredField({
      id: tinaForm.id,
      fieldName: `${field.name}.${index}`
    }),
    onMouseOut: () => setHoveredField({ id: null, fieldName: null }),
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded(true);
      setFocusedField({
        id: tinaForm.id,
        fieldName: `${field.name}.${index}`
      });
    }
  }, /* @__PURE__ */ React.createElement(GroupLabel, null, title), /* @__PURE__ */ React.createElement(BiPencil, {
    className: "h-5 w-auto fill-current text-gray-200 group-hover:text-inherit transition-colors duration-150 ease-out"
  })), /* @__PURE__ */ React.createElement(ItemDeleteButton, {
    onClick: removeItem
  })), /* @__PURE__ */ React.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React.createElement(Panel$1, {
    isExpanded,
    setExpanded,
    field,
    index,
    tinaForm,
    itemTitle: title,
    zIndexShift
  }))));
};
const ItemClickTarget = ({ children, ...props }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "group text-gray-400 hover:text-blue-600 flex-1 min-w-0 relative flex justify-between items-center p-2",
    ...props
  }, children);
};
const GroupLabel = ({
  error,
  children
}) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: `m-0 text-xs font-semibold flex-1 text-ellipsis overflow-hidden transition-all ease-out duration-100 text-left ${error ? `text-red-500` : `text-gray-600 group-hover:text-inherit`}`
  }, children);
};
const GroupListHeader = ({ children }) => {
  return /* @__PURE__ */ React.createElement("span", {
    className: "relative flex w-full justify-between items-center mb-2"
  }, children);
};
const GroupListMeta = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "leading-none w-full flex-1 flex justify-between items-center gap-2"
  }, children);
};
const ListPanel$1 = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "relative mb-6 rounded-md bg-gray-100 shadow"
  }, children);
};
const EmptyList$1 = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "text-center rounded bg-gray-100 text-gray-400 p-3 text-sm italic font-regular"
  }, children);
};
const ItemHeader = ({
  isDragging,
  children,
  provider,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative group cursor-pointer flex justify-between items-stretch bg-white border border-gray-100 -mb-px overflow-visible p-0 text-sm font-normal ${isDragging ? `rounded shadow text-blue-600` : `text-gray-600 first:rounded-t last:rounded-b`}`,
    ref: provider.innerRef,
    ...provider.draggableProps,
    ...provider.dragHandleProps,
    ...props
  }, children);
};
const ItemDeleteButton = ({ onClick }) => {
  return /* @__PURE__ */ React.createElement("button", {
    className: "w-8 px-1 py-2.5 flex items-center justify-center hover:bg-gray-50 text-gray-200 hover:text-red-500",
    onClick
  }, /* @__PURE__ */ React.createElement(TrashIcon, {
    className: "fill-current transition-colors ease-out duration-100"
  }));
};
const DragHandle = ({ isDragging }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative w-8 px-1 py-2.5 flex items-center justify-center hover:bg-gray-50 group cursor-[grab] ${isDragging ? `text-blue-500` : `text-gray-200 hover:text-gray-600`}`
  }, isDragging ? /* @__PURE__ */ React.createElement(ReorderIcon, {
    className: "fill-current w-7 h-auto"
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DragIcon, {
    className: "fill-current w-7 h-auto group-hover:opacity-0 transition-opacity duration-150 ease-out"
  }), /* @__PURE__ */ React.createElement(ReorderIcon, {
    className: "fill-current w-7 h-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-150 ease-out"
  })));
};
const Panel$1 = function Panel22({
  setExpanded,
  isExpanded,
  tinaForm,
  field,
  index,
  itemTitle,
  zIndexShift
}) {
  const cms = useCMS$1();
  const fields = React.useMemo(() => {
    return field.fields.map((subField) => ({
      ...subField,
      name: `${field.name}.${index}.${subField.name}`
    }));
  }, [field.fields, field.name, index]);
  return /* @__PURE__ */ React.createElement(GroupPanel, {
    isExpanded,
    style: { zIndex: zIndexShift + 1e3 }
  }, /* @__PURE__ */ React.createElement(PanelHeader, {
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded(false);
    }
  }, itemTitle), /* @__PURE__ */ React.createElement(PanelBody, {
    id: tinaForm.id
  }, isExpanded ? /* @__PURE__ */ React.createElement(FieldsBuilder, {
    form: tinaForm,
    fields
  }) : null));
};
const GroupListField = Group;
const GroupListFieldPlugin = {
  name: "group-list",
  Component: GroupListField
};
const BlockSelector = ({
  templates,
  addItem
}) => {
  const showFilter = React.useMemo(() => {
    return Object.entries(templates).length > 6;
  }, [templates]);
  const [filter, setFilter] = React.useState("");
  const filteredBlocks = React.useMemo(() => {
    return Object.entries(templates).filter(([name, template]) => {
      return template.label ? template.label.toLowerCase().includes(filter.toLowerCase()) || name.toLowerCase().includes(filter.toLowerCase()) : name.toLowerCase().includes(filter.toLowerCase());
    });
  }, [filter]);
  return /* @__PURE__ */ React.createElement(Popover$1, null, ({ open }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Popover$1.Button, {
    as: "span"
  }, /* @__PURE__ */ React.createElement(IconButton, {
    variant: open ? "secondary" : "primary",
    size: "small",
    className: `${open ? `rotate-45 pointer-events-none` : ``}`
  }, /* @__PURE__ */ React.createElement(AddIcon, {
    className: "w-5/6 h-auto"
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "transform translate-y-full absolute -bottom-1 right-0 z-50"
  }, /* @__PURE__ */ React.createElement(Transition, {
    enter: "transition duration-150 ease-out",
    enterFrom: "transform opacity-0 -translate-y-2",
    enterTo: "transform opacity-100 translate-y-0",
    leave: "transition duration-75 ease-in",
    leaveFrom: "transform opacity-100 translate-y-0",
    leaveTo: "transform opacity-0 -translate-y-2"
  }, /* @__PURE__ */ React.createElement(Popover$1.Panel, {
    className: "relative overflow-hidden rounded-lg shadow-lg bg-white border border-gray-100"
  }, ({ close }) => /* @__PURE__ */ React.createElement("div", {
    className: "min-w-[192px] max-h-[24rem] overflow-y-auto flex flex-col w-full h-full"
  }, showFilter && /* @__PURE__ */ React.createElement("div", {
    className: "sticky top-0 bg-gray-50 p-2 border-b border-gray-100 z-10"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    className: "bg-white text-xs rounded-sm border border-gray-100 shadow-inner py-1 px-2 w-full block placeholder-gray-200",
    onClick: (event) => {
      event.stopPropagation();
      event.preventDefault();
    },
    value: filter,
    onChange: (event) => {
      setFilter(event.target.value);
    },
    placeholder: "Filter..."
  })), filteredBlocks.length === 0 && /* @__PURE__ */ React.createElement("span", {
    className: "relative text-center text-xs px-2 py-3 text-gray-300 bg-gray-50 italic"
  }, "No matches found"), filteredBlocks.length > 0 && filteredBlocks.map(([name, template]) => /* @__PURE__ */ React.createElement("button", {
    className: "relative text-center text-xs py-2 px-4 border-l-0 border-t-0 border-r-0 border-b border-gray-50 w-full outline-none transition-all ease-out duration-150 hover:text-blue-500 focus:text-blue-500 focus:bg-gray-50 hover:bg-gray-50",
    key: name,
    onClick: () => {
      addItem(name, template);
      setFilter("");
      close();
    }
  }, template.label ? template.label : name))))))));
};
const BlockSelectorBig = ({
  templates,
  addItem,
  label
}) => {
  const FormPortal = useFormPortal();
  const [pickerIsOpen, setPickerIsOpen] = React.useState(false);
  const showFilter = React.useMemo(() => {
    return Object.entries(templates).length > 6;
  }, [templates]);
  const [filter, setFilter] = React.useState("");
  const filteredTemplates = React.useMemo(() => {
    return Object.entries(templates).filter(([name, template]) => {
      return template.label ? template.label.toLowerCase().includes(filter.toLowerCase()) || name.toLowerCase().includes(filter.toLowerCase()) : name.toLowerCase().includes(filter.toLowerCase());
    });
  }, [filter]);
  const categories = React.useMemo(() => {
    return [
      ...new Set(Object.entries(templates).filter(([name, template]) => {
        return template.category ? template.category : false;
      }).map(([name, template]) => {
        return template.category;
      }))
    ];
  }, [templates]);
  const hasUncategorized = React.useMemo(() => {
    return Object.entries(templates).filter(([name, template]) => {
      return !template.category;
    }).length > 0;
  }, [templates]);
  const uncategorized = React.useMemo(() => {
    return filteredTemplates.filter(([name, template]) => {
      return !template.category;
    });
  }, [filteredTemplates]);
  const close = (name, template) => {
    if (name && template) {
      addItem(name, template);
    }
    setFilter("");
    setPickerIsOpen(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconButton, {
    variant: pickerIsOpen ? "secondary" : "primary",
    size: "small",
    className: `${pickerIsOpen ? `rotate-45 pointer-events-none` : ``}`,
    onClick: () => setPickerIsOpen(!pickerIsOpen)
  }, /* @__PURE__ */ React.createElement(AddIcon, {
    className: "w-5/6 h-auto"
  })), /* @__PURE__ */ React.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React.createElement(Transition, {
    show: pickerIsOpen
  }, /* @__PURE__ */ React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "transform transition-all ease-out duration-200",
    enterFrom: "opacity-0 -translate-x-1/2",
    enterTo: "opacity-100 translate-x-0",
    leave: "transform transition-all ease-in duration-150",
    leaveFrom: "opacity-100 translate-x-0",
    leaveTo: "opacity-0 -translate-x-1/2"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "absolute left-0 top-0 z-panel h-full w-full transform bg-gray-50",
    style: { zIndex: zIndexShift + 1e3 }
  }, /* @__PURE__ */ React.createElement(PanelHeader, {
    onClick: () => {
      setPickerIsOpen(false);
    }
  }, label, " \u2060\u2013 Add New"), /* @__PURE__ */ React.createElement("div", {
    className: "h-full overflow-y-auto max-h-full bg-gray-50 pt-4 px-6 pb-12"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-full flex justify-center"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-full max-w-form"
  }, showFilter && /* @__PURE__ */ React.createElement("div", {
    className: "block relative group mb-1"
  }, /* @__PURE__ */ React.createElement("input", {
    type: "text",
    className: "shadow-inner focus:shadow-outline focus:border-blue-400 focus:outline-none block text-sm pl-2.5 pr-8 py-1.5 text-gray-600 w-full bg-white border border-gray-200 focus:text-gray-900 rounded-md placeholder-gray-400 hover:placeholder-gray-600 transition-all ease-out duration-150",
    onClick: (event) => {
      event.stopPropagation();
      event.preventDefault();
    },
    value: filter,
    onChange: (event) => {
      setFilter(event.target.value);
    },
    placeholder: "Search"
  }), filter === "" ? /* @__PURE__ */ React.createElement(BiSearch, {
    className: "absolute right-3 top-1/2 -translate-y-1/2 w-5 h-auto text-blue-500 opacity-70 group-hover:opacity-100 transition-all ease-out duration-150"
  }) : /* @__PURE__ */ React.createElement("button", {
    onClick: () => {
      setFilter("");
    },
    className: "outline-none focus:outline-none bg-transparent border-0 p-0 m-0 absolute right-2.5 top-1/2 -translate-y-1/2 opacity-50 hover:opacity-100 transition-all ease-out duration-150"
  }, /* @__PURE__ */ React.createElement(MdOutlineClear, {
    className: "w-5 h-auto text-gray-600"
  }))), uncategorized.length === 0 && categories.length === 0 && /* @__PURE__ */ React.createElement(EmptyState$1, null, "No blocks to display."), uncategorized.length > 0 && categories.length === 0 && /* @__PURE__ */ React.createElement(CardColumns, {
    className: "pt-3"
  }, uncategorized.map(([name, template]) => /* @__PURE__ */ React.createElement(BlockCard, {
    key: `${template}-${name}`,
    close,
    name,
    template
  }))), categories.map((category, index) => {
    return /* @__PURE__ */ React.createElement(BlockGroup, {
      key: index,
      templates: filteredTemplates.filter(([name, template]) => {
        return template.category && template.category === category ? true : false;
      }),
      category,
      isLast: index === categories.length - 1 && !hasUncategorized,
      close
    });
  }), hasUncategorized && uncategorized.length === 0 && /* @__PURE__ */ React.createElement("div", {
    className: "relative text-gray-500 block text-left w-full text-base font-bold tracking-wide py-2 truncate pointer-events-none opacity-50"
  }, "Uncategorized"), uncategorized.length > 0 && categories.length > 0 && /* @__PURE__ */ React.createElement(BlockGroup, {
    templates: uncategorized,
    category: "Uncategorized",
    close,
    isLast: true
  })))))))));
};
const BlockGroup = ({ category, templates, close, isLast = false }) => {
  return /* @__PURE__ */ React.createElement(Disclosure, {
    defaultOpen: true,
    as: "div",
    className: `left-0 right-0 relative`
  }, ({ open }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Disclosure.Button, {
    className: `relative block group text-left w-full text-base font-bold tracking-wide py-2 truncate ${templates.length === 0 ? `pointer-events-none` : ``} ${!isLast && (!open || templates.length === 0) && `border-b border-gray-100`}`
  }, /* @__PURE__ */ React.createElement("span", {
    className: `text-gray-500 group-hover:text-gray-800 transition-all ease-out duration-150 ${templates.length === 0 ? `opacity-50` : ``}`
  }, category), templates.length > 0 && /* @__PURE__ */ React.createElement(MdKeyboardArrowDown, {
    className: `absolute top-1/2 right-0 w-6 h-auto -translate-y-1/2 text-gray-300 origin-center group-hover:text-blue-500 transition-all duration-150 ease-out ${open ? `` : `-rotate-90 opacity-70 group-hover:opacity-100`}`
  })), /* @__PURE__ */ React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-75 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0"
  }, /* @__PURE__ */ React.createElement(Disclosure.Panel, null, templates.length > 0 && /* @__PURE__ */ React.createElement(CardColumns, null, templates.map(([name, template]) => /* @__PURE__ */ React.createElement(BlockCard, {
    close,
    name,
    template
  })))))));
};
const CardColumns = ({ children, className = "" }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: `w-full mb-1 -mt-2 ${className}`,
    style: { columns: "320px", columnGap: "16px" }
  }, children);
};
const BlockCard = ({ close, name, template }) => {
  return /* @__PURE__ */ React.createElement("button", {
    className: "mb-2 mt-2 group relative text-xs font-bold border border-gray-100 w-full outline-none transition-all ease-out duration-150 hover:text-blue-500 focus:text-blue-500 focus:bg-gray-50 hover:bg-gray-50 rounded-md bg-white shadow overflow-hidden",
    style: { breakInside: "avoid", transform: "translateZ(0)" },
    key: name,
    onClick: () => {
      close(name, template);
    }
  }, template.previewSrc && /* @__PURE__ */ React.createElement("img", {
    src: template.previewSrc,
    className: "w-full h-auto transition-all ease-out duration-150 group-hover:opacity-50"
  }), /* @__PURE__ */ React.createElement("span", {
    className: `relative flex justify-between items-center gap-4 w-full px-4 text-left ${template.previewSrc ? `py-2 border-t border-gray-100 ` : `py-3`}`
  }, template.label ? template.label : name, /* @__PURE__ */ React.createElement(AddIcon, {
    className: "w-5 h-auto group-hover:text-blue-500 opacity-30 transition-all ease-out duration-150 group-hover:opacity-80"
  })));
};
const EmptyState$1 = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "block relative text-gray-300 italic py-1"
  }, children);
};
const Blocks = ({ tinaForm, form, field, input }) => {
  const addItem = React.useCallback((name, template) => {
    let obj = {};
    if (typeof template.defaultItem === "function") {
      obj = template.defaultItem();
    } else {
      obj = template.defaultItem || {};
    }
    obj._template = name;
    form.mutators.insert(field.name, 0, obj);
  }, [field.name, form.mutators]);
  const items = input.value || [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GroupListHeader, null, /* @__PURE__ */ React.createElement(GroupListMeta, null, /* @__PURE__ */ React.createElement(GroupLabel, null, field.label || field.name), field.description && /* @__PURE__ */ React.createElement(FieldDescription, null, field.description)), !field.visualSelector && /* @__PURE__ */ React.createElement(BlockSelector, {
    templates: field.templates,
    addItem
  }), field.visualSelector && /* @__PURE__ */ React.createElement(BlockSelectorBig, {
    label: field.label || field.name,
    templates: field.templates,
    addItem
  })), /* @__PURE__ */ React.createElement(ListPanel$1, null, /* @__PURE__ */ React.createElement(Droppable, {
    droppableId: field.name,
    type: field.name
  }, (provider) => /* @__PURE__ */ React.createElement("div", {
    ref: provider.innerRef,
    className: "edit-page--list-parent"
  }, items.length === 0 && /* @__PURE__ */ React.createElement(EmptyState$2, null), items.map((block, index) => {
    const template = field.templates[block._template];
    if (!template) {
      return /* @__PURE__ */ React.createElement(InvalidBlockListItem, {
        key: index,
        index,
        field,
        tinaForm
      });
    }
    const itemProps = (item) => {
      if (!template.itemProps)
        return {};
      return template.itemProps(item);
    };
    return /* @__PURE__ */ React.createElement(BlockListItem, {
      key: index,
      block,
      template,
      index,
      field,
      tinaForm,
      ...itemProps(block)
    });
  }), provider.placeholder))));
};
const BlockListItem = ({
  label,
  tinaForm,
  field,
  index,
  template,
  block
}) => {
  const cms = useCMS$1();
  const FormPortal = useFormPortal();
  const [isExpanded, setExpanded] = React.useState(false);
  const removeItem = React.useCallback(() => {
    tinaForm.mutators.remove(field.name, index);
  }, [tinaForm, field, index]);
  const { dispatch: setHoveredField } = useEvent("field:hover");
  const { dispatch: setFocusedField } = useEvent("field:focus");
  return /* @__PURE__ */ React.createElement(Draggable, {
    key: index,
    type: field.name,
    draggableId: `${field.name}.${index}`,
    index
  }, (provider, snapshot) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ItemHeader, {
    provider,
    isDragging: snapshot.isDragging
  }, /* @__PURE__ */ React.createElement(DragHandle, {
    isDragging: snapshot.isDragging
  }), /* @__PURE__ */ React.createElement(ItemClickTarget, {
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded(true);
      setFocusedField({
        id: tinaForm.id,
        fieldName: `${field.name}.${index}`
      });
    },
    onMouseOver: () => setHoveredField({
      id: tinaForm.id,
      fieldName: `${field.name}.${index}`
    }),
    onMouseOut: () => setHoveredField({ id: null, fieldName: null })
  }, /* @__PURE__ */ React.createElement(GroupLabel, null, label || template.label), /* @__PURE__ */ React.createElement(BiPencil, {
    className: "h-5 w-auto fill-current text-gray-200 group-hover:text-inherit transition-colors duration-150 ease-out"
  })), /* @__PURE__ */ React.createElement(ItemDeleteButton, {
    onClick: removeItem
  })), /* @__PURE__ */ React.createElement(FormPortal, null, ({ zIndexShift }) => /* @__PURE__ */ React.createElement(Panel, {
    zIndexShift,
    isExpanded,
    setExpanded,
    field,
    item: block,
    index,
    tinaForm,
    label: label || template.label,
    template
  }))));
};
const InvalidBlockListItem = ({
  tinaForm,
  field,
  index
}) => {
  const removeItem = React.useCallback(() => {
    tinaForm.mutators.remove(field.name, index);
  }, [tinaForm, field, index]);
  return /* @__PURE__ */ React.createElement(Draggable, {
    key: index,
    type: field.name,
    draggableId: `${field.name}.${index}`,
    index
  }, (provider, snapshot) => /* @__PURE__ */ React.createElement(ItemHeader, {
    provider,
    isDragging: snapshot.isDragging
  }, /* @__PURE__ */ React.createElement(DragHandle, {
    isDragging: snapshot.isDragging
  }), /* @__PURE__ */ React.createElement(ItemClickTarget, null, /* @__PURE__ */ React.createElement(GroupLabel, {
    error: true
  }, "Invalid Block")), /* @__PURE__ */ React.createElement(ItemDeleteButton, {
    onClick: removeItem
  })));
};
const Panel = function Panel23({
  setExpanded,
  isExpanded,
  tinaForm,
  field,
  index,
  label,
  template,
  zIndexShift
}) {
  const cms = useCMS$1();
  const fields = React.useMemo(() => {
    if (!template.fields)
      return [];
    return template.fields.map((subField) => ({
      ...subField,
      name: `${field.name}.${index}.${subField.name}`
    }));
  }, [field.name, index, template.fields]);
  return /* @__PURE__ */ React.createElement(GroupPanel, {
    isExpanded,
    style: { zIndex: zIndexShift + 1e3 }
  }, /* @__PURE__ */ React.createElement(PanelHeader, {
    onClick: () => {
      const state = tinaForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
        return;
      }
      setExpanded(false);
    }
  }, label), /* @__PURE__ */ React.createElement(PanelBody, {
    id: tinaForm.id
  }, isExpanded ? /* @__PURE__ */ React.createElement(FieldsBuilder, {
    form: tinaForm,
    fields
  }) : null));
};
const BlocksField = Blocks;
const BlocksFieldPlugin = {
  name: "blocks",
  Component: BlocksField
};
const parse$2 = (value) => value || "";
const ColorField = wrapFieldsWithMeta(({ input, field }) => {
  return /* @__PURE__ */ React.createElement(ColorPicker, {
    colorFormat: field.colorFormat,
    userColors: field.colors,
    widget: field.widget,
    input
  });
});
const ColorFieldPlugin = {
  name: "color",
  Component: ColorField,
  parse: parse$2
};
const List = ({ tinaForm, form, field, input }) => {
  const addItem = React.useCallback(() => {
    let newItem = "";
    if (typeof field.defaultItem === "function") {
      newItem = field.defaultItem();
    } else if (typeof field.defaultItem !== "undefined") {
      newItem = field.defaultItem;
    }
    form.mutators.insert(field.name, 0, newItem);
  }, [form, field]);
  const items = input.value || [];
  const itemProps = React.useCallback((item) => {
    if (!field.itemProps)
      return {};
    return field.itemProps(item);
  }, [field.itemProps]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListHeader, null, /* @__PURE__ */ React.createElement("div", {
    className: "leading-none"
  }, /* @__PURE__ */ React.createElement(Label, null, field.label || field.name), field.description && /* @__PURE__ */ React.createElement(FieldDescription, {
    className: "whitespace-nowrap text-ellipsis overflow-hidden"
  }, field.description)), /* @__PURE__ */ React.createElement(IconButton, {
    onClick: addItem,
    variant: "primary",
    size: "small"
  }, /* @__PURE__ */ React.createElement(AddIcon, {
    className: "w-5/6 h-auto"
  }))), /* @__PURE__ */ React.createElement(ListPanel, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Droppable, {
    droppableId: field.name,
    type: field.name
  }, (provider) => /* @__PURE__ */ React.createElement("div", {
    ref: provider.innerRef
  }, items.length === 0 && /* @__PURE__ */ React.createElement(EmptyState, null), items.map((item, index) => /* @__PURE__ */ React.createElement(Item, {
    key: index,
    tinaForm,
    field,
    item,
    index,
    ...itemProps(item)
  })), provider.placeholder)))));
};
const EmptyState = () => /* @__PURE__ */ React.createElement(EmptyList, null, "There are no items");
const Item = ({ tinaForm, field, index, item, label, ...p }) => {
  const removeItem = React.useCallback(() => {
    tinaForm.mutators.remove(field.name, index);
  }, [tinaForm, field, index]);
  const fields = [
    {
      type: field.type,
      list: field.list,
      parentTypename: field.parentTypename,
      ...field.field,
      label: "Value",
      name: field.name + "." + index
    }
  ];
  return /* @__PURE__ */ React.createElement(Draggable, {
    type: field.name,
    draggableId: `${field.name}.${index}`,
    index
  }, (provider, snapshot) => /* @__PURE__ */ React.createElement(ItemHeader, {
    provider,
    isDragging: snapshot.isDragging,
    ...p
  }, /* @__PURE__ */ React.createElement(DragHandle, {
    isDragging: snapshot.isDragging
  }), /* @__PURE__ */ React.createElement(ItemClickTarget, null, /* @__PURE__ */ React.createElement(FieldsBuilder, {
    padding: false,
    form: tinaForm,
    fields
  })), /* @__PURE__ */ React.createElement(ItemDeleteButton, {
    onClick: removeItem
  })));
};
const Label = ({ error = false, className = "", ...props }) => /* @__PURE__ */ React.createElement("span", {
  className: `truncate m-0 text-[13px] font-bold tracking-[0.01em] leading-[1.35] flex-grow flex-shrink flex-auto transition-all duration-100 ease-out text-left ${error ? "text-orange-500" : "text-gray-700"} ${className}`,
  ...props
});
const ListHeader = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: `relative flex w-full justify-between items-center mb-2 ${className}`,
  ...props
});
const ListPanel = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: `max-h-[initial] relative h-auto mb-6 rounded-[5px] bg-gray-100 ${className}`,
  ...props
});
const EmptyList = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: `text-center rounded-[5px] bg-gray-100 text-gray-300 leading-[1.35] py-3 text-[15px] font-normal ${className}`,
  ...props
});
const ListField = List;
const ListFieldPlugin = {
  name: "list",
  Component: ListField
};
function usePreviewSrc(value, fieldName, formValues, getPreviewSrc) {
  const cms = useCMS$1();
  const getSrc = getPreviewSrc || cms.media.previewSrc;
  const [{ src, loading }, setState] = useState({
    src: "",
    loading: true
  });
  useEffect(() => {
    let componentUnmounted = false;
    let tmpSrc = "";
    (async () => {
      try {
        tmpSrc = await getSrc(value, fieldName, formValues);
      } catch {
      }
      if (componentUnmounted)
        return;
      setState({
        src: tmpSrc,
        loading: false
      });
    })();
    return () => {
      componentUnmounted = true;
    };
  }, [value]);
  return [src, loading];
}
const ImageField = wrapFieldsWithMeta((props) => {
  const cms = useCMS$1();
  const { form, field } = props;
  const { name, value } = props.input;
  const [src, srcIsLoading] = usePreviewSrc(value, name, form.getState().values, field.previewSrc);
  const [isImgUploading, setIsImgUploading] = useState(false);
  let onClear;
  if (props.field.clearable) {
    onClear = () => props.input.onChange("");
  }
  async function onChange(media) {
    var _a, _b;
    if (media) {
      const parsedValue = typeof ((_b = (_a = cms == null ? void 0 : cms.media) == null ? void 0 : _a.store) == null ? void 0 : _b.parse) === "function" ? cms.media.store.parse(media) : media;
      props.input.onChange(parsedValue);
    }
  }
  const uploadDir = props.field.uploadDir || (() => "");
  return /* @__PURE__ */ React.createElement(ImageUpload, {
    value,
    previewSrc: src,
    loading: isImgUploading || srcIsLoading,
    onClick: () => {
      const directory = uploadDir(props.form.getState().values);
      cms.media.open({
        allowDelete: true,
        directory,
        onSelect: onChange
      });
    },
    onDrop: async ([file]) => {
      setIsImgUploading(true);
      const directory = uploadDir(props.form.getState().values);
      const [media] = await cms.media.persist([
        {
          directory,
          file
        }
      ]);
      if (media) {
        try {
          await onChange(media);
        } catch (error) {
          console.error("Error uploading media asset: ", error);
        } finally {
          setIsImgUploading(false);
        }
      }
    },
    onClear
  });
});
const ImageFieldPlugin = {
  name: "image",
  Component: ImageField,
  parse: parse$2
};
const parse$1 = (value) => value && +value;
const NumberField = wrapFieldsWithMeta(({ input, field }) => {
  return /* @__PURE__ */ React.createElement(NumberInput, {
    ...input,
    step: field.step
  });
});
const NumberFieldPlugin = {
  name: "number",
  Component: NumberField,
  parse: parse$1
};
const SelectField = wrapFieldsWithMeta(Select);
const SelectFieldPlugin = {
  name: "select",
  type: "select",
  Component: SelectField,
  parse: parse$2,
  validate(value, values, meta, field) {
    if (field.required && !value)
      return "Required";
  }
};
const RadioGroupField = wrapFieldsWithMeta(RadioGroup);
const RadioGroupFieldPlugin = {
  name: "radio-group",
  Component: RadioGroupField
};
const TextareaField = wrapFieldsWithMeta(({ input }) => /* @__PURE__ */ React.createElement(TextArea, {
  ...input
}));
const TextareaFieldPlugin = {
  name: "textarea",
  Component: TextareaField,
  parse: parse$2
};
const TextField = wrapFieldsWithMeta(({ input, field }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(BaseTextField, {
    ...input,
    disabled: (_a = field == null ? void 0 : field.disabled) != null ? _a : false,
    placeholder: field.placeholder
  });
});
const TextFieldPlugin = {
  name: "text",
  Component: TextField,
  validate(value, values, meta, field) {
    if (field.required && !value)
      return "Required";
  },
  parse: parse$2
};
const ToggleField = wrapFieldsWithMeta(Toggle);
const ToggleFieldPlugin = {
  name: "toggle",
  type: "checkbox",
  Component: ToggleField
};
const TagsField = wrapFieldsWithMeta(({ input, field, form, tinaForm }) => {
  const [value, setValue] = React.useState("");
  const addTag = React.useCallback((tag) => {
    var _a, _b;
    if ((_b = (_a = form.getFieldState(field.name)) == null ? void 0 : _a.value) == null ? void 0 : _b.includes(tag)) {
      return;
    }
    if (!tag.length) {
      return;
    }
    form.mutators.insert(field.name, 0, tag);
    setValue("");
  }, [form, field.name]);
  const items = input.value || [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BaseTextField, {
    value,
    onChange: (event) => setValue(event.target.value),
    placeholder: field.placeholder,
    onKeyPress: (event) => {
      if (event.key === "," || event.key === "Enter") {
        event.preventDefault();
        addTag(value);
      }
    }
  }), /* @__PURE__ */ React.createElement("span", {
    className: "flex flex-wrap mt-1 -mx-1 mb-0"
  }, items.map((tag, index) => /* @__PURE__ */ React.createElement(Tag, {
    key: tag,
    tinaForm,
    field,
    index
  }, tag))));
});
const Tag = ({ tinaForm, field, index, children, ...styleProps }) => {
  const removeItem = React.useCallback(() => {
    tinaForm.mutators.remove(field.name, index);
  }, [tinaForm, field, index]);
  return /* @__PURE__ */ React.createElement("span", {
    className: "rounded-[5px] shadow-[0_2px_3px_rgba(0,0,0,0.12)] bg-white flex items-center font-semibold tracking-[0.01em] leading-none text-gray-700 pl-2.5 m-1 truncate",
    ...styleProps
  }, /* @__PURE__ */ React.createElement("span", {
    style: { maxHeight: "calc(var(--tina-sidebar-width) - 50px)" },
    className: "text-[15px] flex-shrink overflow-ellipsis overflow-hidden"
  }, children), /* @__PURE__ */ React.createElement("button", {
    className: "text-center flex-shrink-0 border-0 bg-transparent p-2 flex items-center justify-center cursor-pointer",
    onClick: removeItem
  }, /* @__PURE__ */ React.createElement(CloseIcon, {
    className: "w-4 h-auto"
  })));
};
const TagsFieldPlugin = {
  name: "tags",
  Component: TagsField,
  parse: parse$2
};
function ViewNavigation({
  onClickPrev,
  onClickSwitch,
  onClickNext,
  switchContent,
  switchColSpan,
  switchProps
}) {
  return /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("th", {
    className: "rdtPrev",
    onClick: onClickPrev
  }, /* @__PURE__ */ React__default.createElement("span", null, "\u2039")), /* @__PURE__ */ React__default.createElement("th", {
    className: "rdtSwitch",
    colSpan: switchColSpan,
    onClick: onClickSwitch,
    ...switchProps
  }, switchContent), /* @__PURE__ */ React__default.createElement("th", {
    className: "rdtNext",
    onClick: onClickNext
  }, /* @__PURE__ */ React__default.createElement("span", null, "\u203A")));
}
class DaysView extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_setDate", (e) => {
      this.props.updateDate(e);
    });
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtDays"
    }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("thead", null, this.renderNavigation(), this.renderDayHeaders()), /* @__PURE__ */ React__default.createElement("tbody", null, this.renderDays()), this.renderFooter()));
  }
  renderNavigation() {
    const date = this.props.viewDate;
    const locale = date.localeData();
    return /* @__PURE__ */ React__default.createElement(ViewNavigation, {
      onClickPrev: () => this.props.navigate(-1, "months"),
      onClickSwitch: () => this.props.showView("months"),
      onClickNext: () => this.props.navigate(1, "months"),
      switchContent: locale.months(date) + " " + date.year(),
      switchColSpan: 5,
      switchProps: { "data-value": this.props.viewDate.month() }
    });
  }
  renderDayHeaders() {
    const locale = this.props.viewDate.localeData();
    let dayItems = getDaysOfWeek(locale).map((day, index) => /* @__PURE__ */ React__default.createElement("th", {
      key: day + index,
      className: "dow"
    }, day));
    return /* @__PURE__ */ React__default.createElement("tr", null, dayItems);
  }
  renderDays() {
    const date = this.props.viewDate;
    const startOfMonth = date.clone().startOf("month");
    const endOfMonth = date.clone().endOf("month");
    let rows = [[], [], [], [], [], []];
    let startDate = date.clone().subtract(1, "months");
    startDate.date(startDate.daysInMonth()).startOf("week");
    let endDate = startDate.clone().add(42, "d");
    let i = 0;
    while (startDate.isBefore(endDate)) {
      let row = getRow$2(rows, i++);
      row.push(this.renderDay(startDate, startOfMonth, endOfMonth));
      startDate.add(1, "d");
    }
    return rows.map((r, i2) => /* @__PURE__ */ React__default.createElement("tr", {
      key: `${endDate.month()}_${i2}`
    }, r));
  }
  renderDay(date, startOfMonth, endOfMonth) {
    let selectedDate = this.props.selectedDate;
    let dayProps = {
      key: date.format("M_D"),
      "data-value": date.date(),
      "data-month": date.month(),
      "data-year": date.year()
    };
    let className = "rdtDay";
    if (date.isBefore(startOfMonth)) {
      className += " rdtOld";
    } else if (date.isAfter(endOfMonth)) {
      className += " rdtNew";
    }
    if (selectedDate && date.isSame(selectedDate, "day")) {
      className += " rdtActive";
    }
    if (date.isSame(this.props.moment(), "day")) {
      className += " rdtToday";
    }
    if (this.props.isValidDate(date)) {
      dayProps.onClick = this._setDate;
    } else {
      className += " rdtDisabled";
    }
    dayProps.className = className;
    return this.props.renderDay(dayProps, date.clone(), selectedDate && selectedDate.clone());
  }
  renderFooter() {
    if (!this.props.timeFormat)
      return;
    const date = this.props.viewDate;
    return /* @__PURE__ */ React__default.createElement("tfoot", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      onClick: () => this.props.showView("time"),
      colSpan: 7,
      className: "rdtTimeToggle"
    }, date.format(this.props.timeFormat))));
  }
}
__publicField(DaysView, "defaultProps", {
  isValidDate: () => true,
  renderDay: (props, date) => /* @__PURE__ */ React__default.createElement("td", {
    ...props
  }, date.date())
});
function getRow$2(rows, day) {
  return rows[Math.floor(day / 7)];
}
function getDaysOfWeek(locale) {
  const first = locale.firstDayOfWeek();
  let dow = [];
  let i = 0;
  locale._weekdaysMin.forEach(function(day) {
    dow[(7 + i++ - first) % 7] = day;
  });
  return dow;
}
class MonthsView extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "_updateSelectedMonth", (event) => {
      this.props.updateDate(event);
    });
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtMonths"
    }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("thead", null, this.renderNavigation())), /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("tbody", null, this.renderMonths())));
  }
  renderNavigation() {
    let year = this.props.viewDate.year();
    return /* @__PURE__ */ React__default.createElement(ViewNavigation, {
      onClickPrev: () => this.props.navigate(-1, "years"),
      onClickSwitch: () => this.props.showView("years"),
      onClickNext: () => this.props.navigate(1, "years"),
      switchContent: year,
      switchColSpan: "2"
    });
  }
  renderMonths() {
    let rows = [[], [], []];
    for (let month = 0; month < 12; month++) {
      let row = getRow$1(rows, month);
      row.push(this.renderMonth(month));
    }
    return rows.map((months, i) => /* @__PURE__ */ React__default.createElement("tr", {
      key: i
    }, months));
  }
  renderMonth(month) {
    const selectedDate = this.props.selectedDate;
    let className = "rdtMonth";
    let onClick;
    if (this.isDisabledMonth(month)) {
      className += " rdtDisabled";
    } else {
      onClick = this._updateSelectedMonth;
    }
    if (selectedDate && selectedDate.year() === this.props.viewDate.year() && selectedDate.month() === month) {
      className += " rdtActive";
    }
    let props = { key: month, className, "data-value": month, onClick };
    if (this.props.renderMonth) {
      return this.props.renderMonth(props, month, this.props.viewDate.year(), this.props.selectedDate && this.props.selectedDate.clone());
    }
    return /* @__PURE__ */ React__default.createElement("td", {
      ...props
    }, this.getMonthText(month));
  }
  isDisabledMonth(month) {
    let isValidDate = this.props.isValidDate;
    if (!isValidDate) {
      return false;
    }
    let date = this.props.viewDate.clone().set({ month });
    let day = date.endOf("month").date() + 1;
    while (day-- > 1) {
      if (isValidDate(date.date(day))) {
        return false;
      }
    }
    return true;
  }
  getMonthText(month) {
    const localMoment = this.props.viewDate;
    const monthStr = localMoment.localeData().monthsShort(localMoment.month(month));
    return capitalize(monthStr.substring(0, 3));
  }
}
function getRow$1(rows, year) {
  if (year < 4) {
    return rows[0];
  }
  if (year < 8) {
    return rows[1];
  }
  return rows[2];
}
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
class YearsView extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "disabledYearsCache", {});
    __publicField(this, "_updateSelectedYear", (event) => {
      this.props.updateDate(event);
    });
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtYears"
    }, /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("thead", null, this.renderNavigation())), /* @__PURE__ */ React__default.createElement("table", null, /* @__PURE__ */ React__default.createElement("tbody", null, this.renderYears())));
  }
  renderNavigation() {
    const viewYear = this.getViewYear();
    return /* @__PURE__ */ React__default.createElement(ViewNavigation, {
      onClickPrev: () => this.props.navigate(-10, "years"),
      onClickSwitch: () => this.props.showView("years"),
      onClickNext: () => this.props.navigate(10, "years"),
      switchContent: `${viewYear}-${viewYear + 9}`
    });
  }
  renderYears() {
    const viewYear = this.getViewYear();
    let rows = [[], [], []];
    for (let year = viewYear - 1; year < viewYear + 11; year++) {
      let row = getRow(rows, year - viewYear);
      row.push(this.renderYear(year));
    }
    return rows.map((years, i) => /* @__PURE__ */ React__default.createElement("tr", {
      key: i
    }, years));
  }
  renderYear(year) {
    const selectedYear = this.getSelectedYear();
    let className = "rdtYear";
    let onClick;
    if (this.isDisabledYear(year)) {
      className += " rdtDisabled";
    } else {
      onClick = this._updateSelectedYear;
    }
    if (selectedYear === year) {
      className += " rdtActive";
    }
    let props = { key: year, className, "data-value": year, onClick };
    return this.props.renderYear(props, year, this.props.selectedDate && this.props.selectedDate.clone());
  }
  getViewYear() {
    return parseInt(this.props.viewDate.year() / 10, 10) * 10;
  }
  getSelectedYear() {
    return this.props.selectedDate && this.props.selectedDate.year();
  }
  isDisabledYear(year) {
    let cache = this.disabledYearsCache;
    if (cache[year] !== void 0) {
      return cache[year];
    }
    let isValidDate = this.props.isValidDate;
    if (!isValidDate) {
      return false;
    }
    let date = this.props.viewDate.clone().set({ year });
    let day = date.endOf("year").dayOfYear() + 1;
    while (day-- > 1) {
      if (isValidDate(date.dayOfYear(day))) {
        cache[year] = false;
        return false;
      }
    }
    cache[year] = true;
    return true;
  }
}
__publicField(YearsView, "defaultProps", {
  renderYear: (props, year) => /* @__PURE__ */ React__default.createElement("td", {
    ...props
  }, year)
});
function getRow(rows, year) {
  if (year < 3) {
    return rows[0];
  }
  if (year < 7) {
    return rows[1];
  }
  return rows[2];
}
const timeConstraints = {
  hours: {
    min: 0,
    max: 23,
    step: 1
  },
  minutes: {
    min: 0,
    max: 59,
    step: 1
  },
  seconds: {
    min: 0,
    max: 59,
    step: 1
  },
  milliseconds: {
    min: 0,
    max: 999,
    step: 1
  }
};
function createConstraints(overrideTimeConstraints) {
  let constraints = {};
  Object.keys(timeConstraints).forEach((type) => {
    constraints[type] = {
      ...timeConstraints[type],
      ...overrideTimeConstraints[type] || {}
    };
  });
  return constraints;
}
class TimeView extends React__default.Component {
  constructor(props) {
    super(props);
    this.constraints = createConstraints(props.timeConstraints);
    this.state = this.getTimeParts(props.selectedDate || props.viewDate);
  }
  render() {
    let items = [];
    const timeParts = this.state;
    this.getCounters().forEach((c, i) => {
      if (i && c !== "ampm") {
        items.push(/* @__PURE__ */ React__default.createElement("div", {
          key: `sep${i}`,
          className: "rdtCounterSeparator"
        }, ":"));
      }
      items.push(this.renderCounter(c, timeParts[c]));
    });
    return /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtTime"
    }, /* @__PURE__ */ React__default.createElement("table", null, this.renderHeader(), /* @__PURE__ */ React__default.createElement("tbody", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", null, /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtCounters"
    }, items))))));
  }
  renderCounter(type, value) {
    if (type === "hours" && this.isAMPM()) {
      value = (value - 1) % 12 + 1;
      if (value === 0) {
        value = 12;
      }
    }
    if (type === "ampm") {
      if (this.props.timeFormat.indexOf(" A") !== -1) {
        value = this.props.viewDate.format("A");
      } else {
        value = this.props.viewDate.format("a");
      }
    }
    return /* @__PURE__ */ React__default.createElement("div", {
      key: type,
      className: "rdtCounter"
    }, /* @__PURE__ */ React__default.createElement("span", {
      className: "rdtBtn",
      onMouseDown: (e) => this.onStartClicking(e, "increase", type)
    }, "\u25B2"), /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtCount"
    }, value), /* @__PURE__ */ React__default.createElement("span", {
      className: "rdtBtn",
      onMouseDown: (e) => this.onStartClicking(e, "decrease", type)
    }, "\u25BC"));
  }
  renderHeader() {
    if (!this.props.dateFormat)
      return;
    const date = this.props.selectedDate || this.props.viewDate;
    return /* @__PURE__ */ React__default.createElement("thead", null, /* @__PURE__ */ React__default.createElement("tr", null, /* @__PURE__ */ React__default.createElement("td", {
      className: "rdtSwitch",
      colSpan: "4",
      onClick: () => this.props.showView("days")
    }, date.format(this.props.dateFormat))));
  }
  onStartClicking(e, action, type) {
    if (e && e.button && e.button !== 0) {
      return;
    }
    if (type === "ampm")
      return this.toggleDayPart();
    let update = {};
    let body = document.body;
    update[type] = this[action](type);
    this.setState(update);
    this.timer = setTimeout(() => {
      this.increaseTimer = setInterval(() => {
        update[type] = this[action](type);
        this.setState(update);
      }, 70);
    }, 500);
    this.mouseUpListener = () => {
      clearTimeout(this.timer);
      clearInterval(this.increaseTimer);
      this.props.setTime(type, parseInt(this.state[type], 10));
      body.removeEventListener("mouseup", this.mouseUpListener);
      body.removeEventListener("touchend", this.mouseUpListener);
    };
    body.addEventListener("mouseup", this.mouseUpListener);
    body.addEventListener("touchend", this.mouseUpListener);
  }
  toggleDayPart() {
    let hours = parseInt(this.state.hours, 10);
    if (hours >= 12) {
      hours -= 12;
    } else {
      hours += 12;
    }
    this.props.setTime("hours", hours);
  }
  increase(type) {
    const tc = this.constraints[type];
    let value = parseInt(this.state[type], 10) + tc.step;
    if (value > tc.max)
      value = tc.min + (value - (tc.max + 1));
    return pad(type, value);
  }
  decrease(type) {
    const tc = this.constraints[type];
    let value = parseInt(this.state[type], 10) - tc.step;
    if (value < tc.min)
      value = tc.max + 1 - (tc.min - value);
    return pad(type, value);
  }
  getCounters() {
    let counters = [];
    let format2 = this.props.timeFormat;
    if (format2.toLowerCase().indexOf("h") !== -1) {
      counters.push("hours");
      if (format2.indexOf("m") !== -1) {
        counters.push("minutes");
        if (format2.indexOf("s") !== -1) {
          counters.push("seconds");
          if (format2.indexOf("S") !== -1) {
            counters.push("milliseconds");
          }
        }
      }
    }
    if (this.isAMPM()) {
      counters.push("ampm");
    }
    return counters;
  }
  isAMPM() {
    return this.props.timeFormat.toLowerCase().indexOf(" a") !== -1;
  }
  getTimeParts(date) {
    const hours = date.hours();
    return {
      hours: pad("hours", hours),
      minutes: pad("minutes", date.minutes()),
      seconds: pad("seconds", date.seconds()),
      milliseconds: pad("milliseconds", date.milliseconds()),
      ampm: hours < 12 ? "am" : "pm"
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.selectedDate) {
      if (this.props.selectedDate !== prevProps.selectedDate) {
        this.setState(this.getTimeParts(this.props.selectedDate));
      }
    } else if (prevProps.viewDate !== this.props.viewDate) {
      this.setState(this.getTimeParts(this.props.viewDate));
    }
  }
}
function pad(type, value) {
  const padValues = {
    hours: 1,
    minutes: 2,
    seconds: 2,
    milliseconds: 3
  };
  let str = value + "";
  while (str.length < padValues[type])
    str = "0" + str;
  return str;
}
const viewModes = {
  YEARS: "years",
  MONTHS: "months",
  DAYS: "days",
  TIME: "time"
};
const TYPES = PropTypes;
const nofn = function() {
};
const datetype = TYPES.oneOfType([
  TYPES.instanceOf(moment),
  TYPES.instanceOf(Date),
  TYPES.string
]);
class Datetime extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_renderCalendar", () => {
      const props = this.props;
      const state = this.state;
      let viewProps = {
        viewDate: state.viewDate.clone(),
        selectedDate: this.getSelectedDate(),
        isValidDate: props.isValidDate,
        updateDate: this._updateDate,
        navigate: this._viewNavigate,
        moment,
        showView: this._showView
      };
      switch (state.currentView) {
        case viewModes.YEARS:
          viewProps.renderYear = props.renderYear;
          return /* @__PURE__ */ React__default.createElement(YearsView, {
            ...viewProps
          });
        case viewModes.MONTHS:
          viewProps.renderMonth = props.renderMonth;
          return /* @__PURE__ */ React__default.createElement(MonthsView, {
            ...viewProps
          });
        case viewModes.DAYS:
          viewProps.renderDay = props.renderDay;
          viewProps.timeFormat = this.getFormat("time");
          return /* @__PURE__ */ React__default.createElement(DaysView, {
            ...viewProps
          });
        default:
          viewProps.dateFormat = this.getFormat("date");
          viewProps.timeFormat = this.getFormat("time");
          viewProps.timeConstraints = props.timeConstraints;
          viewProps.setTime = this._setTime;
          return /* @__PURE__ */ React__default.createElement(TimeView, {
            ...viewProps
          });
      }
    });
    __publicField(this, "_showView", (view, date) => {
      const d = (date || this.state.viewDate).clone();
      const nextView = this.props.onBeforeNavigate(view, this.state.currentView, d);
      if (nextView && this.state.currentView !== nextView) {
        this.props.onNavigate(nextView);
        this.setState({ currentView: nextView });
      }
    });
    __publicField(this, "viewToMethod", { days: "date", months: "month", years: "year" });
    __publicField(this, "nextView", { days: "time", months: "days", years: "months" });
    __publicField(this, "_updateDate", (e) => {
      let state = this.state;
      let currentView = state.currentView;
      let updateOnView = this.getUpdateOn(this.getFormat("date"));
      let viewDate = this.state.viewDate.clone();
      viewDate[this.viewToMethod[currentView]](parseInt(e.target.getAttribute("data-value"), 10));
      if (currentView === "days") {
        viewDate.month(parseInt(e.target.getAttribute("data-month"), 10));
        viewDate.year(parseInt(e.target.getAttribute("data-year"), 10));
      }
      let update = { viewDate };
      if (currentView === updateOnView) {
        update.selectedDate = viewDate.clone();
        update.inputValue = viewDate.format(this.getFormat("datetime"));
        if (this.props.open === void 0 && this.props.input && this.props.closeOnSelect) {
          this._closeCalendar();
        }
        this.props.onChange(viewDate.clone());
      } else {
        this._showView(this.nextView[currentView], viewDate);
      }
      this.setState(update);
    });
    __publicField(this, "_viewNavigate", (modifier, unit) => {
      let viewDate = this.state.viewDate.clone();
      viewDate.add(modifier, unit);
      if (modifier > 0) {
        this.props.onNavigateForward(modifier, unit);
      } else {
        this.props.onNavigateBack(-modifier, unit);
      }
      this.setState({ viewDate });
    });
    __publicField(this, "_setTime", (type, value) => {
      let date = (this.getSelectedDate() || this.state.viewDate).clone();
      date[type](value);
      if (!this.props.value) {
        this.setState({
          selectedDate: date,
          viewDate: date.clone(),
          inputValue: date.format(this.getFormat("datetime"))
        });
      }
      this.props.onChange(date);
    });
    __publicField(this, "_openCalendar", () => {
      if (this.isOpen())
        return;
      this.setState({ open: true }, this.props.onOpen);
    });
    __publicField(this, "_closeCalendar", () => {
      if (!this.isOpen())
        return;
      this.setState({ open: false }, () => {
        this.props.onClose(this.state.selectedDate || this.state.inputValue);
      });
    });
    __publicField(this, "_handleClickOutside", () => {
      let props = this.props;
      if (props.input && this.state.open && props.open === void 0 && props.closeOnClickOutside) {
        this._closeCalendar();
      }
    });
    __publicField(this, "_onInputFocus", (e) => {
      if (!this.callHandler(this.props.inputProps.onFocus, e))
        return;
      this._openCalendar();
    });
    __publicField(this, "_onInputChange", (e) => {
      if (!this.callHandler(this.props.inputProps.onChange, e))
        return;
      const value = e.target ? e.target.value : e;
      const localMoment = this.localMoment(value, this.getFormat("datetime"));
      let update = { inputValue: value };
      if (localMoment.isValid()) {
        update.selectedDate = localMoment;
        update.viewDate = localMoment.clone().startOf("month");
      } else {
        update.selectedDate = null;
      }
      this.setState(update, () => {
        this.props.onChange(localMoment.isValid() ? localMoment : this.state.inputValue);
      });
    });
    __publicField(this, "_onInputKeyDown", (e) => {
      if (!this.callHandler(this.props.inputProps.onKeyDown, e))
        return;
      if (e.which === 9 && this.props.closeOnTab) {
        this._closeCalendar();
      }
    });
    __publicField(this, "_onInputClick", (e) => {
      if (!this.callHandler(this.props.inputProps.onClick, e))
        return;
      this._openCalendar();
    });
    this.state = this.getInitialState();
  }
  render() {
    return /* @__PURE__ */ React__default.createElement(ClickableWrapper, {
      className: this.getClassName(),
      onClickOut: this._handleClickOutside
    }, this.renderInput(), /* @__PURE__ */ React__default.createElement("div", {
      className: "rdtPicker"
    }, this.renderView()));
  }
  renderInput() {
    if (!this.props.input)
      return;
    const finalInputProps = {
      type: "text",
      className: "form-control",
      value: this.getInputValue(),
      ...this.props.inputProps,
      onFocus: this._onInputFocus,
      onChange: this._onInputChange,
      onKeyDown: this._onInputKeyDown,
      onClick: this._onInputClick
    };
    if (this.props.renderInput) {
      return /* @__PURE__ */ React__default.createElement("div", null, this.props.renderInput(finalInputProps, this._openCalendar, this._closeCalendar));
    }
    return /* @__PURE__ */ React__default.createElement("input", {
      ...finalInputProps
    });
  }
  renderView() {
    return this.props.renderView(this.state.currentView, this._renderCalendar);
  }
  getInitialState() {
    let props = this.props;
    let inputFormat = this.getFormat("datetime");
    let selectedDate = this.parseDate(props.value || props.initialValue, inputFormat);
    this.checkTZ();
    return {
      open: !props.input,
      currentView: props.initialViewMode || this.getInitialView(),
      viewDate: this.getInitialViewDate(selectedDate),
      selectedDate: selectedDate && selectedDate.isValid() ? selectedDate : void 0,
      inputValue: this.getInitialInputValue(selectedDate)
    };
  }
  getInitialViewDate(selectedDate) {
    const propDate = this.props.initialViewDate;
    let viewDate;
    if (propDate) {
      viewDate = this.parseDate(propDate, this.getFormat("datetime"));
      if (viewDate && viewDate.isValid()) {
        return viewDate;
      } else {
        log('The initialViewDated given "' + propDate + '" is not valid. Using current date instead.');
      }
    } else if (selectedDate && selectedDate.isValid()) {
      return selectedDate.clone();
    }
    return this.getInitialDate();
  }
  getInitialDate() {
    let m = this.localMoment();
    m.hour(0).minute(0).second(0).millisecond(0);
    return m;
  }
  getInitialView() {
    const dateFormat = this.getFormat("date");
    return dateFormat ? this.getUpdateOn(dateFormat) : viewModes.TIME;
  }
  parseDate(date, dateFormat) {
    let parsedDate;
    if (date && typeof date === "string")
      parsedDate = this.localMoment(date, dateFormat);
    else if (date)
      parsedDate = this.localMoment(date);
    if (parsedDate && !parsedDate.isValid())
      parsedDate = null;
    return parsedDate;
  }
  getClassName() {
    let cn = "rdt";
    let props = this.props;
    let propCn = props.className;
    if (Array.isArray(propCn)) {
      cn += " " + propCn.join(" ");
    } else if (propCn) {
      cn += " " + propCn;
    }
    if (!props.input) {
      cn += " rdtStatic";
    }
    if (this.isOpen()) {
      cn += " rdtOpen";
    }
    return cn;
  }
  isOpen() {
    return !this.props.input || (this.props.open === void 0 ? this.state.open : this.props.open);
  }
  getUpdateOn(dateFormat) {
    if (this.props.updateOnView) {
      return this.props.updateOnView;
    }
    if (dateFormat.match(/[lLD]/)) {
      return viewModes.DAYS;
    }
    if (dateFormat.indexOf("M") !== -1) {
      return viewModes.MONTHS;
    }
    if (dateFormat.indexOf("Y") !== -1) {
      return viewModes.YEARS;
    }
    return viewModes.DAYS;
  }
  getLocaleData() {
    let p = this.props;
    return this.localMoment(p.value || p.defaultValue || new Date()).localeData();
  }
  getDateFormat() {
    const locale = this.getLocaleData();
    let format2 = this.props.dateFormat;
    if (format2 === true)
      return locale.longDateFormat("L");
    if (format2)
      return format2;
    return "";
  }
  getTimeFormat() {
    const locale = this.getLocaleData();
    let format2 = this.props.timeFormat;
    if (format2 === true) {
      return locale.longDateFormat("LT");
    }
    return format2 || "";
  }
  getFormat(type) {
    if (type === "date") {
      return this.getDateFormat();
    } else if (type === "time") {
      return this.getTimeFormat();
    }
    let dateFormat = this.getDateFormat();
    let timeFormat = this.getTimeFormat();
    return dateFormat && timeFormat ? dateFormat + " " + timeFormat : dateFormat || timeFormat;
  }
  updateTime(op, amount, type, toSelected) {
    let update = {};
    const date = toSelected ? "selectedDate" : "viewDate";
    update[date] = this.state[date].clone()[op](amount, type);
    this.setState(update);
  }
  localMoment(date, format2, props) {
    props = props || this.props;
    let m = null;
    if (props.utc) {
      m = moment.utc(date, format2, props.strictParsing);
    } else if (props.displayTimeZone) {
      m = moment.tz(date, format2, props.displayTimeZone);
    } else {
      m = moment(date, format2, props.strictParsing);
    }
    if (props.locale)
      m.locale(props.locale);
    return m;
  }
  checkTZ() {
    const { displayTimeZone } = this.props;
    if (displayTimeZone && !this.tzWarning && !moment.tz) {
      this.tzWarning = true;
      log('displayTimeZone prop with value "' + displayTimeZone + '" is used but moment.js timezone is not loaded.', "error");
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps === this.props)
      return;
    let needsUpdate = false;
    let thisProps = this.props;
    ["locale", "utc", "displayZone", "dateFormat", "timeFormat"].forEach(function(p) {
      prevProps[p] !== thisProps[p] && (needsUpdate = true);
    });
    if (needsUpdate) {
      this.regenerateDates();
    }
    if (thisProps.value && thisProps.value !== prevProps.value) {
      this.setViewDate(thisProps.value);
    }
    this.checkTZ();
  }
  regenerateDates() {
    const props = this.props;
    let viewDate = this.state.viewDate.clone();
    let selectedDate = this.state.selectedDate && this.state.selectedDate.clone();
    if (props.locale) {
      viewDate.locale(props.locale);
      selectedDate && selectedDate.locale(props.locale);
    }
    if (props.utc) {
      viewDate.utc();
      selectedDate && selectedDate.utc();
    } else if (props.displayTimeZone) {
      viewDate.tz(props.displayTimeZone);
      selectedDate && selectedDate.tz(props.displayTimeZone);
    } else {
      viewDate.locale();
      selectedDate && selectedDate.locale();
    }
    let update = { viewDate, selectedDate };
    if (selectedDate && selectedDate.isValid()) {
      update.inputValue = selectedDate.format(this.getFormat("datetime"));
    }
    this.setState(update);
  }
  getSelectedDate() {
    if (this.props.value === void 0)
      return this.state.selectedDate;
    let selectedDate = this.parseDate(this.props.value, this.getFormat("datetime"));
    return selectedDate && selectedDate.isValid() ? selectedDate : false;
  }
  getInitialInputValue(selectedDate) {
    const props = this.props;
    if (props.inputProps.value)
      return props.inputProps.value;
    if (selectedDate && selectedDate.isValid())
      return selectedDate.format(this.getFormat("datetime"));
    if (props.value && typeof props.value === "string")
      return props.value;
    if (props.initialValue && typeof props.initialValue === "string")
      return props.initialValue;
    return "";
  }
  getInputValue() {
    let selectedDate = this.getSelectedDate();
    return selectedDate ? selectedDate.format(this.getFormat("datetime")) : this.state.inputValue;
  }
  setViewDate(date) {
    let logError = function() {
      return log("Invalid date passed to the `setViewDate` method: " + date);
    };
    if (!date)
      return logError();
    let viewDate;
    if (typeof date === "string") {
      viewDate = this.localMoment(date, this.getFormat("datetime"));
    } else {
      viewDate = this.localMoment(date);
    }
    if (!viewDate || !viewDate.isValid())
      return logError();
    this.setState({ viewDate });
  }
  navigate(mode) {
    this._showView(mode);
  }
  callHandler(method, e) {
    if (!method)
      return true;
    return method(e) !== false;
  }
}
__publicField(Datetime, "propTypes", {
  value: datetype,
  initialValue: datetype,
  initialViewDate: datetype,
  initialViewMode: TYPES.oneOf([
    viewModes.YEARS,
    viewModes.MONTHS,
    viewModes.DAYS,
    viewModes.TIME
  ]),
  onOpen: TYPES.func,
  onClose: TYPES.func,
  onChange: TYPES.func,
  onNavigate: TYPES.func,
  onBeforeNavigate: TYPES.func,
  onNavigateBack: TYPES.func,
  onNavigateForward: TYPES.func,
  updateOnView: TYPES.string,
  locale: TYPES.string,
  utc: TYPES.bool,
  displayTimeZone: TYPES.string,
  input: TYPES.bool,
  dateFormat: TYPES.oneOfType([TYPES.string, TYPES.bool]),
  timeFormat: TYPES.oneOfType([TYPES.string, TYPES.bool]),
  inputProps: TYPES.object,
  timeConstraints: TYPES.object,
  isValidDate: TYPES.func,
  open: TYPES.bool,
  strictParsing: TYPES.bool,
  closeOnSelect: TYPES.bool,
  closeOnTab: TYPES.bool,
  renderView: TYPES.func,
  renderInput: TYPES.func,
  renderDay: TYPES.func,
  renderMonth: TYPES.func,
  renderYear: TYPES.func
});
__publicField(Datetime, "defaultProps", {
  onOpen: nofn,
  onClose: nofn,
  onCalendarOpen: nofn,
  onCalendarClose: nofn,
  onChange: nofn,
  onNavigate: nofn,
  onBeforeNavigate: function(next) {
    return next;
  },
  onNavigateBack: nofn,
  onNavigateForward: nofn,
  dateFormat: true,
  timeFormat: true,
  utc: false,
  className: "",
  input: true,
  inputProps: {},
  timeConstraints: {},
  isValidDate: function() {
    return true;
  },
  strictParsing: true,
  closeOnSelect: false,
  closeOnTab: true,
  closeOnClickOutside: true,
  renderView: (_, renderFunc) => renderFunc()
});
__publicField(Datetime, "moment", moment);
function log(message, method) {
  let con = typeof window !== "undefined" && window.console;
  if (!con)
    return;
  if (!method) {
    method = "warn";
  }
  con[method]("***react-datetime:" + message);
}
class ClickOutBase extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "container", React__default.createRef());
  }
  render() {
    return /* @__PURE__ */ React__default.createElement("div", {
      className: this.props.className,
      ref: this.container
    }, this.props.children);
  }
  handleClickOutside(e) {
    this.props.onClickOut(e);
  }
  setClickOutsideRef() {
    return this.container.current;
  }
}
const ClickableWrapper = onClickOutside(ClickOutBase);
const DEFAULT_DATE_DISPLAY_FORMAT = "MMM DD, YYYY";
const DEFAULT_TIME_DISPLAY_FORMAT = "h:mm A";
const format = (val, _name, field) => {
  if (!val)
    return val;
  const dateFormat = parseDateFormat(field.dateFormat);
  const timeFormat = parseTimeFormat(field.timeFormat);
  const combinedFormat = typeof timeFormat === "string" ? `${dateFormat} ${timeFormat}` : dateFormat;
  if (typeof val === "string") {
    const date = moment(val);
    return date.isValid() ? date.format(combinedFormat) : val;
  }
  return moment(val).format(combinedFormat);
};
const parse = (val) => {
  if (!val)
    return val;
  const date = new Date(val);
  if (!isNaN(date.getTime())) {
    return new Date(val).toISOString();
  }
  return val;
};
function parseDateFormat(format2) {
  if (typeof format2 === "string") {
    return format2;
  }
  return DEFAULT_DATE_DISPLAY_FORMAT;
}
function parseTimeFormat(format2) {
  if (typeof format2 === "string") {
    return format2;
  } else if (format2) {
    return DEFAULT_TIME_DISPLAY_FORMAT;
  }
}
var DateFieldPluginCSS = ".tina-date-field .rdt {\n  position: relative;\n}\n\n.tina-date-field .rdtPicker {\n  display: none;\n  position: absolute;\n  width: 100%;\n  max-width: 350px;\n  padding: 4px;\n  margin-top: 4px;\n  z-index: 99999 !important;\n  background: var(--tina-color-grey-0);\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-big);\n  border: 1px solid var(--tina-color-grey-2);\n}\n\n.tina-date-field .rdtOpen .rdtPicker {\n  display: block;\n}\n\n.tina-date-field .rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.tina-date-field .rdtPicker .rdtTimeToggle {\n  text-align: center;\n}\n\n.tina-date-field .rdtPicker table {\n  width: 100%;\n  margin: 0;\n}\n\n.tina-date-field .rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  height: 28px;\n}\n\n.tina-date-field .rdtPicker td {\n  cursor: pointer;\n}\n\n.tina-date-field .rdtPicker td.rdtDay:hover,\n.tina-date-field .rdtPicker td.rdtHour:hover,\n.tina-date-field .rdtPicker td.rdtMinute:hover,\n.tina-date-field .rdtPicker td.rdtSecond:hover,\n.tina-date-field .rdtPicker .rdtTimeToggle:hover {\n  background: var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  border-radius: var(--tina-radius-small);\n  cursor: pointer;\n}\n\n.tina-date-field .rdtPicker td.rdtDay:hover:active,\n.tina-date-field .rdtPicker td.rdtHour:hover:active,\n.tina-date-field .rdtPicker td.rdtMinute:hover:active,\n.tina-date-field .rdtPicker td.rdtSecond:hover:active,\n.tina-date-field .rdtPicker .rdtTimeToggle:hover:active {\n  background: var(--tina-color-primary);\n  color: var(--tina-color-grey-0);\n  border-radius: var(--tina-radius-small);\n}\n\n.tina-date-field .rdtPicker td.rdtOld,\n.rdtPicker td.rdtNew {\n  color: var(--tina-color-grey-6);\n}\n\n.tina-date-field .rdtPicker td.rdtToday {\n  position: relative;\n}\n\n.tina-date-field .rdtPicker td.rdtToday:before {\n  content: '';\n  display: inline-block;\n  border-left: 7px solid transparent;\n  border-bottom: 7px solid var(--tina-color-primary);\n  border-radius: 20px;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n\n.tina-date-field .rdtPicker td.rdtActive,\n.rdtPicker td.rdtActive:hover {\n  background-color: var(--tina-color-primary);\n  color: var(--tina-color-grey-0);\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n\n.tina-date-field .rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: var(--tina-color-grey-0);\n}\n\n.tina-date-field .rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: var(--tina-color-grey-6);\n  cursor: not-allowed;\n}\n\n.tina-date-field .rdtPicker td span.rdtOld {\n  color: var(--tina-color-grey-6);\n}\n\n.tina-date-field .rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: var(--tina-color-grey-6);\n  cursor: not-allowed;\n}\n\n.tina-date-field .rdtPicker th {\n  border-bottom: 1px solid var(--tina-color-grey-1);\n}\n\n.tina-date-field .rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  cursor: default;\n}\n\n.tina-date-field .rdtPicker th.rdtSwitch {\n  width: 100px;\n}\n\n.tina-date-field .rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 21px;\n  vertical-align: top;\n}\n\n.tina-date-field .rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Chrome/Safari/Opera */\n  -khtml-user-select: none;\n  /* Konqueror */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.tina-date-field .rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: var(--tina-color-grey-6);\n  cursor: not-allowed;\n}\n\n.tina-date-field .rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n\n.tina-date-field .rdtPicker thead tr:first-child th:hover {\n  background: var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  border-radius: var(--tina-radius-small);\n}\n\n.tina-date-field .rdtPicker tfoot {\n  border-top: 1px solid var(--tina-color-grey-1);\n}\n\n.tina-date-field .rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.tina-date-field .rdtPicker button:hover {\n  background: var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  border-radius: var(--tina-radius-small);\n}\n\n.tina-date-field .rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\n.tina-date-field td.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\n\n.tina-date-field td.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  border-radius: var(--tina-radius-small);\n}\n\n.tina-date-field .rdtCounters {\n  display: inline-block;\n}\n\n.tina-date-field .rdtCounters > div {\n  float: left;\n}\n\n.tina-date-field .rdtCounter {\n  height: 100px;\n  width: 40px;\n}\n\n.tina-date-field .rdtCounterSeparator {\n  line-height: 100px;\n}\n\n.tina-date-field .rdtCounter .rdtBtn {\n  height: 40%;\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Chrome/Safari/Opera */\n  -khtml-user-select: none;\n  /* Konqueror */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.tina-date-field .rdtCounter .rdtBtn:hover {\n  background: var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  border-radius: var(--tina-radius-small);\n}\n\n.tina-date-field .rdtCounter .rdtCount {\n  height: 20%;\n  font-size: 1.2em;\n}\n\n.tina-date-field .rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.tina-date-field .rdtMilli input {\n  width: 100%;\n  font-size: 1.2em;\n  margin-top: 37px;\n}\n\n.tina-date-field .rdtTime td {\n  cursor: default;\n}\n";
const DateField = wrapFieldsWithMeta(({ input, field: { dateFormat, timeFormat, ...rest } }) => {
  const [isOpen, setIsOpen] = useState(false);
  const area = useRef(null);
  useEffect(() => {
    const handleClick = (event) => {
      if (!area.current)
        return;
      if (!event.target)
        return;
      if (!area.current.contains(event.target)) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };
    document.addEventListener("mouseup", handleClick, false);
    return () => {
      document.removeEventListener("mouseup", handleClick, false);
    };
  }, [document]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("style", null, DateFieldPluginCSS), /* @__PURE__ */ React.createElement("div", {
    className: "tina-date-field",
    ref: area
  }, /* @__PURE__ */ React.createElement(Datetime, {
    value: input.value,
    onFocus: input.onFocus,
    onChange: input.onChange,
    open: isOpen,
    dateFormat: dateFormat || DEFAULT_DATE_DISPLAY_FORMAT,
    timeFormat: timeFormat || false,
    inputProps: { className: textFieldClasses },
    ...rest
  })));
});
const DateFieldPlugin = {
  __type: "field",
  name: "date",
  Component: DateField,
  format,
  parse
};
const CheckboxGroupField = wrapFieldsWithMeta(CheckboxGroup);
const CheckboxGroupFieldPlugin = {
  name: "checkbox-group",
  Component: CheckboxGroupField
};
const ReferenceField = wrapFieldsWithMeta(Reference);
const ReferenceFieldPlugin = {
  name: "reference",
  type: "reference",
  Component: ReferenceField,
  parse: parse$2
};
const PendingFormsPlaceholder = () => /* @__PURE__ */ React.createElement("div", {
  className: "relative flex flex-col items-center justify-center text-center p-5 pb-16 w-full h-full overflow-y-auto",
  style: {
    animationName: "fade-in",
    animationDelay: "300ms",
    animationTimingFunction: "ease-out",
    animationIterationCount: 1,
    animationFillMode: "both",
    animationDuration: "150ms"
  }
}, /* @__PURE__ */ React.createElement("p", {
  className: "block pb-5"
}, "Please wait while Tina", /* @__PURE__ */ React.createElement("br", null), "loads your forms"), /* @__PURE__ */ React.createElement(LoadingDots, {
  color: "var(--tina-color-primary)"
}));
const NoFormsPlaceholder = () => /* @__PURE__ */ React.createElement("div", {
  className: "relative flex flex-col items-center justify-center text-center p-5 pb-16 w-full h-full overflow-y-auto",
  style: {
    animationName: "fade-in",
    animationDelay: "300ms",
    animationTimingFunction: "ease-out",
    animationIterationCount: 1,
    animationFillMode: "both",
    animationDuration: "150ms"
  }
}, /* @__PURE__ */ React.createElement(Emoji, {
  className: "pb-5"
}, "\u{1F50E}"), /* @__PURE__ */ React.createElement("p", {
  className: "block pb-5"
}, "Looks like there's ", /* @__PURE__ */ React.createElement("br", null), "nothing to edit on ", /* @__PURE__ */ React.createElement("br", null), "this page."), /* @__PURE__ */ React.createElement("p", {
  className: "block"
}, /* @__PURE__ */ React.createElement(Button, {
  href: "https://tina.io/docs/tinacms-context/",
  target: "_blank",
  as: "a"
}, /* @__PURE__ */ React.createElement(Emoji, {
  className: "mr-1.5"
}, "\u{1F4D6}"), " Contextual Editing")));
const Emoji = ({ className = "", ...props }) => /* @__PURE__ */ React.createElement("span", {
  className: `text-[24px] leading-none inline-block ${className}`,
  ...props
});
class SidebarState {
  constructor(events, options = {}) {
    var _a, _b;
    this.events = events;
    this._isOpen = false;
    this.position = "displace";
    this.renderNav = true;
    this.buttons = {
      save: "Save",
      reset: "Reset"
    };
    this.position = options.position || "displace";
    this.renderNav = options.renderNav || true;
    this.placeholder = options.placeholder || NoFormsPlaceholder;
    if ((_a = options.buttons) == null ? void 0 : _a.save) {
      this.buttons.save = options.buttons.save;
    }
    if ((_b = options.buttons) == null ? void 0 : _b.reset) {
      this.buttons.reset = options.buttons.reset;
    }
  }
  get isOpen() {
    return this._isOpen;
  }
  set isOpen(nextValue) {
    if (this._isOpen === nextValue) {
      return;
    }
    this._isOpen = nextValue;
    if (nextValue) {
      this.events.dispatch({ type: "sidebar:opened" });
    } else {
      this.events.dispatch({ type: "sidebar:closed" });
    }
  }
  subscribe(callback) {
    const unsub = this.events.subscribe("sidebar", callback);
    return () => unsub();
  }
}
function BsArrowsAngleContract(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707zM15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707z" } }] })(props);
}
function BsArrowsAngleExpand(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z" } }] })(props);
}
function BsCheckCircleFill(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" } }] })(props);
}
function BsExclamationOctagonFill(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" } }] })(props);
}
const FormList = ({
  hidden = false,
  forms,
  setActiveFormId
}) => {
  return /* @__PURE__ */ React.createElement(Transition, {
    appear: true,
    show: !hidden,
    enter: "transition-all ease-out duration-150",
    enterFrom: "opacity-0 -translate-x-1/2",
    enterTo: "opacity-100",
    leave: "transition-all ease-out duration-150",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0 -translate-x-1/2"
  }, /* @__PURE__ */ React.createElement("ul", {
    className: "pt-16"
  }, forms.sort(byId).map((form, index) => /* @__PURE__ */ React.createElement("li", {
    key: form.id,
    className: `relative px-6 py-2`
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: () => setActiveFormId(form.id),
    className: "w-full h-full bg-transparent border-none text-lg text-gray-700 hover:text-blue-500 transition-all ease-out duration-150 flex items-center gap-2 p-1 m-0"
  }, /* @__PURE__ */ React.createElement(BiPencil, {
    className: "opacity-70 w-5 h-auto fill-current"
  }), form.label), index !== forms.length - 1 && /* @__PURE__ */ React.createElement("hr", {
    className: "absolute bottom-0 left-0 border-t border-gray-100 w-full"
  })))));
};
const byId = (b, a) => {
  if (a.id < b.id) {
    return -1;
  }
  if (a.id > b.id) {
    return 1;
  }
  return 0;
};
const FormsView = ({
  children
}) => {
  var _a;
  const [activeFormId, setActiveFormId] = useState("");
  const cms = useCMS$1();
  const renderNav = typeof ((_a = cms == null ? void 0 : cms.sidebar) == null ? void 0 : _a.renderNav) !== "undefined" ? cms.sidebar.renderNav : true;
  const formPlugins = cms.plugins.getType("form");
  const { setFormIsPristine } = React.useContext(SidebarContext);
  const { formsRegistering, setFormsRegistering } = React.useContext(EditContext);
  React.useMemo(() => cms.events.subscribe("forms:register", (event) => {
    if (event.value === "start") {
      setFormsRegistering(true);
    } else {
      setFormsRegistering(false);
    }
  }), []);
  function setSingleActiveForm() {
    if (formPlugins.all().length === 1) {
      setActiveFormId(formPlugins.all()[0].id);
    }
  }
  useSubscribable(formPlugins, () => {
    setSingleActiveForm();
  });
  React.useEffect(() => {
    setSingleActiveForm();
  }, []);
  const forms = formPlugins.all();
  const isMultiform = forms.length > 1;
  const activeForm = formPlugins.find(activeFormId);
  const isEditing = !!activeForm;
  if (!forms.length) {
    if (formsRegistering)
      return /* @__PURE__ */ React.createElement(PendingFormsPlaceholder, null);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, " ", children, " ");
  }
  if (isMultiform && !activeForm) {
    return /* @__PURE__ */ React.createElement(FormList, {
      isEditing,
      forms,
      setActiveFormId
    });
  }
  const formMetas = cms.plugins.all("form:meta");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, activeForm && /* @__PURE__ */ React.createElement(FormWrapper, {
    isEditing,
    isMultiform
  }, isMultiform && /* @__PURE__ */ React.createElement(MultiformFormHeader, {
    renderNav,
    activeForm,
    setActiveFormId
  }), !isMultiform && /* @__PURE__ */ React.createElement(FormHeader, {
    renderNav,
    activeForm
  }), formMetas && formMetas.map((meta) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: meta.name
  }, /* @__PURE__ */ React.createElement(meta.Component, null))), /* @__PURE__ */ React.createElement(FormBuilder, {
    form: activeForm,
    onPristineChange: setFormIsPristine
  })));
};
const FormWrapper = ({ isEditing, children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-1 flex flex-col flex-nowrap overflow-hidden h-full w-full relative bg-white",
    style: isEditing ? {
      transform: "none",
      animationName: "fly-in-left",
      animationDuration: "150ms",
      animationDelay: "0",
      animationIterationCount: 1,
      animationTimingFunction: "ease-out"
    } : {
      transform: "translate3d(100%, 0, 0)"
    }
  }, children);
};
const MultiformFormHeader = ({
  activeForm,
  setActiveFormId,
  renderNav
}) => {
  const cms = useCMS$1();
  const { sidebarWidth, formIsPristine } = React.useContext(SidebarContext);
  return /* @__PURE__ */ React.createElement("div", {
    className: `py-4 border-b border-gray-200 bg-white ${sidebarWidth > navBreakpoint && renderNav ? `px-6` : renderNav ? `pl-20 pr-28` : `pl-6 pr-28`}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "max-w-form mx-auto flex flex-col items-start justify-center min-h-[2.5rem]"
  }, /* @__PURE__ */ React.createElement("button", {
    className: "pointer-events-auto text-xs mb-1 text-gray-400 hover:text-blue-500 hover:underline transition-all ease-out duration-150 font-medium flex items-center justify-start gap-0.5",
    onClick: () => {
      const state = activeForm.finalForm.getState();
      if (state.invalid === true) {
        cms.alerts.error("Cannot navigate away from an invalid form.");
      } else {
        setActiveFormId("");
      }
    }
  }, /* @__PURE__ */ React.createElement(BiChevronLeft, {
    className: "h-auto w-5 inline-block opacity-70 -mt-0.5 -mx-0.5"
  }), "Return to Form List"), /* @__PURE__ */ React.createElement("span", {
    className: "block w-full text-xl mb-[6px] text-gray-700 font-medium leading-tight"
  }, activeForm.label || activeForm.name), /* @__PURE__ */ React.createElement(FormStatus, {
    pristine: formIsPristine
  })));
};
const FormHeader = ({ renderNav, activeForm }) => {
  const { sidebarWidth, formIsPristine, displayState } = React.useContext(SidebarContext);
  const headerPadding = {
    navOpen: "px-6",
    navClosed: "pl-20 pr-28",
    noNav: "pl-6 pr-28"
  };
  const windowWidth = useWindowWidth();
  const navState = !renderNav ? "noNav" : sidebarWidth > navBreakpoint && windowWidth > navBreakpoint || displayState === "fullscreen" && windowWidth > navBreakpoint ? "navOpen" : "navClosed";
  const shortFormLabel = activeForm.label ? activeForm.label.replace(/^.*[\\\/]/, "") : false;
  return /* @__PURE__ */ React.createElement("div", {
    className: `py-4 border-b border-gray-200 bg-white ${headerPadding[navState]}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: "max-w-form mx-auto  flex flex-col items-start justify-center min-h-[2.5rem]"
  }, shortFormLabel && /* @__PURE__ */ React.createElement("span", {
    className: "block w-full text-lg mb-[6px] text-gray-700 font-medium leading-tight text-ellipsis overflow-hidden whitespace-nowrap"
  }, shortFormLabel), /* @__PURE__ */ React.createElement(FormStatus, {
    pristine: formIsPristine
  })));
};
function ImFilesEmpty(props) {
  return GenIcon({ "tag": "svg", "attr": { "version": "1.1", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z" } }, { "tag": "path", "attr": { "d": "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z" } }] })(props);
}
function AiFillWarning(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 1024 1024" }, "child": [{ "tag": "path", "attr": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z" } }] })(props);
}
const LocalWarning = () => {
  return /* @__PURE__ */ React.createElement("a", {
    className: "flex-grow-0 flex w-full text-xs items-center py-1 px-4 text-yellow-600 bg-gradient-to-r from-yellow-50 to-yellow-100 border-b border-yellow-200",
    href: "https://tina.io/docs/tina-cloud/",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement(AiFillWarning, {
    className: "w-5 h-auto inline-block mr-1 opacity-70 text-yellow-600"
  }), " ", "You are currently in", /* @__PURE__ */ React.createElement("strong", {
    className: "ml-1 font-bold text-yellow-700"
  }, "Local Mode"));
};
function FiInfo(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "circle", "attr": { "cx": "12", "cy": "12", "r": "10" } }, { "tag": "line", "attr": { "x1": "12", "y1": "16", "x2": "12", "y2": "12" } }, { "tag": "line", "attr": { "x1": "12", "y1": "8", "x2": "12.01", "y2": "8" } }] })(props);
}
function FiMoreVertical(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "circle", "attr": { "cx": "12", "cy": "12", "r": "1" } }, { "tag": "circle", "attr": { "cx": "12", "cy": "5", "r": "1" } }, { "tag": "circle", "attr": { "cx": "12", "cy": "19", "r": "1" } }] })(props);
}
function VscNewFile(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 16 16", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M9.5 1.1l3.4 3.5.1.4v2h-1V6H8V2H3v11h4v1H2.5l-.5-.5v-12l.5-.5h6.7l.3.1zM9 2v3h2.9L9 2zm4 14h-1v-3H9v-1h3V9h1v3h3v1h-3v3z" } }] })(props);
}
const FormModal = ({ plugin, close }) => {
  const cms = useCMS$1();
  const form = useMemo(() => new Form({
    id: "create-form-id",
    label: "create-form",
    fields: plugin.fields,
    actions: plugin.actions,
    buttons: plugin.buttons,
    initialValues: plugin.initialValues || {},
    reset: plugin.reset,
    onChange: plugin.onChange,
    onSubmit: async (values) => {
      await plugin.onSubmit(values, cms).then(() => {
        close();
      });
    }
  }), [close, cms, plugin]);
  return /* @__PURE__ */ React.createElement(Modal, {
    id: "content-creator-modal",
    onClick: (e) => e.stopPropagation()
  }, /* @__PURE__ */ React.createElement(PopupModal, null, /* @__PURE__ */ React.createElement(ModalHeader, {
    close
  }, plugin.name), /* @__PURE__ */ React.createElement(ModalBody, null, /* @__PURE__ */ React.createElement(FormBuilder, {
    form
  }))));
};
function HiOutlineClipboardList(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "none", "viewBox": "0 0 24 24", "stroke": "currentColor" }, "child": [{ "tag": "path", "attr": { "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "2", "d": "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" } }] })(props);
}
const useGetEvents = (cms, cursor, existingEvents) => {
  const [events, setEvents] = useState([]);
  const [nextCursor, setNextCursor] = useState(void 0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(void 0);
  React.useEffect(() => {
    const fetchEvents = async () => {
      if (cms.api.tina.isAuthorized()) {
        try {
          const { events: nextEvents, cursor: nextCursor2 } = await cms.api.tina.fetchEvents(15, cursor);
          setEvents([...existingEvents, ...nextEvents]);
          setNextCursor(nextCursor2);
        } catch (error2) {
          cms.alerts.error(`[${error2.name}] GetEvents failed: ${error2.message}`, 30 * 1e3);
          console.error(error2);
          setEvents(void 0);
          setError(error2);
        }
        setLoading(false);
      }
    };
    setLoading(true);
    fetchEvents();
  }, [cms, cursor]);
  return { events, cursor: nextCursor, loading, error };
};
function useSyncStatus(cms) {
  const [syncStatus, setSyncStatus] = useState({ state: "loading", message: "Loading..." });
  React.useEffect(() => {
    const interval = setInterval(async () => {
      if (cms.api.tina.isAuthorized()) {
        const { events } = await cms.api.tina.fetchEvents();
        if (events.length === 0) {
          setSyncStatus({ state: "success", message: "No Events" });
        } else {
          if (events[0].isError) {
            setSyncStatus({
              state: "error",
              message: `Sync Failure ${events[0].message}`
            });
          } else {
            setSyncStatus({ state: "success", message: "Sync Successful" });
          }
        }
      } else {
        setSyncStatus({ state: "unauthorized", message: "Not Authenticated" });
      }
    }, 5e3);
    return () => clearInterval(interval);
  }, [cms]);
  return syncStatus;
}
const SyncErrorWidget = ({ cms }) => {
  const syncStatus = useSyncStatus(cms);
  if (syncStatus.state !== "error") {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    title: syncStatus.message,
    className: "flex-grow-0 flex text-xs items-center"
  }, /* @__PURE__ */ React.createElement(MdSyncProblem, {
    className: "w-6 h-full ml-2 text-red-500 fill-current"
  }));
};
const EventsList = ({ cms }) => {
  const [cursor, setCursor] = React.useState(void 0);
  const [existingEvents, setExistingEvents] = React.useState([]);
  const {
    events,
    cursor: nextCursor,
    loading,
    error
  } = useGetEvents(cms, cursor, existingEvents);
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-4 w-full h-full grow-0"
  }, events.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "shrink grow-0 overflow-scroll w-full rounded-md shadow ring-1 ring-black ring-opacity-5"
  }, /* @__PURE__ */ React.createElement("table", {
    className: "w-full divide-y divide-gray-100"
  }, events.map((event, index) => {
    const date = new Date(event.timestamp).toDateString();
    const time = new Date(event.timestamp).toTimeString();
    return /* @__PURE__ */ React.createElement("tr", {
      className: index % 2 === 0 ? "" : "bg-gray-50"
    }, event.isError ? /* @__PURE__ */ React.createElement("td", {
      key: `${event.id}_error_icon`,
      className: "py-3 pl-4 pr-0 w-0"
    }, /* @__PURE__ */ React.createElement(BsExclamationOctagonFill, {
      className: "text-red-500 fill-current w-5 h-auto"
    })) : /* @__PURE__ */ React.createElement("td", {
      key: `${event.id}_ok_icon`,
      className: "py-3 pl-4 pr-0 w-0"
    }, /* @__PURE__ */ React.createElement(BsCheckCircleFill, {
      className: "text-green-500 fill-current w-5 h-auto"
    })), /* @__PURE__ */ React.createElement("td", {
      key: `${event.id}_msg`,
      className: "whitespace-nowrap p-3 text-base text-gray-500"
    }, event.message, event.isError && /* @__PURE__ */ React.createElement("div", {
      className: "w-full text-gray-300 text-xs mt-0.5"
    }, event.id)), /* @__PURE__ */ React.createElement("td", {
      key: `${event.id}_ts`,
      className: "whitespace-nowrap py-3 pl-3 pr-4 text-sm text-gray-500"
    }, date, /* @__PURE__ */ React.createElement("span", {
      className: "w-full block text-gray-300 text-xs mt-0.5"
    }, time)));
  }).flat())), loading && /* @__PURE__ */ React.createElement("div", {
    className: "text-sm text-gray-400 text-center"
  }, "Loading..."), error && /* @__PURE__ */ React.createElement("div", null, "Error: ", error.message), /* @__PURE__ */ React.createElement("div", {
    className: "text-center flex-1"
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => {
      setExistingEvents(events);
      setCursor(nextCursor);
    }
  }, "Load More Events")));
};
const SyncStatusModal = ({ closeEventsModal, cms }) => /* @__PURE__ */ React.createElement(Modal, null, /* @__PURE__ */ React.createElement(FullscreenModal, null, /* @__PURE__ */ React.createElement(ModalHeader, {
  close: closeEventsModal
}, "Event Log"), /* @__PURE__ */ React.createElement(ModalBody, {
  className: "flex h-full flex-col",
  padded: true
}, /* @__PURE__ */ React.createElement(EventsList, {
  cms
}))));
const SyncStatus = ({ cms, setEventsOpen }) => {
  var _a, _b;
  const syncStatus = useSyncStatus(cms);
  function openEventsModal() {
    setEventsOpen(true);
  }
  if ((_b = (_a = cms.api) == null ? void 0 : _a.tina) == null ? void 0 : _b.isLocalMode) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("button", {
    className: `text-lg px-4 py-2 first:pt-3 last:pb-3 tracking-wide whitespace-nowrap flex items-center opacity-80 text-gray-600 hover:text-blue-400 hover:bg-gray-50 hover:opacity-100`,
    onClick: openEventsModal
  }, syncStatus.state !== "error" ? /* @__PURE__ */ React.createElement(HiOutlineClipboardList, {
    className: "w-6 h-auto mr-2 text-blue-400"
  }) : /* @__PURE__ */ React.createElement(MdSyncProblem, {
    className: "w-6 h-auto mr-2 text-red-400"
  }), " ", "Event Log"));
};
const Nav = ({
  isLocalMode,
  className = "",
  children,
  showCollections,
  collectionsInfo,
  screens,
  cloudConfigs,
  contentCreators,
  sidebarWidth,
  RenderNavSite,
  RenderNavCloud,
  RenderNavCollection,
  ...props
}) => {
  const cms = useCMS$1();
  const { setEdit } = useEditState();
  const [eventsOpen, setEventsOpen] = React.useState(false);
  function closeEventsModal() {
    setEventsOpen(false);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative z-30 flex flex-col bg-white border-r border-gray-200 w-96 h-full ${className}`,
    style: { maxWidth: sidebarWidth + "px" },
    ...props
  }, /* @__PURE__ */ React.createElement("div", {
    className: "border-b border-gray-200"
  }, /* @__PURE__ */ React.createElement(Menu, {
    as: "div",
    className: "relative block"
  }, ({ open }) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Menu.Button, {
    className: `group w-full px-6 py-3 gap-2 flex justify-between items-center transition-colors duration-150 ease-out ${open ? `bg-gray-50` : `bg-transparent`}`
  }, /* @__PURE__ */ React.createElement("span", {
    className: "text-left inline-flex items-center text-xl tracking-wide text-gray-800 flex-1 gap-1 opacity-80 group-hover:opacity-100 transition-opacity duration-150 ease-out"
  }, /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 32 32",
    fill: "#EC4815",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-10 h-auto -ml-1"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M18.6466 14.5553C19.9018 13.5141 20.458 7.36086 21.0014 5.14903C21.5447 2.9372 23.7919 3.04938 23.7919 3.04938C23.7919 3.04938 23.2085 4.06764 23.4464 4.82751C23.6844 5.58738 25.3145 6.26662 25.3145 6.26662L24.9629 7.19622C24.9629 7.19622 24.2288 7.10204 23.7919 7.9785C23.355 8.85496 24.3392 17.4442 24.3392 17.4442C24.3392 17.4442 21.4469 22.7275 21.4469 24.9206C21.4469 27.1136 22.4819 28.9515 22.4819 28.9515H21.0296C21.0296 28.9515 18.899 26.4086 18.462 25.1378C18.0251 23.8669 18.1998 22.596 18.1998 22.596C18.1998 22.596 15.8839 22.4646 13.8303 22.596C11.7767 22.7275 10.4072 24.498 10.16 25.4884C9.91287 26.4787 9.81048 28.9515 9.81048 28.9515H8.66211C7.96315 26.7882 7.40803 26.0129 7.70918 24.9206C8.54334 21.8949 8.37949 20.1788 8.18635 19.4145C7.99321 18.6501 6.68552 17.983 6.68552 17.983C7.32609 16.6741 7.97996 16.0452 10.7926 15.9796C13.6052 15.914 17.3915 15.5965 18.6466 14.5553Z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M11.1268 24.7939C11.1268 24.7939 11.4236 27.5481 13.0001 28.9516H14.3511C13.0001 27.4166 12.8527 23.4155 12.8527 23.4155C12.1656 23.6399 11.3045 24.3846 11.1268 24.7939Z"
  })), /* @__PURE__ */ React.createElement("span", null, "Tina")), /* @__PURE__ */ React.createElement(SyncErrorWidget, {
    cms
  }), /* @__PURE__ */ React.createElement(FiMoreVertical, {
    className: `flex-0 w-6 h-full inline-block group-hover:opacity-80 transition-all duration-300 ease-in-out transform ${open ? `opacity-100 text-blue-400` : `text-gray-400 opacity-50 hover:opacity-70`}`
  })), /* @__PURE__ */ React.createElement("div", {
    className: "transform translate-y-full absolute bottom-3 right-5 z-50"
  }, /* @__PURE__ */ React.createElement(Transition, {
    enter: "transition duration-150 ease-out",
    enterFrom: "transform opacity-0 -translate-y-2",
    enterTo: "transform opacity-100 translate-y-0",
    leave: "transition duration-75 ease-in",
    leaveFrom: "transform opacity-100 translate-y-0",
    leaveTo: "transform opacity-0 -translate-y-2"
  }, /* @__PURE__ */ React.createElement(Menu.Items, {
    className: "bg-white border border-gray-150 rounded-lg shadow-lg flex flex-col items-stretch overflow-hidden"
  }, /* @__PURE__ */ React.createElement(Menu.Item, null, /* @__PURE__ */ React.createElement("button", {
    className: `text-lg px-4 py-2 first:pt-3 last:pb-3 tracking-wide whitespace-nowrap flex items-center opacity-80 text-gray-600 hover:text-blue-400 hover:bg-gray-50 hover:opacity-100`,
    onClick: () => {
      var _a, _b;
      updateBodyDisplacement({
        displayState: "closed",
        sidebarWidth: null,
        resizingSidebar: false
      });
      setEdit(false);
      if ((_b = (_a = cms == null ? void 0 : cms.api) == null ? void 0 : _a.tina) == null ? void 0 : _b.onLogout) {
        cms.api.tina.onLogout();
      }
    }
  }, /* @__PURE__ */ React.createElement(BiExit, {
    className: "w-6 h-auto mr-2 text-blue-400"
  }), " Log Out")), /* @__PURE__ */ React.createElement(Menu.Item, null, /* @__PURE__ */ React.createElement(SyncStatus, {
    cms,
    setEventsOpen
  })))))))), eventsOpen && /* @__PURE__ */ React.createElement(SyncStatusModal, {
    cms,
    closeEventsModal
  }), children, /* @__PURE__ */ React.createElement("div", {
    className: "px-6 flex-1 overflow-auto"
  }, showCollections && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h4", {
    className: "flex space-x-1 justify-items-start uppercase font-sans font-bold text-sm mb-3 mt-8 text-gray-700"
  }, /* @__PURE__ */ React.createElement("span", null, "Collections"), isLocalMode && /* @__PURE__ */ React.createElement("span", {
    className: "flex items-center"
  }, /* @__PURE__ */ React.createElement("a", {
    href: "https://tina.io/docs/schema/#defining-collections",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement(FiInfo, null)))), /* @__PURE__ */ React.createElement(CollectionsList, {
    RenderNavCollection,
    ...collectionsInfo
  })), (screens.length > 0 || contentCreators.length) > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h4", {
    className: "uppercase font-sans font-bold text-sm mb-3 mt-8 text-gray-700"
  }, "Site"), /* @__PURE__ */ React.createElement("ul", {
    className: "flex flex-col gap-4"
  }, screens.map((view) => {
    return /* @__PURE__ */ React.createElement("li", {
      key: `nav-site-${view.name}`
    }, /* @__PURE__ */ React.createElement(RenderNavSite, {
      view
    }));
  }), contentCreators.map((plugin, idx) => {
    return /* @__PURE__ */ React.createElement(CreateContentNavItem, {
      key: `plugin-${idx}`,
      plugin
    });
  }))), !!(cloudConfigs == null ? void 0 : cloudConfigs.length) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h4", {
    className: "uppercase font-sans font-bold text-sm mb-3 mt-8 text-gray-700"
  }, "Cloud"), /* @__PURE__ */ React.createElement("ul", {
    className: "flex flex-col gap-4"
  }, cloudConfigs.map((config) => {
    return /* @__PURE__ */ React.createElement("li", {
      key: `nav-site-${config.name}`
    }, /* @__PURE__ */ React.createElement(RenderNavCloud, {
      config
    }));
  })))));
};
const CollectionsList = ({
  collections,
  loading,
  RenderNavCollection
}) => {
  if (loading === true) {
    return /* @__PURE__ */ React.createElement(LoadingDots, {
      color: "var(--tina-color-primary)"
    });
  }
  if (collections.length === 0) {
    return /* @__PURE__ */ React.createElement("div", null, "No collections found");
  }
  return /* @__PURE__ */ React.createElement("ul", {
    className: "flex flex-col gap-4"
  }, collections.map((collection) => {
    return /* @__PURE__ */ React.createElement("li", {
      key: `nav-collection-${collection.name}`
    }, /* @__PURE__ */ React.createElement(RenderNavCollection, {
      collection
    }));
  }));
};
const CreateContentNavItem = ({ plugin }) => {
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ React.createElement("li", {
    key: plugin.name
  }, /* @__PURE__ */ React.createElement("button", {
    className: "text-base tracking-wide text-gray-500 hover:text-blue-600 flex items-center opacity-90 hover:opacity-100",
    onClick: () => {
      setOpen(true);
    }
  }, /* @__PURE__ */ React.createElement(VscNewFile, {
    className: "mr-3 h-6 opacity-80 w-auto"
  }), " ", plugin.name), open && /* @__PURE__ */ React.createElement(FormModal, {
    plugin,
    close: () => setOpen(false)
  }));
};
const ResizeHandle = () => {
  const {
    resizingSidebar,
    setResizingSidebar,
    fullscreen,
    setSidebarWidth,
    displayState
  } = React.useContext(SidebarContext);
  React.useEffect(() => {
    const handleMouseUp = () => setResizingSidebar(false);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);
  React.useEffect(() => {
    const handleMouseMove = (e) => {
      setSidebarWidth((sidebarWidth) => {
        const newWidth = sidebarWidth + e.movementX;
        const maxWidth = window.innerWidth - 8;
        if (newWidth < minSidebarWidth) {
          return minSidebarWidth;
        } else if (newWidth > maxWidth) {
          return maxWidth;
        } else {
          return newWidth;
        }
      });
    };
    if (resizingSidebar) {
      window.addEventListener("mousemove", handleMouseMove);
      document.body.classList.add("select-none");
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      document.body.classList.remove("select-none");
    };
  }, [resizingSidebar]);
  const handleresizingSidebar = () => setResizingSidebar(true);
  if (fullscreen) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", {
    onMouseDown: handleresizingSidebar,
    className: `z-100 absolute top-1/2 right-0 w-2 h-32 bg-white rounded-r-md border border-gray-100 shadow-sm hover:shadow-md transition-all duration-150 ease-out transform translate-x-full -translate-y-1/2 group hover:bg-gray-50 ${displayState !== "closed" ? `opacity-100` : `opacity-0`} ${resizingSidebar ? `scale-110` : ``}`,
    style: { cursor: "grab" }
  }, /* @__PURE__ */ React.createElement("span", {
    className: "absolute top-1/2 left-1/2 h-4/6 w-px bg-gray-300 transform -translate-y-1/2 -translate-x-1/2 opacity-50 transition-opacity duration-150 ease-out group-hover:opacity-100"
  }));
};
const SidebarContext = React.createContext(null);
const minPreviewWidth = 440;
const minSidebarWidth = 360;
const navBreakpoint = 1e3;
const LOCALSTATEKEY = "tina.sidebarState";
const LOCALWIDTHKEY = "tina.sidebarWidth";
const defaultSidebarWidth = 440;
const defaultSidebarPosition = "displace";
const defaultSidebarState = "open";
function SidebarProvider({
  position = defaultSidebarPosition,
  resizingSidebar,
  setResizingSidebar,
  defaultWidth = defaultSidebarWidth,
  defaultState = defaultSidebarState,
  sidebar
}) {
  var _a, _b, _c, _d;
  useSubscribable(sidebar);
  const cms = useCMS$1();
  if (!cms.enabled)
    return null;
  return /* @__PURE__ */ React.createElement(Sidebar, {
    position: ((_a = cms == null ? void 0 : cms.sidebar) == null ? void 0 : _a.position) || position,
    defaultWidth: ((_b = cms == null ? void 0 : cms.sidebar) == null ? void 0 : _b.defaultWidth) || defaultWidth,
    defaultState: ((_c = cms == null ? void 0 : cms.sidebar) == null ? void 0 : _c.defaultState) || defaultState,
    resizingSidebar,
    setResizingSidebar,
    renderNav: typeof ((_d = cms == null ? void 0 : cms.sidebar) == null ? void 0 : _d.renderNav) !== "undefined" ? cms.sidebar.renderNav : true,
    sidebar
  });
}
const useFetchCollections = (cms) => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCollections = async () => {
      if (await cms.api.admin.isAuthenticated()) {
        try {
          const collections2 = await cms.api.admin.fetchCollections();
          setCollections(collections2);
        } catch (error) {
          setCollections([]);
          throw new Error(`[${error.name}] GetCollections failed: ${error.message}`);
        }
        setLoading(false);
      }
    };
    if (cms.api.admin) {
      setLoading(true);
      fetchCollections();
    }
  }, [cms.api.admin]);
  return { collections, loading };
};
const Sidebar = ({
  sidebar,
  defaultWidth,
  defaultState,
  position,
  renderNav,
  resizingSidebar,
  setResizingSidebar
}) => {
  var _a, _b, _c, _d, _e, _f;
  const cms = useCMS$1();
  const collectionsInfo = useFetchCollections(cms);
  const screens = cms.plugins.getType("screen");
  const cloudConfigs = cms.plugins.getType("cloud-config");
  useSubscribable(sidebar);
  useSubscribable(screens);
  const allScreens = screens.all();
  const allConfigs = cloudConfigs.all();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [activeScreen, setActiveView] = useState(null);
  const [displayState, setDisplayState] = React.useState(defaultState);
  const [sidebarWidth, setSidebarWidth] = React.useState(defaultWidth);
  const [formIsPristine, setFormIsPristine] = React.useState(true);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const localSidebarState = window.localStorage.getItem(LOCALSTATEKEY);
      const localSidebarWidth = window.localStorage.getItem(LOCALWIDTHKEY);
      if (localSidebarState !== null) {
        setDisplayState(JSON.parse(localSidebarState));
      }
      if (localSidebarWidth !== null) {
        setSidebarWidth(JSON.parse(localSidebarWidth));
      }
    }
  }, []);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const localSidebarState = window.localStorage.getItem(LOCALSTATEKEY);
      if (localSidebarState === null) {
        setDisplayState(defaultState);
      }
    }
  }, [defaultState]);
  React.useEffect(() => {
    if (typeof window !== "undefined" && cms.enabled) {
      window.localStorage.setItem(LOCALSTATEKEY, JSON.stringify(displayState));
    }
  }, [displayState, cms]);
  React.useEffect(() => {
    if (resizingSidebar) {
      window.localStorage.setItem(LOCALWIDTHKEY, JSON.stringify(sidebarWidth));
    }
  }, [sidebarWidth, resizingSidebar]);
  const isTinaAdminEnabled = cms.flags.get("tina-admin") === false ? false : true;
  const contentCreators = isTinaAdminEnabled ? [] : cms.plugins.getType("content-creator").all();
  const toggleFullscreen = () => {
    if (displayState === "fullscreen") {
      setDisplayState("open");
    } else {
      setDisplayState("fullscreen");
    }
  };
  const toggleSidebarOpen = () => {
    if (displayState === "closed") {
      setDisplayState("open");
    } else {
      setDisplayState("closed");
    }
  };
  const toggleMenu = () => {
    setMenuIsOpen((menuIsOpen2) => !menuIsOpen2);
  };
  React.useEffect(() => {
    const updateLayout = () => {
      if (displayState === "fullscreen") {
        return;
      }
      updateBodyDisplacement({
        position,
        displayState,
        sidebarWidth,
        resizingSidebar
      });
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => {
      window.removeEventListener("resize", updateLayout);
    };
  }, [displayState, position, sidebarWidth, resizingSidebar]);
  const windowWidth = useWindowWidth();
  const displayNav = renderNav && (sidebarWidth > navBreakpoint && windowWidth > navBreakpoint || displayState === "fullscreen" && windowWidth > navBreakpoint);
  const renderMobileNav = renderNav && (sidebarWidth < navBreakpoint + 1 || windowWidth < navBreakpoint + 1);
  return /* @__PURE__ */ React.createElement(SidebarContext.Provider, {
    value: {
      sidebarWidth,
      setSidebarWidth,
      displayState,
      setDisplayState,
      position,
      toggleFullscreen,
      toggleSidebarOpen,
      resizingSidebar,
      setResizingSidebar,
      menuIsOpen,
      setMenuIsOpen,
      toggleMenu,
      setActiveView,
      formIsPristine,
      setFormIsPristine
    }
  }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SidebarWrapper, null, /* @__PURE__ */ React.createElement(EditButton, null), displayNav && /* @__PURE__ */ React.createElement(Nav, {
    isLocalMode: (_b = (_a = cms.api) == null ? void 0 : _a.tina) == null ? void 0 : _b.isLocalMode,
    showCollections: isTinaAdminEnabled,
    collectionsInfo,
    screens: allScreens,
    cloudConfigs: allConfigs,
    contentCreators,
    sidebarWidth,
    RenderNavSite: ({ view }) => /* @__PURE__ */ React.createElement(SidebarSiteLink, {
      view,
      onClick: () => {
        setActiveView(view);
        setMenuIsOpen(false);
      }
    }),
    RenderNavCloud: ({ config }) => /* @__PURE__ */ React.createElement(SidebarCloudLink, {
      config
    }),
    RenderNavCollection: ({ collection }) => /* @__PURE__ */ React.createElement(SidebarCollectionLink, {
      onClick: () => {
        setMenuIsOpen(false);
      },
      collection
    })
  }), /* @__PURE__ */ React.createElement(SidebarBody, null, /* @__PURE__ */ React.createElement(SidebarHeader, {
    displayNav,
    renderNav,
    isLocalMode: (_d = (_c = cms.api) == null ? void 0 : _c.tina) == null ? void 0 : _d.isLocalMode
  }), /* @__PURE__ */ React.createElement(FormsView, null, /* @__PURE__ */ React.createElement(sidebar.placeholder, null)), activeScreen && /* @__PURE__ */ React.createElement(ScreenPluginModal, {
    screen: activeScreen,
    close: () => setActiveView(null)
  })), /* @__PURE__ */ React.createElement(ResizeHandle, null)), renderMobileNav && /* @__PURE__ */ React.createElement(Transition, {
    show: menuIsOpen
  }, /* @__PURE__ */ React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "transform transition-all ease-out duration-300",
    enterFrom: "opacity-0 -translate-x-full",
    enterTo: "opacity-100 translate-x-0",
    leave: "transform transition-all ease-in duration-200",
    leaveFrom: "opacity-100 translate-x-0",
    leaveTo: "opacity-0 -translate-x-full"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "fixed left-0 top-0 z-overlay h-full transform"
  }, /* @__PURE__ */ React.createElement(Nav, {
    isLocalMode: (_f = (_e = cms.api) == null ? void 0 : _e.tina) == null ? void 0 : _f.isLocalMode,
    className: "rounded-r-md",
    showCollections: isTinaAdminEnabled,
    collectionsInfo,
    screens: allScreens,
    cloudConfigs: allConfigs,
    contentCreators,
    sidebarWidth,
    RenderNavSite: ({ view }) => /* @__PURE__ */ React.createElement(SidebarSiteLink, {
      view,
      onClick: () => {
        setActiveView(view);
        setMenuIsOpen(false);
      }
    }),
    RenderNavCloud: ({ config }) => /* @__PURE__ */ React.createElement(SidebarCloudLink, {
      config
    }),
    RenderNavCollection: ({ collection }) => /* @__PURE__ */ React.createElement(SidebarCollectionLink, {
      onClick: () => {
        setMenuIsOpen(false);
      },
      collection
    })
  }, /* @__PURE__ */ React.createElement("div", {
    className: "absolute top-8 right-0 transform translate-x-full overflow-hidden"
  }, /* @__PURE__ */ React.createElement(Button, {
    rounded: "right",
    variant: "secondary",
    onClick: () => {
      setMenuIsOpen(false);
    },
    className: `transition-opacity duration-150 ease-out`
  }, /* @__PURE__ */ React.createElement(IoMdClose, {
    className: "h-6 w-auto"
  })))))), /* @__PURE__ */ React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-80",
    entered: "opacity-80",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-80",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement("div", {
    onClick: () => {
      setMenuIsOpen(false);
    },
    className: "fixed z-menu inset-0 bg-gradient-to-br from-gray-800 via-gray-900 to-black"
  })))));
};
const updateBodyDisplacement = ({
  position = "overlay",
  displayState,
  sidebarWidth,
  resizingSidebar
}) => {
  const body = document.getElementsByTagName("body")[0];
  const windowWidth = window.innerWidth;
  if (position === "displace") {
    if (!resizingSidebar) {
      body.style.transition = "all 200ms ease-out";
    } else {
      body.style.transition = "";
    }
    if (displayState === "open") {
      const bodyDisplacement = Math.min(sidebarWidth, windowWidth - minPreviewWidth);
      body.style.paddingLeft = bodyDisplacement + "px";
    } else {
      body.style.paddingLeft = "0";
    }
  } else {
    body.style.transition = "";
    body.style.paddingLeft = "0";
  }
};
const SidebarHeader = ({ renderNav, displayNav, isLocalMode }) => {
  const { toggleFullscreen, displayState, setMenuIsOpen, toggleSidebarOpen } = React.useContext(SidebarContext);
  const displayMenuButton = renderNav && !displayNav;
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-grow-0 w-full overflow-visible z-20"
  }, isLocalMode && /* @__PURE__ */ React.createElement(LocalWarning, null), /* @__PURE__ */ React.createElement("div", {
    className: "mt-4 -mb-14 w-full flex items-center justify-between pointer-events-none"
  }, displayMenuButton && /* @__PURE__ */ React.createElement(Button, {
    rounded: "right",
    variant: "secondary",
    onClick: () => {
      setMenuIsOpen(true);
    },
    className: "pointer-events-auto -ml-px"
  }, /* @__PURE__ */ React.createElement(BiMenu, {
    className: "h-7 w-auto"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex-1"
  }), /* @__PURE__ */ React.createElement("div", {
    className: `flex items-center gap-2 pointer-events-auto transition-opacity duration-150 ease-in-out -mr-px`
  }, /* @__PURE__ */ React.createElement(Button, {
    rounded: "full",
    variant: "ghost",
    onClick: toggleFullscreen,
    className: "pointer-events-auto opacity-50 hover:opacity-100 focus:opacity-80"
  }, displayState === "fullscreen" ? /* @__PURE__ */ React.createElement(BsArrowsAngleContract, {
    className: "h-5 w-auto -mx-1"
  }) : /* @__PURE__ */ React.createElement(BsArrowsAngleExpand, {
    className: "h-5 w-auto -mx-1"
  })), /* @__PURE__ */ React.createElement(Button, {
    rounded: "left",
    variant: "secondary",
    onClick: toggleSidebarOpen,
    "aria-label": "closes cms sidebar",
    className: ``
  }, /* @__PURE__ */ React.createElement(MdOutlineArrowBackIos, {
    className: "h-6 w-auto"
  })))));
};
const SidebarSiteLink = ({
  view,
  onClick
}) => {
  return /* @__PURE__ */ React.createElement("button", {
    className: "text-base tracking-wide text-gray-500 hover:text-blue-600 flex items-center opacity-90 hover:opacity-100",
    value: view.name,
    onClick
  }, /* @__PURE__ */ React.createElement(view.Icon, {
    className: "mr-2 h-6 opacity-80 w-auto"
  }), " ", view.name);
};
const SidebarCloudLink = ({ config }) => {
  if (config.text) {
    return /* @__PURE__ */ React.createElement("span", {
      className: "text-base tracking-wide text-gray-500 flex items-center opacity-90"
    }, config.text, " ", /* @__PURE__ */ React.createElement("a", {
      target: "_blank",
      className: "ml-1 text-blue-600 hover:opacity-60",
      href: config.link.href
    }, config.link.text));
  }
  return /* @__PURE__ */ React.createElement("span", {
    className: "text-base tracking-wide text-gray-500 hover:text-blue-600 flex items-center opacity-90 hover:opacity-100"
  }, /* @__PURE__ */ React.createElement(config.Icon, {
    className: "mr-2 h-6 opacity-80 w-auto"
  }), /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    href: config.link.href
  }, config.link.text));
};
const SidebarCollectionLink = ({
  collection,
  onClick
}) => {
  const cms = useCMS$1();
  const tinaPreview = cms.flags.get("tina-preview") || false;
  return /* @__PURE__ */ React.createElement("a", {
    onClick,
    href: `${tinaPreview ? `/${tinaPreview}/index.html#` : "/admin#"}/collections/${collection.name}`,
    className: "text-base tracking-wide text-gray-500 hover:text-blue-600 flex items-center opacity-90 hover:opacity-100"
  }, /* @__PURE__ */ React.createElement(ImFilesEmpty, {
    className: "mr-2 h-6 opacity-80 w-auto"
  }), " ", collection.label ? collection.label : collection.name);
};
const EditButton = ({}) => {
  const { displayState, toggleSidebarOpen } = React.useContext(SidebarContext);
  return /* @__PURE__ */ React.createElement(Button, {
    rounded: "right",
    variant: "primary",
    onClick: toggleSidebarOpen,
    className: ` absolute top-8 right-0 transition-all duration-150 ease-out ${displayState !== "closed" ? "opacity-0" : "translate-x-full pointer-events-auto"}`,
    "aria-label": "opens cms sidebar"
  }, /* @__PURE__ */ React.createElement(BiPencil, {
    className: "h-6 w-auto"
  }));
};
const SidebarWrapper = ({ children }) => {
  const { displayState, sidebarWidth, resizingSidebar } = React.useContext(SidebarContext);
  return /* @__PURE__ */ React.createElement("div", {
    className: `fixed top-0 left-0 h-screen z-base ${displayState === "closed" ? `pointer-events-none` : ``}`
  }, /* @__PURE__ */ React.createElement("div", {
    className: `relative h-screen transform flex ${displayState !== "closed" ? `` : `-translate-x-full`} ${resizingSidebar ? `transition-none` : displayState === "fullscreen" ? `transition-all duration-150 ease-out` : `transition-all duration-300 ease-out`}`,
    style: {
      width: displayState === "fullscreen" ? "100vw" : sidebarWidth + "px",
      maxWidth: displayState === "fullscreen" ? "100vw" : "calc(100vw - 8px)",
      minWidth: "360px"
    }
  }, children));
};
const SidebarBody = ({ children }) => {
  const { displayState } = React.useContext(SidebarContext);
  return /* @__PURE__ */ React.createElement("div", {
    className: `relative left-0 w-full h-full flex flex-col items-stretch bg-white border-r border-gray-200 overflow-hidden transition-opacity duration-300 ease-out ${displayState !== "closed" ? "opacity-100" : "opacity-0"} ${displayState === "fullscreen" ? "" : ""}`
  }, children);
};
class GlobalFormPlugin {
  constructor(form, icon, layout) {
    this.form = form;
    this.__type = "screen";
    this.name = form.label;
    this.Icon = icon || MdOutlineSettings;
    this.layout = layout || "popup";
    this.Component = () => {
      return /* @__PURE__ */ React.createElement(FormBuilder, {
        form
      });
    };
  }
}
function useGlobalForm(options, watch = {}) {
  const [values, form] = useForm(options, watch);
  const GlobalForm = useMemo(() => {
    if (!form)
      return;
    return new GlobalFormPlugin(form);
  }, [form]);
  usePlugins(GlobalForm);
  return [values, form];
}
function useFormScreenPlugin(form, icon, layout) {
  const GlobalForm = useMemo(() => {
    if (!form)
      return;
    return new GlobalFormPlugin(form, icon, layout);
  }, [form, icon, layout]);
  usePlugins(GlobalForm);
}
const MarkdownFieldPlaceholder = {
  __type: "field",
  name: "markdown",
  Component: createPlaceholder("Markdown")
};
const HtmlFieldPlaceholder = {
  __type: "field",
  name: "html",
  Component: createPlaceholder("HTML")
};
function createPlaceholder(name, _pr) {
  return (props) => {
    return /* @__PURE__ */ React__default.createElement(FieldMeta, {
      name: props.input.name,
      label: `${name} Field not Registered`,
      tinaForm: props.tinaForm
    }, /* @__PURE__ */ React__default.createElement("p", {
      className: "whitespace-normal text-[15px] mt-2"
    }, "The ", name, " field is not registered. Some built-in field types are not bundled by default in an effort to control bundle size. Consult the Tina docs to learn how to use this field type."), /* @__PURE__ */ React__default.createElement("p", {
      className: "whitespace-normal text-[15px] mt-2"
    }, /* @__PURE__ */ React__default.createElement("a", {
      className: "text-blue-500 underline",
      href: "https://tina.io/docs/editing/markdown/#registering-the-field-plugins",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "Tina Docs: Registering Field Plugins")));
  };
}
function CursorPaginator({
  navigateNext,
  navigatePrev,
  hasNext,
  hasPrev,
  variant = "secondary"
}) {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "w-full flex flex-shrink-0 justify-end gap-2 items-center"
  }, /* @__PURE__ */ React__default.createElement(Button, {
    variant,
    disabled: !hasPrev,
    onClick: navigatePrev
  }, /* @__PURE__ */ React__default.createElement(BiLeftArrowAlt, {
    className: "w-6 h-full mr-2 opacity-70"
  }), " Previous"), /* @__PURE__ */ React__default.createElement(Button, {
    variant,
    disabled: !hasNext,
    onClick: navigateNext
  }, "Next ", /* @__PURE__ */ React__default.createElement(BiRightArrowAlt, {
    className: "w-6 h-full ml-2 opacity-70"
  })));
}
function MediaItem({
  item,
  onClick,
  onSelect,
  onDelete
}) {
  const FileIcon = item.type === "dir" ? Folder : File;
  return /* @__PURE__ */ React__default.createElement("li", {
    className: "flex items-center p-2 bg-white rounded-[5px] transition duration-300 ease-linear hover:drop-shadow-md " + (item.type === "dir" ? "cursor-pointer" : ""),
    onClick: () => onClick(item)
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "w-[56px] h-[56px] rounded-[5px] overflow-hidden flex justify-center flex-shrink-0 mr-3"
  }, item.previewSrc ? /* @__PURE__ */ React__default.createElement("img", {
    className: "object-cover w-full min-h-full object-center",
    src: item.previewSrc,
    alt: item.filename
  }) : /* @__PURE__ */ React__default.createElement(FileIcon, {
    className: "w-[47%] h-full fill-gray-300"
  })), /* @__PURE__ */ React__default.createElement(Filename, null, item.filename), /* @__PURE__ */ React__default.createElement("div", {
    className: "flex justify-end gap-2 items-center ml-2"
  }, onSelect && item.type === "file" && /* @__PURE__ */ React__default.createElement(Button, {
    size: "medium",
    onClick: () => onSelect(item)
  }, "Insert"), onDelete && item.type === "file" && /* @__PURE__ */ React__default.createElement(IconButton, {
    size: "medium",
    onClick: () => onDelete(item)
  }, /* @__PURE__ */ React__default.createElement(TrashIcon, {
    className: "w-5/6 h-auto"
  }))));
}
const Filename = ({ className = "", ...props }) => /* @__PURE__ */ React__default.createElement("span", {
  className: "text-[15px] flex-grow w-full break-words truncate " + className,
  ...props
});
function dirname(path) {
  return path.match(/.*\//);
}
const BreadcrumbButton = ({ className = "", ...props }) => /* @__PURE__ */ React__default.createElement("button", {
  className: "capitalize transition-colors duration-200 border-0 bg-transparent hover:text-gray-900 md:text-[15px] after:pl-2 after:content-['/'] " + className,
  ...props
});
function Breadcrumb({ directory = "", setDirectory }) {
  directory = directory.replace(/^\/|\/$/g, "");
  let prevDir = dirname(directory) || "";
  if (prevDir === ".") {
    prevDir = "";
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "w-full flex items-center text-[16px] text-gray-300"
  }, directory !== "" && /* @__PURE__ */ React__default.createElement("span", {
    className: "flex",
    onClick: () => setDirectory(prevDir)
  }, /* @__PURE__ */ React__default.createElement(LeftArrowIcon, {
    className: `w-8 h-auto fill-gray-300 self-center cursor-pointer hover:fill-gray-900 md:-ml-2 ${directory === "" ? "opacity-0 translate-x-1.5" : "opacity-100 md:-translate-x-1"}`,
    style: {
      transition: directory === "" ? "opacity 200ms ease, transform 300ms ease-out" : "opacity 180ms ease, transform 300ms ease-in"
    }
  })), /* @__PURE__ */ React__default.createElement(BreadcrumbButton, {
    onClick: () => setDirectory(""),
    className: directory === "" ? "" : "hidden md:flex"
  }, "Media"), directory && directory.split("/").map((part, index, parts) => {
    const currentDir = parts.slice(0, index + 1).join("/");
    return /* @__PURE__ */ React__default.createElement(BreadcrumbButton, {
      className: "pl-2 " + (index + 1 === parts.length ? "flex" : "hidden md:flex"),
      key: currentDir,
      onClick: () => {
        setDirectory(currentDir);
      }
    }, part);
  }));
}
async function poll(fn, timeout, interval) {
  const endTime = Number(new Date()) + (timeout || 2e3);
  interval = interval || 100;
  const checkCondition = async function(resolve, reject) {
    const result = await fn();
    if (result.complete) {
      resolve(result);
    } else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    } else {
      reject(new Error("Time out error"));
    }
  };
  return new Promise(checkCondition);
}
const join = function(...parts) {
  const [first, last, slash] = [0, parts.length - 1, "/"];
  const matchLeadingSlash = new RegExp("^" + slash);
  const matchTrailingSlash = new RegExp(slash + "$");
  parts = parts.map(function(part, index) {
    if (index === first && part === "file://")
      return part;
    if (index > first)
      part = part.replace(matchLeadingSlash, "");
    if (index < last)
      part = part.replace(matchTrailingSlash, "");
    return part;
  });
  return parts.join(slash);
};
function MediaManager() {
  const cms = useCMS();
  const [request, setRequest] = useState();
  useEffect(() => {
    return cms.events.subscribe("media:open", ({ type, ...request2 }) => {
      setRequest(request2);
    });
  }, []);
  if (!request)
    return null;
  const close = () => setRequest(void 0);
  return /* @__PURE__ */ React__default.createElement(Modal, null, /* @__PURE__ */ React__default.createElement(FullscreenModal, null, /* @__PURE__ */ React__default.createElement(ModalHeader, {
    close
  }, "Media Manager"), /* @__PURE__ */ React__default.createElement(ModalBody, {
    className: "flex h-full flex-col"
  }, /* @__PURE__ */ React__default.createElement(MediaPicker, {
    ...request,
    close
  }))));
}
const defaultListError = new MediaListError({
  title: "Error fetching media",
  message: "Something went wrong while requesting the resource.",
  docsLink: "https://tina.io/docs/media/#media-store"
});
function MediaPicker({
  allowDelete,
  onSelect,
  close,
  ...props
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const cms = useCMS();
  const [listState, setListState] = useState(() => {
    if (cms.media.isConfigured)
      return "loading";
    return "not-configured";
  });
  const [listError, setListError] = useState(defaultListError);
  const [directory, setDirectory] = useState(props.directory);
  const [list, setList] = useState({
    items: [],
    nextOffset: void 0
  });
  const [showSync, setShowSync] = useState(false);
  const [offsetHistory, setOffsetHistory] = useState([]);
  const [loadingText, setLoadingText] = useState("");
  const offset = offsetHistory[offsetHistory.length - 1];
  const resetOffset = () => setOffsetHistory([]);
  const navigateNext = () => {
    if (!list.nextOffset)
      return;
    setOffsetHistory([...offsetHistory, list.nextOffset]);
  };
  const navigatePrev = () => {
    const offsets = offsetHistory.slice(0, offsetHistory.length - 1);
    setOffsetHistory(offsets);
  };
  const hasPrev = offsetHistory.length > 0;
  const hasNext = !!list.nextOffset;
  const isLocal = cms.api.tina.isLocalMode;
  const hasTinaMedia = Object.keys(((_c = (_b = (_a = cms.api.tina.schema.schema) == null ? void 0 : _a.config) == null ? void 0 : _b.media) == null ? void 0 : _c.tina) || {}).includes("mediaRoot") && Object.keys(((_f = (_e = (_d = cms.api.tina.schema.schema) == null ? void 0 : _d.config) == null ? void 0 : _e.media) == null ? void 0 : _f.tina) || {}).includes("publicFolder");
  const folder = hasTinaMedia ? join((_i = (_h = (_g = cms.api.tina.schema.schema) == null ? void 0 : _g.config) == null ? void 0 : _h.media) == null ? void 0 : _i.tina.publicFolder, (_l = (_k = (_j = cms.api.tina.schema.schema) == null ? void 0 : _j.config) == null ? void 0 : _k.media) == null ? void 0 : _l.tina.mediaRoot) : "";
  const branch = (_m = cms.api.tina) == null ? void 0 : _m.branch;
  function loadMedia() {
    setListState("loading");
    cms.media.list({ offset, limit: cms.media.pageSize, directory }).then((list2) => {
      setList(list2);
      setListState("loaded");
    }).catch((e) => {
      console.error(e);
      if (e.ERR_TYPE === "MediaListError") {
        setListError(e);
      } else {
        setListError(defaultListError);
      }
      setListState("error");
    });
  }
  useEffect(() => {
    if (!cms.media.isConfigured)
      return;
    loadMedia();
    return cms.events.subscribe(["media:upload:success", "media:delete:success", "media:pageSize"], loadMedia);
  }, [offset, directory, cms.media.isConfigured]);
  const onClickMediaItem = (item) => {
    if (item.type === "dir") {
      setDirectory(item.directory === "." || item.directory === "" ? item.filename : join(item.directory, item.filename));
      resetOffset();
    }
  };
  let deleteMediaItem;
  if (allowDelete) {
    deleteMediaItem = (item) => {
      if (confirm("Are you sure you want to delete this file?")) {
        cms.media.delete(item);
      }
    };
  }
  let selectMediaItem;
  if (onSelect) {
    selectMediaItem = (item) => {
      onSelect(item);
      if (close)
        close();
    };
  }
  const [uploading, setUploading] = useState(false);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: cms.media.accept || "image/*",
    multiple: true,
    onDrop: async (files) => {
      try {
        setUploading(true);
        await cms.media.persist(files.map((file) => {
          return {
            directory: directory || "/",
            file
          };
        }));
      } catch {
      }
      setUploading(false);
    }
  });
  const syncMedia = async () => {
    if (hasTinaMedia) {
      const res = await cms.api.tina.syncTinaMedia();
      if (res == null ? void 0 : res.assetsSyncing) {
        try {
          setListState("loading");
          await poll(async () => {
            var _a2, _b2;
            const status = await cms.api.tina.checkSyncStatus({
              assetsSyncing: res.assetsSyncing
            });
            const totalDone = (_a2 = Object.values(status.status).filter(Boolean)) == null ? void 0 : _a2.length;
            const total = (_b2 = Object.keys(status.status)) == null ? void 0 : _b2.length;
            setLoadingText(`${totalDone}/${total} Media items loaded`);
            return status;
          }, 6e4, 3e3);
          setLoadingText("");
          loadMedia();
        } catch (e) {
          cms.alerts.error("Error in syncing media, check console for more details");
          console.error("'Error in syncing media, check below for more details");
          console.error(e);
        }
      } else {
        cms.alerts.warn("Whoops, Looks media is not set up correctly in Tina Cloud. Check console for more details");
        console.warn("Whoops, Looks media is not set up correctly. Check below for more details");
        console.warn(res);
      }
    }
  };
  const { onClick, ...rootProps } = getRootProps();
  function disableScrollBody() {
    const body = document == null ? void 0 : document.body;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = "auto";
    };
  }
  useEffect(disableScrollBody, []);
  if (listState === "loading" || uploading) {
    return /* @__PURE__ */ React__default.createElement(LoadingMediaList, {
      extraText: loadingText
    });
  }
  if (listState === "not-configured") {
    return /* @__PURE__ */ React__default.createElement(DocsLink, {
      title: "No Media Store Configured",
      message: "To use the media manager, you need to configure a Media Store.",
      docsLink: "https://tina.io/docs/reference/media/overview/"
    });
  }
  if (listState === "error") {
    const { title, message, docsLink } = listError;
    return /* @__PURE__ */ React__default.createElement(DocsLink, {
      title,
      message,
      docsLink
    });
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(MediaPickerWrap, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "flex items-center bg-white border-b border-gray-100 gap-x-3 py-3 px-5 shadow-sm flex-shrink-0"
  }, /* @__PURE__ */ React__default.createElement(Breadcrumb, {
    directory,
    setDirectory
  }), !isLocal && hasTinaMedia && /* @__PURE__ */ React__default.createElement(Button, {
    busy: false,
    variant: "white",
    onClick: () => {
      setShowSync(true);
    }
  }, "Sync ", /* @__PURE__ */ React__default.createElement(IoMdSync, {
    className: "w-6 h-full ml-2 opacity-70"
  })), /* @__PURE__ */ React__default.createElement(UploadButton, {
    onClick,
    uploading
  })), /* @__PURE__ */ React__default.createElement("ul", {
    ...rootProps,
    className: `flex flex-1 flex-col gap-4 p-5 m-0 h-full overflow-y-auto ${isDragActive ? `border-2 border-blue-500 rounded-lg` : ``}`
  }, /* @__PURE__ */ React__default.createElement("input", {
    ...getInputProps()
  }), listState === "loaded" && list.items.length === 0 && /* @__PURE__ */ React__default.createElement(EmptyMediaList, {
    hasTinaMedia
  }), list.items.map((item) => /* @__PURE__ */ React__default.createElement(MediaItem, {
    key: item.id,
    item,
    onClick: onClickMediaItem,
    onSelect: selectMediaItem,
    onDelete: deleteMediaItem
  }))), /* @__PURE__ */ React__default.createElement("div", {
    className: "bg-white border-t border-gray-100 py-3 px-5 shadow-sm z-10"
  }, /* @__PURE__ */ React__default.createElement(CursorPaginator, {
    hasNext,
    navigateNext,
    hasPrev,
    navigatePrev
  }))), showSync && /* @__PURE__ */ React__default.createElement(SyncModal, {
    folder,
    branch,
    syncFunc: syncMedia,
    close: () => {
      setShowSync(false);
    }
  }));
}
const UploadButton = ({ onClick, uploading }) => {
  return /* @__PURE__ */ React__default.createElement(Button, {
    variant: "primary",
    size: "custom",
    className: "text-sm h-10 px-6",
    busy: uploading,
    onClick
  }, uploading ? /* @__PURE__ */ React__default.createElement(LoadingDots, null) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "Upload ", /* @__PURE__ */ React__default.createElement(BiCloudUpload, {
    className: "w-6 h-full ml-2 opacity-70"
  })));
};
const LoadingMediaList = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "w-full h-full flex flex-col items-center justify-center",
    ...props
  }, props.extraText && /* @__PURE__ */ React__default.createElement("p", null, props.extraText), /* @__PURE__ */ React__default.createElement(LoadingDots, {
    color: "var(--tina-color-primary)"
  }));
};
const MediaPickerWrap = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "h-full flex-1 text-gray-700 flex flex-col relative bg-gray-50 outline-none active:outline-none focus:outline-none"
  }, children);
};
const EmptyMediaList = (props) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: `text-2xl opacity-50 p-12 text-center`,
    ...props
  }, "Drag and Drop assets here", props.hasTinaMedia && " or click 'Sync' to sync your media to Tina Cloud");
};
const DocsLink = ({ title, message, docsLink, ...props }) => {
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "h-3/4 text-center flex flex-col justify-center",
    ...props
  }, /* @__PURE__ */ React__default.createElement("h2", {
    className: "mb-3 text-xl text-gray-600"
  }, title), /* @__PURE__ */ React__default.createElement("div", {
    className: "mb-3 text-base text-gray-700"
  }, message), /* @__PURE__ */ React__default.createElement("a", {
    href: docsLink,
    target: "_blank",
    rel: "noreferrer noopener",
    className: "font-bold text-blue-500 hover:text-blue-600 hover:underline transition-all ease-out duration-150"
  }, "Learn More"));
};
const SyncModal = ({ close, syncFunc, folder, branch }) => {
  return /* @__PURE__ */ React__default.createElement(Modal, null, /* @__PURE__ */ React__default.createElement(PopupModal, null, /* @__PURE__ */ React__default.createElement(ModalHeader, {
    close
  }, "Sync Media"), /* @__PURE__ */ React__default.createElement(ModalBody, {
    padded: true
  }, /* @__PURE__ */ React__default.createElement("p", null, `This will copy media assets from the \`${folder}\` folder on branch \`${branch}\` in your git repository to Tina Cloud's asset service. This will allow you to use these assets in your site with Tina Cloud`)), /* @__PURE__ */ React__default.createElement(ModalActions, null, /* @__PURE__ */ React__default.createElement(Button, {
    style: { flexGrow: 2 },
    onClick: close
  }, "Cancel"), /* @__PURE__ */ React__default.createElement(Button, {
    style: { flexGrow: 3 },
    variant: "primary",
    onClick: async () => {
      await syncFunc();
      close();
    }
  }, "Sync Media"))));
};
const MediaManagerScreenPlugin = createScreen({
  name: "Media Manager",
  Component: MediaPicker,
  Icon: MdOutlinePhotoLibrary,
  layout: "fullscreen",
  props: {
    allowDelete: true
  }
});
function createCloudConfig({
  ...options
}) {
  return {
    __type: "cloud-config",
    Icon: MdOutlineCloud,
    ...options
  };
}
const DEFAULT_FIELDS = [
  TextFieldPlugin,
  TextareaFieldPlugin,
  ImageFieldPlugin,
  ColorFieldPlugin,
  NumberFieldPlugin,
  ToggleFieldPlugin,
  SelectFieldPlugin,
  MdxFieldPlugin,
  RadioGroupFieldPlugin,
  GroupFieldPlugin,
  GroupListFieldPlugin,
  ListFieldPlugin,
  BlocksFieldPlugin,
  TagsFieldPlugin,
  DateFieldPlugin,
  MarkdownFieldPlaceholder,
  HtmlFieldPlaceholder,
  CheckboxGroupFieldPlugin,
  ReferenceFieldPlugin
];
class TinaCMS extends CMS {
  constructor({
    sidebar,
    alerts = {},
    isLocalClient,
    clientId,
    ...config
  } = {}) {
    super(config);
    this.alerts.setMap({
      "media:upload:failure": (event) => {
        return {
          error: event.error,
          level: "error",
          message: `Failed to upload file(s) ${event == null ? void 0 : event.uploaded.map((x) => x.file.name).join(", ")}. See error message: 

 ${event == null ? void 0 : event.error.toString()}`
        };
      },
      "media:delete:failure": () => ({
        level: "error",
        message: "Failed to delete file."
      }),
      ...alerts
    });
    if (sidebar) {
      const sidebarConfig = typeof sidebar === "object" ? sidebar : void 0;
      this.sidebar = new SidebarState(this.events, sidebarConfig);
    }
    DEFAULT_FIELDS.forEach((field) => {
      if (!this.fields.find(field.name)) {
        this.fields.add(field);
      }
    });
    this.plugins.add(MediaManagerScreenPlugin);
    if (isLocalClient !== true) {
      if (clientId) {
        this.plugins.add(createCloudConfig({
          name: "Project Config",
          link: {
            text: "Project Config",
            href: `https://app.tina.io/projects/${clientId}/0`
          }
        }));
        this.plugins.add(createCloudConfig({
          name: "User Management",
          link: {
            text: "User Management",
            href: `https://app.tina.io/projects/${clientId}/3`
          }
        }));
      } else {
        this.plugins.add(createCloudConfig({
          name: "Setup Cloud",
          text: "No project configured, set one up ",
          link: {
            text: "here",
            href: `https://app.tina.io`
          }
        }));
      }
    }
  }
  get alerts() {
    if (!this._alerts) {
      this._alerts = new Alerts$1(this.events);
    }
    return this._alerts;
  }
  registerApi(name, api) {
    if (api.alerts) {
      this.alerts.setMap(api.alerts);
    }
    super.registerApi(name, api);
  }
  get forms() {
    return this.plugins.findOrCreateMap("form");
  }
  get fields() {
    return this.plugins.findOrCreateMap("field");
  }
  get screens() {
    return this.plugins.findOrCreateMap("screen");
  }
}
const INVALID_CMS_ERROR = "The `cms` prop must be an instance of `TinaCMS`.";
const TinaCMSProvider = ({
  cms,
  children
}) => {
  if (!(cms instanceof TinaCMS)) {
    throw new Error(INVALID_CMS_ERROR);
  }
  return /* @__PURE__ */ React.createElement(CMSContext.Provider, {
    value: cms
  }, children);
};
function Alerts({ alerts }) {
  useSubscribable(alerts);
  if (!alerts.all.length) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
    className: "fixed bottom-0 left-0 right-0 p-6 flex flex-col items-center z-[999999] pointer-events-none"
  }, alerts.all.filter((alert) => {
    return alert.level !== "error";
  }).map((alert) => {
    return /* @__PURE__ */ React__default.createElement(Alert, {
      key: alert.id,
      level: alert.level
    }, alert.level === "info" && /* @__PURE__ */ React__default.createElement(InfoIcon, {
      className: "w-5 h-5 mr-2"
    }), alert.level === "success" && /* @__PURE__ */ React__default.createElement(AlertIcon, {
      className: "w-5 h-5 mr-2"
    }), alert.level === "warn" && /* @__PURE__ */ React__default.createElement(WarningIcon, {
      className: "w-5 h-5 mr-2"
    }), /* @__PURE__ */ React__default.createElement("p", {
      className: "m-0 flex-1 max-w-[680px] text-left"
    }, alert.message), /* @__PURE__ */ React__default.createElement(CloseAlert, {
      onClick: () => {
        alerts.dismiss(alert);
      }
    }));
  })), alerts.all.filter((alert) => {
    return alert.level === "error";
  }).map((alert) => {
    const AlertMessage = typeof alert.message === "string" ? () => {
      return /* @__PURE__ */ React__default.createElement("p", {
        className: "text-base mb-3 overflow-y-auto"
      }, alert.message);
    } : alert.message;
    return /* @__PURE__ */ React__default.createElement(Modal, {
      key: alert.id
    }, /* @__PURE__ */ React__default.createElement(PopupModal, null, /* @__PURE__ */ React__default.createElement(ModalHeader, {
      close: () => {
        alerts.dismiss(alert);
      }
    }, /* @__PURE__ */ React__default.createElement(ErrorIcon, {
      className: "mr-1 w-6 h-auto fill-current inline-block text-red-600"
    }), " ", "Error"), /* @__PURE__ */ React__default.createElement(ModalBody, {
      padded: true
    }, /* @__PURE__ */ React__default.createElement("div", {
      className: "tina-prose"
    }, /* @__PURE__ */ React__default.createElement(AlertMessage, null))), /* @__PURE__ */ React__default.createElement(ModalActions, null, /* @__PURE__ */ React__default.createElement("div", {
      className: "flex-1"
    }), /* @__PURE__ */ React__default.createElement(Button, {
      style: { flexGrow: 1 },
      onClick: () => {
        alerts.dismiss(alert);
      }
    }, "Close"))));
  }));
}
const Alert = ({ level, ...props }) => {
  const fillColor = {
    info: "var(--tina-color-primary)",
    success: "var(--tina-color-success)",
    warn: "var(--tina-color-dark)",
    error: "var(--tina-color-error)"
  };
  const borderColor = {
    info: "var(--tina-color-primary)",
    success: "var(--tina-color-success)",
    warn: "var(--tina-color-warning)",
    error: "var(--tina-color-error)"
  };
  return /* @__PURE__ */ React__default.createElement("div", {
    className: `text-center rounded-[5px] bg-gray-50 border border-solid border-gray-100 text-gray-800 fill-blue-500 font-normal cursor-pointer text-[15px] py-2 pr-1 pl-3 transition-all duration-100 ease-out mb-4 flex items-center min-w-[350px] max-w-full `,
    style: {
      pointerEvents: "all",
      animationName: "fly-in-up, fade-in",
      animationTimingFunction: "ease-out",
      animationIterationCount: 1,
      animationFillMode: "both",
      animationDuration: "150ms",
      fill: fillColor[level],
      borderLeft: `6px solid ${borderColor[level]}`
    },
    ...props
  });
};
const CloseAlert = ({ ...styleProps }) => /* @__PURE__ */ React__default.createElement("button", {
  className: "border-none bg-transparent p-0 ml-[14px] outline-none fill-gray-400 flex items-center",
  ...styleProps
}, /* @__PURE__ */ React__default.createElement(CloseIcon, {
  className: "w-5 h-5 flex-grow-0 flex-shrink-0 basis-[auto] mr-2"
}));
const MutationSignalContext = React.createContext(-1);
const MutationSignalProvider = ({ children }) => {
  const observerAreaRef = React.useRef(null);
  const [signal, setSignal] = React.useState(0);
  React.useEffect(() => {
    if (!observerAreaRef)
      return;
    const observer = new MutationObserver(() => setSignal((s) => s + 1));
    observer.observe(observerAreaRef.current, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return () => observer.disconnect();
  }, []);
  return /* @__PURE__ */ React.createElement(MutationSignalContext.Provider, {
    value: signal
  }, /* @__PURE__ */ React.createElement("div", {
    ref: observerAreaRef
  }, children));
};
const useFieldReference = (fieldName) => {
  const signal = React.useContext(MutationSignalContext);
  const [ele, setEle] = React.useState(null);
  React.useEffect(() => {
    let doc;
    const iframe = document.getElementById("tina-iframe");
    if (iframe) {
      doc = iframe.contentDocument;
    } else {
      doc = document;
    }
    const fieldEle = doc.querySelector(`[data-tinafield="${fieldName}"]`);
    if (!fieldEle) {
      if (fieldName == null ? void 0 : fieldName.includes("#")) {
        const fieldNameWithoutFormId = fieldName.split("#")[1];
        const fieldEle2 = doc.querySelector(`[data-tinafield="${fieldNameWithoutFormId}"]`);
        setEle(fieldEle2);
      }
    } else {
      setEle(fieldEle);
    }
  }, [signal, fieldName]);
  return ele;
};
const IndicatorWrap = ({ style = {}, position, ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: "fixed left-0 py-2 px-0 text-center",
  style: {
    ...style,
    marginLeft: "var(--tina-sidebar-width)",
    width: "calc(100% - var(--tina-sidebar-width))",
    top: position === "top" ? 0 : "auto",
    bottom: position === "top" ? "auto" : 0,
    zIndex: "var(--tina-z-index-3)"
  },
  ...props
});
const ArrowWrap = (props) => /* @__PURE__ */ React.createElement("div", {
  className: "inline-block fill-white rounded-[50%] bg-blue-500 shadow-md",
  ...props
});
const AboveViewportIndicator = () => {
  return /* @__PURE__ */ React.createElement(IndicatorWrap, {
    position: "top"
  }, /* @__PURE__ */ React.createElement(ArrowWrap, null, /* @__PURE__ */ React.createElement(ChevronUpIcon, {
    className: "w-8 h-auto"
  })));
};
const BelowViewportIndicator = () => {
  return /* @__PURE__ */ React.createElement(IndicatorWrap, {
    position: "bottom"
  }, /* @__PURE__ */ React.createElement(ArrowWrap, null, /* @__PURE__ */ React.createElement(ChevronDownIcon$2, {
    className: "w-8 h-auto"
  })));
};
const useScrollToFocusedField = () => {
  const { subscribe } = useEvent("field:focus");
  React.useEffect(() => subscribe(({ fieldName }) => {
    const ele = document.querySelector(`[data-tinafield="${fieldName}"]`);
    if (!ele)
      return;
    const { top, height } = ele.getBoundingClientRect();
    const eleTopY = top + window.scrollY;
    const eleBottomY = top + height + window.scrollY;
    const viewportTopY = window.scrollY;
    const viewportBottomY = window.innerHeight + window.scrollY;
    if (height < window.innerHeight) {
      if (eleBottomY > viewportBottomY) {
        window.scrollTo({
          top: eleBottomY - window.innerHeight,
          behavior: "smooth"
        });
      } else if (eleTopY < viewportTopY) {
        window.scrollTo({
          top: eleTopY,
          behavior: "smooth"
        });
      }
    } else {
      if (eleBottomY < viewportBottomY) {
        window.scrollTo({
          top: eleBottomY - window.innerHeight,
          behavior: "smooth"
        });
      } else if (eleTopY > viewportTopY) {
        window.scrollTo({
          top: eleTopY,
          behavior: "smooth"
        });
      }
    }
  }));
};
const ActiveFieldIndicator = () => {
  const [activeFieldName, setActiveFieldName] = React.useState(null);
  const [display, setDisplay] = React.useState(false);
  const [position, setPosition] = React.useState(false);
  const [iframePosition, setIframePosition] = React.useState({ left: 0 });
  const activeEle = useFieldReference(activeFieldName);
  React.useEffect(() => {
    let displayTimeout;
    if (activeEle) {
      setDisplay(true);
      setPosition(activeEle.getBoundingClientRect());
      const iframe = document.getElementById("tina-iframe");
      if (iframe) {
        setIframePosition(iframe.getBoundingClientRect());
      }
    } else {
      displayTimeout = setTimeout(() => {
        setDisplay(false);
      }, 150);
    }
    return () => {
      clearTimeout(displayTimeout);
    };
  }, [activeEle]);
  const [, setArbitraryValue] = React.useState(0);
  const rerender = () => setArbitraryValue((s) => s + 1);
  React.useEffect(() => {
    window.addEventListener("scroll", rerender);
    return () => {
      window.removeEventListener("scroll", rerender);
    };
  }, []);
  const { subscribe } = useEvent("field:hover");
  React.useEffect(() => subscribe(({ fieldName, id }) => {
    setActiveFieldName(`${id}#${fieldName}`);
  }));
  useScrollToFocusedField();
  if (!display)
    return null;
  const eleTopY = position.top + window.scrollY;
  const eleBottomY = position.top + position.height + window.scrollY;
  const viewportTopY = window.scrollY;
  const viewportBottomY = window.innerHeight + window.scrollY;
  if (eleTopY > viewportBottomY) {
    return /* @__PURE__ */ React.createElement(BelowViewportIndicator, null);
  }
  if (eleBottomY < viewportTopY) {
    return /* @__PURE__ */ React.createElement(AboveViewportIndicator, null);
  }
  return /* @__PURE__ */ React.createElement("div", {
    style: {
      position: "absolute",
      zIndex: "var(--tina-z-index-3)",
      top: position.top + window.scrollY,
      left: position.left + window.scrollX + iframePosition.left,
      width: position.width,
      height: position.height,
      outline: "2px dashed var(--tina-color-indicator)",
      borderRadius: "var(--tina-radius-small)",
      transition: display ? activeEle ? `opacity 300ms ease-out` : `opacity 150ms ease-in` : `none`,
      opacity: activeEle && display ? 0.8 : 0
    }
  });
};
var styles = `:root {
  --tina-color-primary-light: #2296fe;
  --tina-color-primary: #0084ff;
  --tina-color-primary-dark: #0574e4;
  --tina-color-error-light: #eb6337;
  --tina-color-error: #ec4815;
  --tina-color-error-dark: #dc4419;
  --tina-color-warning-light: #f5e06e;
  --tina-color-warning: #e9d050;
  --tina-color-warning-dark: #d3ba38;
  --tina-color-success-light: #57c355;
  --tina-color-success: #3cad3a;
  --tina-color-success-dark: #249a21;
  --tina-color-grey-0: #ffffff;
  --tina-color-grey-1: #f6f6f9;
  --tina-color-grey-2: #edecf3;
  --tina-color-grey-3: #e1ddec;
  --tina-color-grey-4: #b2adbe;
  --tina-color-grey-5: #918c9e;
  --tina-color-grey-6: #716c7f;
  --tina-color-grey-7: #565165;
  --tina-color-grey-8: #433e52;
  --tina-color-grey-9: #363145;
  --tina-color-grey-10: #252336;
  --tina-color-indicator: var(--tina-color-primary);

  --tina-radius-small: 5px;
  --tina-radius-big: 24px;

  --tina-padding-small: 12px;
  --tina-padding-big: 20px;

  --tina-font-size-0: 12px;
  --tina-font-size-1: 13px;
  --tina-font-size-2: 15px;
  --tina-font-size-3: 16px;
  --tina-font-size-4: 18px;
  --tina-font-size-5: 20px;
  --tina-font-size-6: 22px;
  --tina-font-size-7: 26px;
  --tina-font-size-8: 32px;

  --tina-font-family: 'Inter', sans-serif;

  --tina-font-weight-regular: 400;
  --tina-font-weight-bold: 600;

  --tina-shadow-big: 0px 2px 3px rgba(0, 0, 0, 0.05),
    0 4px 12px rgba(0, 0, 0, 0.1);
  --tina-shadow-small: 0px 2px 3px rgba(0, 0, 0, 0.12);

  --tina-timing-short: 85ms;
  --tina-timing-medium: 150ms;
  --tina-timing-long: 250ms;

  --tina-z-index-0: 0;
  --tina-z-index-1: 10;
  --tina-z-index-2: 20;
  --tina-z-index-3: 30;
  --tina-z-index-4: 40;
  --tina-z-index-5: 50;

  --tina-sidebar-width: 340px;
  --tina-sidebar-header-height: 60px;
  --tina-toolbar-height: 62px;
}

@keyframes fly-in-left {
  0% {
    transform: translate3d(100%, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fly-in-up {
  0% {
    transform: translate3d(0, 100%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes popup-right {
  0% {
    transform: translate3d(-2rem, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes popup-down {
  0% {
    transform: translate3d(0, -2rem, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.tina-tailwind {
  line-height: 1.5;
  -webkit-text-size-adjust: 100%;
  -moz-tab-size: 4;
  tab-size: 4;
}

.tina-tailwind *,
  .tina-tailwind ::before,
  .tina-tailwind ::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: transparent;
  }

.tina-tailwind ::before,
  .tina-tailwind ::after {
    --tw-content: '';
  }

.tina-tailwind hr {
    height: 0; /* 1 */
    color: inherit; /* 2 */
    border-top-width: 1px; /* 3 */
  }

.tina-tailwind abbr:where([title]) {
    text-decoration: underline dotted;
  }

.tina-tailwind h1,
  .tina-tailwind h2,
  .tina-tailwind h3,
  .tina-tailwind h4,
  .tina-tailwind h5,
  .tina-tailwind h6 {
    font-size: inherit;
    font-weight: inherit;
  }

.tina-tailwind a {
    color: inherit;
    text-decoration: inherit;
  }

.tina-tailwind b,
  .tina-tailwind strong {
    font-weight: bolder;
  }

.tina-tailwind code,
  .tina-tailwind kbd,
  .tina-tailwind samp,
  .tina-tailwind pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

.tina-tailwind small {
    font-size: 80%;
  }

.tina-tailwind sub,
  .tina-tailwind sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

.tina-tailwind sub {
    bottom: -0.25em;
  }

.tina-tailwind sup {
    top: -0.5em;
  }

.tina-tailwind table {
    text-indent: 0; /* 1 */
    border-color: inherit; /* 2 */
    border-collapse: collapse; /* 3 */
  }

.tina-tailwind button,
  .tina-tailwind input,
  .tina-tailwind optgroup,
  .tina-tailwind select,
  .tina-tailwind textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: inherit; /* 1 */
    color: inherit; /* 1 */
    margin: 0; /* 2 */
    padding: 0; /* 3 */
  }

.tina-tailwind button,
  .tina-tailwind select {
    text-transform: none;
  }

.tina-tailwind button,
  .tina-tailwind [type='button'],
  .tina-tailwind [type='reset'],
  .tina-tailwind [type='submit'] {
    -webkit-appearance: button; /* 1 */
    background-color: transparent; /* 2 */
    background-image: none; /* 2 */
  }

.tina-tailwind :-moz-focusring {
    outline: auto;
  }

.tina-tailwind :-moz-ui-invalid {
    box-shadow: none;
  }

.tina-tailwind progress {
    vertical-align: baseline;
  }

.tina-tailwind ::-webkit-inner-spin-button,
  .tina-tailwind ::-webkit-outer-spin-button {
    height: auto;
  }

.tina-tailwind [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

.tina-tailwind ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

.tina-tailwind ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

.tina-tailwind summary {
    display: list-item;
  }

.tina-tailwind blockquote,
  .tina-tailwind dl,
  .tina-tailwind dd,
  .tina-tailwind h1,
  .tina-tailwind h2,
  .tina-tailwind h3,
  .tina-tailwind h4,
  .tina-tailwind h5,
  .tina-tailwind h6,
  .tina-tailwind hr,
  .tina-tailwind figure,
  .tina-tailwind p,
  .tina-tailwind pre {
    margin: 0;
  }

.tina-tailwind fieldset {
    margin: 0;
    padding: 0;
  }

.tina-tailwind legend {
    padding: 0;
  }

.tina-tailwind ol,
  .tina-tailwind ul,
  .tina-tailwind menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

.tina-tailwind li:before {
    display: none;
  }

.tina-tailwind textarea {
    resize: vertical;
  }

.tina-tailwind input::placeholder,
  .tina-tailwind textarea::placeholder {
    opacity: 1; /* 1 */
    color: #918c9e; /* 2 */
  }

.tina-tailwind button,
  .tina-tailwind [role='button'] {
    cursor: pointer;
  }

.tina-tailwind :disabled {
    cursor: default;
  }

.tina-tailwind img,
  .tina-tailwind svg,
  .tina-tailwind video,
  .tina-tailwind canvas,
  .tina-tailwind audio,
  .tina-tailwind iframe,
  .tina-tailwind embed,
  .tina-tailwind object {
    display: block; /* 1 */
    vertical-align: middle; /* 2 */
  }

.tina-tailwind img,
  .tina-tailwind video {
    max-width: 100%;
    height: auto;
  }

.tina-tailwind [hidden] {
    display: none;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(0 132 255 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(0 132 255 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.container {
  width: 100%;
}

@media (min-width: 320px) {

  .container {
    max-width: 320px;
  }
}

@media (min-width: 560px) {

  .container {
    max-width: 560px;
  }
}

@media (min-width: 720px) {

  .container {
    max-width: 720px;
  }
}

@media (min-width: 1030px) {

  .container {
    max-width: 1030px;
  }
}

@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}

.tina-prose {
  color: var(--tw-prose-body);
  max-width: 65ch;
}

.tina-prose :where([class~="lead"]):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.tina-prose :where(a):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}

.tina-prose :where(strong):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-bold);
  font-weight: 600;
}

.tina-prose :where(ol):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: decimal;
  padding-left: 1.625em;
}

.tina-prose :where(ol[type="A"]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: upper-alpha;
}

.tina-prose :where(ol[type="a"]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: lower-alpha;
}

.tina-prose :where(ol[type="A" s]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: upper-alpha;
}

.tina-prose :where(ol[type="a" s]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: lower-alpha;
}

.tina-prose :where(ol[type="I"]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: upper-roman;
}

.tina-prose :where(ol[type="i"]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: lower-roman;
}

.tina-prose :where(ol[type="I" s]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: upper-roman;
}

.tina-prose :where(ol[type="i" s]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: lower-roman;
}

.tina-prose :where(ol[type="1"]):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: decimal;
}

.tina-prose :where(ul):not(:where([class~="not-tina-prose"] *)) {
  list-style-type: disc;
  padding-left: 1.625em;
}

.tina-prose :where(ol > li):not(:where([class~="not-tina-prose"] *))::marker {
  font-weight: 400;
  color: var(--tw-prose-counters);
}

.tina-prose :where(ul > li):not(:where([class~="not-tina-prose"] *))::marker {
  color: var(--tw-prose-bullets);
}

.tina-prose :where(hr):not(:where([class~="not-tina-prose"] *)) {
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.tina-prose :where(blockquote):not(:where([class~="not-tina-prose"] *)) {
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-left-width: 0.25rem;
  border-left-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}

.tina-prose :where(blockquote p:first-of-type):not(:where([class~="not-tina-prose"] *))::before {
  content: open-quote;
}

.tina-prose :where(blockquote p:last-of-type):not(:where([class~="not-tina-prose"] *))::after {
  content: close-quote;
}

.tina-prose :where(h1):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.tina-prose :where(h1 strong):not(:where([class~="not-tina-prose"] *)) {
  font-weight: 900;
}

.tina-prose :where(h2):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}

.tina-prose :where(h2 strong):not(:where([class~="not-tina-prose"] *)) {
  font-weight: 800;
}

.tina-prose :where(h3):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.tina-prose :where(h3 strong):not(:where([class~="not-tina-prose"] *)) {
  font-weight: 700;
}

.tina-prose :where(h4):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

.tina-prose :where(h4 strong):not(:where([class~="not-tina-prose"] *)) {
  font-weight: 700;
}

.tina-prose :where(figure > *):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}

.tina-prose :where(figcaption):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}

.tina-prose :where(code):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}

.tina-prose :where(code):not(:where([class~="not-tina-prose"] *))::before {
  content: "\`";
}

.tina-prose :where(code):not(:where([class~="not-tina-prose"] *))::after {
  content: "\`";
}

.tina-prose :where(a code):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-links);
}

.tina-prose :where(pre):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}

.tina-prose :where(pre code):not(:where([class~="not-tina-prose"] *)) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

.tina-prose :where(pre code):not(:where([class~="not-tina-prose"] *))::before {
  content: none;
}

.tina-prose :where(pre code):not(:where([class~="not-tina-prose"] *))::after {
  content: none;
}

.tina-prose :where(table):not(:where([class~="not-tina-prose"] *)) {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}

.tina-prose :where(thead):not(:where([class~="not-tina-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}

.tina-prose :where(thead th):not(:where([class~="not-tina-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.tina-prose :where(tbody tr):not(:where([class~="not-tina-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}

.tina-prose :where(tbody tr:last-child):not(:where([class~="not-tina-prose"] *)) {
  border-bottom-width: 0;
}

.tina-prose :where(tbody td):not(:where([class~="not-tina-prose"] *)) {
  vertical-align: baseline;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.tina-prose {
  --tw-prose-body: #374151;
  --tw-prose-headings: #111827;
  --tw-prose-lead: #4b5563;
  --tw-prose-links: #111827;
  --tw-prose-bold: #111827;
  --tw-prose-counters: #6b7280;
  --tw-prose-bullets: #d1d5db;
  --tw-prose-hr: #e5e7eb;
  --tw-prose-quotes: #111827;
  --tw-prose-quote-borders: #e5e7eb;
  --tw-prose-captions: #6b7280;
  --tw-prose-code: #111827;
  --tw-prose-pre-code: #e5e7eb;
  --tw-prose-pre-bg: #1f2937;
  --tw-prose-th-borders: #d1d5db;
  --tw-prose-td-borders: #e5e7eb;
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}

.tina-prose :where(p):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.tina-prose :where(img):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}

.tina-prose :where(video):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}

.tina-prose :where(figure):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}

.tina-prose :where(h2 code):not(:where([class~="not-tina-prose"] *)) {
  font-size: 0.875em;
}

.tina-prose :where(h3 code):not(:where([class~="not-tina-prose"] *)) {
  font-size: 0.9em;
}

.tina-prose :where(li):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.tina-prose :where(ol > li):not(:where([class~="not-tina-prose"] *)) {
  padding-left: 0.375em;
}

.tina-prose :where(ul > li):not(:where([class~="not-tina-prose"] *)) {
  padding-left: 0.375em;
}

.tina-prose > :where(ul > li p):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.tina-prose > :where(ul > li > *:first-child):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 1.25em;
}

.tina-prose > :where(ul > li > *:last-child):not(:where([class~="not-tina-prose"] *)) {
  margin-bottom: 1.25em;
}

.tina-prose > :where(ol > li > *:first-child):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 1.25em;
}

.tina-prose > :where(ol > li > *:last-child):not(:where([class~="not-tina-prose"] *)) {
  margin-bottom: 1.25em;
}

.tina-prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.tina-prose :where(hr + *):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
}

.tina-prose :where(h2 + *):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
}

.tina-prose :where(h3 + *):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
}

.tina-prose :where(h4 + *):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
}

.tina-prose :where(thead th:first-child):not(:where([class~="not-tina-prose"] *)) {
  padding-left: 0;
}

.tina-prose :where(thead th:last-child):not(:where([class~="not-tina-prose"] *)) {
  padding-right: 0;
}

.tina-prose :where(tbody td:first-child):not(:where([class~="not-tina-prose"] *)) {
  padding-left: 0;
}

.tina-prose :where(tbody td:last-child):not(:where([class~="not-tina-prose"] *)) {
  padding-right: 0;
}

.tina-prose > :where(:first-child):not(:where([class~="not-tina-prose"] *)) {
  margin-top: 0;
}

.tina-prose > :where(:last-child):not(:where([class~="not-tina-prose"] *)) {
  margin-bottom: 0;
}

.tina-tailwind .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.tina-tailwind .pointer-events-none {
  pointer-events: none;
}

.tina-tailwind .pointer-events-auto {
  pointer-events: auto;
}

.tina-tailwind .visible {
  visibility: visible;
}

.tina-tailwind .static {
  position: static;
}

.tina-tailwind .fixed {
  position: fixed;
}

.tina-tailwind .absolute {
  position: absolute;
}

.tina-tailwind .relative {
  position: relative;
}

.tina-tailwind .sticky {
  position: sticky;
}

.tina-tailwind .inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.tina-tailwind .inset-y-0 {
  top: 0px;
  bottom: 0px;
}

.tina-tailwind .left-0 {
  left: 0px;
}

.tina-tailwind .bottom-5 {
  bottom: 20px;
}

.tina-tailwind .right-5 {
  right: 20px;
}

.tina-tailwind .left-5 {
  left: 20px;
}

.tina-tailwind .top-1\\/2 {
  top: 50%;
}

.tina-tailwind .bottom-0 {
  bottom: 0px;
}

.tina-tailwind .right-0 {
  right: 0px;
}

.tina-tailwind .top-0 {
  top: 0px;
}

.tina-tailwind .right-3 {
  right: 12px;
}

.tina-tailwind .right-2\\.5 {
  right: 10px;
}

.tina-tailwind .right-2 {
  right: 8px;
}

.tina-tailwind .left-0\\.5 {
  left: 2px;
}

.tina-tailwind .left-1\\/2 {
  left: 50%;
}

.tina-tailwind .bottom-3 {
  bottom: 12px;
}

.tina-tailwind .top-8 {
  top: 32px;
}

.tina-tailwind .top-2 {
  top: 8px;
}

.tina-tailwind .-bottom-1 {
  bottom: -4px;
}

.tina-tailwind .-right-3 {
  right: -12px;
}

.tina-tailwind .-top-4 {
  top: -16px;
}

.tina-tailwind .-top-2 {
  top: -8px;
}

.tina-tailwind .z-10 {
  z-index: 10;
}

.tina-tailwind .z-\\[999999\\] {
  z-index: 999999;
}

.tina-tailwind .z-0 {
  z-index: 0;
}

.tina-tailwind .z-20 {
  z-index: 20;
}

.tina-tailwind .z-40 {
  z-index: 40;
}

.tina-tailwind .z-modal {
  z-index: 10800;
}

.tina-tailwind .-z-1 {
  z-index: -1;
}

.tina-tailwind .z-30 {
  z-index: 30;
}

.tina-tailwind .z-50 {
  z-index: 50;
}

.tina-tailwind .z-100 {
  z-index: 100;
}

.tina-tailwind .z-overlay {
  z-index: 10600;
}

.tina-tailwind .z-menu {
  z-index: 9800;
}

.tina-tailwind .z-base {
  z-index: 9000;
}

.tina-tailwind .z-panel {
  z-index: 9400;
}

.tina-tailwind .m-0 {
  margin: 0px;
}

.tina-tailwind .m-1 {
  margin: 4px;
}

.tina-tailwind .my-10 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.tina-tailwind .mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.tina-tailwind .-mx-0\\.5 {
  margin-left: -2px;
  margin-right: -2px;
}

.tina-tailwind .-mx-0 {
  margin-left: -0px;
  margin-right: -0px;
}

.tina-tailwind .-mx-1 {
  margin-left: -4px;
  margin-right: -4px;
}

.tina-tailwind .my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.tina-tailwind .my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.tina-tailwind .my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.tina-tailwind .mr-3 {
  margin-right: 12px;
}

.tina-tailwind .ml-2 {
  margin-left: 8px;
}

.tina-tailwind .mb-3 {
  margin-bottom: 12px;
}

.tina-tailwind .mr-2 {
  margin-right: 8px;
}

.tina-tailwind .-mr-4 {
  margin-right: -16px;
}

.tina-tailwind .mr-1 {
  margin-right: 4px;
}

.tina-tailwind .mb-4 {
  margin-bottom: 16px;
}

.tina-tailwind .ml-\\[14px\\] {
  margin-left: 14px;
}

.tina-tailwind .mt-0 {
  margin-top: 0px;
}

.tina-tailwind .-mr-1 {
  margin-right: -4px;
}

.tina-tailwind .mr-0\\.5 {
  margin-right: 2px;
}

.tina-tailwind .mr-0 {
  margin-right: 0px;
}

.tina-tailwind .mb-6 {
  margin-bottom: 24px;
}

.tina-tailwind .ml-1\\.5 {
  margin-left: 6px;
}

.tina-tailwind .ml-1 {
  margin-left: 4px;
}

.tina-tailwind .mt-2 {
  margin-top: 8px;
}

.tina-tailwind .mr-\\[5px\\] {
  margin-right: 5px;
}

.tina-tailwind .-ml-0\\.5 {
  margin-left: -2px;
}

.tina-tailwind .-ml-0 {
  margin-left: -0px;
}

.tina-tailwind .mb-5 {
  margin-bottom: 20px;
}

.tina-tailwind .-mt-px {
  margin-top: -1px;
}

.tina-tailwind .-mt-0\\.5 {
  margin-top: -2px;
}

.tina-tailwind .-mt-0 {
  margin-top: -0px;
}

.tina-tailwind .mb-2 {
  margin-bottom: 8px;
}

.tina-tailwind .-mb-px {
  margin-bottom: -1px;
}

.tina-tailwind .mt-1 {
  margin-top: 4px;
}

.tina-tailwind .mb-0 {
  margin-bottom: 0px;
}

.tina-tailwind .-ml-1 {
  margin-left: -4px;
}

.tina-tailwind .mt-8 {
  margin-top: 32px;
}

.tina-tailwind .mr-1\\.5 {
  margin-right: 6px;
}

.tina-tailwind .mt-4 {
  margin-top: 16px;
}

.tina-tailwind .-mb-14 {
  margin-bottom: -56px;
}

.tina-tailwind .-ml-px {
  margin-left: -1px;
}

.tina-tailwind .-mr-px {
  margin-right: -1px;
}

.tina-tailwind .mb-1 {
  margin-bottom: 4px;
}

.tina-tailwind .mb-\\[6px\\] {
  margin-bottom: 6px;
}

.tina-tailwind .mt-0\\.5 {
  margin-top: 2px;
}

.tina-tailwind .-mt-2 {
  margin-top: -8px;
}

.tina-tailwind .mt-3 {
  margin-top: 12px;
}

.tina-tailwind .ml-3 {
  margin-left: 12px;
}

.tina-tailwind .mt-5 {
  margin-top: 20px;
}

.tina-tailwind .mt-6 {
  margin-top: 24px;
}

.tina-tailwind .block {
  display: block;
}

.tina-tailwind .inline-block {
  display: inline-block;
}

.tina-tailwind .inline {
  display: inline;
}

.tina-tailwind .flex {
  display: flex;
}

.tina-tailwind .inline-flex {
  display: inline-flex;
}

.tina-tailwind .table {
  display: table;
}

.tina-tailwind .grid {
  display: grid;
}

.tina-tailwind .contents {
  display: contents;
}

.tina-tailwind .hidden {
  display: none;
}

.tina-tailwind .\\!hidden {
  display: none !important;
}

.tina-tailwind .h-auto {
  height: auto;
}

.tina-tailwind .h-\\[56px\\] {
  height: 56px;
}

.tina-tailwind .h-full {
  height: 100%;
}

.tina-tailwind .h-10 {
  height: 40px;
}

.tina-tailwind .h-3\\/4 {
  height: 75%;
}

.tina-tailwind .h-16 {
  height: 64px;
}

.tina-tailwind .h-screen {
  height: 100vh;
}

.tina-tailwind .h-3 {
  height: 12px;
}

.tina-tailwind .h-5 {
  height: 20px;
}

.tina-tailwind .h-8 {
  height: 32px;
}

.tina-tailwind .h-7 {
  height: 28px;
}

.tina-tailwind .h-9 {
  height: 36px;
}

.tina-tailwind .h-0 {
  height: 0px;
}

.tina-tailwind .h-\\[34px\\] {
  height: 34px;
}

.tina-tailwind .h-\\[22px\\] {
  height: 22px;
}

.tina-tailwind .h-6 {
  height: 24px;
}

.tina-tailwind .h-14 {
  height: 56px;
}

.tina-tailwind .h-32 {
  height: 128px;
}

.tina-tailwind .h-4\\/6 {
  height: 66.666667%;
}

.tina-tailwind .h-4 {
  height: 16px;
}

.tina-tailwind .max-h-full {
  max-height: 100%;
}

.tina-tailwind .max-h-\\[24rem\\] {
  max-height: 24rem;
}

.tina-tailwind .max-h-\\[initial\\] {
  max-height: initial;
}

.tina-tailwind .max-h-\\[400px\\] {
  max-height: 400px;
}

.tina-tailwind .max-h-\\[300px\\] {
  max-height: 300px;
}

.tina-tailwind .max-h-\\[10rem\\] {
  max-height: 10rem;
}

.tina-tailwind .max-h-\\[200px\\] {
  max-height: 200px;
}

.tina-tailwind .min-h-full {
  min-height: 100%;
}

.tina-tailwind .min-h-\\[42px\\] {
  min-height: 42px;
}

.tina-tailwind .min-h-\\[160px\\] {
  min-height: 160px;
}

.tina-tailwind .min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}

.tina-tailwind .min-h-\\[100px\\] {
  min-height: 100px;
}

.tina-tailwind .min-h-\\[96px\\] {
  min-height: 96px;
}

.tina-tailwind .w-8 {
  width: 32px;
}

.tina-tailwind .w-full {
  width: 100%;
}

.tina-tailwind .w-\\[56px\\] {
  width: 56px;
}

.tina-tailwind .w-\\[47\\%\\] {
  width: 47%;
}

.tina-tailwind .w-5\\/6 {
  width: 83.333333%;
}

.tina-tailwind .w-6 {
  width: 24px;
}

.tina-tailwind .w-10 {
  width: 40px;
}

.tina-tailwind .w-3 {
  width: 12px;
}

.tina-tailwind .w-5 {
  width: 20px;
}

.tina-tailwind .w-\\[460px\\] {
  width: 460px;
}

.tina-tailwind .w-7 {
  width: 28px;
}

.tina-tailwind .w-9 {
  width: 36px;
}

.tina-tailwind .w-0 {
  width: 0px;
}

.tina-tailwind .w-12 {
  width: 48px;
}

.tina-tailwind .w-\\[22px\\] {
  width: 22px;
}

.tina-tailwind .w-auto {
  width: auto;
}

.tina-tailwind .w-4 {
  width: 16px;
}

.tina-tailwind .w-screen {
  width: 100vw;
}

.tina-tailwind .w-96 {
  width: 384px;
}

.tina-tailwind .w-2 {
  width: 8px;
}

.tina-tailwind .w-px {
  width: 1px;
}

.tina-tailwind .w-fit {
  width: fit-content;
}

.tina-tailwind .w-\\[300px\\] {
  width: 300px;
}

.tina-tailwind .w-48 {
  width: 192px;
}

.tina-tailwind .w-32 {
  width: 128px;
}

.tina-tailwind .w-56 {
  width: 224px;
}

.tina-tailwind .min-w-\\[192px\\] {
  min-width: 192px;
}

.tina-tailwind .min-w-\\[350px\\] {
  min-width: 350px;
}

.tina-tailwind .min-w-0 {
  min-width: 0px;
}

.tina-tailwind .max-w-form {
  max-width: 900px;
}

.tina-tailwind .max-w-\\[680px\\] {
  max-width: 680px;
}

.tina-tailwind .max-w-full {
  max-width: 100%;
}

.tina-tailwind .max-w-\\[1500px\\] {
  max-width: 1500px;
}

.tina-tailwind .max-w-\\[90\\%\\] {
  max-width: 90%;
}

.tina-tailwind .max-w-prose {
  max-width: 65ch;
}

.tina-tailwind .max-w-screen-xl {
  max-width: 1280px;
}

.tina-tailwind .max-w-xl {
  max-width: 36rem;
}

.tina-tailwind .flex-1 {
  flex: 1 1 0%;
}

.tina-tailwind .flex-none {
  flex: none;
}

.tina-tailwind .flex-auto {
  flex: 1 1 auto;
}

.tina-tailwind .flex-shrink-0 {
  flex-shrink: 0;
}

.tina-tailwind .flex-shrink {
  flex-shrink: 1;
}

.tina-tailwind .shrink {
  flex-shrink: 1;
}

.tina-tailwind .flex-grow {
  flex-grow: 1;
}

.tina-tailwind .flex-grow-0 {
  flex-grow: 0;
}

.tina-tailwind .grow-0 {
  flex-grow: 0;
}

.tina-tailwind .basis-\\[auto\\] {
  flex-basis: auto;
}

.tina-tailwind .origin-bottom-right {
  transform-origin: bottom right;
}

.tina-tailwind .origin-center {
  transform-origin: center;
}

.tina-tailwind .origin-top-right {
  transform-origin: top right;
}

.tina-tailwind .origin-top-left {
  transform-origin: top left;
}

.tina-tailwind .translate-x-1\\.5 {
  --tw-translate-x: 6px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-x-1 {
  --tw-translate-x: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .-translate-y-2 {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .translate-y-1 {
  --tw-translate-y: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .cursor-pointer {
  cursor: pointer;
}

.tina-tailwind .cursor-not-allowed {
  cursor: not-allowed;
}

.tina-tailwind .cursor-wait {
  cursor: wait;
}

.tina-tailwind .cursor-\\[grab\\] {
  cursor: grab;
}

.tina-tailwind .cursor-default {
  cursor: default;
}

.tina-tailwind .select-none {
  user-select: none;
}

.tina-tailwind .resize-y {
  resize: vertical;
}

.tina-tailwind .resize {
  resize: both;
}

.tina-tailwind .list-inside {
  list-style-position: inside;
}

.tina-tailwind .list-outside {
  list-style-position: outside;
}

.tina-tailwind .list-disc {
  list-style-type: disc;
}

.tina-tailwind .list-decimal {
  list-style-type: decimal;
}

.tina-tailwind .appearance-none {
  appearance: none;
}

.tina-tailwind .flex-col {
  flex-direction: column;
}

.tina-tailwind .flex-wrap {
  flex-wrap: wrap;
}

.tina-tailwind .flex-nowrap {
  flex-wrap: nowrap;
}

.tina-tailwind .items-start {
  align-items: flex-start;
}

.tina-tailwind .items-center {
  align-items: center;
}

.tina-tailwind .items-stretch {
  align-items: stretch;
}

.tina-tailwind .justify-start {
  justify-content: flex-start;
}

.tina-tailwind .justify-end {
  justify-content: flex-end;
}

.tina-tailwind .justify-center {
  justify-content: center;
}

.tina-tailwind .justify-between {
  justify-content: space-between;
}

.tina-tailwind .justify-items-start {
  justify-items: start;
}

.tina-tailwind .gap-2 {
  gap: 8px;
}

.tina-tailwind .gap-4 {
  gap: 16px;
}

.tina-tailwind .gap-3 {
  gap: 12px;
}

.tina-tailwind .gap-\\[3px\\] {
  gap: 3px;
}

.tina-tailwind .gap-1 {
  gap: 4px;
}

.tina-tailwind .gap-0\\.5 {
  gap: 2px;
}

.tina-tailwind .gap-0 {
  gap: 0px;
}

.tina-tailwind .gap-x-3 {
  column-gap: 12px;
}

.tina-tailwind .gap-x-6 {
  column-gap: 24px;
}

.tina-tailwind .gap-y-3 {
  row-gap: 12px;
}

.tina-tailwind .space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(4px * var(--tw-space-x-reverse));
  margin-left: calc(4px * calc(1 - var(--tw-space-x-reverse)));
}

.tina-tailwind .space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}

.tina-tailwind .divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.tina-tailwind .divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(237 236 243 / var(--tw-divide-opacity));
}

.tina-tailwind .self-center {
  align-self: center;
}

.tina-tailwind .self-stretch {
  align-self: stretch;
}

.tina-tailwind .overflow-auto {
  overflow: auto;
}

.tina-tailwind .overflow-hidden {
  overflow: hidden;
}

.tina-tailwind .overflow-visible {
  overflow: visible;
}

.tina-tailwind .overflow-scroll {
  overflow: scroll;
}

.tina-tailwind .overflow-y-auto {
  overflow-y: auto;
}

.tina-tailwind .overflow-x-visible {
  overflow-x: visible;
}

.tina-tailwind .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tina-tailwind .overflow-ellipsis {
  text-overflow: ellipsis;
}

.tina-tailwind .text-ellipsis {
  text-overflow: ellipsis;
}

.tina-tailwind .whitespace-normal {
  white-space: normal;
}

.tina-tailwind .whitespace-nowrap {
  white-space: nowrap;
}

.tina-tailwind .whitespace-pre-wrap {
  white-space: pre-wrap;
}

.tina-tailwind .break-words {
  overflow-wrap: break-word;
}

.tina-tailwind .rounded-\\[50\\%\\] {
  border-radius: 50%;
}

.tina-tailwind .rounded-\\[5px\\] {
  border-radius: 5px;
}

.tina-tailwind .rounded-lg {
  border-radius: 8px;
}

.tina-tailwind .rounded-3xl {
  border-radius: 24px;
}

.tina-tailwind .rounded-full {
  border-radius: 9999px;
}

.tina-tailwind .rounded-none {
  border-radius: 0px;
}

.tina-tailwind .rounded {
  border-radius: 4px;
}

.tina-tailwind .rounded-md {
  border-radius: 6px;
}

.tina-tailwind .rounded-sm {
  border-radius: 2px;
}

.tina-tailwind .rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.tina-tailwind .rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.tina-tailwind .rounded-b-md {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.tina-tailwind .rounded-r-md {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.tina-tailwind .rounded-l-md {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.tina-tailwind .border-0 {
  border-width: 0;
}

.tina-tailwind .border-2 {
  border-width: 2px;
}

.tina-tailwind .border {
  border-width: 1px;
}

.tina-tailwind .border-b {
  border-bottom-width: 1px;
}

.tina-tailwind .border-t {
  border-top-width: 1px;
}

.tina-tailwind .border-b-\\[1px\\] {
  border-bottom-width: 1px;
}

.tina-tailwind .border-l-0 {
  border-left-width: 0;
}

.tina-tailwind .border-t-0 {
  border-top-width: 0;
}

.tina-tailwind .border-r-0 {
  border-right-width: 0;
}

.tina-tailwind .border-r {
  border-right-width: 1px;
}

.tina-tailwind .border-l-3 {
  border-left-width: 3px;
}

.tina-tailwind .border-l {
  border-left-width: 1px;
}

.tina-tailwind .border-solid {
  border-style: solid;
}

.tina-tailwind .border-none {
  border-style: none;
}

.tina-tailwind .border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(237 236 243 / var(--tw-border-opacity));
}

.tina-tailwind .border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 132 255 / var(--tw-border-opacity));
}

.tina-tailwind .border-\\[\\#efefef\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 239 239 / var(--tw-border-opacity));
}

.tina-tailwind .border-gray-150 {
  --tw-border-opacity: 1;
  border-color: rgb(230 227 239 / var(--tw-border-opacity));
}

.tina-tailwind .border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}

.tina-tailwind .border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}

.tina-tailwind .border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(225 221 236 / var(--tw-border-opacity));
}

.tina-tailwind .border-transparent {
  border-color: transparent;
}

.tina-tailwind .border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(246 246 249 / var(--tw-border-opacity));
}

.tina-tailwind .border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}

.tina-tailwind .border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(178 173 190 / var(--tw-border-opacity));
}

.tina-tailwind .border-b-\\[\\#edecf3\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(237 236 243 / var(--tw-border-opacity));
}

.tina-tailwind .bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 132 255 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-transparent {
  background-color: transparent;
}

.tina-tailwind .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 249 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 238 255 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 236 243 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(178 173 190 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 221 236 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}

.tina-tailwind .bg-none {
  background-image: none;
}

.tina-tailwind .bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.tina-tailwind .bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.tina-tailwind .from-gray-800 {
  --tw-gradient-from: #363145;
  --tw-gradient-to: rgb(54 49 69 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.tina-tailwind .from-yellow-50 {
  --tw-gradient-from: #fefce8;
  --tw-gradient-to: rgb(254 252 232 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.tina-tailwind .via-gray-900 {
  --tw-gradient-to: rgb(37 35 54 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), #252336, var(--tw-gradient-to);
}

.tina-tailwind .to-black {
  --tw-gradient-to: #000;
}

.tina-tailwind .to-yellow-100 {
  --tw-gradient-to: #fef9c3;
}

.tina-tailwind .bg-\\[length\\:auto_18px\\] {
  background-size: auto 18px;
}

.tina-tailwind .bg-auto {
  background-size: auto;
}

.tina-tailwind .bg-center {
  background-position: center;
}

.tina-tailwind .bg-no-repeat {
  background-repeat: no-repeat;
}

.tina-tailwind .fill-white {
  fill: #fff;
}

.tina-tailwind .fill-gray-300 {
  fill: #b2adbe;
}

.tina-tailwind .fill-current {
  fill: currentColor;
}

.tina-tailwind .fill-blue-500 {
  fill: #0084FF;
}

.tina-tailwind .fill-gray-400 {
  fill: #918c9e;
}

.tina-tailwind .object-cover {
  object-fit: cover;
}

.tina-tailwind .object-center {
  object-position: center;
}

.tina-tailwind .p-2 {
  padding: 8px;
}

.tina-tailwind .p-5 {
  padding: 20px;
}

.tina-tailwind .p-12 {
  padding: 48px;
}

.tina-tailwind .p-6 {
  padding: 24px;
}

.tina-tailwind .p-0 {
  padding: 0px;
}

.tina-tailwind .p-3 {
  padding: 12px;
}

.tina-tailwind .p-\\[3px\\] {
  padding: 3px;
}

.tina-tailwind .p-1 {
  padding: 4px;
}

.tina-tailwind .p-4 {
  padding: 16px;
}

.tina-tailwind .py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.tina-tailwind .px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.tina-tailwind .py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}

.tina-tailwind .px-5 {
  padding-left: 20px;
  padding-right: 20px;
}

.tina-tailwind .px-6 {
  padding-left: 24px;
  padding-right: 24px;
}

.tina-tailwind .px-3 {
  padding-left: 12px;
  padding-right: 12px;
}

.tina-tailwind .py-4 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.tina-tailwind .px-4 {
  padding-left: 16px;
  padding-right: 16px;
}

.tina-tailwind .py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}

.tina-tailwind .py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.tina-tailwind .py-1\\.5 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.tina-tailwind .px-1 {
  padding-left: 4px;
  padding-right: 4px;
}

.tina-tailwind .py-2\\.5 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.tina-tailwind .px-2 {
  padding-left: 8px;
  padding-right: 8px;
}

.tina-tailwind .py-5 {
  padding-top: 20px;
  padding-bottom: 20px;
}

.tina-tailwind .py-0\\.5 {
  padding-top: 2px;
  padding-bottom: 2px;
}

.tina-tailwind .py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.tina-tailwind .pl-2 {
  padding-left: 8px;
}

.tina-tailwind .pb-16 {
  padding-bottom: 64px;
}

.tina-tailwind .pb-5 {
  padding-bottom: 20px;
}

.tina-tailwind .pr-5 {
  padding-right: 20px;
}

.tina-tailwind .pl-14 {
  padding-left: 56px;
}

.tina-tailwind .pt-6 {
  padding-top: 24px;
}

.tina-tailwind .pb-2 {
  padding-bottom: 8px;
}

.tina-tailwind .pr-1 {
  padding-right: 4px;
}

.tina-tailwind .pl-3 {
  padding-left: 12px;
}

.tina-tailwind .pt-1 {
  padding-top: 4px;
}

.tina-tailwind .pr-7 {
  padding-right: 28px;
}

.tina-tailwind .pl-2\\.5 {
  padding-left: 10px;
}

.tina-tailwind .pt-0\\.5 {
  padding-top: 2px;
}

.tina-tailwind .pt-0 {
  padding-top: 0px;
}

.tina-tailwind .pt-2 {
  padding-top: 8px;
}

.tina-tailwind .pt-16 {
  padding-top: 64px;
}

.tina-tailwind .pl-20 {
  padding-left: 80px;
}

.tina-tailwind .pr-28 {
  padding-right: 114px;
}

.tina-tailwind .pl-6 {
  padding-left: 24px;
}

.tina-tailwind .pl-4 {
  padding-left: 16px;
}

.tina-tailwind .pr-0 {
  padding-right: 0px;
}

.tina-tailwind .pr-4 {
  padding-right: 16px;
}

.tina-tailwind .pt-4 {
  padding-top: 16px;
}

.tina-tailwind .pb-12 {
  padding-bottom: 48px;
}

.tina-tailwind .pr-8 {
  padding-right: 32px;
}

.tina-tailwind .pt-3 {
  padding-top: 12px;
}

.tina-tailwind .pr-10 {
  padding-right: 40px;
}

.tina-tailwind .pr-2 {
  padding-right: 8px;
}

.tina-tailwind .text-left {
  text-align: left;
}

.tina-tailwind .text-center {
  text-align: center;
}

.tina-tailwind .text-right {
  text-align: right;
}

.tina-tailwind .align-baseline {
  vertical-align: baseline;
}

.tina-tailwind .align-top {
  vertical-align: top;
}

.tina-tailwind .font-sans {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.tina-tailwind .font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.tina-tailwind .text-\\[16px\\] {
  font-size: 16px;
}

.tina-tailwind .text-\\[15px\\] {
  font-size: 15px;
}

.tina-tailwind .text-sm {
  font-size: 14px;
  line-height: 1.43;
}

.tina-tailwind .text-2xl {
  font-size: 24px;
  line-height: 1.33;
}

.tina-tailwind .text-xl {
  font-size: 20px;
  line-height: 1.4;
}

.tina-tailwind .text-base {
  font-size: 16px;
  line-height: 1.5;
}

.tina-tailwind .text-\\[13px\\] {
  font-size: 13px;
}

.tina-tailwind .text-lg {
  font-size: 18px;
  line-height: 1.55;
}

.tina-tailwind .text-\\[12px\\] {
  font-size: 12px;
}

.tina-tailwind .text-\\[40px\\] {
  font-size: 40px;
}

.tina-tailwind .text-xs {
  font-size: 13px;
  line-height: 1.33;
}

.tina-tailwind .text-\\[24px\\] {
  font-size: 24px;
}

.tina-tailwind .text-4xl {
  font-size: 36px;
  line-height: 1.1;
}

.tina-tailwind .text-3xl {
  font-size: 30px;
  line-height: 1.2;
}

.tina-tailwind .font-bold {
  font-weight: 700;
}

.tina-tailwind .font-normal {
  font-weight: 400;
}

.tina-tailwind .font-medium {
  font-weight: 500;
}

.tina-tailwind .font-semibold {
  font-weight: 600;
}

.tina-tailwind .font-light {
  font-weight: 300;
}

.tina-tailwind .uppercase {
  text-transform: uppercase;
}

.tina-tailwind .capitalize {
  text-transform: capitalize;
}

.tina-tailwind .italic {
  font-style: italic;
}

.tina-tailwind .not-italic {
  font-style: normal;
}

.tina-tailwind .leading-tight {
  line-height: 1.25;
}

.tina-tailwind .leading-none {
  line-height: 1;
}

.tina-tailwind .leading-\\[1\\.35\\] {
  line-height: 1.35;
}

.tina-tailwind .leading-6 {
  line-height: 24px;
}

.tina-tailwind .leading-5 {
  line-height: 20px;
}

.tina-tailwind .tracking-wide {
  letter-spacing: 0.025em;
}

.tina-tailwind .tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}

.tina-tailwind .text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(178 173 190 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(67 62 82 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(86 81 101 / var(--tw-text-opacity));
}

.tina-tailwind .text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(0 132 255 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(113 108 127 / var(--tw-text-opacity));
}

.tina-tailwind .text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(54 49 69 / var(--tw-text-opacity));
}

.tina-tailwind .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tina-tailwind .text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(34 150 254 / var(--tw-text-opacity));
}

.tina-tailwind .text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}

.tina-tailwind .text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(5 116 228 / var(--tw-text-opacity));
}

.tina-tailwind .text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(20 70 150 / var(--tw-text-opacity));
}

.tina-tailwind .text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(225 221 236 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(145 140 158 / var(--tw-text-opacity));
}

.tina-tailwind .text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.tina-tailwind .text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 21 / var(--tw-text-opacity));
}

.tina-tailwind .text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}

.tina-tailwind .text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}

.tina-tailwind .text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}

.tina-tailwind .text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}

.tina-tailwind .text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(37 35 54 / var(--tw-text-opacity));
}

.tina-tailwind .underline {
  text-decoration-line: underline;
}

.tina-tailwind .no-underline {
  text-decoration-line: none;
}

.tina-tailwind .placeholder-gray-200::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(225 221 236 / var(--tw-placeholder-opacity));
}

.tina-tailwind .placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(145 140 158 / var(--tw-placeholder-opacity));
}

.tina-tailwind .opacity-0 {
  opacity: 0;
}

.tina-tailwind .opacity-100 {
  opacity: 1;
}

.tina-tailwind .opacity-70 {
  opacity: .7;
}

.tina-tailwind .opacity-50 {
  opacity: .5;
}

.tina-tailwind .opacity-80 {
  opacity: .8;
}

.tina-tailwind .opacity-30 {
  opacity: .3;
}

.tina-tailwind .opacity-90 {
  opacity: .9;
}

.tina-tailwind .shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-\\[0_2px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 2px 3px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 2px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-\\[0_2px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 2px 3px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 2px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .shadow-\\[0_0_0_0_\\#e1ddec\\] {
  --tw-shadow: 0 0 0 0 #e1ddec;
  --tw-shadow-colored: 0 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tina-tailwind .outline {
  outline-style: solid;
}

.tina-tailwind .ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .ring-inset {
  --tw-ring-inset: inset;
}

.tina-tailwind .ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}

.tina-tailwind .ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 219 255 / var(--tw-ring-opacity));
}

.tina-tailwind .ring-opacity-5 {
  --tw-ring-opacity: .05;
}

.tina-tailwind .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.tina-tailwind .\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.tina-tailwind .transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tina-tailwind .transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tina-tailwind .transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tina-tailwind .transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tina-tailwind .transition-none {
  transition-property: none;
}

.tina-tailwind .duration-200 {
  transition-duration: 200ms;
}

.tina-tailwind .duration-300 {
  transition-duration: 300ms;
}

.tina-tailwind .duration-150 {
  transition-duration: 150ms;
}

.tina-tailwind .duration-100 {
  transition-duration: 100ms;
}

.tina-tailwind .duration-\\[150ms\\] {
  transition-duration: 150ms;
}

.tina-tailwind .duration-75 {
  transition-duration: 75ms;
}

.tina-tailwind .ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.tina-tailwind .ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.tina-tailwind .ease-linear {
  transition-timing-function: linear;
}

.tina-tailwind .ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.tina-tailwind .icon-parent svg {
      fill: currentColor;
    }

.tina-tailwind {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 16px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(86 81 101 / var(--tw-text-opacity));
}

/* if the last block has margin-bottom it makes the text box larger but some of it isn't clickable */

.tina-prose [data-slate-editor='true'] {
  padding-bottom: 0.5em;
}

/* prose adds backticks, which look like they should be editable */

.tina-prose [data-slate-editor='true'] .slate-code::before {
  content: '';
}

.tina-prose [data-slate-editor='true'] .slate-code::after {
  content: '';
}

.tina-prose [data-slate-editor='true'] .slate-code_block {
  margin: 0;
}

/* code lines as part of a block don't need the same background formatting */

.tina-prose [data-slate-editor='true'] .slate-code_block .slate-code {
  background: none;
}

/* prose makes the first p in a block slightly larger */

.tina-prose [data-slate-editor='true'] p:first-of-type {
  font-size: 1em;
}

/* experimental floating toolbar doesn't need a large text area */

.with-toolbar [data-slate-editor='true'] {
  min-height: 72px;
}

.tina-tailwind .before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.tina-tailwind .before\\:left-1\\/2::before {
  content: var(--tw-content);
  left: 50%;
}

.tina-tailwind .before\\:bottom-0::before {
  content: var(--tw-content);
  bottom: 0px;
}

.tina-tailwind .before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.tina-tailwind .before\\:z-10::before {
  content: var(--tw-content);
  z-index: 10;
}

.tina-tailwind .before\\:mr-1::before {
  content: var(--tw-content);
  margin-right: 4px;
}

.tina-tailwind .before\\:mt-\\[1px\\]::before {
  content: var(--tw-content);
  margin-top: 1px;
}

.tina-tailwind .before\\:mb-\\[1px\\]::before {
  content: var(--tw-content);
  margin-bottom: 1px;
}

.tina-tailwind .before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.tina-tailwind .before\\:h-4::before {
  content: var(--tw-content);
  height: 16px;
}

.tina-tailwind .before\\:h-\\[14px\\]::before {
  content: var(--tw-content);
  height: 14px;
}

.tina-tailwind .before\\:w-4::before {
  content: var(--tw-content);
  width: 16px;
}

.tina-tailwind .before\\:w-\\[18px\\]::before {
  content: var(--tw-content);
  width: 18px;
}

.tina-tailwind .before\\:-translate-x-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .before\\:translate-y-full::before {
  content: var(--tw-content);
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .before\\:-translate-y-full::before {
  content: var(--tw-content);
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .before\\:rounded-3xl::before {
  content: var(--tw-content);
  border-radius: 24px;
}

.tina-tailwind .before\\:border::before {
  content: var(--tw-content);
  border-width: 1px;
}

.tina-tailwind .before\\:border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}

.tina-tailwind .before\\:border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 132 255 / var(--tw-border-opacity));
}

.tina-tailwind .before\\:border-gray-100::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(237 236 243 / var(--tw-border-opacity));
}

.tina-tailwind .before\\:bg-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 132 255 / var(--tw-bg-opacity));
}

.tina-tailwind .before\\:bg-gray-200::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(225 221 236 / var(--tw-bg-opacity));
}

.tina-tailwind .before\\:shadow-\\[0_0_0_0_\\#e1ddec\\2c _inset_0_0_0_8px_white\\]::before {
  content: var(--tw-content);
  --tw-shadow: 0 0 0 0 #e1ddec, inset 0 0 0 8px white;
  --tw-shadow-colored: 0 0 0 0 var(--tw-shadow-color), inset 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .before\\:shadow-\\[0_0_0_0_\\#0084ff\\2c _inset_0_0_0_4px_white\\]::before {
  content: var(--tw-content);
  --tw-shadow: 0 0 0 0 #0084ff, inset 0 0 0 4px white;
  --tw-shadow-colored: 0 0 0 0 var(--tw-shadow-color), inset 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tina-tailwind .before\\:duration-100::before {
  content: var(--tw-content);
  transition-duration: 100ms;
}

.tina-tailwind .before\\:ease-out::before {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.tina-tailwind .before\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}

.tina-tailwind .after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.tina-tailwind .after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}

.tina-tailwind .after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}

.tina-tailwind .after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}

.tina-tailwind .after\\:z-20::after {
  content: var(--tw-content);
  z-index: 20;
}

.tina-tailwind .after\\:mb-0\\.5::after {
  content: var(--tw-content);
  margin-bottom: 2px;
}

.tina-tailwind .after\\:mb-0::after {
  content: var(--tw-content);
  margin-bottom: 0px;
}

.tina-tailwind .after\\:mt-0\\.5::after {
  content: var(--tw-content);
  margin-top: 2px;
}

.tina-tailwind .after\\:mt-0::after {
  content: var(--tw-content);
  margin-top: 0px;
}

.tina-tailwind .after\\:h-\\[13px\\]::after {
  content: var(--tw-content);
  height: 13px;
}

.tina-tailwind .after\\:w-4::after {
  content: var(--tw-content);
  width: 16px;
}

.tina-tailwind .after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .after\\:translate-y-full::after {
  content: var(--tw-content);
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .after\\:-translate-y-full::after {
  content: var(--tw-content);
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.tina-tailwind .after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.tina-tailwind .after\\:pl-2::after {
  content: var(--tw-content);
  padding-left: 8px;
}

.tina-tailwind .after\\:content-\\[\\'\\/\\'\\]::after {
  --tw-content: '/';
  content: var(--tw-content);
}

.tina-tailwind .after\\:content-\\[\\"\\"\\]::after {
  --tw-content: "";
  content: var(--tw-content);
}

.tina-tailwind .first\\:mt-0:first-child {
  margin-top: 0px;
}

.tina-tailwind .first\\:rounded-t:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tina-tailwind .first\\:pt-3:first-child {
  padding-top: 12px;
}

.tina-tailwind .last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.tina-tailwind .last\\:rounded-b:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.tina-tailwind .last\\:pb-3:last-child {
  padding-bottom: 12px;
}

.tina-tailwind .focus-within\\:border-blue-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(0 132 255 / var(--tw-border-opacity));
}

.tina-tailwind .focus-within\\:text-gray-900:focus-within {
  --tw-text-opacity: 1;
  color: rgb(37 35 54 / var(--tw-text-opacity));
}

.tina-tailwind .focus-within\\:shadow-\\[0_0_0_2px_\\#0084ff\\]:focus-within {
  --tw-shadow: 0 0 0 2px #0084ff;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .focus-within\\:shadow-outline:focus-within {
  --tw-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(225 221 236 / var(--tw-border-opacity));
}

.tina-tailwind .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 249 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 116 228 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 132 255 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 236 243 / var(--tw-bg-opacity));
}

.tina-tailwind .hover\\:fill-gray-900:hover {
  fill: #252336;
}

.tina-tailwind .hover\\:fill-gray-700:hover {
  fill: #433e52;
}

.tina-tailwind .hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(37 35 54 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 116 228 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(0 132 255 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(34 150 254 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(86 81 101 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tina-tailwind .hover\\:underline:hover {
  text-decoration-line: underline;
}

.tina-tailwind .hover\\:placeholder-gray-600:hover::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(86 81 101 / var(--tw-placeholder-opacity));
}

.tina-tailwind .hover\\:opacity-100:hover {
  opacity: 1;
}

.tina-tailwind .hover\\:opacity-70:hover {
  opacity: .7;
}

.tina-tailwind .hover\\:opacity-60:hover {
  opacity: .6;
}

.tina-tailwind .hover\\:opacity-\\[\\.6\\]:hover {
  opacity: .6;
}

.tina-tailwind .hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .hover\\:drop-shadow-md:hover {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.tina-tailwind .hover\\:before\\:shadow-\\[0_0_0_2px_\\#e1ddec\\2c _inset_0_0_0_8px_white\\]:hover::before {
  content: var(--tw-content);
  --tw-shadow: 0 0 0 2px #e1ddec, inset 0 0 0 8px white;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), inset 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .focus\\:z-10:focus {
  z-index: 10;
}

.tina-tailwind .focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 132 255 / var(--tw-border-opacity));
}

.tina-tailwind .focus\\:border-blue-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 150 254 / var(--tw-border-opacity));
}

.tina-tailwind .focus\\:bg-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 249 / var(--tw-bg-opacity));
}

.tina-tailwind .focus\\:text-blue-500:focus {
  --tw-text-opacity: 1;
  color: rgb(0 132 255 / var(--tw-text-opacity));
}

.tina-tailwind .focus\\:text-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(37 35 54 / var(--tw-text-opacity));
}

.tina-tailwind .focus\\:opacity-80:focus {
  opacity: .8;
}

.tina-tailwind .focus\\:shadow-outline:focus {
  --tw-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tina-tailwind .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 132 255 / var(--tw-ring-opacity));
}

.tina-tailwind .focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}

.tina-tailwind .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.tina-tailwind .focus\\:ring-offset-gray-100:focus {
  --tw-ring-offset-color: #EDECF3;
}

.tina-tailwind .focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tina-tailwind .focus-visible\\:ring-white:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}

.tina-tailwind .focus-visible\\:ring-opacity-75:focus-visible {
  --tw-ring-opacity: .75;
}

.tina-tailwind .focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.tina-tailwind .focus-visible\\:ring-offset-teal-300:focus-visible {
  --tw-ring-offset-color: #5eead4;
}

.tina-tailwind .active\\:bg-gray-100:active {
  --tw-bg-opacity: 1;
  background-color: rgb(237 236 243 / var(--tw-bg-opacity));
}

.tina-tailwind .active\\:shadow-\\[0_0_0_2px_\\#0084ff\\]:active {
  --tw-shadow: 0 0 0 2px #0084ff;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .active\\:outline-none:active {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tina-tailwind .group:hover .group-hover\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(0 132 255 / var(--tw-text-opacity));
}

.tina-tailwind .group:hover .group-hover\\:text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(34 150 254 / var(--tw-text-opacity));
}

.tina-tailwind .group:hover .group-hover\\:text-inherit {
  color: inherit;
}

.tina-tailwind .group:hover .group-hover\\:text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(54 49 69 / var(--tw-text-opacity));
}

.tina-tailwind .group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.tina-tailwind .group:hover .group-hover\\:opacity-90 {
  opacity: .9;
}

.tina-tailwind .group:hover .group-hover\\:opacity-0 {
  opacity: 0;
}

.tina-tailwind .group:hover .group-hover\\:opacity-80 {
  opacity: .8;
}

.tina-tailwind .group:hover .group-hover\\:opacity-50 {
  opacity: .5;
}

@media (min-width: 560px) {

  .tina-tailwind .sm\\:rounded-lg {
    border-radius: 8px;
  }

  .tina-tailwind .sm\\:p-6 {
    padding: 24px;
  }

  .tina-tailwind .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .tina-tailwind .sm\\:text-sm {
    font-size: 14px;
    line-height: 1.43;
  }
}

@media (min-width: 720px) {

  .tina-tailwind .md\\:-ml-2 {
    margin-left: -8px;
  }

  .tina-tailwind .md\\:flex {
    display: flex;
  }

  .tina-tailwind .md\\:w-\\[calc\\(100\\%-170px\\)\\] {
    width: calc(100% - 170px);
  }

  .tina-tailwind .md\\:-translate-x-1 {
    --tw-translate-x: -4px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .tina-tailwind .md\\:text-\\[15px\\] {
    font-size: 15px;
  }
}

.tina-tailwind .\\[\\&\\:not\\(\\:active\\)\\]\\:hover\\:bg-gray-50:hover:not(:active) {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 249 / var(--tw-bg-opacity));
}

.tina-tailwind .\\[\\&\\:not\\(\\:active\\)\\]\\:\\[\\&\\:not\\(\\:focus-within\\)\\]\\:hover\\:shadow-\\[0_0_0_2px_\\#e1ddec\\]:hover:not(:focus-within):not(:active) {
  --tw-shadow: 0 0 0 2px #e1ddec;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind input:focus+.\\[input\\:focus\\+\\&\\:before\\]\\:border:before {
  border-width: 1px;
}

.tina-tailwind input:focus+.\\[input\\:focus\\+\\&\\:before\\]\\:border-solid:before {
  border-style: solid;
}

.tina-tailwind input:focus+.\\[input\\:focus\\+\\&\\:before\\]\\:border-gray-100:before {
  --tw-border-opacity: 1;
  border-color: rgb(237 236 243 / var(--tw-border-opacity));
}

.tina-tailwind input:focus+.\\[input\\:focus\\+\\&\\:before\\]\\:shadow-\\[0_0_0_2px_\\#0084ff\\2c _inset_0_0_0_4px_white\\]:before {
  --tw-shadow: 0 0 0 2px #0084ff, inset 0 0 0 4px white;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), inset 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind input:focus+.\\[input\\:focus\\+\\&\\:before\\]\\:shadow-\\[0_0_0_2px_\\#0084ff\\2c _inset_0_0_0_8px_white\\]:before {
  --tw-shadow: 0 0 0 2px #0084ff, inset 0 0 0 8px white;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), inset 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tina-tailwind .\\[\\&\\:last-child\\]\\:rounded-\\[0_0_5px_5px\\]:last-child {
  border-radius: 0 0 5px 5px;
}

.tina-tailwind .\\[\\&\\:not\\(\\:hover\\)\\]\\:fill-white:not(:hover) {
  fill: #fff;
}
`;
const TinaUI = ({ children, position }) => {
  const cms = useCMS();
  const [resizingSidebar, setResizingSidebar] = React.useState(false);
  return /* @__PURE__ */ React.createElement(MutationSignalProvider, null, /* @__PURE__ */ React.createElement("style", null, styles), /* @__PURE__ */ React.createElement("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=Inter:400,600",
    media: "all"
  }), /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement("div", {
    className: "tina-tailwind"
  }, /* @__PURE__ */ React.createElement(Alerts, {
    alerts: cms.alerts
  }), /* @__PURE__ */ React.createElement(MediaManager, null), cms.sidebar && /* @__PURE__ */ React.createElement(SidebarProvider, {
    resizingSidebar,
    setResizingSidebar,
    position,
    sidebar: cms.sidebar
  }), /* @__PURE__ */ React.createElement(ActiveFieldIndicator, null)), /* @__PURE__ */ React.createElement("div", {
    className: `${resizingSidebar ? "pointer-events-none" : ""}`
  }, children)));
};
const TinaProvider = ({
  cms,
  children,
  position,
  styled = true
}) => {
  return /* @__PURE__ */ React.createElement(TinaCMSProvider, {
    cms
  }, /* @__PURE__ */ React.createElement(TinaUI, {
    position,
    styled
  }, children));
};
const Tina = TinaProvider;
function withTina(Component, config) {
  return (props) => {
    const cms = React.useMemo(() => new TinaCMS(config), [config]);
    return /* @__PURE__ */ React.createElement(TinaProvider, {
      cms
    }, /* @__PURE__ */ React.createElement(Component, {
      ...props
    }));
  };
}
class FormMetaPlugin {
  constructor(options) {
    this.__type = "form:meta";
    this.name = options.name;
    this.Component = options.Component;
  }
}
const BranchContext = React.createContext({
  currentBranch: null,
  setCurrentBranch: (branch) => {
    console.warn("BranchContext not initialized");
  }
});
const BranchDataProvider = ({
  currentBranch,
  setCurrentBranch,
  children
}) => {
  return /* @__PURE__ */ React.createElement(BranchContext.Provider, {
    value: {
      currentBranch,
      setCurrentBranch
    }
  }, children);
};
const useBranchData = () => {
  const branchData = React.useContext(BranchContext);
  const { dispatch } = useEvent("branch:change");
  React.useEffect(() => {
    dispatch({ branchName: branchData.currentBranch });
  }, [branchData.currentBranch]);
  return branchData;
};
const BranchSwitcher = ({
  listBranches,
  createBranch
}) => {
  var _a, _b;
  const cms = useCMS$1();
  const isLocalMode = (_b = (_a = cms.api) == null ? void 0 : _a.tina) == null ? void 0 : _b.isLocalMode;
  const [listState, setListState] = React.useState("loading");
  const [branchList, setBranchList] = React.useState([]);
  const { currentBranch, setCurrentBranch } = useBranchData();
  const handleCreateBranch = React.useCallback((value) => {
    setListState("loading");
    createBranch({
      branchName: value,
      baseBranch: currentBranch
    }).then(async (createdBranchName) => {
      setCurrentBranch(createdBranchName);
      await refreshBranchList();
    });
  }, []);
  const refreshBranchList = React.useCallback(async () => {
    setListState("loading");
    await listBranches().then((data) => {
      setBranchList(data);
      setListState("ready");
    }).catch(() => setListState("error"));
  }, []);
  React.useEffect(() => {
    refreshBranchList();
  }, []);
  return /* @__PURE__ */ React.createElement("div", {
    className: "w-full flex justify-center p-5"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-full max-w-form"
  }, isLocalMode ? /* @__PURE__ */ React.createElement("div", {
    className: "px-6 py-8 w-full h-full flex flex-col items-center justify-center"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "text-base mb-4 text-center"
  }, /* @__PURE__ */ React.createElement(AiFillWarning, {
    className: "w-7 h-auto inline-block mr-0.5 opacity-70 text-yellow-600"
  })), /* @__PURE__ */ React.createElement("p", {
    className: "text-base mb-6 text-center"
  }, "Tina's branch switcher isn't available in local mode.", " ", /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    className: "transition-all duration-150 ease-out text-blue-600 hover:text-blue-400 hover:underline no-underline",
    href: "https://tina.io/docs/tina-cloud/"
  }, "Learn more about moving to production with Tina Cloud.")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Button, {
    href: "https://tina.io/docs/tina-cloud/",
    target: "_blank",
    as: "a"
  }, "Read Our Docs", " ", /* @__PURE__ */ React.createElement(MdArrowForward, {
    className: "w-5 h-auto ml-1.5 opacity-80"
  })))) : listState === "loading" ? /* @__PURE__ */ React.createElement("div", {
    style: { margin: "32px auto", textAlign: "center" }
  }, /* @__PURE__ */ React.createElement(LoadingDots, {
    color: "var(--tina-color-primary)"
  })) : /* @__PURE__ */ React.createElement(React.Fragment, null, listState === "ready" ? /* @__PURE__ */ React.createElement(BranchSelector, {
    currentBranch,
    branchList,
    onCreateBranch: (newBranch) => {
      handleCreateBranch(newBranch);
    },
    onChange: (branchName) => {
      setCurrentBranch(branchName);
    }
  }) : /* @__PURE__ */ React.createElement("div", {
    className: "px-6 py-8 w-full h-full flex flex-col items-center justify-center"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "text-base mb-4 text-center"
  }, "An error occurred while retrieving the branch list."), /* @__PURE__ */ React.createElement(Button, {
    className: "mb-4",
    onClick: refreshBranchList
  }, "Try again ", /* @__PURE__ */ React.createElement(BiRefresh, {
    className: "w-6 h-full ml-1 opacity-70"
  }))))));
};
const BranchSelector = ({
  branchList,
  currentBranch,
  onCreateBranch,
  onChange
}) => {
  const [newBranchName, setNewBranchName] = React.useState("");
  const [filter, setFilter] = React.useState("");
  const filteredBranchList = branchList.filter((branch) => !filter || branch.name.includes(filter));
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "block relative group"
  }, /* @__PURE__ */ React.createElement(BaseTextField, {
    placeholder: "Search",
    value: filter,
    onChange: (e) => setFilter(e.target.value)
  }), filter === "" ? /* @__PURE__ */ React.createElement(BiSearch, {
    className: "absolute right-3 top-1/2 -translate-y-1/2 w-5 h-auto text-blue-500 opacity-70 group-hover:opacity-100 transition-all ease-out duration-150"
  }) : /* @__PURE__ */ React.createElement("button", {
    onClick: () => {
      setFilter("");
    },
    className: "outline-none focus:outline-none bg-transparent border-0 p-0 m-0 absolute right-2.5 top-1/2 -translate-y-1/2 opacity-50 hover:opacity-100 transition-all ease-out duration-150"
  }, /* @__PURE__ */ React.createElement(MdOutlineClear, {
    className: "w-5 h-auto text-gray-600"
  }))), filteredBranchList.length === 0 && /* @__PURE__ */ React.createElement("div", {
    className: "block relative text-gray-300 italic py-1"
  }, "No branches to display"), filteredBranchList.length > 0 && /* @__PURE__ */ React.createElement("div", {
    className: "min-w-[192px] max-h-[24rem] overflow-y-auto flex flex-col w-full h-full rounded-lg shadow-inner bg-white border border-gray-200"
  }, filteredBranchList.map((branch) => {
    const isCurrentBranch = branch.name === currentBranch;
    return /* @__PURE__ */ React.createElement("div", {
      className: `cursor-pointer relative text-base py-1.5 px-3 border-l-0 border-t-0 border-r-0 border-b border-gray-50 w-full outline-none transition-all ease-out duration-150 hover:text-blue-500 focus:text-blue-500 focus:bg-gray-50 hover:bg-gray-50 ${isCurrentBranch ? "bg-blue-50 text-blue-800 pointer-events-none" : ""}`,
      key: branch,
      onClick: () => onChange(branch.name)
    }, branch.name, isCurrentBranch && /* @__PURE__ */ React.createElement("span", {
      className: "opacity-70 italic"
    }, ` (current)`));
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between items-center w-full gap-3"
  }, /* @__PURE__ */ React.createElement(BaseTextField, {
    placeholder: "Branch Name",
    value: newBranchName,
    onChange: (e) => setNewBranchName(e.target.value)
  }), /* @__PURE__ */ React.createElement(Button, {
    className: "flex-0 flex items-center gap-2 whitespace-nowrap",
    size: "medium",
    variant: "primary",
    onClick: () => onCreateBranch(newBranchName)
  }, /* @__PURE__ */ React.createElement(BiPlus, {
    className: "w-5 h-auto opacity-70"
  }), " Create New")));
};
class BranchSwitcherPlugin {
  constructor(options) {
    this.__type = "screen";
    this.Icon = BiGitRepoForked;
    this.name = "Select Branch";
    this.layout = "popup";
    this.Component = () => {
      return /* @__PURE__ */ React.createElement(BranchSwitcher, {
        listBranches: this.listBranches,
        createBranch: this.createBranch
      });
    };
    this.listBranches = options.listBranches;
    this.createBranch = options.createBranch;
  }
}
function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = React.useState(initialValue);
  React.useEffect(() => {
    const valueFromStorage = window.localStorage && window.localStorage.getItem(key);
    if (valueFromStorage != null && valueFromStorage != void 0) {
      setStoredValue(JSON.parse(valueFromStorage));
    }
  }, [key]);
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}
export { ActionButton, AddIcon, AlertIcon, Alerts$1 as Alerts, AlignCenter, AlignLeft, AlignRight, BaseTextField, BlocksField, BlocksFieldPlugin, BoldIcon$1 as BoldIcon, BranchDataProvider, BranchSwitcher, BranchSwitcherPlugin, Button, CMSContext, CheckboxGroup, CheckboxGroupField, CheckboxGroupFieldPlugin, ChevronDownIcon$2 as ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, Circle, CircleCheck, CloseIcon, CodeIcon$1 as CodeIcon, ColorField, ColorFieldPlugin, ColorPicker, CursorPaginator, DateField, DateFieldPlugin, DeleteImageButton, Dismissible, DragHandle, DragIcon, DummyMediaStore, DuplicateIcon, ERROR_MISSING_CMS, EditIcon, EllipsisVerticalIcon, EmptyList$1 as EmptyList, EmptyState$2 as EmptyState, ErrorIcon, EventBus, ExitIcon, FieldDescription, FieldError, FieldLabel, FieldMeta, FieldWrapper, FieldsBuilder, FieldsGroup, File, Folder, FontLoader, Form, FormActionMenu, FormBuilder, FormLegacy, FormMetaPlugin, FormPortalProvider, FormStatus, FormWrapper$1 as FormWrapper, FullscreenFormBuilder, FullscreenModal, GlobalFormPlugin, Group$1 as Group, GroupField, GroupFieldPlugin, GroupLabel, GroupListField, GroupListFieldPlugin, GroupListHeader, GroupListMeta, GroupPanel, HamburgerIcon, HeadingIcon$1 as HeadingIcon, IconButton, ImageField, ImageFieldPlugin, ImageUpload, InfoIcon, Input, ItalicIcon$1 as ItalicIcon, ItemClickTarget, ItemDeleteButton, ItemHeader, LeftArrowIcon, LinkIcon$1 as LinkIcon, ListField, ListFieldPlugin, ListPanel$1 as ListPanel, LoadingDots, LocalWarning, LockIcon, MarkdownIcon, MdxFieldPlugin, MdxFieldPluginExtendible, MediaIcon, MediaListError, MediaManager$1 as MediaManager, Modal, ModalActions, ModalBody, ModalFullscreen, ModalHeader, ModalOverlay, ModalPopup, ModalProvider, Nav, NumberField, NumberFieldPlugin, NumberInput, OrderedListIcon$1 as OrderedListIcon, OverflowMenu$1 as OverflowMenu, PanelBody, PanelHeader, PopupModal, PullRequestIcon, QuoteIcon$1 as QuoteIcon, RadioGroup, RadioGroupField, RadioGroupFieldPlugin, RedoIcon, Reference, ReferenceField, ReferenceFieldPlugin, ReorderIcon, ReorderRowIcon, ResetForm, ResetIcon, RightArrowIcon, Select, SelectField, SelectFieldPlugin, SettingsIcon, StrikethroughIcon, SyncStatus, TableIcon, TagsField, TagsFieldPlugin, TextArea, TextField, TextFieldPlugin, TextareaField, TextareaFieldPlugin, Tina, TinaCMS, TinaCMSProvider, TinaField, TinaForm, TinaIcon, TinaMediaStore, TinaProvider, TinaUI, Toggle, ToggleField, ToggleFieldPlugin, TrashIcon, UnderlineIcon, UndoIcon, UnorderedListIcon$1 as UnorderedListIcon, UploadIcon, WarningIcon, classNames, selectFieldClasses, textFieldClasses, useBranchData, useCMS, useCMSEvent, useDismissible, useForm, useFormPortal, useFormScreenPlugin, useGlobalForm, useLocalForm, useLocalStorage, useModalContainer, usePlugin, usePlugins, usePreviewSrc, useScreenPlugin, useSubscribable, useWatchFormValues, withPlugin, withPlugins, withTina, wrapFieldsWithMeta };
